webpackJsonp([1],{

/***/ 1020:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"wrap"},[_c('el-header',{staticClass:"main-header",attrs:{"height":"80"}},[_c('div',{staticClass:"branding"},[_c('router-link',{attrs:{"to":"/"}}),_vm._v(" "),_c('div',{staticClass:"app-title"},[_vm._v("BP Payin Slip "+_vm._s(_vm.appName ? ("| " + (_vm.$t(_vm.appName))) : ''))])],1),_vm._v(" "),(_vm.isAuthenticated)?_c('div',{staticClass:"menu profile-menu"},[_c('el-menu',{attrs:{"mode":"horizontal","router":true,"collapse-transition":false,"menu-trigger":"click","text-color":"#000000"}},[_c('el-submenu',{attrs:{"index":"1"}},[_c('template',{slot:"title"},[_vm._v("ข้อมูลส่วนตัว")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/reset-password","route":{ name: 'ResetPassword' }}},[_vm._v("เปลี่ยนรหัสผ่าน")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/logout","route":{ name: 'Logout' }}},[_vm._v(_vm._s(_vm._f("translate")('Logout')))])],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.isAuthenticated)?_c('div',{staticClass:"profile-info"},[_c('i',{staticClass:"profile-icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.faUser}})],1),_vm._v("\n      "+_vm._s(_vm.userName)+"\n      "),(_vm.isAdmin && _vm.isAdminRole)?_c('el-tag',{staticClass:"user-role",attrs:{"type":"info"}},[_vm._v("SCB ADMIN")]):_vm._e(),_vm._v(" "),(_vm.isAdmin && _vm.isViewerRole)?_c('el-tag',{staticClass:"user-role",attrs:{"type":"info"}},[_vm._v("SCB VIEWER")]):_vm._e(),_vm._v(" "),(_vm.isBiller && _vm.billerRole)?_c('el-tag',{staticClass:"user-role",attrs:{"type":_vm.isBillerAdmin ? 'success' : 'default'}},[_vm._v(_vm._s(_vm.billerRole))]):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('el-container',{staticClass:"body-wrap"},[_c('el-container',{staticClass:"content-wrap"},[(_vm.isAuthenticated && !_vm.isNeedResetPwd && _vm.shouldShowAside)?_c('el-aside',{attrs:{"width":"250px"}},[(_vm.shouldShowMainMenu)?_c('el-menu',{ref:"scbMainMenu",staticClass:"scb-main-menu",attrs:{"router":true,"default-openeds":['1'],"default-active":_vm.currentRoutePath,"background-color":"#4c5256","text-color":"#fff","active-text-color":"#ffffff"},on:{"close":_vm.preventSCBSubmenuClosing}},[_c('el-menu-item-group',{attrs:{"title":"SCB Admin Menu"}},[_c('el-menu-item',{attrs:{"index":"/company","route":{ name: 'CompanyList' }}},[_vm._v("จัดการรายชื่อบริษัท")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/admins","route":{ name: 'AdminAccountList' }}},[_vm._v("จัดการบัญชีผู้ใช้งาน")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/qr-verify"},on:{"click":_vm.showQRModal}},[_vm._v("ตรวจสอบ QR")])],1)],1):_vm._e(),_vm._v(" "),(_vm.shouldShowCompanyMenu)?_c('el-menu',{ref:"companyMainMenu",staticClass:"company-main-menu",attrs:{"router":true,"default-openeds":['1'],"default-active":_vm.currentCompanyRoutePath,"background-color":"#4c5256","text-color":"#fff","active-text-color":"#ffffff"},on:{"close":_vm.preventCompanySubmenuClosing}},[_c('el-menu-item',{staticClass:"company-back-btn",attrs:{"index":"/company/list","route":{ name: 'CompanyList' }}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" ย้อนกลับ\n          ")]),_vm._v(" "),_c('el-submenu',{attrs:{"index":"1"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"company-profile",on:{"click":function($event){$event.preventDefault();return _vm.viewCompanyDetail.apply(null, arguments)}}},[(_vm.currentCompany.logo)?_c('div',{staticClass:"company-logo-holder"},[_c('div',{staticClass:"company-logo",style:({
                    'background-image': ("url('" + (_vm.currentCompany.logo) + "')"),
                  })})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"company-name"},[_vm._v(_vm._s(_vm.currentCompany.name))])])]),_vm._v(" "),_c('el-menu-item-group',{attrs:{"title":"Company Menu"}},[(_vm.isAdminRole)?_c('el-menu-item',{attrs:{"index":("/company/" + (_vm.currentCompany.id) + "/edit"),"route":{ name: 'CompanyEdit', params: { companyId: _vm.currentCompany.id }}}},[_vm._v("\n                แก้ไขรายละเอียดบริษัท\n              ")]):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":("/company/" + (_vm.currentCompany.id) + "/profile"),"route":{ name: 'CompanyProfileList', params: { companyId: _vm.currentCompany.id } }}},[_vm._v("\n                "+_vm._s(_vm.isViewerRole ? 'ดู' : 'จัดการ')+"ข้อมูลบริษัทสำหรับรับชำระ\n              ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":("/company/" + (_vm.currentCompany.id) + "/admin"),"route":{ name: 'CompanyAdminList', params: { companyId: _vm.currentCompany.id } }}},[_vm._v("\n                จัดการบัญชีผู้ดูแลบริษัท\n              ")])],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.shouldShowBillerMenu)?_c('el-menu',{ref:"billerMainMenu",staticClass:"biller-main-menu company-main-menu",attrs:{"router":true,"default-openeds":['1'],"default-active":_vm.currentBillerRoutePath,"background-color":"#4c5256","text-color":"#fff","active-text-color":"#ffffff"},on:{"close":_vm.preventBillerSubmenuClosing}},[_c('el-submenu',{attrs:{"index":"1"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"company-profile",on:{"click":function($event){$event.preventDefault();return _vm.viewBillerCompanyDetail.apply(null, arguments)}}},[(_vm.currentBiller.logo)?_c('div',{staticClass:"company-logo-holder"},[_c('div',{staticClass:"company-logo",style:({
                    'background-image': ("url('" + (_vm.currentBiller.logo) + "')"),
                  })})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"company-name"},[_vm._v(_vm._s(_vm.currentBiller.name))])])]),_vm._v(" "),_c('el-menu-item-group',{attrs:{"title":"Company Menu"}},[(_vm.isBillerAdmin)?_c('el-menu-item',{attrs:{"index":"/company/edit","route":{ name: 'BillerCompanyEdit' }}},[_vm._v("\n                แก้ไขรายละเอียดบริษัท\n              ")]):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/profiles","route":{ name: 'BillerProfileList' }}},[_vm._v("\n                จัดการข้อมูลบริษัทสำหรับรับชำระ\n              ")]),_vm._v(" "),(_vm.isBillerAdmin)?_c('el-menu-item',{attrs:{"index":"/users","route":{ name: 'BillerUserList' }}},[_vm._v("\n                จัดการบัญชีผู้ดูแลบริษัท\n              ")]):_vm._e()],1)],2)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-main',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isContentLoading),expression:"isContentLoading",modifiers:{"body":true}}],staticClass:"main-content",attrs:{"element-loading-text":_vm.$t('Loading...')}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1),_vm._v(" "),_c('el-dialog',{staticClass:"qr-verify-dialog",attrs:{"title":"ตรวจสอบ QR Code","fullscreen":true,"visible":_vm.isShowingQRModal},on:{"update:visible":function($event){_vm.isShowingQRModal=$event}}},[(!_vm.isQRImporting)?_c('div',{staticClass:"qr-uploader-holder"},[(_vm.qrVerificationResult === null)?_c('el-upload',{staticClass:"qr-uploader",attrs:{"action":"","drag":"","show-file-list":false,"before-upload":_vm.handleBeforeQRUpload,"http-request":_vm.handleQRImport}},[_c('i',{staticClass:"icon el-icon-document"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n                เลือกไฟล์รูป QR Code ที่ต้องการ หรือลากมาวางที่นี่เพื่อเริ่มนำเข้าข้อมูล (นามสกุล jpg, png, gif)"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('span',{staticClass:"el-button el-button--primary"},[_vm._v("เลือกไฟล์")])])])]):_vm._e(),_vm._v(" "),(_vm.qrVerificationResult !== null)?_c('el-row',{staticClass:"qr-verification-result"},[_c('el-col',{attrs:{"span":12}},[(_vm.qrFile)?_c('img',{staticClass:"qr-image",attrs:{"src":_vm.qrFile}}):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"icon-holder"},[(_vm.qrVerificationResult.correctness === true)?_c('i',{staticClass:"el-icon-success icon success"}):_vm._e(),_vm._v(" "),(_vm.qrVerificationResult.correctness === false)?_c('i',{staticClass:"el-icon-error icon error"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"result-text"},[(_vm.qrVerificationResult.correctness === true)?_c('div',{staticClass:"success"},[_c('h3',{staticStyle:{"line-height":"1.2em"}},[_vm._v("QR Code มีรูปแบบตรงตาม"+_vm._s(_vm.qrVerificationResult.format))]),_vm._v(" "),_c('p',{staticClass:"result-code"},[_c('code',{domProps:{"innerHTML":_vm._s(_vm.qrInfoFormat)}})])]):_vm._e(),_vm._v(" "),(_vm.qrVerificationResult.correctness === false)?_c('div',{staticClass:"error"},[_c('h3',{staticStyle:{"line-height":"1.2em"}},[_vm._v("QR Code มีข้อผิดพลาด ("+_vm._s(_vm.qrVerificationResult.format)+")")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.qrVerificationResult.incorrectReason)}}),_vm._v(" "),_c('p',{staticClass:"result-code"},[_c('code',{domProps:{"innerHTML":_vm._s(_vm.qrInfoFormat)}})])]):_vm._e(),_vm._v(" "),_c('el-button',{staticClass:"reset-qr-btn",attrs:{"type":"primary"},on:{"click":_vm.resetQR}},[_c('i',{staticClass:"el-icon-refresh"}),_vm._v("\n                    เริ่มใหม่\n                  ")])],1)])],1):_vm._e()],1):_vm._e()])],1)],1),_vm._v(" "),_c('el-footer',{staticClass:"main-footer",attrs:{"height":"50"}},[_c('div',{staticClass:"container"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8dd384_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__(1023);
function injectStyle (ssrContext) {
  __webpack_require__(1022)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f8dd384"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f8dd384_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1023:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"body":true}}],staticClass:"login-container",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"login-page",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"splash-holder",attrs:{"span":12}},[_c('div',{staticClass:"splash"},[_c('h1',{staticClass:"title"},[_vm._v("BP Payin Slip")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm._f("translate")(_vm.appName)))])]),_vm._v(" "),_c('div',{staticClass:"footer"})]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-row',{attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{staticClass:"form-holder",attrs:{"span":12,"offset":3}},[_c('div',{staticClass:"login-form-holder"},[_c('h2',[_vm._v("เข้าสู่ระบบ")]),_vm._v(" "),_c('el-form',{ref:"loginModel",staticClass:"login-form",attrs:{"model":_vm.loginModel,"rules":_vm.loginRules,"label-width":"120px","label-position":"top"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('loginModel')}}},[_c('el-form-item',{attrs:{"label":_vm.$t('E-mail'),"prop":"email"}},[_c('el-input',{attrs:{"id":"loginModel-email","placeholder":"กรอกอีเมลของท่าน","autofocus":true,"suffix-icon":"el-icon-message"},model:{value:(_vm.loginModel.email),callback:function ($$v) {_vm.$set(_vm.loginModel, "email", $$v)},expression:"loginModel.email"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":_vm.$t('Password'),"prop":"password"}},[_c('el-input',{attrs:{"id":"loginModel-password","placeholder":"กรอกรหัสผ่านของท่าน","type":"password","suffix-icon":"el-icon-star-off"},model:{value:(_vm.loginModel.password),callback:function ($$v) {_vm.$set(_vm.loginModel, "password", $$v)},expression:"loginModel.password"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","id":"loginModel-loginButton","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Login')))]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.$t('Forgot your password?'))+" "),_c('el-button',{staticClass:"forgot-password-btn",attrs:{"type":"text"},on:{"click":function($event){$event.preventDefault();return _vm.goToForgotPassword.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Recover Password now!')))])],1),_vm._v(" "),(_vm.tenantId === 'scb')?_c('p',[_c('a',{attrs:{"href":"/static/bppayin-admin-user-manual-v2.1.pdf","target":"_blank"}},[_vm._v("ดาวน์โหลดคู่มือการใช้งาน")])]):_c('p',[_c('a',{attrs:{"href":"/static/bppayin-biller-user-manual-v2.3.pdf","target":"_blank"}},[_vm._v("ดาวน์โหลดคู่มือการใช้งาน")])])],1)],1)],1)])],1)],1)],1),_vm._v(" "),(_vm.showNotice)?_c('div',{staticClass:"notice-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeNotice.apply(null, arguments)}}},[_c('div',{staticClass:"notice-content",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.closeNotice.apply(null, arguments)}}},[_c('img',{staticClass:"notice-image",attrs:{"src":__webpack_require__(1024),"alt":"ประกาศ"}}),_vm._v(" "),_c('el-button',{staticClass:"notice-button",attrs:{"type":"primary"},on:{"click":_vm.closeNotice}},[_vm._v("เข้าสู่เว็บไซต์")])],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notice_system_migrate.b90f3cb.jpg";

/***/ }),

/***/ 1025:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_700a3adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__ = __webpack_require__(1027);
function injectStyle (ssrContext) {
  __webpack_require__(1026)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_700a3adc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"logout-page"},[_c('el-row',{staticClass:"logout-panel-holder",attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{attrs:{"span":24}},[_c('h3',[_vm._v("กำลังออกจากระบบ...")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80fd4e9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_vue__ = __webpack_require__(1030);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80fd4e9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1029:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1030:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"body":true}}],staticClass:"reset-password-page",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{attrs:{"span":8}},[_c('h2',[_vm._v("เปลี่ยนรหัสผ่านใหม่")]),_vm._v(" "),_c('el-form',{ref:"resetPasswordModel",staticClass:"reset-password-form forgot-password-form-holder",attrs:{"model":_vm.resetPasswordModel,"rules":_vm.rules,"label-width":"120px","label-position":"top"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('resetPasswordModel')}}},[_c('el-form-item',{attrs:{"label":"รหัสผ่านใหม่","prop":"password"}},[_c('el-input',{attrs:{"id":"resetPasswordModel-password","placeholder":"กรอกรหัสผ่านของท่าน","type":"password","autofocus":true,"suffix-icon":"el-icon-star-off"},model:{value:(_vm.resetPasswordModel.password),callback:function ($$v) {_vm.$set(_vm.resetPasswordModel, "password", $$v)},expression:"resetPasswordModel.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"ยืนยันรหัสผ่านใหม่","prop":"passwordRepeat"}},[_c('el-input',{attrs:{"id":"resetPasswordModel-password-repeat","placeholder":"กรอกรหัสผ่านของท่านอีกครั้ง","type":"password","suffix-icon":"el-icon-star-off"},model:{value:(_vm.resetPasswordModel.passwordRepeat),callback:function ($$v) {_vm.$set(_vm.resetPasswordModel, "passwordRepeat", $$v)},expression:"resetPasswordModel.passwordRepeat"}})],1),_vm._v(" "),_c('div',{staticClass:"reset-password-instruction"},[_c('ul',[_c('li',[_vm._v("ใช้อักษรอังกฤษเท่านั้น ต้องมี อย่างน้อย")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวเลข")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวพิมพ์ใหญ่")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวพิมพ์เล็ก")]),_vm._v(" "),_c('li',[_vm._v("ความยาว 8 ตัวขึ้นไป")]),_vm._v(" "),_c('li',[_vm._v("อักขระพิเศษใส่ได้ยกเว้น space")])])]),_vm._v(" "),_c('el-form-item',[(!_vm.needResetPwd)?_c('el-button',{staticClass:"cancel-reset-password-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Cancel')))]):_vm._e(),_vm._v(" "),_c('el-button',{class:{
              'right': !_vm.needResetPwd,
            },attrs:{"type":"primary","id":"resetPasswordModel-submitButton","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Confirm')))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1031:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_with_token_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229cc30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_with_token_vue__ = __webpack_require__(1033);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-229cc30a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reset_password_with_token_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_229cc30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reset_password_with_token_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1032:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1033:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"body":true}}],staticClass:"login-container",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"login-page",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"splash-holder",attrs:{"span":12}},[_c('div',{staticClass:"splash"},[_c('h1',{staticClass:"title"},[_vm._v("BP Payin Slip")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm._f("translate")(_vm.appName)))])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('code',{staticClass:"app-env"},[_vm._v("\n          env: "+_vm._s(_vm.$scbAppInfo.env)),_c('br'),_vm._v("\n          mode: "+_vm._s(_vm.$scbAppInfo.mode)),_c('br'),_vm._v("\n          build: "+_vm._s(_vm.$scbAppInfo.build)),_c('br'),_vm._v("\n          version: "+_vm._s(_vm.$scbAppInfo.version))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-row',{attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{staticClass:"form-holder",attrs:{"span":12,"offset":3}},[_c('div',{staticClass:"forgot-password-form-holder"},[_c('h2',[_vm._v("เปลี่ยนรหัสผ่านใหม่")]),_vm._v(" "),_c('el-form',{ref:"resetPasswordModel",staticClass:"reset-password-form",attrs:{"model":_vm.resetPasswordModel,"rules":_vm.rules,"label-width":"120px","label-position":"top"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('resetPasswordModel')}}},[_c('el-form-item',{attrs:{"label":"รหัสผ่านใหม่","prop":"password"}},[_c('el-input',{attrs:{"id":"resetPasswordModel-password","placeholder":"กรอกรหัสผ่านของท่าน","type":"password","autofocus":true,"suffix-icon":"el-icon-star-off"},model:{value:(_vm.resetPasswordModel.password),callback:function ($$v) {_vm.$set(_vm.resetPasswordModel, "password", $$v)},expression:"resetPasswordModel.password"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"ยืนยันรหัสผ่านใหม่","prop":"passwordRepeat"}},[_c('el-input',{attrs:{"id":"resetPasswordModel-password-repeat","placeholder":"กรอกรหัสผ่านของท่านอีกครั้ง","type":"password","suffix-icon":"el-icon-star-off"},model:{value:(_vm.resetPasswordModel.passwordRepeat),callback:function ($$v) {_vm.$set(_vm.resetPasswordModel, "passwordRepeat", $$v)},expression:"resetPasswordModel.passwordRepeat"}})],1),_vm._v(" "),_c('div',{staticClass:"reset-password-instruction"},[_c('ul',[_c('li',[_vm._v("ใช้อักษรอังกฤษเท่านั้น ต้องมี อย่างน้อย")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวเลข")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวพิมพ์ใหญ่")]),_vm._v(" "),_c('li',[_vm._v("1 ตัวพิมพ์เล็ก")]),_vm._v(" "),_c('li',[_vm._v("ความยาว 8 ตัวขึ้นไป")]),_vm._v(" "),_c('li',[_vm._v("อักขระพิเศษใส่ได้ยกเว้น space")])])]),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"cancel-reset-password-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"resetPasswordModel-submitButton","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Confirm')))])],1)],1)],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5be167c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__ = __webpack_require__(1036);
function injectStyle (ssrContext) {
  __webpack_require__(1035)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e5be167c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5be167c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1036:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',{directives:[{name:"loading",rawName:"v-loading.body",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"body":true}}],staticClass:"login-container",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"login-page",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"splash-holder",attrs:{"span":12}},[_c('div',{staticClass:"splash"},[_c('h1',{staticClass:"title"},[_vm._v("BP Payin Slip")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm._f("translate")(_vm.appName)))])]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('code',{staticClass:"app-env"},[_vm._v("\n          env: "+_vm._s(_vm.$scbAppInfo.env)),_c('br'),_vm._v("\n          mode: "+_vm._s(_vm.$scbAppInfo.mode)),_c('br'),_vm._v("\n          build: "+_vm._s(_vm.$scbAppInfo.build)),_c('br'),_vm._v("\n          version: "+_vm._s(_vm.$scbAppInfo.version))])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-row',{attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{staticClass:"form-holder",attrs:{"span":16,"offset":3}},[_c('div',{staticClass:"forgot-password-form-holder"},[_c('h2',[_vm._v("ลืมรหัสผ่าน")]),_vm._v(" "),(_vm.feedbackMessage)?_c('p',[_vm._v("\n              "+_vm._s(_vm.feedbackMessage)+"\n              "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('el-button',{staticClass:"go-to-login-btn",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.goToLogin.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Login')))])],1):_vm._e(),_vm._v(" "),(!_vm.feedbackMessage)?_c('el-form',{ref:"forgotPasswordModel",staticClass:"forgot-password-form",attrs:{"model":_vm.forgotPasswordModel,"rules":_vm.forgotPasswordRules,"label-width":"120px","label-position":"top"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForgotPasswordForm('forgotPasswordModel')}}},[_c('el-form-item',{attrs:{"label":_vm.$t('E-mail'),"prop":"email"}},[_c('el-input',{attrs:{"id":"forgotPasswordModel-email","placeholder":"กรอกอีเมลของท่าน","autofocus":true,"suffix-icon":"el-icon-message"},model:{value:(_vm.forgotPasswordModel.email),callback:function ($$v) {_vm.$set(_vm.forgotPasswordModel, "email", $$v)},expression:"forgotPasswordModel.email"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"cancel-forgot-password-btn",attrs:{"type":"primary","plain":""},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('Cancel')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"forgotPasswordModel-loginButton","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Submit')))])],1)],1):_vm._e()],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1037:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_account_form_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0937b331_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_account_form_vue__ = __webpack_require__(1039);
function injectStyle (ssrContext) {
  __webpack_require__(1038)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_account_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0937b331_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_account_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"admin-account-form page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.backToAdminAccountList.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชีผู้ดูแล' : 'เพิ่มบัญชีผู้ดูแล'))])],1)],1),_vm._v(" "),_c('el-form',{ref:"adminForm",staticClass:"admin-form",attrs:{"model":_vm.adminForm,"rules":_vm.adminFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('adminForm')}}},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"อีเมลผู้ดูแล","prop":"email"}},[_c('el-input',{attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.email","placeholder":"กรอกอีเมลผู้ดูแล"},model:{value:(_vm.adminForm.email),callback:function ($$v) {_vm.$set(_vm.adminForm, "email", $$v)},expression:"adminForm.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ชื่อผู้ดูแล","prop":"name"}},[_c('el-input',{attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.name","placeholder":"กรอกชื่อผู้ดูแล"},model:{value:(_vm.adminForm.name),callback:function ($$v) {_vm.$set(_vm.adminForm, "name", $$v)},expression:"adminForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"รหัสพนักงานของธนาคาร","prop":"scb_employee_id"}},[_c('el-input',{ref:"adminForm.scb_employee_id",attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.scb_employee_id","placeholder":"กรอกรหัสพนักงานของธนาคาร"},nativeOn:{"input":function($event){return _vm.handleInput($event, 'adminForm.scb_employee_id', 'scb_employee_id')}},model:{value:(_vm.adminForm.scb_employee_id),callback:function ($$v) {_vm.$set(_vm.adminForm, "scb_employee_id", $$v)},expression:"adminForm.scb_employee_id"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"หมายเลขโทรศัพท์","prop":"tel"}},[_c('el-input',{attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.tel","placeholder":"กรอกหมายเลขโทรศัพท์"},model:{value:(_vm.adminForm.tel),callback:function ($$v) {_vm.$set(_vm.adminForm, "tel", $$v)},expression:"adminForm.tel"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"หน้าที่ผู้ดูแล","prop":"role"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isViewerRole},model:{value:(_vm.adminForm.role),callback:function ($$v) {_vm.$set(_vm.adminForm, "role", $$v)},expression:"adminForm.role"}},_vm._l((_vm.roleList),function(role){return _c('el-radio',{key:role.value,attrs:{"label":role.value}},[_vm._v(_vm._s(role.label))])}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"สถานะบัญชี","prop":"status"}},[_c('el-checkbox',{staticClass:"status-holder",class:{hide: _vm.isViewerRole},attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.status"},model:{value:(_vm.adminForm.status),callback:function ($$v) {_vm.$set(_vm.adminForm, "status", $$v)},expression:"adminForm.status"}},[_vm._v("สถานะการใช้งาน (Flag = Enable, Not Flag = Disable/Blocked)")]),_vm._v(" "),(_vm.isViewerRole)?_c('div',{staticClass:"user-status"},[_c('el-tag',{attrs:{"type":_vm.statusTypeFormatter(_vm.adminForm.status),"close-transition":""}},[_vm._v(_vm._s(_vm.statusFormatter(_vm.adminForm.status)))])],1):_vm._e(),_vm._v(" "),(_vm.isBlocked && _vm.isViewerRole)?_c('div',{staticClass:"blocked-status-section"},[_c('el-button',{attrs:{"plain":"","type":"primary","id":"unblock-button"},on:{"click":_vm.unblockUser}},[_vm._v("ปลดล็อคบัญชีผู้ดูแลบริษัท")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('el-form-item',{attrs:{"label":"รายละเอียดผู้ดูแล","prop":"description"}},[_c('el-input',{attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.description","placeholder":"กรอกรายละเอียดผู้ดูแล"},model:{value:(_vm.adminForm.description),callback:function ($$v) {_vm.$set(_vm.adminForm, "description", $$v)},expression:"adminForm.description"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"adminForm.cancelButton"},on:{"click":_vm.backToAdminAccountList}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),(!_vm.isViewerRole)?_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated)?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"adminForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"adminForm.submitButton","native-type":"submit"}},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชี' : 'สร้างบัญชี'))])],1):_vm._e()],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1040:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_account_list_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a3e1fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_account_list_vue__ = __webpack_require__(1042);
function injectStyle (ssrContext) {
  __webpack_require__(1041)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_account_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2a3e1fc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_account_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1042:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-account-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":7}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายชื่อผู้ใช้งาน")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"ค้นหารายชื่อผู้ใช้งาน (อีเมล, ชื่อ หรือ รหัสพนักงาน)"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search"},slot:"append"})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[(!_vm.isViewerRole)?_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createAdminAccount.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v("เพิ่มผู้ใช้งาน")]),_vm._v(" "),_c('i',{staticClass:"el-icon-plus el-icon-right"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"admin-list-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.adminListData,"default-sort":{prop: 'email', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"email","label":"อีเมล","sortable":"","class-name":"no-wrap","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","sortable":"","class-name":"no-wrap","min-width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"โทรศัพท์","sortable":"","formatter":_vm.telFormatter,"width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"scb_employee_id","label":"รหัสพนักงาน","sortable":"","width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"role","label":"หน้าที่","sortable":"","formatter":_vm.roleFormatter,"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"สถานะ","width":"100","formatter":_vm.statusFormatter},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.statusTypeFormatter(scope.row),"close-transition":""}},[_vm._v(_vm._s(_vm.statusFormatter(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"รายละเอียด","min-width":"150","class-name":"desc-col no-wrap"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleEdit(scope.$index, scope.row)}}},[_vm._v("แก้ไข")])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unauthorized__ = __webpack_require__(1044);


/* harmony default export */ __webpack_exports__["a"] = ({
  unauthorized: __WEBPACK_IMPORTED_MODULE_0__unauthorized__["a" /* default */]
});

/***/ }),

/***/ 1044:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unauthorized_vue__ = __webpack_require__(476);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61440c7d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unauthorized_vue__ = __webpack_require__(1046);
function injectStyle (ssrContext) {
  __webpack_require__(1045)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unauthorized_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61440c7d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_unauthorized_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1046:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('el-row',{staticClass:"unauthorized-error-page",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"splash-holder",attrs:{"xs":24,"sm":16}},[_c('h1',[_vm._v("คุณไม่ได้รับอนุญาตให้เข้าถึงข้อมูลของระบบนี้")]),_vm._v(" "),_c('h3',[_vm._v("กรุณาเข้าสู่เว็ปไซต์ที่ตรงกับบัญชีผู้ใช้ของคุณเพื่อใช้งานระบบ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1047:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_auth__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_company__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(153);





/* const defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ?
  process.env.DEFAULT_ROUTE_NAME : process.env.DEFAULT_BILLER_ROUTE_NAME; */

var requireAdmin = function requireAdmin(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isAuthenticated) {
    return next({ name: 'Login' });
  } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
    return next({ name: 'ResetPassword' });
  } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.isBiller) {
    return next({ name: 'Logout' });
  }
  return next();
};

var routes = [{
  path: '/',
  name: 'AdminUserLoadInfo',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].adminLoadInfo,
  beforeEnter: requireAdmin,
  meta: {
    title: 'กำลังโหลด...'
  }
},
// Company
{
  path: '/company',
  name: 'CompanyList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyList,
  beforeEnter: requireAdmin,
  meta: {
    title: 'รายชื่อบริษัท'
  }
}, {
  path: '/company/create',
  name: 'CompanyCreate',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'เพิ่มรายละเอียดบริษัทใหม่'
  }
}, {
  path: '/company/:companyId',
  props: true,
  name: 'CompanyDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyDetail,
  beforeEnter: requireAdmin,
  meta: {
    title: 'รายละเอียดบริษัท'
  }
}, {
  path: '/company/:companyId/edit',
  props: true,
  name: 'CompanyEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'แก้ไขรายละเอียดบริษัท'
  }
},
// Company Admin
{
  path: '/company/:companyId/admin',
  props: true,
  name: 'CompanyAdminList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyAdminList,
  beforeEnter: requireAdmin,
  meta: {
    title: 'รายชื่อบัญชีผู้ดูแลบริษัท'
  }
}, {
  path: '/company/:companyId/admin/create',
  props: true,
  name: 'CompanyAdminCreate',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyAdminForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'เพิ่มบัญชีผู้ดูแลบริษัท'
  }
}, {
  path: '/company/:companyId/admin/:userId',
  props: true,
  name: 'CompanyAdminEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyAdminForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'แก้ไขบัญชีผู้ดูแลบริษัท'
  }
},
// Company Profiles
{
  path: '/company/:companyId/profile/:profileId/edit',
  props: true,
  name: 'CompanyProfileEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyProfileForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'แก้ไขข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/company/:companyId/profile/:profileId/view',
  props: true,
  name: 'CompanyProfileDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyProfileDetail,
  beforeEnter: requireAdmin,
  meta: {
    title: 'ข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/company/:companyId/profile/create',
  props: true,
  name: 'CompanyProfileCreate',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyProfileForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'เพิ่มข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/company/:companyId/profile',
  props: true,
  name: 'CompanyProfileList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_company__["a" /* default */].companyProfileList,
  beforeEnter: requireAdmin,
  meta: {
    title: 'รายชื่อข้อมูลบริษัทสำหรับรับชำระ'
  }
},
// Admin Users
{
  path: '/admins',
  name: 'AdminAccountList',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_auth__["a" /* default */].adminAccountList,
  beforeEnter: requireAdmin,
  meta: {
    title: 'รายชื่อบัญชีผู้ใช้งาน'
  }
}, {
  path: '/admins/create',
  name: 'AdminAccountCreate',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_auth__["a" /* default */].adminAccountForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'เพิ่มบัญชีผู้ใช้งาน'
  }
}, {
  path: '/admins/:adminId',
  props: true,
  name: 'AdminAccountEdit',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_auth__["a" /* default */].adminAccountForm,
  beforeEnter: requireAdmin,
  meta: {
    title: 'แก้ไขบัญชีผู้ใช้งาน'
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 1048:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__admin_load_info__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__company_list__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__company_detail__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__company_form__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__company_admin_list__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__company_admin_form__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__company_profile_list__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__company_profile_form__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__company_profile_detail__ = __webpack_require__(1075);










/* harmony default export */ __webpack_exports__["a"] = ({
  adminLoadInfo: __WEBPACK_IMPORTED_MODULE_0__admin_load_info__["a" /* default */],
  companyList: __WEBPACK_IMPORTED_MODULE_1__company_list__["a" /* default */],
  companyDetail: __WEBPACK_IMPORTED_MODULE_2__company_detail__["a" /* default */],
  companyForm: __WEBPACK_IMPORTED_MODULE_3__company_form__["a" /* default */],
  companyAdminList: __WEBPACK_IMPORTED_MODULE_4__company_admin_list__["a" /* default */],
  companyAdminForm: __WEBPACK_IMPORTED_MODULE_5__company_admin_form__["a" /* default */],
  companyProfileList: __WEBPACK_IMPORTED_MODULE_6__company_profile_list__["a" /* default */],
  companyProfileForm: __WEBPACK_IMPORTED_MODULE_7__company_profile_form__["a" /* default */],
  companyProfileDetail: __WEBPACK_IMPORTED_MODULE_8__company_profile_detail__["a" /* default */]
});

/***/ }),

/***/ 1049:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_load_info_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299227e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_load_info_vue__ = __webpack_require__(1051);
function injectStyle (ssrContext) {
  __webpack_require__(1050)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_admin_load_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299227e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_admin_load_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1051:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isLoading),expression:"isLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"user-load-info",attrs:{"element-loading-text":"กำลังโหลดข้อมูล..."}},[_c('el-row',{staticClass:"reload-panel-holder",attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{attrs:{"span":24}},[(_vm.shouldReloadData && !_vm.isLoading)?_c('div',{staticClass:"reload-panel"},[_c('h3',[_vm._v("ระบบไม่สามารถโหลดข้อมูลของบริษัทได้"),_c('br'),_vm._v("กรุณาลองใหม่อีกครั้ง")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-refresh"},on:{"click":_vm.reloadInfo}},[_vm._v("โหลดข้อมูลใหม่")])],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__ = __webpack_require__(478);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d33f3284_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__ = __webpack_require__(1055);
function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d33f3284_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1055:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":6}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายชื่อบริษัท")])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"ค้นหารายชื่อบริษัท"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('el-button',{attrs:{"slot":"append","icon":""},slot:"append"})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.searchCompany.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v("ค้นหา")]),_vm._v(" "),_c('i',{})])],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[(!_vm.isViewerRole)?_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createCompany.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v("เพิ่มรายชื่อบริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-plus el-icon-right"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"company-list-table"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isSortingData),expression:"isSortingData"}],staticStyle:{"width":"100%"},attrs:{"data":_vm.companyList,"default-sort":{prop: 'name', order: 'ascending'}},on:{"sort-change":_vm.dataTableSorted}},[_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อบริษัท","min-width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"profiles_count","label":"จำนวนบริษัทรับชำระ","header-align":"center","align":"center","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address","label":"ที่อยู่บริษัท","class-name":"address-col no-wrap","min-width":"300","formatter":_vm.addressFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"address.tel","label":"โทรศัพท์","formatter":_vm.telFormatter,"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleManage(scope.$index, scope.row)}}},[_vm._v("\n            "+_vm._s(_vm.isViewerRole ? 'ดูข้อมูล' : 'จัดการ')+"\n          ")])]}}])})],1),_vm._v(" "),_c('el-pagination',{attrs:{"layout":"prev, pager, next, jumper","background":"","current-page":_vm.companyListDataCurrentPage,"page-size":_vm.query.limit},on:{"update:currentPage":function($event){_vm.companyListDataCurrentPage=$event},"update:current-page":function($event){_vm.companyListDataCurrentPage=$event}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_detail_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bcea23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_detail_vue__ = __webpack_require__(1058);
function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17bcea23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1057:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.company)?_c('div',{staticClass:"company-detail-page page-content"},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายละเอียดบริษัท")])])],1),_vm._v(" "),_c('div',{staticClass:"company-detail-info"},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("รายละเอียดบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            ชื่อบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.name))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            เลขประจำตัวผู้เสียภาษี\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            เว็ปไซต์สำหรับจัดการของบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.taxIdFormatter(_vm.company.tax_id)))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('code',{staticClass:"slug-host-code"},[_vm._v(_vm._s((_vm.baseHost + "/" + (_vm.company.slug))))])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n            โลโก้บริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[(_vm.company.logo)?_c('img',{staticClass:"company-logo-preview",attrs:{"src":_vm.company.logo,"alt":_vm.company.name}}):_vm._e()])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่หลักของบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n            ที่อยู่\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_vm._v(_vm._s(_vm.company.address.line_1))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            อำเภอ/เขต\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            ตำบล/แขวง\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.city))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.district))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            จังหวัด\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            รหัสไปรษณีย์\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.province))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.postal_code))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            โทรศัพท์\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            โทรสาร\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.telFormatter(_vm.company.address.tel)))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.faxFormatter(_vm.company.address.fax)))])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1059:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111f5646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__ = __webpack_require__(1062);
function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_111f5646_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1061:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xregexp__);

/* eslint no-param-reassign: 0 */
/* eslint quote-props: 0 */
/* eslint prefer-template: 0 */


/* harmony default export */ __webpack_exports__["a"] = ({
  // http://locutus.io/php/pcre/preg_quote/
  preg_quote: function preg_quote(str, delimiter) {
    return (str + '').replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\' + (delimiter || '') + '-]', 'g'), '\\$&');
  },
  str_slug: function str_slug(title, separator) {
    if (!separator) separator = '-';
    title = this.ascii(title);
    // convert all dashes/underscores into separator
    var flip = separator === '-' ? '_' : '-';
    var pqflip = this.preg_quote(flip);
    var pqsep = this.preg_quote(separator);
    return title.replace(new __WEBPACK_IMPORTED_MODULE_1_xregexp___default.a('[' + pqflip + ']+', 'ug'), separator).toLowerCase()
    // Remove all characters that are not the separator, letters, numbers, or whitespace.
    .replace(new __WEBPACK_IMPORTED_MODULE_1_xregexp___default.a('[^' + pqsep + '\\p{L}\\p{N}\\s]+', 'ug'), '')
    // Replace all separator characters and whitespace by a single separator
    .replace(new __WEBPACK_IMPORTED_MODULE_1_xregexp___default.a('[' + pqsep + '\\s]+', 'ug'), separator)
    // trim by separator and whitespace
    .replace(new __WEBPACK_IMPORTED_MODULE_1_xregexp___default.a('^[' + pqsep + '\\s]', 'ug'), '').replace(new __WEBPACK_IMPORTED_MODULE_1_xregexp___default.a('[' + pqsep + '\\s]$', 'ug'), '').trim();
  },
  ascii: function ascii(value) {
    var charArray = this.charArray();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(charArray).forEach(function (key) {
      var val = charArray[key];
      value = value.replace(val, key);
    });
    return value.replace(/(?:[\0-\x1F\x7F-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/);
  },
  charArray: function charArray() {
    return {
      '0': ['°', '₀', '۰'],
      '1': ['¹', '₁', '۱'],
      '2': ['²', '₂', '۲'],
      '3': ['³', '₃', '۳'],
      '4': ['⁴', '₄', '۴', '٤'],
      '5': ['⁵', '₅', '۵', '٥'],
      '6': ['⁶', '₆', '۶', '٦'],
      '7': ['⁷', '₇', '۷'],
      '8': ['⁸', '₈', '۸'],
      '9': ['⁹', '₉', '۹'],
      'a': ['à', 'á', 'ả', 'ã', 'ạ', 'ă', 'ắ', 'ằ', 'ẳ', 'ẵ', 'ặ', 'â', 'ấ', 'ầ', 'ẩ', 'ẫ', 'ậ', 'ā', 'ą', 'å', 'α', 'ά', 'ἀ', 'ἁ', 'ἂ', 'ἃ', 'ἄ', 'ἅ', 'ἆ', 'ἇ', 'ᾀ', 'ᾁ', 'ᾂ', 'ᾃ', 'ᾄ', 'ᾅ', 'ᾆ', 'ᾇ', 'ὰ', 'ά', 'ᾰ', 'ᾱ', 'ᾲ', 'ᾳ', 'ᾴ', 'ᾶ', 'ᾷ', 'а', 'أ', 'အ', 'ာ', 'ါ', 'ǻ', 'ǎ', 'ª', 'ა', 'अ', 'ا'],
      'b': ['б', 'β', 'Ъ', 'Ь', 'ب', 'ဗ', 'ბ'],
      'c': ['ç', 'ć', 'č', 'ĉ', 'ċ'],
      'd': ['ď', 'ð', 'đ', 'ƌ', 'ȡ', 'ɖ', 'ɗ', 'ᵭ', 'ᶁ', 'ᶑ', 'д', 'δ', 'د', 'ض', 'ဍ', 'ဒ', 'დ'],
      'e': ['é', 'è', 'ẻ', 'ẽ', 'ẹ', 'ê', 'ế', 'ề', 'ể', 'ễ', 'ệ', 'ë', 'ē', 'ę', 'ě', 'ĕ', 'ė', 'ε', 'έ', 'ἐ', 'ἑ', 'ἒ', 'ἓ', 'ἔ', 'ἕ', 'ὲ', 'έ', 'е', 'ё', 'э', 'є', 'ə', 'ဧ', 'ေ', 'ဲ', 'ე', 'ए', 'إ', 'ئ'],
      'f': ['ф', 'φ', 'ف', 'ƒ', 'ფ'],
      'g': ['ĝ', 'ğ', 'ġ', 'ģ', 'г', 'ґ', 'γ', 'ဂ', 'გ', 'گ'],
      'h': ['ĥ', 'ħ', 'η', 'ή', 'ح', 'ه', 'ဟ', 'ှ', 'ჰ'],
      'i': ['í', 'ì', 'ỉ', 'ĩ', 'ị', 'î', 'ï', 'ī', 'ĭ', 'į', 'ı', 'ι', 'ί', 'ϊ', 'ΐ', 'ἰ', 'ἱ', 'ἲ', 'ἳ', 'ἴ', 'ἵ', 'ἶ', 'ἷ', 'ὶ', 'ί', 'ῐ', 'ῑ', 'ῒ', 'ΐ', 'ῖ', 'ῗ', 'і', 'ї', 'и', 'ဣ', 'ိ', 'ီ', 'ည်', 'ǐ', 'ი', 'इ'],
      'j': ['ĵ', 'ј', 'Ј', 'ჯ', 'ج'],
      'k': ['ķ', 'ĸ', 'к', 'κ', 'Ķ', 'ق', 'ك', 'က', 'კ', 'ქ', 'ک'],
      'l': ['ł', 'ľ', 'ĺ', 'ļ', 'ŀ', 'л', 'λ', 'ل', 'လ', 'ლ'],
      'm': ['м', 'μ', 'م', 'မ', 'მ'],
      'n': ['ñ', 'ń', 'ň', 'ņ', 'ŉ', 'ŋ', 'ν', 'н', 'ن', 'န', 'ნ'],
      'o': ['ó', 'ò', 'ỏ', 'õ', 'ọ', 'ô', 'ố', 'ồ', 'ổ', 'ỗ', 'ộ', 'ơ', 'ớ', 'ờ', 'ở', 'ỡ', 'ợ', 'ø', 'ō', 'ő', 'ŏ', 'ο', 'ὀ', 'ὁ', 'ὂ', 'ὃ', 'ὄ', 'ὅ', 'ὸ', 'ό', 'о', 'و', 'θ', 'ို', 'ǒ', 'ǿ', 'º', 'ო', 'ओ'],
      'p': ['п', 'π', 'ပ', 'პ', 'پ'],
      'q': ['ყ'],
      'r': ['ŕ', 'ř', 'ŗ', 'р', 'ρ', 'ر', 'რ'],
      's': ['ś', 'š', 'ş', 'с', 'σ', 'ș', 'ς', 'س', 'ص', 'စ', 'ſ', 'ს'],
      't': ['ť', 'ţ', 'т', 'τ', 'ț', 'ت', 'ط', 'ဋ', 'တ', 'ŧ', 'თ', 'ტ'],
      'u': ['ú', 'ù', 'ủ', 'ũ', 'ụ', 'ư', 'ứ', 'ừ', 'ử', 'ữ', 'ự', 'û', 'ū', 'ů', 'ű', 'ŭ', 'ų', 'µ', 'у', 'ဉ', 'ု', 'ူ', 'ǔ', 'ǖ', 'ǘ', 'ǚ', 'ǜ', 'უ', 'उ'],
      'v': ['в', 'ვ', 'ϐ'],
      'w': ['ŵ', 'ω', 'ώ', 'ဝ', 'ွ'],
      'x': ['χ', 'ξ'],
      'y': ['ý', 'ỳ', 'ỷ', 'ỹ', 'ỵ', 'ÿ', 'ŷ', 'й', 'ы', 'υ', 'ϋ', 'ύ', 'ΰ', 'ي', 'ယ'],
      'z': ['ź', 'ž', 'ż', 'з', 'ζ', 'ز', 'ဇ', 'ზ'],
      'aa': ['ع', 'आ', 'آ'],
      'ae': ['ä', 'æ', 'ǽ'],
      'ai': ['ऐ'],
      'at': ['@'],
      'ch': ['ч', 'ჩ', 'ჭ', 'چ'],
      'dj': ['ђ', 'đ'],
      'dz': ['џ', 'ძ'],
      'ei': ['ऍ'],
      'gh': ['غ', 'ღ'],
      'ii': ['ई'],
      'ij': ['ĳ'],
      'kh': ['х', 'خ', 'ხ'],
      'lj': ['љ'],
      'nj': ['њ'],
      'oe': ['ö', 'œ', 'ؤ'],
      'oi': ['ऑ'],
      'oii': ['ऒ'],
      'ps': ['ψ'],
      'sh': ['ш', 'შ', 'ش'],
      'shch': ['щ'],
      'ss': ['ß'],
      'sx': ['ŝ'],
      'th': ['þ', 'ϑ', 'ث', 'ذ', 'ظ'],
      'ts': ['ц', 'ც', 'წ'],
      'ue': ['ü'],
      'uu': ['ऊ'],
      'ya': ['я'],
      'yu': ['ю'],
      'zh': ['ж', 'ჟ', 'ژ'],
      '(c)': ['©'],
      'A': ['Á', 'À', 'Ả', 'Ã', 'Ạ', 'Ă', 'Ắ', 'Ằ', 'Ẳ', 'Ẵ', 'Ặ', 'Â', 'Ấ', 'Ầ', 'Ẩ', 'Ẫ', 'Ậ', 'Å', 'Ā', 'Ą', 'Α', 'Ά', 'Ἀ', 'Ἁ', 'Ἂ', 'Ἃ', 'Ἄ', 'Ἅ', 'Ἆ', 'Ἇ', 'ᾈ', 'ᾉ', 'ᾊ', 'ᾋ', 'ᾌ', 'ᾍ', 'ᾎ', 'ᾏ', 'Ᾰ', 'Ᾱ', 'Ὰ', 'Ά', 'ᾼ', 'А', 'Ǻ', 'Ǎ'],
      'B': ['Б', 'Β', 'ब'],
      'C': ['Ç', 'Ć', 'Č', 'Ĉ', 'Ċ'],
      'D': ['Ď', 'Ð', 'Đ', 'Ɖ', 'Ɗ', 'Ƌ', 'ᴅ', 'ᴆ', 'Д', 'Δ'],
      'E': ['É', 'È', 'Ẻ', 'Ẽ', 'Ẹ', 'Ê', 'Ế', 'Ề', 'Ể', 'Ễ', 'Ệ', 'Ë', 'Ē', 'Ę', 'Ě', 'Ĕ', 'Ė', 'Ε', 'Έ', 'Ἐ', 'Ἑ', 'Ἒ', 'Ἓ', 'Ἔ', 'Ἕ', 'Έ', 'Ὲ', 'Е', 'Ё', 'Э', 'Є', 'Ə'],
      'F': ['Ф', 'Φ'],
      'G': ['Ğ', 'Ġ', 'Ģ', 'Г', 'Ґ', 'Γ'],
      'H': ['Η', 'Ή', 'Ħ'],
      'I': ['Í', 'Ì', 'Ỉ', 'Ĩ', 'Ị', 'Î', 'Ï', 'Ī', 'Ĭ', 'Į', 'İ', 'Ι', 'Ί', 'Ϊ', 'Ἰ', 'Ἱ', 'Ἳ', 'Ἴ', 'Ἵ', 'Ἶ', 'Ἷ', 'Ῐ', 'Ῑ', 'Ὶ', 'Ί', 'И', 'І', 'Ї', 'Ǐ', 'ϒ'],
      'K': ['К', 'Κ'],
      'L': ['Ĺ', 'Ł', 'Л', 'Λ', 'Ļ', 'Ľ', 'Ŀ', 'ल'],
      'M': ['М', 'Μ'],
      'N': ['Ń', 'Ñ', 'Ň', 'Ņ', 'Ŋ', 'Н', 'Ν'],
      'O': ['Ó', 'Ò', 'Ỏ', 'Õ', 'Ọ', 'Ô', 'Ố', 'Ồ', 'Ổ', 'Ỗ', 'Ộ', 'Ơ', 'Ớ', 'Ờ', 'Ở', 'Ỡ', 'Ợ', 'Ø', 'Ō', 'Ő', 'Ŏ', 'Ο', 'Ό', 'Ὀ', 'Ὁ', 'Ὂ', 'Ὃ', 'Ὄ', 'Ὅ', 'Ὸ', 'Ό', 'О', 'Θ', 'Ө', 'Ǒ', 'Ǿ'],
      'P': ['П', 'Π'],
      'R': ['Ř', 'Ŕ', 'Р', 'Ρ', 'Ŗ'],
      'S': ['Ş', 'Ŝ', 'Ș', 'Š', 'Ś', 'С', 'Σ'],
      'T': ['Ť', 'Ţ', 'Ŧ', 'Ț', 'Т', 'Τ'],
      'U': ['Ú', 'Ù', 'Ủ', 'Ũ', 'Ụ', 'Ư', 'Ứ', 'Ừ', 'Ử', 'Ữ', 'Ự', 'Û', 'Ū', 'Ů', 'Ű', 'Ŭ', 'Ų', 'У', 'Ǔ', 'Ǖ', 'Ǘ', 'Ǚ', 'Ǜ'],
      'V': ['В'],
      'W': ['Ω', 'Ώ', 'Ŵ'],
      'X': ['Χ', 'Ξ'],
      'Y': ['Ý', 'Ỳ', 'Ỷ', 'Ỹ', 'Ỵ', 'Ÿ', 'Ῠ', 'Ῡ', 'Ὺ', 'Ύ', 'Ы', 'Й', 'Υ', 'Ϋ', 'Ŷ'],
      'Z': ['Ź', 'Ž', 'Ż', 'З', 'Ζ'],
      'AE': ['Ä', 'Æ', 'Ǽ'],
      'CH': ['Ч'],
      'DJ': ['Ђ'],
      'DZ': ['Џ'],
      'GX': ['Ĝ'],
      'HX': ['Ĥ'],
      'IJ': ['Ĳ'],
      'JX': ['Ĵ'],
      'KH': ['Х'],
      'LJ': ['Љ'],
      'NJ': ['Њ'],
      'OE': ['Ö', 'Œ'],
      'PS': ['Ψ'],
      'SH': ['Ш'],
      'SHCH': ['Щ'],
      'SS': ['ẞ'],
      'TH': ['Þ'],
      'TS': ['Ц'],
      'UE': ['Ü'],
      'YA': ['Я'],
      'YU': ['Ю'],
      'ZH': ['Ж'],
      ' ': ['\xA0', '\u2000', '\u2001', '\u2002', '\u2003', '\u2004', '\u2005', '\u2006', '\u2007', '\u2008', '\u2009', '\u200A', '\u202F', '\u205F', '\u3000']
    };
  }
});

/***/ }),

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"company-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[(_vm.isUpdated)?_c('h2',{staticClass:"page-title"},[_vm._v("แก้ไขรายละเอียด")]):_c('h2',{staticClass:"page-title"},[_vm._v("เพิ่มบริษัทใหม่")])])],1),_vm._v(" "),_c('el-form',{ref:"companyForm",staticClass:"company-form company-detail-info",attrs:{"model":_vm.companyForm,"rules":_vm.companyFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('companyForm')}}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("รายละเอียดบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ชื่อบริษัท","prop":"name"}},[_c('el-input',{attrs:{"id":"companyForm.name","maxlength":50,"placeholder":"กรอกชื่อบริษัท"},model:{value:(_vm.companyForm.name),callback:function ($$v) {_vm.$set(_vm.companyForm, "name", $$v)},expression:"companyForm.name"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"เลขประจำตัวผู้เสียภาษี","prop":"tax_id"}},[_c('el-input',{ref:"companyForm.tax_id",attrs:{"id":"companyForm.tax_id","placeholder":"กรอกเลขประจำตัวผู้เสียภาษี"},on:{"change":_vm.updateMaskTaxId},nativeOn:{"input":function($event){return _vm.handleInput($event, 'companyForm.tax_id', 'taxIdMask')}},model:{value:(_vm.companyForm.tax_id),callback:function ($$v) {_vm.$set(_vm.companyForm, "tax_id", $$v)},expression:"companyForm.tax_id"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ชื่อเว็ปไซต์สำหรับจัดการของบริษัท","prop":"slug"}},[_c('el-input',{staticClass:"slug-base-host",attrs:{"value":(_vm.baseHost + "/"),"readonly":true}})],1)],1),_vm._v(" "),_c('el-col',{staticClass:"company-slug-holder",attrs:{"span":10}},[_c('el-input',{staticClass:"company-slug-input",attrs:{"disabled":_vm.isUpdated,"id":"companyForm.slug","placeholder":"กรอกชื่อเว็ปไซต์สำหรับจัดการของบริษัท"},nativeOn:{"keyup":function($event){return _vm.genSlug(_vm.vm)}},model:{value:(_vm.companyForm.slug),callback:function ($$v) {_vm.$set(_vm.companyForm, "slug", $$v)},expression:"companyForm.slug"}})],1)],1),_vm._v(" "),(!_vm.isUpdated)?_c('el-row',[_c('el-col',{staticClass:"slug-preview-block",attrs:{"span":20}},[_c('h4',[_vm._v("ตัวอย่างรูปแบบที่จะนำไปใช้งาน:")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.baseHost)+"/"),_c('span',[_vm._v(_vm._s(_vm.slugPreview))])]),_vm._v(" "),(_vm.slugPreview !== 'company-web-name' && _vm.slugPreview !== '' && _vm.slugPreview !== _vm.companyForm.slug)?_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.assignSlug}},[_vm._v("เลือกใช้ชื่อนี้")]):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',{staticClass:"logo-uploader-holder"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"โลโก้บริษัท","prop":"logo"}},[(_vm.companyForm.logo)?_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.companyForm.logo}})]):_vm._e(),_vm._v(" "),_c('el-upload',{staticClass:"company-logo-uploader",attrs:{"action":_vm.uploadUrl,"drag":"","show-file-list":false,"http-request":_vm.handleHttpRequest,"on-success":_vm.handleLogoSuccess,"on-error":_vm.handleLogoFail,"before-upload":_vm.beforeLogoUpload}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isUploading),expression:"isUploading"}],staticClass:"upload-instruction"},[_c('h3',[_vm._v("อัพโหลดโลโก้บริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-upload logo-uploader-icon"})])]),_vm._v(" "),_c('div',{staticClass:"upload-instruction-hint"},[_vm._v("\n                ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section last"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่หลักของบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ที่อยู่","prop":"address.line_1"}},[_c('el-input',{attrs:{"id":"companyForm.address.line_1","placeholder":"กรอกที่อยู่"},model:{value:(_vm.companyForm.address.line_1),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "line_1", $$v)},expression:"companyForm.address.line_1"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ตำบล/แขวง","prop":"address.district"}},[_c('el-input',{attrs:{"id":"companyForm.address.district","placeholder":"กรอกตำบล/แขวง"},model:{value:(_vm.companyForm.address.district),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "district", $$v)},expression:"companyForm.address.district"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"อำเภอ/เขต","prop":"address.city"}},[_c('el-input',{attrs:{"id":"companyForm.address.city","placeholder":"กรอกอำเภอ/เขต"},model:{value:(_vm.companyForm.address.city),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "city", $$v)},expression:"companyForm.address.city"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"จังหวัด","prop":"address.province"}},[_c('el-select',{attrs:{"id":"companyForm.address.province"},model:{value:(_vm.companyForm.address.province),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "province", $$v)},expression:"companyForm.address.province"}},_vm._l((_vm.provinceList),function(province){return _c('el-option',{key:province,attrs:{"label":province,"value":province}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"รหัสไปรษณีย์","prop":"address.postal_code"}},[_c('el-input',{ref:"companyForm.address.postal_code",attrs:{"id":"companyForm.address.postal_code","placeholder":"กรอกรหัสไปรษณีย์"},on:{"change":_vm.updatePostCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'companyForm.address.postal_code', 'postcode')}},model:{value:(_vm.companyForm.address.postal_code),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "postal_code", $$v)},expression:"companyForm.address.postal_code"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"โทรศัพท์","prop":"address.tel"}},[_c('el-input',{attrs:{"id":"companyForm.address.tel","placeholder":"กรอกโทรศัพท์"},model:{value:(_vm.companyForm.address.tel),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "tel", $$v)},expression:"companyForm.address.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"โทรสาร","prop":"address.fax"}},[_c('el-input',{attrs:{"id":"companyForm.address.fax","placeholder":"กรอกโทรสาร"},model:{value:(_vm.companyForm.address.fax),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "fax", $$v)},expression:"companyForm.address.fax"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"companyForm.cancelButton"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated)?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"companyForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"companyForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Save and continue')))])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1063:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_admin_list_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e13bbb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_admin_list_vue__ = __webpack_require__(1065);
function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_admin_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e13bbb9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_admin_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1064:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1065:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-admin-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":6}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายชื่อผู้ดูแลบริษัท")])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"ค้นหารายชื่อผู้ดูแลบริษัท"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search"},slot:"append"})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[(!_vm.isViewerRole)?_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createCompanyAdmin.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v("เพิ่มข้อมูลผู้ดูแลบริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-plus el-icon-right"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"profile-list-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.adminListData,"default-sort":{prop: 'email', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"email","label":"อีเมล","sortable":"","class-name":"no-wrap","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","sortable":"","class-name":"no-wrap","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"โทรศัพท์","sortable":"","formatter":_vm.telFormatter,"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"role","label":"หน้าที่","sortable":"","formatter":_vm.roleFormatter,"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"สถานะ","width":"100","formatter":_vm.statusFormatter},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.statusTypeFormatter(scope.row),"close-transition":""}},[_vm._v(_vm._s(_vm.statusFormatter(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"รายละเอียด","min-width":"150","class-name":"desc-col no-wrap"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleEdit(scope.$index, scope.row)}}},[_vm._v("แก้ไข")])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_admin_form_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759e1141_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_admin_form_vue__ = __webpack_require__(1068);
function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_admin_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_759e1141_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_admin_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"company-admin-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.backToCompanyAdminList.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชีผู้ดูแลบริษัท' : 'เพิ่มบัญชีผู้ดูแลบริษัท'))])],1)],1),_vm._v(" "),_c('el-form',{ref:"adminForm",staticClass:"admin-form",attrs:{"model":_vm.adminForm,"rules":_vm.adminFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('adminForm')}}},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"อีเมลผู้ดูแล","prop":"email"}},[_c('el-input',{attrs:{"id":"adminForm.email","disabled":_vm.isViewerRole,"placeholder":"กรอกอีเมลผู้ดูแล"},model:{value:(_vm.adminForm.email),callback:function ($$v) {_vm.$set(_vm.adminForm, "email", $$v)},expression:"adminForm.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ชื่อผู้ดูแล","prop":"name"}},[_c('el-input',{attrs:{"id":"adminForm.name","disabled":_vm.isViewerRole,"placeholder":"กรอกชื่อผู้ดูแล"},model:{value:(_vm.adminForm.name),callback:function ($$v) {_vm.$set(_vm.adminForm, "name", $$v)},expression:"adminForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"หมายเลขโทรศัพท์","prop":"tel"}},[_c('el-input',{attrs:{"id":"adminForm.tel","disabled":_vm.isViewerRole,"placeholder":"กรอกหมายเลขโทรศัพท์"},model:{value:(_vm.adminForm.tel),callback:function ($$v) {_vm.$set(_vm.adminForm, "tel", $$v)},expression:"adminForm.tel"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"สถานะบัญชี","prop":"status"}},[_c('el-checkbox',{staticClass:"status-holder",class:{hide: _vm.isViewerRole},attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.status"},model:{value:(_vm.adminForm.status),callback:function ($$v) {_vm.$set(_vm.adminForm, "status", $$v)},expression:"adminForm.status"}},[_vm._v("สถานะการใช้งาน (Flag = Enable, Not Flag = Disable/Blocked)")]),_vm._v(" "),(_vm.isViewerRole)?_c('div',{staticClass:"user-status"},[_c('el-tag',{attrs:{"type":_vm.statusTypeFormatter(_vm.adminForm.status),"close-transition":""}},[_vm._v(_vm._s(_vm.statusFormatter(_vm.adminForm.status)))])],1):_vm._e(),_vm._v(" "),(_vm.isBlocked && _vm.isViewerRole)?_c('div',{staticClass:"blocked-status-section"},[_c('el-button',{attrs:{"plain":"","type":"primary","id":"unblock-button"},on:{"click":_vm.unblockUser}},[_vm._v("ปลดล็อคบัญชีผู้ดูแลบริษัท")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('el-form-item',{attrs:{"label":"รายละเอียดผู้ดูแล","prop":"description"}},[_c('el-input',{attrs:{"disabled":_vm.isViewerRole,"id":"adminForm.description","placeholder":"กรอกรายละเอียดผู้ดูแล"},model:{value:(_vm.adminForm.description),callback:function ($$v) {_vm.$set(_vm.adminForm, "description", $$v)},expression:"adminForm.description"}})],1)],1)],1),_vm._v(" "),(_vm.shouldShowRole)?_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"หน้าที่","prop":"role"}},[_c('el-radio-group',{attrs:{"disabled":_vm.isViewerRole},model:{value:(_vm.adminForm.role),callback:function ($$v) {_vm.$set(_vm.adminForm, "role", $$v)},expression:"adminForm.role"}},[_c('el-radio',{attrs:{"label":"ADMIN","id":"adminForm.role_1"}},[_vm._v("Admin")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"STAFF","id":"adminForm.role_2"}},[_vm._v("Staff")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"adminForm.cancelButton"},on:{"click":_vm.backToCompanyAdminList}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated && !_vm.isViewerRole)?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"adminForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),(!_vm.isViewerRole)?_c('el-button',{attrs:{"type":"primary","id":"adminForm.submitButton","native-type":"submit"}},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชี' : 'สร้างบัญชี'))]):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_list_vue__ = __webpack_require__(483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f5d653_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_list_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f5d653_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-profile-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":8}},[_c('h2',{staticClass:"page-title"},[_vm._v("ข้อมูลบริษัทสำหรับรับชำระ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"ค้นหารายชื่อบริษัท"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search"},slot:"append"})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[(!_vm.isViewerRole)?_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createProfile.apply(null, arguments)}}},[_c('span',{staticClass:"text"},[_vm._v("เพิ่มข้อมูลบริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-plus el-icon-right"})]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"profile-list-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.profileListData,"default-sort":{prop: 'name', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","class-name":"no-wrap","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ข้อมูล Bill Payment","header-align":"center","align":"center"}},[_c('el-table-column',{attrs:{"prop":"bill_payment_comp_code","label":"COMP CODE","header-align":"center","align":"center","sortable":"","formatter":_vm.compCodeFormatter,"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"account_no","label":"หมายเลขบัญชี","header-align":"center","align":"center","sortable":"","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.account_no)?_c('div',{staticClass:"bill-payment-info-row",domProps:{"innerHTML":_vm._s(_vm.accountNoAllFormatter(scope.row.account_no))}}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"biller_id","label":"Biller ID","header-align":"center","align":"center","sortable":"","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.biller_id)?_c('div',{staticClass:"bill-payment-info-row",domProps:{"innerHTML":_vm._s(_vm.accountNoAllFormatter(scope.row.biller_id))}}):_vm._e()]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payment_type","label":"วิธีการชำระเงิน","sortable":"","header-align":"center","align":"center","width":"140","formatter":_vm.paymentTypeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"update_at","label":"วันที่แก้ไข","width":"120","header-align":"center","align":"center","sortable":"","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleEdit(scope.$index, scope.row)}}},[_vm._v("\n            "+_vm._s(_vm.isViewerRole ? 'ดูข้อมูล' : 'แก้ไข')+"\n          ")])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1072:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_form_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ef96e1d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_form_vue__ = __webpack_require__(1074);
function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ef96e1d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1073:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"company-profile-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.backToCompanyProfileList.apply(null, arguments)}}}),_vm._v(" "),(_vm.isUpdated)?_c('h2',{staticClass:"page-title"},[_vm._v("แก้ไขข้อมูลบริษัทสำหรับรับชำระ")]):_c('h2',{staticClass:"page-title"},[_vm._v("เพิ่มข้อมูลบริษัทสำหรับรับชำระใหม่")])],1)],1),_vm._v(" "),_c('el-form',{ref:"profileForm",staticClass:"profile-form profile-detail-info detail-form",attrs:{"model":_vm.profileForm,"rules":_vm.profileFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('profileForm')}}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบริษัทสำหรับรับชำระ")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ชื่อบริษัท","prop":"name"}},[_c('el-input',{attrs:{"id":"profileForm.name","maxlength":50,"placeholder":"กรอกชื่อข้อมูลบริษัทสำหรับรับชำระ"},model:{value:(_vm.profileForm.name),callback:function ($$v) {_vm.$set(_vm.profileForm, "name", $$v)},expression:"profileForm.name"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่บริษัท "),_c('sup',{staticClass:"required"},[_vm._v("**")])])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"","prop":"use_company_address"}},[_c('el-checkbox',{attrs:{"id":"profileForm.use_company_address"},on:{"change":_vm.toggleUsingCompanyAddress},model:{value:(_vm.profileForm.use_company_address),callback:function ($$v) {_vm.$set(_vm.profileForm, "use_company_address", $$v)},expression:"profileForm.use_company_address"}},[_vm._v("ใช้ที่อยู่เดียวกับรายละเอียดหลักของบริษัท")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ที่อยู่","prop":"address.line_1"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.line_1","placeholder":"กรอกที่อยู่"},model:{value:(_vm.profileForm.address.line_1),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "line_1", $$v)},expression:"profileForm.address.line_1"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ตำบล/แขวง","prop":"address.district"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.district","placeholder":"กรอกตำบล/แขวง"},model:{value:(_vm.profileForm.address.district),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "district", $$v)},expression:"profileForm.address.district"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-form-item',{attrs:{"label":"อำเภอ/เขต","prop":"address.city"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.city","placeholder":"กรอกอำเภอ/เขต"},model:{value:(_vm.profileForm.address.city),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "city", $$v)},expression:"profileForm.address.city"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"จังหวัด","prop":"address.province"}},[_c('el-select',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.province"},model:{value:(_vm.profileForm.address.province),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "province", $$v)},expression:"profileForm.address.province"}},_vm._l((_vm.provinceList),function(province){return _c('el-option',{key:province,attrs:{"label":province,"value":province}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-form-item',{attrs:{"label":"รหัสไปรษณีย์","prop":"address.postal_code"}},[_c('el-input',{ref:"profileForm.address.postal_code",attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.postal_code","placeholder":"กรอกรหัสไปรษณีย์"},on:{"change":_vm.updatePostCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.address.postal_code', 'postcode')}},model:{value:(_vm.profileForm.address.postal_code),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "postal_code", $$v)},expression:"profileForm.address.postal_code"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"โทรศัพท์","prop":"address.tel"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.tel","placeholder":"กรอกโทรศัพท์"},model:{value:(_vm.profileForm.address.tel),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "tel", $$v)},expression:"profileForm.address.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-form-item',{attrs:{"label":"โทรสาร","prop":"address.fax"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.fax","placeholder":"กรอกโทรสาร"},model:{value:(_vm.profileForm.address.fax),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "fax", $$v)},expression:"profileForm.address.fax"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('h3',{staticClass:"section-title"},[_vm._v("Bill Payment "),_c('sup',{staticClass:"required"},[_vm._v("**")])])]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('h3',{staticClass:"section-title"},[_vm._v("Cross Bank Bill Payment "),_c('sup',{staticClass:"required"},[_vm._v("**")])])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{ref:"bill_payment_account_no",attrs:{"label":"","prop":"bill_payment_account_no"}},[_c('el-checkbox',{attrs:{"id":"profileForm.use_bill_payment_account_no"},on:{"change":_vm.toggleUsingAccountNo},model:{value:(_vm.profileForm.use_bill_payment_account_no),callback:function ($$v) {_vm.$set(_vm.profileForm, "use_bill_payment_account_no", $$v)},expression:"profileForm.use_bill_payment_account_no"}},[_vm._v("หมายเลขบัญชี")]),_vm._v(" "),_c('el-input',{ref:"profileForm.bill_payment_account_no",attrs:{"disabled":!_vm.profileForm.use_bill_payment_account_no,"id":"profileForm.bill_payment_account_no","placeholder":"หมายเลขบัญชี"},on:{"change":_vm.updateMaskAccountNo},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.bill_payment_account_no', 'accountNo')}},model:{value:(_vm.profileForm.bill_payment_account_no),callback:function ($$v) {_vm.$set(_vm.profileForm, "bill_payment_account_no", $$v)},expression:"profileForm.bill_payment_account_no"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":3,"offset":1}},[_c('el-form-item',{ref:"bill_payment_comp_code",attrs:{"label":"","prop":"bill_payment_comp_code"}},[_c('el-checkbox',{attrs:{"id":"profileForm.use_bill_payment_comp_code"},on:{"change":_vm.toggleUsingCompCode},model:{value:(_vm.profileForm.use_bill_payment_comp_code),callback:function ($$v) {_vm.$set(_vm.profileForm, "use_bill_payment_comp_code", $$v)},expression:"profileForm.use_bill_payment_comp_code"}},[_vm._v("COMP CODE")]),_vm._v(" "),_c('el-input',{ref:"profileForm.bill_payment_comp_code",attrs:{"disabled":!_vm.profileForm.use_bill_payment_comp_code,"id":"profileForm.bill_payment_comp_code","placeholder":"COMP CODE"},on:{"update":_vm.updateMaskCompCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.bill_payment_comp_code', 'compCode')}},model:{value:(_vm.profileForm.bill_payment_comp_code),callback:function ($$v) {_vm.$set(_vm.profileForm, "bill_payment_comp_code", $$v)},expression:"profileForm.bill_payment_comp_code"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6,"offset":1}},[_c('el-form-item',{ref:"bill_payment_biller_id",attrs:{"label":"","prop":"bill_payment_biller_id"}},[_c('el-checkbox',{attrs:{"id":"profileForm.use_bill_payment_biller_id"},on:{"change":_vm.toggleUsingBillerId},model:{value:(_vm.profileForm.use_bill_payment_biller_id),callback:function ($$v) {_vm.$set(_vm.profileForm, "use_bill_payment_biller_id", $$v)},expression:"profileForm.use_bill_payment_biller_id"}},[_vm._v("Biller ID")]),_vm._v(" "),_c('el-input',{ref:"profileForm.bill_payment_biller_id",attrs:{"disabled":!_vm.profileForm.use_bill_payment_biller_id,"id":"profileForm.bill_payment_biller_id","placeholder":"Biller ID"},nativeOn:{"keyup":function($event){return _vm.changeBillPaymentBillerId.apply(null, arguments)},"input":function($event){return _vm.handleInput($event, 'profileForm.bill_payment_biller_id', 'billerId')}},model:{value:(_vm.profileForm.bill_payment_biller_id),callback:function ($$v) {_vm.$set(_vm.profileForm, "bill_payment_biller_id", $$v)},expression:"profileForm.bill_payment_biller_id"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลสำหรับบาร์โค้ดและ QR code")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{ref:"barcode_qrcode_biller_id_tax_id",attrs:{"label":"","prop":"barcode_qrcode_biller_id_tax_id"}},[_c('el-radio',{attrs:{"label":"biller_id","id":"profileForm.use_barcode_qrcode_biller_id_1"},on:{"change":_vm.toggleUsingBarcodeQRcodeType},model:{value:(_vm.profileForm.barcode_qrcode_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_type", $$v)},expression:"profileForm.barcode_qrcode_type"}},[_vm._v("Biller ID")]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('el-input',{ref:"profileForm.barcode_qrcode_biller_id_tax_id",attrs:{"disabled":_vm.profileForm.barcode_qrcode_type !== 'biller_id',"id":"profileForm.barcode_qrcode_biller_id_tax_id","placeholder":"Biller ID"},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.barcode_qrcode_biller_id_tax_id', 'qrBillerId')}},model:{value:(_vm.profileForm.barcode_qrcode_biller_id_tax_id),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_biller_id_tax_id", $$v)},expression:"profileForm.barcode_qrcode_biller_id_tax_id"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-input',{attrs:{"minlength":2,"maxlength":2,"disabled":_vm.profileForm.barcode_qrcode_type !== 'biller_id',"id":"profileForm.barcode_qrcode_biller_id_suffix","placeholder":"Suffix 2 digits"},model:{value:(_vm.profileForm.barcode_qrcode_biller_id_suffix),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_biller_id_suffix", $$v)},expression:"profileForm.barcode_qrcode_biller_id_suffix"}})],1)],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-form-item',{ref:"barcode_qrcode_account_no",attrs:{"label":"","prop":"barcode_qrcode_account_no"}},[_c('el-radio',{attrs:{"label":"account_no","disabled":_vm.profileForm.use_bill_payment_biller_id,"id":"profileForm.use_barcode_qrcode_biller_id_2"},on:{"change":_vm.toggleUsingBarcodeQRcodeType},model:{value:(_vm.profileForm.barcode_qrcode_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_type", $$v)},expression:"profileForm.barcode_qrcode_type"}},[_vm._v("หมายเลขบัญชี")]),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":14}},[_c('el-input',{ref:"profileForm.barcode_qrcode_account_no",attrs:{"disabled":_vm.profileForm.barcode_qrcode_type === 'biller_id' || _vm.profileForm.use_bill_payment_biller_id,"id":"profileForm.barcode_qrcode_account_no","placeholder":"หมายเลขบัญชี"},on:{"change":_vm.updateMaskAccountNo},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.barcode_qrcode_account_no', 'accountNo')}},model:{value:(_vm.profileForm.barcode_qrcode_account_no),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_account_no", $$v)},expression:"profileForm.barcode_qrcode_account_no"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-input',{attrs:{"minlength":2,"maxlength":2,"disabled":_vm.profileForm.barcode_qrcode_type === 'biller_id' || _vm.profileForm.use_bill_payment_biller_id,"id":"profileForm.barcode_qrcode_account_no_suffix","placeholder":"Suffix 2 digits"},model:{value:(_vm.profileForm.barcode_qrcode_account_no_suffix),callback:function ($$v) {_vm.$set(_vm.profileForm, "barcode_qrcode_account_no_suffix", $$v)},expression:"profileForm.barcode_qrcode_account_no_suffix"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"remark-red"},[_vm._v("**กรณีที่ใช้หมายเลขบัญชี จะไม่สามารถสร้าง QR Code ได้")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Business Type")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-col',{attrs:{"span":6}},[_c('el-radio',{attrs:{"label":"B2C","id":"profileForm.business_type_b2c"},on:{"change":_vm.businessTypeChange},model:{value:(_vm.profileForm.business_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "business_type", $$v)},expression:"profileForm.business_type"}},[_vm._v("B2C")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-radio',{attrs:{"label":"B2B","id":"profileForm.business_type_b2b"},on:{"change":_vm.businessTypeChange},model:{value:(_vm.profileForm.business_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "business_type", $$v)},expression:"profileForm.business_type"}},[_vm._v("ธุรกิจ B2B")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-radio',{attrs:{"label":"EDU","id":"profileForm.business_type_edu"},on:{"change":_vm.businessTypeChange},model:{value:(_vm.profileForm.business_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "business_type", $$v)},expression:"profileForm.business_type"}},[_vm._v("สถานศึกษา")])],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-radio',{attrs:{"label":"SPECIAL","id":"profileForm.business_type_special"},on:{"change":_vm.businessTypeChange},model:{value:(_vm.profileForm.business_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "business_type", $$v)},expression:"profileForm.business_type"}},[_vm._v("ธุรกิจพิเศษ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"","prop":"business_type_special_industry"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.business_type !== 'SPECIAL',"id":"profileForm.business_type_special_industry","placeholder":"สาขา"},on:{"blur":_vm.businessTypeChange},model:{value:(_vm.profileForm.business_type_special_industry),callback:function ($$v) {_vm.$set(_vm.profileForm, "business_type_special_industry", $$v)},expression:"profileForm.business_type_special_industry"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("วิธีการชำระเงิน  "),_c('sup',{staticClass:"required"},[_vm._v("**")])])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"","prop":"payment_type"}},[_c('el-radio',{attrs:{"label":"CHEQUE_OR_CASH","id":"profileForm.payment_type_cheque_cash"},model:{value:(_vm.profileForm.payment_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "payment_type", $$v)},expression:"profileForm.payment_type"}},[_vm._v("เช็ค/เงินสด")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"CASH_ONLY","id":"profileForm.payment_type_cash_only"},model:{value:(_vm.profileForm.payment_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "payment_type", $$v)},expression:"profileForm.payment_type"}},[_vm._v("เงินสดอย่างเดียว")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Charge Type")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"","prop":"charge_payer"}},[_c('el-checkbox',{attrs:{"id":"profileForm.charge_payer"},on:{"change":_vm.checkChargePayer},model:{value:(_vm.profileForm.charge_payer),callback:function ($$v) {_vm.$set(_vm.profileForm, "charge_payer", $$v)},expression:"profileForm.charge_payer"}},[_vm._v("Charge Payer")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"IB/IR","prop":"ir_br"}},[_c('el-input',{attrs:{"disabled":!_vm.profileForm.charge_payer,"id":"profileForm.ir_br","placeholder":"กรอก IB/IR"},model:{value:(_vm.profileForm.ir_br),callback:function ($$v) {_vm.$set(_vm.profileForm, "ir_br", $$v)},expression:"profileForm.ir_br"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Account Reference")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"ชื่อบัญชี","prop":"account_name"}},[_c('el-input',{attrs:{"id":"profileForm.account_name","placeholder":"กรอกชื่อบัญชี"},model:{value:(_vm.profileForm.account_name),callback:function ($$v) {_vm.$set(_vm.profileForm, "account_name", $$v)},expression:"profileForm.account_name"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"Label (Ref. 1)","prop":"label_ref1"}},[_c('el-input',{attrs:{"id":"profileForm.label_ref1","maxlength":25,"placeholder":"กรอกชื่อเรียก Reference No. 1"},model:{value:(_vm.profileForm.label_ref1),callback:function ($$v) {_vm.$set(_vm.profileForm, "label_ref1", $$v)},expression:"profileForm.label_ref1"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":9,"offset":1}},[_c('el-form-item',{attrs:{"label":"Label (Ref. 2)","prop":"label_ref2"}},[_c('el-input',{attrs:{"id":"profileForm.label_ref2","maxlength":25,"placeholder":"กรอกชื่อเรียก Reference No. 2"},model:{value:(_vm.profileForm.label_ref2),callback:function ($$v) {_vm.$set(_vm.profileForm, "label_ref2", $$v)},expression:"profileForm.label_ref2"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบัญชีธนาคารอื่นๆที่จะปรากฎบน Pay-in Slip (สูงสุด 6 บัญชี)")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"","prop":"allow_other_banks"}},[_c('el-checkbox',{attrs:{"id":"profileForm.allow_other_banks"},model:{value:(_vm.profileForm.allow_other_banks),callback:function ($$v) {_vm.$set(_vm.profileForm, "allow_other_banks", $$v)},expression:"profileForm.allow_other_banks"}},[_vm._v("Admin ของบริษัทผู้ใช้งานสามารถเพิ่มข้อมูลด้วยตนเองได้")])],1)],1)],1),_vm._v(" "),(_vm.profileForm.allow_other_banks && _vm.profileForm.other_banks.length > 0)?_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('h4',[_vm._v("รายการข้อมูลบัญชีธนาคารอื่นๆ")]),_vm._v(" "),_c('div',{staticClass:"other-bank-list"},_vm._l((_vm.profileForm.other_banks),function(bankInfo,idx){return _c('div',{key:idx,staticClass:"other-bank-info"},[_c('div',{staticClass:"other-bank-logo-holder"},[(bankInfo.account_logo)?_c('img',{attrs:{"src":bankInfo.account_logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"other-bank-text-holder"},[_vm._v("\n                  "+_vm._s(bankInfo.account_name.trim() !== '' ? _vm.getOtherBankInfoSummaryText(bankInfo) : '-')+"\n                ")])])}),0)])],1):_vm._e()],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"","prop":"is_banking_agent"}},[_c('el-checkbox',{attrs:{"id":"profileForm.is_banking_agent"},model:{value:(_vm.profileForm.is_banking_agent),callback:function ($$v) {_vm.$set(_vm.profileForm, "is_banking_agent", $$v)},expression:"profileForm.is_banking_agent"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ตัวแทนธนาคาร (Banking agent)")])])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("การแจ้งเตือน")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{ref:"notification_msg",attrs:{"label":"","prop":"notification_msg"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"DATE","id":"profileForm.notification_msg_type_1"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_type", $$v)},expression:"profileForm.notification_msg_type"}},[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_vm._v("กรุณาชำระภายในวันที่")]),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_c('el-select',{staticStyle:{"width":"100px","text-align":"center"},attrs:{"disabled":_vm.profileForm.notification_msg_type === 'CUSTOM',"id":"profileForm.notification_msg_date"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_date),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_date", $$v)},expression:"profileForm.notification_msg_date"}},_vm._l((_vm.notificationDayList),function(day){return _c('el-option',{key:day,attrs:{"label":day,"value":day}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_vm._v("\n                      ของทุกเดือน\n                    ")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"20px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"CUSTOM","id":"profileForm.notification_msg_type_2"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_type", $$v)},expression:"profileForm.notification_msg_type"}},[_vm._v("\n                  _\n                ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px"},attrs:{"disabled":_vm.profileForm.notification_msg_type !== 'CUSTOM',"id":"profileForm.notification_msg_custom","maxlength":100,"placeholder":"กรอกข้อความแจ้งเตือนที่ต้องการ"},model:{value:(_vm.profileForm.notification_msg_custom),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_custom", $$v)},expression:"profileForm.notification_msg_custom"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ตัวเลือกในการพิมพ์")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',{staticClass:"logo-uploader-holder"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"โลโก้บริษัท","prop":"logo"}},[(_vm.profileForm.logo)?_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.profileForm.logo}})]):_vm._e(),_vm._v(" "),_c('el-upload',{staticClass:"company-logo-uploader",attrs:{"action":_vm.uploadUrl,"drag":"","show-file-list":false,"http-request":_vm.handleHttpRequest,"on-success":_vm.handleLogoSuccess,"on-error":_vm.handleLogoFail,"before-upload":_vm.beforeLogoUpload}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isUploading),expression:"isUploading"}],staticClass:"upload-instruction"},[_c('h3',[_vm._v("อัพโหลดโลโก้บริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-upload logo-uploader-icon"})])]),_vm._v(" "),_c('div',{staticClass:"upload-instruction-hint"},[_vm._v("\n                ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":18}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"profileForm.cancelButton"},on:{"click":_vm.backToCompanyProfileList}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated)?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"profileForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"profileForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Save and continue')))])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1075:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_detail_vue__ = __webpack_require__(485);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326384ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_detail_vue__ = __webpack_require__(1077);
function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-326384ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_profile_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326384ff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_profile_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1077:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-profile-form-page page-content"},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.backToCompanyProfileList.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v("รายละเอียดข้อมูลบริษัทสำหรับรับชำระ")])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('table',{attrs:{"id":"company-profile-detail-table"}},[_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบริษัทสำหรับรับชำระ")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ชื่อบริษัท")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.name))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่บริษัท")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ใช้ที่อยู่เดียวกับรายละเอียดหลักของบริษัท")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.use_company_address ? 'ใช่' : 'ไม่ใช่'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ที่อยู่")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.line_1 || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ตำบล/แขวง")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.district || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("อำเภอ/เขต")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.city || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("จังหวัด")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.province || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("รหัสไปรษณีย์")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.postal_code || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("โทรศัพท์")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.tel || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("โทรสาร")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.address.fax || '-'))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("Bill Payment")])])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("Cross Bank Bill Payment")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("หมายเลขบัญชี")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.bill_payment_account_no || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("COMP CODE")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.bill_payment_comp_code || '-'))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Biller ID")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.profileForm.bill_payment_biller_id || '-'))])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลสำหรับบาร์โค้ดและ QR code")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("หมายเลขบัญชี")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.barcode_qrcode_account_no || '-')+"\n                "+_vm._s(_vm.profileForm.barcode_qrcode_account_no_suffix)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Biller ID")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.barcode_qrcode_biller_id_tax_id || '-')+"\n                "+_vm._s(_vm.profileForm.barcode_qrcode_biller_id_suffix)+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("Business Type")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Business Type")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.business_type == 'B2C' ? 'B2C' : '')+"\n                "+_vm._s(_vm.profileForm.business_type == 'B2B' ? 'ธุรกิจ B2B' : '')+"\n                "+_vm._s(_vm.profileForm.business_type == 'EDU' ? 'สถานศึกษา' : '')+"\n                "+_vm._s(_vm.profileForm.business_type == 'SPECIAL' ? ("ธุรกิจพิเศษ สาขา" + (_vm.profileForm.business_type_special_industry)) : '')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("วิธีการชำระเงิน")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("วิธีการชำระเงิน")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.payment_type == 'CHEQUE_OR_CASH' ? 'เช็ค/เงินสด' : '')+"\n                "+_vm._s(_vm.profileForm.payment_type == 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : '')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("Charge Type")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Charge Type")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.charge_payer ? 'Payer' : 'Biller')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("IB/IR")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.ir_br || '')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("Account Reference")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ชื่อบัญชี")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.account_name || '-')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Label (Ref. 1)")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.label_ref1 || '-')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Label (Ref. 2)")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.label_ref2 || '-')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบัญชีธนาคารอื่นๆที่จะปรากฎบน Pay-in Slip")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Admin ของบริษัทผู้ใช้งานสามารถเพิ่มข้อมูลด้วยตนเองได้")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.allow_other_banks ? 'เพิ่มได้' : 'เพิ่มไม่ได้')+"\n              ")])]),_vm._v(" "),(_vm.profileForm.allow_other_banks)?_c('tr',[_c('th',[_vm._v("รายการข้อมูลบัญชีธนาคารอื่นๆ")]),_vm._v(" "),_c('td',[_c('div',_vm._l((_vm.profileForm.other_banks),function(bankInfo){return _c('div',{staticClass:"other-bank-list"},[_c('div',{staticClass:"other-bank-info"},[_c('div',{staticClass:"other-bank-logo-holder"},[(bankInfo.account_logo)?_c('img',{attrs:{"src":bankInfo.account_logo}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"other-bank-text-holder"},[_vm._v("\n                        "+_vm._s(bankInfo.account_name.trim() !== '' ? _vm.getOtherBankInfoSummaryText(bankInfo) : '-')+"\n                      ")])])])}),0)])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("การแจ้งเตือน")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("ข้อความแจ้งเตือน")]),_vm._v(" "),_c('td',[_vm._v("\n                "+_vm._s(_vm.profileForm.notification_msg || '-')+"\n              ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('hr')])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"colspan":"2"}},[_c('h3',{staticClass:"section-title"},[_vm._v("ตัวเลือกในการพิมพ์")])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("โลโก้บริษัท")]),_vm._v(" "),_c('td',[(_vm.profileForm.logo)?_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"logo",staticStyle:{"max-width":"150px"},attrs:{"src":_vm.profileForm.logo}})]):_vm._e()])])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1080:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations_app__ = __webpack_require__(1084);



var _mutations;

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */


var state = {
  errorFlashs: [],
  activities: [],
  checkSessionCount: 0,
  isContentLoading: false,
  appMode: ''
};
var getters = {
  activityCount: function activityCount(state) {
    return state.activities.length;
  },
  checkSessionCount: function checkSessionCount(state) {
    return state.checkSessionCount;
  },
  errorFlashs: function errorFlashs(state) {
    return state.errorFlashs;
  },
  isContentLoading: function isContentLoading(state) {
    return state.isContentLoading;
  },
  appMode: function appMode(state) {
    return state.appMode;
  },
  appName: function appName(state) {
    return state.appMode === 'admin' ? 'Admin Panel' : '';
  },
  isAdmin: function isAdmin(state) {
    return state.appMode === 'admin';
  },
  isBiller: function isBiller(state) {
    return state.appMode === 'biller';
  }
};
var actions = {
  APP_CLEAR_STATE: function APP_CLEAR_STATE(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["d" /* APP_STATE_CLEARED */]);
      resolve();
    });
  },
  ADD_ACTIVITY: function ADD_ACTIVITY(_ref2, activity) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["a" /* ACTIVITY_ADDED */], activity);
      resolve();
    });
  },
  CLEAR_ACTIVITY: function CLEAR_ACTIVITY(_ref3) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["b" /* ACTIVITY_CLEARED */]);
      resolve();
    });
  },
  ADD_SESSION_COUNT: function ADD_SESSION_COUNT(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["i" /* SESSION_COUNT_ADDED */]);
      resolve();
    });
  },
  CLEAR_SESSION_COUNT: function CLEAR_SESSION_COUNT(_ref5) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["j" /* SESSION_COUNT_CLEARED */]);
      resolve();
    });
  },
  ADD_ERROR_FLASH: function ADD_ERROR_FLASH(_ref6, errMessage) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["g" /* ERROR_FLASH_ADDED */], errMessage);
      resolve();
    });
  },
  CLEAR_ERROR_FLASH: function CLEAR_ERROR_FLASH(_ref7) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["h" /* ERROR_FLASH_CLEARED */]);
      resolve();
    });
  },
  START_CONTENT_LOADING: function START_CONTENT_LOADING(_ref8) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["f" /* CONTENT_LOADING */]);
      resolve();
    });
  },
  STOP_CONTENT_LOADING: function STOP_CONTENT_LOADING(_ref9) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["e" /* CONTENT_LOADED */]);
      resolve();
    });
  },
  SET_APP_MODE: function SET_APP_MODE(_ref10, mode) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutations_app__["c" /* APP_MODE_SET */], mode);
      resolve();
    });
  }
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["a" /* ACTIVITY_ADDED */], function (state, activity) {
  state.activities.push(activity);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["b" /* ACTIVITY_CLEARED */], function (state) {
  // delete all stuffs in the array including related reference object
  state.activities.splice(0);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["i" /* SESSION_COUNT_ADDED */], function (state) {
  state.checkSessionCount += 1;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["j" /* SESSION_COUNT_CLEARED */], function (state) {
  state.checkSessionCount = 0;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["g" /* ERROR_FLASH_ADDED */], function (state, errMessage) {
  state.errorFlashs.push(errMessage);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["h" /* ERROR_FLASH_CLEARED */], function (state) {
  // delete all stuffs in the array including related reference object
  state.errorFlashs.splice(0);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["f" /* CONTENT_LOADING */], function (state) {
  state.isContentLoading = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["e" /* CONTENT_LOADED */], function (state) {
  state.isContentLoading = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["c" /* APP_MODE_SET */], function (state, mode) {
  state.appMode = mode;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__mutations_app__["d" /* APP_STATE_CLEARED */], function (state) {
  state.errorFlashs.splice(0);
  state.activities.splice(0);
  state.checkSessionCount = 0;
  state.isContentLoading = false;
}), _mutations);

/**
 * App Store - Manage Application state
 */
var AppStore = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/* harmony default export */ __webpack_exports__["a"] = (AppStore);

/***/ }),

/***/ 1084:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APP_STATE_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVITY_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVITY_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SESSION_COUNT_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SESSION_COUNT_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ERROR_FLASH_ADDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ERROR_FLASH_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTENT_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CONTENT_LOADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return APP_MODE_SET; });
/**
 * Store Mutation types
 */
// APP
// Activity Related
var APP_STATE_CLEARED = 'app.STATE_CLEARED';
var ACTIVITY_ADDED = 'app.ACTIVITY_ADDED';
var ACTIVITY_CLEARED = 'app.ACTIVITY_CLEARED';
var SESSION_COUNT_ADDED = 'app.SESSION_COUNT_ADDED';
var SESSION_COUNT_CLEARED = 'app.SESSION_COUNT_CLEARED';
var ERROR_FLASH_ADDED = 'app.ERROR_FLASH_ADDED';
var ERROR_FLASH_CLEARED = 'app.ERROR_FLASH_CLEARED';
var CONTENT_LOADING = 'app.CONTENT_LOADING';
var CONTENT_LOADED = 'app.CONTENT_LOADED';
var APP_MODE_SET = 'app.APP_MODE_SET';

/***/ }),

/***/ 1085:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mutations_auth__ = __webpack_require__(1086);




var _mutations;

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
// import decode from 'jwt-decode';






var state = {
  // status
  isAuthenticating: false,
  isSendingHeartbeat: false,
  isCheckingSession: false,
  isSubmittingPassword: false,
  // profile
  idToken: null,
  userId: null,
  userName: '',
  needResetPwd: false,
  tenantId: '',
  activeTimestamp: 0
  // userRole: null,
};
var getters = {
  userId: function userId(state) {
    return state.userId;
  },
  idToken: function idToken(state) {
    return state.idToken;
  },
  userName: function userName(state) {
    return state.userName;
  },
  needResetPwd: function needResetPwd(state) {
    return state.needResetPwd;
  },
  isAuthenticated: function isAuthenticated(state) {
    return state.idToken !== null;
  },
  tenantId: function tenantId(state) {
    return state.tenantId;
  },
  activeTimestamp: function activeTimestamp(state) {
    return state.activeTimestamp;
  }
  // userRole: state => state.userRole,
  /* isAdminRole: state => state.userRole === 'admin',
  isViewerRole: state => state.userRole === 'viewer',
  isBillerRole: state => state.userRole === 'biller', */
};
var actions = {
  AUTH_CLEAR_STATE: function AUTH_CLEAR_STATE(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["b" /* AUTH_STATE_CLEARED */]);
      resolve();
    });
  },
  LOGIN: function LOGIN(_ref2, _ref3) {
    var commit = _ref2.commit;
    var tenantId = _ref3.tenant_id,
        email = _ref3.email,
        password = _ref3.password;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["k" /* LOGIN_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].login(tenantId, email, password, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["j" /* LOGIN_FAIL */]);
          return reject(err);
        }
        result.email = email;
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["l" /* LOGIN_SUCCESS */], result);
        return resolve(result);
      });
    });
  },

  /* eslint no-else-return: 0 */
  LOGOUT: function LOGOUT(_ref4, _ref5) {
    var state = _ref4.state,
        commit = _ref4.commit;
    var vm = _ref5.vm;

    var token = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.idToken));
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["m" /* LOGOUT_SUCCESS */]);
      vm.$nextTick(function () {
        vm.$store.dispatch('APP_CLEAR_STATE');
        vm.$store.dispatch('AUTH_CLEAR_STATE');
        vm.$store.dispatch('BILLER_CLEAR_STATE');
        vm.$store.dispatch('COMPANY_CLEAR_STATE');
        if (token) {
          // we simply clear auth stuff
          return __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].logout(token, function (err) {
            if (err) {
              return reject(err);
            }
            // now we wipe out the storage for vux
            return resolve();
          });
        } else {
          return resolve();
        }
      });
    });
  },
  SEND_HEARTBEAT: function SEND_HEARTBEAT(_ref6) {
    var state = _ref6.state,
        commit = _ref6.commit;

    var token = state.idToken;
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // check if we is sending heartbeat in any tab or not
      if (state.isSendingHeartbeat) {
        resolve();
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["h" /* HEARTBEAT_REQUEST */]);
        __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].heartbeat(token, function (err, result) {
          if (err) {
            commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["g" /* HEARTBEAT_FAIL */]);
            return reject(err);
          }
          commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["i" /* HEARTBEAT_SUCCESS */], result);
          return resolve(result);
        });
      }
    });
  },
  UPDATE_ACTIVE_TIMESTAMP: function UPDATE_ACTIVE_TIMESTAMP(_ref7) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var now = __WEBPACK_IMPORTED_MODULE_5_moment_timezone___default()().tz("Asia/Bangkok");
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["a" /* ACTIVE_TIMESTAMP_UPDATED */], Number(now.format('X')));
      return resolve();
    });
  },
  CHECK_SESSION: function CHECK_SESSION(_ref8) {
    var state = _ref8.state,
        commit = _ref8.commit;

    var token = state.idToken;
    console.log('CHECK_SESSION', token);
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // check if we is sending check session in any tab or not
      /* if (state.isCheckingSession) {
        resolve();
      } else */
      if (token === null) {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["g" /* HEARTBEAT_FAIL */]);
        reject();
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["f" /* CHECK_SESSION_REQUEST */]);
        __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].checkSession(token, function (err, result) {
          console.log('check session', err, result);
          if (err) {
            commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["g" /* HEARTBEAT_FAIL */]);
            return reject(err);
          }
          commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["i" /* HEARTBEAT_SUCCESS */], result);
          return resolve(result);
        });
      }
    });
  },
  CHANGE_PASSWORD: function CHANGE_PASSWORD(_ref9, _ref10) {
    var commit = _ref9.commit;
    var force = _ref10.force,
        token = _ref10.token,
        password = _ref10.password;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["d" /* CHANGE_PASSWORD_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].changePassword(force, token, password, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["c" /* CHANGE_PASSWORD_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["e" /* CHANGE_PASSWORD_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  RESET_PASSWORD: function RESET_PASSWORD(_ref11, _ref12) {
    var commit = _ref11.commit;
    var tenantId = _ref12.tenantId,
        email = _ref12.email;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["o" /* RESET_PASSWORD_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].resetPassword(tenantId, email, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["n" /* RESET_PASSWORD_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["p" /* RESET_PASSWORD_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SET_TENANT_ID: function SET_TENANT_ID(_ref13, slug) {
    var commit = _ref13.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      var tenantId = slug === 'admin' ? 'scb' : slug;
      commit(__WEBPACK_IMPORTED_MODULE_6__mutations_auth__["q" /* TENANT_ID_SET */], tenantId);
      resolve();
    });
  }
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["k" /* LOGIN_REQUEST */], function (state) {
  state.isAuthenticating = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["j" /* LOGIN_FAIL */], function (state) {
  state.isAuthenticating = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["l" /* LOGIN_SUCCESS */], function (state, _ref14) {
  var token = _ref14.token,
      userId = _ref14.user_id,
      userName = _ref14.user_name,
      needResetPwd = _ref14.need_reset_pwd,
      email = _ref14.email;

  state.isAuthenticating = false;
  state.idToken = token;
  state.userId = userId;
  state.userName = userName;
  state.needResetPwd = needResetPwd;
  // state.userRole = role;
  // log sentry
  __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.setUserContext({
    userId: userId,
    email: email,
    userName: userName
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["m" /* LOGOUT_SUCCESS */], function (state) {
  state.isAuthenticating = false;
  state.idToken = null;
  state.userId = null;
  state.userName = '';
  state.needResetPwd = false;
  // state.userRole = null;
  __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.setUserContext();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["h" /* HEARTBEAT_REQUEST */], function (state) {
  state.isSendingHeartbeat = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["f" /* CHECK_SESSION_REQUEST */], function (state) {
  state.isCheckingSession = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["g" /* HEARTBEAT_FAIL */], function (state) {
  state.isSendingHeartbeat = false;
  state.isCheckingSession = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["i" /* HEARTBEAT_SUCCESS */], function (state) {
  state.isSendingHeartbeat = false;
  state.isCheckingSession = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["q" /* TENANT_ID_SET */], function (state, slug) {
  state.tenantId = slug;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["o" /* RESET_PASSWORD_REQUEST */], function (state) {
  state.isSubmittingPassword = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["p" /* RESET_PASSWORD_SUCCESS */], function (state) {
  state.isSubmittingPassword = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["n" /* RESET_PASSWORD_FAIL */], function (state) {
  state.isSubmittingPassword = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["d" /* CHANGE_PASSWORD_REQUEST */], function (state) {
  state.isSubmittingPassword = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["e" /* CHANGE_PASSWORD_SUCCESS */], function (state) {
  state.isSubmittingPassword = false;
  state.needResetPwd = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["c" /* CHANGE_PASSWORD_FAIL */], function (state) {
  state.isSubmittingPassword = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["b" /* AUTH_STATE_CLEARED */], function (state) {
  state.isAuthenticating = false;
  state.isSendingHeartbeat = false;
  state.isCheckingSession = false;
  state.isSubmittingPassword = false;
  state.idToken = null;
  state.userId = null;
  state.userName = '';
  state.needResetPwd = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__mutations_auth__["a" /* ACTIVE_TIMESTAMP_UPDATED */], function (state, nowTimestamp) {
  state.activeTimestamp = nowTimestamp;
}), _mutations);

/**
 * Auth Store - Manage Authentication state
 */
var AuthStore = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/* harmony default export */ __webpack_exports__["a"] = (AuthStore);

/***/ }),

/***/ 1086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_STATE_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOGIN_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOGIN_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return TENANT_ID_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HEARTBEAT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHECK_SESSION_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HEARTBEAT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HEARTBEAT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_TIMESTAMP_UPDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_PASSWORD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RESET_PASSWORD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RESET_PASSWORD_FAIL; });
/**
 * Store Mutation types
 */
// AUTH
var AUTH_STATE_CLEARED = 'auth.STATE_CLEARED';
/** Login Request */
var LOGIN_REQUEST = 'auth.LOGIN_REQUEST';
/** Login Fail */
var LOGIN_FAIL = 'auth.LOGIN_FAIL';
/** Login Success - store JWT token */
var LOGIN_SUCCESS = 'auth.LOGIN_SUCCESS';
/** Logout Success - clear all related user's information stored */
var LOGOUT_SUCCESS = 'auth.LOGOUT_SUCCESS';
/** Refresh Token Success - update stored JWT token */
// export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
var TENANT_ID_SET = 'auth.TENANT_ID_SET';
var HEARTBEAT_REQUEST = 'auth.HEARTBEAT_REQUEST';
var CHECK_SESSION_REQUEST = 'auth.CHECK_SESSION_REQUEST';
var HEARTBEAT_SUCCESS = 'auth.HEARTBEAT_SUCCESS';
var HEARTBEAT_FAIL = 'auth.HEARTBEAT_FAIL';
var ACTIVE_TIMESTAMP_UPDATED = 'auth.ACTIVE_TIMESTAMP_UPDATED';
// export const FORCE_LOGIN = 'auth.FORCE_LOGIN';
// export const FORCE_LOGOUT = 'auth.FORCE_LOGOUT';
var CHANGE_PASSWORD_REQUEST = 'auth.CHANGE_PASSWORD_REQUEST';
var CHANGE_PASSWORD_SUCCESS = 'auth.CHANGE_PASSWORD_SUCCESS';
var CHANGE_PASSWORD_FAIL = 'auth.CHANGE_PASSWORD_FAIL';
var RESET_PASSWORD_REQUEST = 'auth.RESET_PASSWORD_REQUEST';
var RESET_PASSWORD_SUCCESS = 'auth.RESET_PASSWORD_SUCCESS';
var RESET_PASSWORD_FAIL = 'auth.RESET_PASSWORD_FAIL';

/***/ }),

/***/ 1087:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_company__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations_company__ = __webpack_require__(1088);



var _mutations;

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */
// import lunr from 'lunr';
// import Vue from 'vue';



var rebuildCompanyIndex = function rebuildCompanyIndex(state) {
  delete state.companyListIndex;
  state.companyListIndex = {};
  state.companyList.forEach(function (item, index) {
    state.companyListIndex['_' + item.id] = index;
  });
};

var rebuildCompanyProfileIndex = function rebuildCompanyProfileIndex(state) {
  delete state.companyProfileListIndex;
  state.companyProfileListIndex = {};
  state.companyProfileList.forEach(function (item, index) {
    state.companyProfileListIndex['_' + item.id] = index;
  });
};

var rebuildCompanyAdminIndex = function rebuildCompanyAdminIndex(state) {
  delete state.companyAdminListIndex;
  state.companyAdminListIndex = {};
  state.companyAdminList.forEach(function (item, index) {
    state.companyAdminListIndex['_' + item.id] = index;
  });
};

var rebuildAdminIndex = function rebuildAdminIndex(state) {
  // rebuild index
  delete state.adminListIndex;
  state.adminListIndex = {};
  state.adminList.forEach(function (item, index) {
    state.adminListIndex['_' + item.id] = index;
  });
};

var state = {
  companyList: [],
  companyListIndex: {}, // reverse index
  isGettingCompany: false,
  isUploadingCompanyFile: false,
  isSubmittingCompanyInfo: false,
  currentCompanyId: null,
  // profiles
  isGettingCompanyProfile: false,
  companyProfileList: [],
  companyProfileListIndex: {}, // reverse index
  isSubmittingCompanyProfileInfo: false,
  currentCompanyProfileId: null,
  isUploadingCompanyProfileFile: false,
  // company's admins
  isGettingCompanyAdmin: false,
  companyAdminList: [],
  companyAdminListIndex: {}, // reverse index
  isSubmittingcompanyAdminInfo: false,
  currentCompanyAdminId: null,
  // admins
  isSubmittingAdminInfo: false,
  adminList: [],
  adminListIndex: {}, // reverse index
  isGettingAdmin: false,
  // search stuffs
  companyListSearchIndex: null,
  adminListSearchIndex: null,
  // my admin info
  scbAdminInfo: null,
  isGettingAdminMyAdmin: false
};
var getters = {
  scbAdminInfo: function scbAdminInfo(state) {
    return state.scbAdminInfo;
  },
  isAdminInitialLoading: function isAdminInitialLoading(state) {
    return state.isGettingAdminMyAdmin;
  },

  isAdminRole: function isAdminRole(state) {
    return state.scbAdminInfo && state.scbAdminInfo.role === 'ADMIN';
  },
  isViewerRole: function isViewerRole(state) {
    return state.scbAdminInfo && state.scbAdminInfo.role === 'VIEWER';
  },
  adminUserRole: function adminUserRole(state) {
    return state.scbAdminInfo ? state.scbAdminInfo.role : '';
  },
  companyList: function companyList(state) {
    return state.companyList;
  },
  companyListIndex: function companyListIndex(state) {
    return state.companyListIndex;
  },
  currentCompany: function currentCompany(state) {
    if (state.currentCompanyId) {
      var indexId = '_' + state.currentCompanyId;
      if (typeof state.companyListIndex[indexId] !== 'undefined') {
        return state.companyList[state.companyListIndex[indexId]];
      }
    }
    return null;
  },
  companyProfileList: function companyProfileList(state) {
    return state.companyProfileList;
  },
  companyProfileListIndex: function companyProfileListIndex(state) {
    return state.companyProfileListIndex;
  },
  currentCompanyProfile: function currentCompanyProfile(state) {
    if (state.currentCompanyProfileId) {
      var indexId = '_' + state.currentCompanyProfileId;
      if (typeof state.companyProfileListIndex[indexId] !== 'undefined') {
        return state.companyProfileList[state.companyProfileListIndex[indexId]];
      }
    }
    return null;
  },

  // COMPANY ADMIN USERS
  companyAdminList: function companyAdminList(state) {
    return state.companyAdminList;
  },
  companyAdminListIndex: function companyAdminListIndex(state) {
    return state.companyAdminListIndex;
  },
  currentCompanyAdmin: function currentCompanyAdmin(state) {
    if (state.currentCompanyAdminId) {
      var indexId = '_' + state.currentCompanyAdminId;
      if (typeof state.companyAdminListIndex[indexId] !== 'undefined') {
        return state.companyAdminList[state.companyAdminListIndex[indexId]];
      }
    }
    return null;
  },

  // ADMINS
  adminList: function adminList(state) {
    return state.adminList;
  },
  adminListIndex: function adminListIndex(state) {
    return state.adminListIndex;
  }
};
var actions = {
  COMPANY_CLEAR_STATE: function COMPANY_CLEAR_STATE(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["a" /* COMPANY_STATE_CLEARED */]);
      resolve();
    });
  },
  GET_COMPANY_LIST: function GET_COMPANY_LIST(_ref2, payload) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["M" /* GET_COMPANY_LIST_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].getCompany(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["L" /* GET_COMPANY_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["N" /* GET_COMPANY_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPLOAD_COMPANY_LOGO: function UPLOAD_COMPANY_LOGO(_ref3, file) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_7" /* UPLOAD_COMPANY_LOGO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].uploadCompanyLogo(file, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_6" /* UPLOAD_COMPANY_LOGO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_8" /* UPLOAD_COMPANY_LOGO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY: function SELECT_CURRENT_COMPANY(_ref4, companyId) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["p" /* CURRENT_COMPANY_SELECTED */], companyId);
      resolve();
    });
  },
  CREATE_COMPANY_INFO: function CREATE_COMPANY_INFO(_ref5, payload) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["i" /* CREATE_COMPANY_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].createCompanyInfo(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["h" /* CREATE_COMPANY_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["j" /* CREATE_COMPANY_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_INFO: function UPDATE_COMPANY_INFO(_ref6, payload) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_1" /* UPDATE_COMPANY_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].updateCompanyInfo(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_0" /* UPDATE_COMPANY_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_2" /* UPDATE_COMPANY_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_INFO: function DELETE_COMPANY_INFO(_ref7, companyId) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["x" /* DELETE_COMPANY_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].deleteCompanyInfo(companyId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["w" /* DELETE_COMPANY_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["y" /* DELETE_COMPANY_INFO_SUCCESS */], companyId);
        return resolve();
      });
    });
  },

  // Profiles
  GET_COMPANY_PROFILE_LIST: function GET_COMPANY_PROFILE_LIST(_ref8, companyId) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["P" /* GET_COMPANY_PROFILE_LIST_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].getCompanyProfile(companyId, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["O" /* GET_COMPANY_PROFILE_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["Q" /* GET_COMPANY_PROFILE_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPLOAD_COMPANY_PROFILE_LOGO: function UPLOAD_COMPANY_PROFILE_LOGO(_ref9, file) {
    var commit = _ref9.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_10" /* UPLOAD_COMPANY_PROFILE_LOGO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].uploadCompanyLogo(file, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_9" /* UPLOAD_COMPANY_PROFILE_LOGO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_11" /* UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY_PROFILE: function SELECT_CURRENT_COMPANY_PROFILE(_ref10, profileId) {
    var commit = _ref10.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["o" /* CURRENT_COMPANY_PROFILE_SELECTED */], profileId);
      resolve();
    });
  },
  CREATE_COMPANY_PROFILE_INFO: function CREATE_COMPANY_PROFILE_INFO(_ref11, _ref12) {
    var commit = _ref11.commit;
    var companyId = _ref12.companyId,
        payload = _ref12.payload;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["l" /* CREATE_COMPANY_PROFILE_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].createCompanyProfile(companyId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["k" /* CREATE_COMPANY_PROFILE_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["m" /* CREATE_COMPANY_PROFILE_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_PROFILE_INFO: function UPDATE_COMPANY_PROFILE_INFO(_ref13, _ref14) {
    var commit = _ref13.commit;
    var profileId = _ref14.profileId,
        payload = _ref14.payload;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_4" /* UPDATE_COMPANY_PROFILE_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].updateCompanyProfile(profileId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_3" /* UPDATE_COMPANY_PROFILE_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["_5" /* UPDATE_COMPANY_PROFILE_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_PROFILE_INFO: function DELETE_COMPANY_PROFILE_INFO(_ref15, profileId) {
    var commit = _ref15.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["A" /* DELETE_COMPANY_PROFILE_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].deleteCompanyProfile(profileId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["z" /* DELETE_COMPANY_PROFILE_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["B" /* DELETE_COMPANY_PROFILE_INFO_SUCCESS */], profileId);
        return resolve();
      });
    });
  },

  // Company Admin Users
  GET_COMPANY_ADMIN_LIST: function GET_COMPANY_ADMIN_LIST(_ref16, companyId) {
    var commit = _ref16.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["J" /* GET_COMPANY_ADMIN_LIST_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].getCompanyAdmin(companyId, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["I" /* GET_COMPANY_ADMIN_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["K" /* GET_COMPANY_ADMIN_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_COMPANY_ADMIN: function SELECT_CURRENT_COMPANY_ADMIN(_ref17, userId) {
    var commit = _ref17.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["n" /* CURRENT_COMPANY_ADMIN_SELECTED */], userId);
      resolve();
    });
  },
  CREATE_COMPANY_ADMIN_INFO: function CREATE_COMPANY_ADMIN_INFO(_ref18, _ref19) {
    var commit = _ref18.commit;
    var companyId = _ref19.companyId,
        payload = _ref19.payload;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["f" /* CREATE_COMPANY_ADMIN_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].createCompanyAdmin(companyId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["e" /* CREATE_COMPANY_ADMIN_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["g" /* CREATE_COMPANY_ADMIN_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_COMPANY_ADMIN_INFO: function UPDATE_COMPANY_ADMIN_INFO(_ref20, _ref21) {
    var commit = _ref20.commit;
    var userId = _ref21.userId,
        payload = _ref21.payload;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["Y" /* UPDATE_COMPANY_ADMIN_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].updateCompanyAdmin(userId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["X" /* UPDATE_COMPANY_ADMIN_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["Z" /* UPDATE_COMPANY_ADMIN_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_COMPANY_ADMIN_INFO: function DELETE_COMPANY_ADMIN_INFO(_ref22, userId) {
    var commit = _ref22.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["u" /* DELETE_COMPANY_ADMIN_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].deleteCompanyAdmin(userId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["t" /* DELETE_COMPANY_ADMIN_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["v" /* DELETE_COMPANY_ADMIN_INFO_SUCCESS */], userId);
        return resolve();
      });
    });
  },

  // Admin Users
  GET_ADMIN_MY_ADMIN_INFO: function GET_ADMIN_MY_ADMIN_INFO(_ref23) {
    var commit = _ref23.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["D" /* GET_ADMIN_MY_ADMIN_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].getAdminMyAdmin(function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["C" /* GET_ADMIN_MY_ADMIN_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["E" /* GET_ADMIN_MY_ADMIN_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  GET_ADMIN_USER_LIST: function GET_ADMIN_USER_LIST(_ref24) {
    var commit = _ref24.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["G" /* GET_ADMIN_USER_LIST_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].getAdminUser(function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["F" /* GET_ADMIN_USER_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["H" /* GET_ADMIN_USER_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  CREATE_ADMIN_USER: function CREATE_ADMIN_USER(_ref25, payload) {
    var commit = _ref25.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["c" /* CREATE_ADMIN_USER_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].createAdminUser(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["b" /* CREATE_ADMIN_USER_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["d" /* CREATE_ADMIN_USER_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_ADMIN_USER: function UPDATE_ADMIN_USER(_ref26, payload) {
    var commit = _ref26.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["V" /* UPDATE_ADMIN_USER_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].updateAdminUser(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["U" /* UPDATE_ADMIN_USER_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["W" /* UPDATE_ADMIN_USER_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_ADMIN_USER: function DELETE_ADMIN_USER(_ref27, userId) {
    var commit = _ref27.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["r" /* DELETE_ADMIN_USER_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].deleteAdminUser(userId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["q" /* DELETE_ADMIN_USER_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["s" /* DELETE_ADMIN_USER_SUCCESS */], userId);
        return resolve();
      });
    });
  },
  UNBLOCK_ADMIN_USER: function UNBLOCK_ADMIN_USER(_ref28, adminId) {
    var commit = _ref28.commit;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["S" /* UNBLOCK_ADMIN_USER_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_2__services_company__["a" /* default */].unblockAdminUser(adminId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["R" /* UNBLOCK_ADMIN_USER_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_3__mutations_company__["T" /* UNBLOCK_ADMIN_USER_SUCCESS */], adminId);
        return resolve();
      });
    });
  }
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["M" /* GET_COMPANY_LIST_REQUEST */], function (state) {
  state.isGettingCompany = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["N" /* GET_COMPANY_LIST_SUCCESS */], function (state, result) {
  state.isGettingCompany = false;
  state.companyList = result;
  // rebuild index
  rebuildCompanyIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["L" /* GET_COMPANY_LIST_FAIL */], function (state) {
  state.isGettingCompany = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["p" /* CURRENT_COMPANY_SELECTED */], function (state, companyId) {
  state.currentCompanyId = companyId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_7" /* UPLOAD_COMPANY_LOGO_REQUEST */], function (state) {
  state.isUploadingCompanyFile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_6" /* UPLOAD_COMPANY_LOGO_FAIL */], function (state) {
  state.isUploadingCompanyFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_8" /* UPLOAD_COMPANY_LOGO_SUCCESS */], function (state) {
  state.isUploadingCompanyFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["i" /* CREATE_COMPANY_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["h" /* CREATE_COMPANY_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["j" /* CREATE_COMPANY_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyInfo = false;
  // inject data to companyList
  state.companyList.push(result);
  rebuildCompanyIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_1" /* UPDATE_COMPANY_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_0" /* UPDATE_COMPANY_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_2" /* UPDATE_COMPANY_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyInfo = false;
  // replace data in companyList
  var companyId = '_' + result.id;
  if (typeof state.companyListIndex[companyId] !== 'undefined') {
    state.companyList.splice(state.companyListIndex[companyId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["x" /* DELETE_COMPANY_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["w" /* DELETE_COMPANY_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["y" /* DELETE_COMPANY_INFO_SUCCESS */], function (state, companyId) {
  state.currentCompanyId = null;
  state.isSubmittingCompanyInfo = false;
  // remove data in companyList
  var idx = '_' + companyId;
  if (typeof state.companyListIndex[idx] !== 'undefined') {
    // delete state.companyList[state.companyListIndex[idx]];
    state.companyList.splice(state.companyListIndex[idx], 1);
    rebuildCompanyIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["P" /* GET_COMPANY_PROFILE_LIST_REQUEST */], function (state) {
  state.isGettingCompanyProfile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["Q" /* GET_COMPANY_PROFILE_LIST_SUCCESS */], function (state, result) {
  state.isGettingCompanyProfile = false;
  state.companyProfileList = result;
  // rebuild index
  rebuildCompanyProfileIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["O" /* GET_COMPANY_PROFILE_LIST_FAIL */], function (state) {
  state.isGettingCompanyProfile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["o" /* CURRENT_COMPANY_PROFILE_SELECTED */], function (state, profileId) {
  state.currentCompanyProfileId = profileId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_10" /* UPLOAD_COMPANY_PROFILE_LOGO_REQUEST */], function (state) {
  state.isUploadingCompanyProfileFile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_9" /* UPLOAD_COMPANY_PROFILE_LOGO_FAIL */], function (state) {
  state.isUploadingCompanyProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_11" /* UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS */], function (state) {
  state.isUploadingCompanyProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["l" /* CREATE_COMPANY_PROFILE_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyProfileInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["k" /* CREATE_COMPANY_PROFILE_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyProfileInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["m" /* CREATE_COMPANY_PROFILE_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyProfileInfo = false;
  // inject data to companyList
  state.companyProfileList.push(result);
  rebuildCompanyProfileIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_4" /* UPDATE_COMPANY_PROFILE_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyProfileInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_3" /* UPDATE_COMPANY_PROFILE_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyProfileInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["_5" /* UPDATE_COMPANY_PROFILE_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyProfileInfo = false;
  // replace data in companyList
  var profileId = '_' + result.id;
  if (typeof state.companyProfileListIndex[profileId] !== 'undefined') {
    state.companyProfileList.splice(state.companyProfileListIndex[profileId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["A" /* DELETE_COMPANY_PROFILE_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyProfileInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["z" /* DELETE_COMPANY_PROFILE_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyProfileInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["B" /* DELETE_COMPANY_PROFILE_INFO_SUCCESS */], function (state, profileId) {
  state.currentCompanyProfileId = null;
  state.isSubmittingCompanyProfileInfo = false;
  // remove data in companyList
  var idx = '_' + profileId;
  if (typeof state.companyProfileListIndex[idx] !== 'undefined') {
    // delete state.companyProfileList[state.companyProfileListIndex[idx]];
    state.companyProfileList.splice(state.companyProfileListIndex[idx], 1);
    rebuildCompanyProfileIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["J" /* GET_COMPANY_ADMIN_LIST_REQUEST */], function (state) {
  state.isGettingCompanyAdmin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["K" /* GET_COMPANY_ADMIN_LIST_SUCCESS */], function (state, result) {
  state.isGettingCompanyAdmin = false;
  state.companyAdminList = result;
  // rebuild index
  rebuildCompanyAdminIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["I" /* GET_COMPANY_ADMIN_LIST_FAIL */], function (state) {
  state.isGettingCompanyAdmin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["n" /* CURRENT_COMPANY_ADMIN_SELECTED */], function (state, userId) {
  state.currentCompanyAdminId = userId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["f" /* CREATE_COMPANY_ADMIN_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["e" /* CREATE_COMPANY_ADMIN_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["g" /* CREATE_COMPANY_ADMIN_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyAdminInfo = false;
  // inject data to companyAdminList
  state.companyAdminList.push(result);
  rebuildCompanyAdminIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["Y" /* UPDATE_COMPANY_ADMIN_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["X" /* UPDATE_COMPANY_ADMIN_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["Z" /* UPDATE_COMPANY_ADMIN_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingCompanyAdminInfo = false;
  // replace data in companyAdminList
  var userId = '_' + result.id;
  if (typeof state.companyAdminListIndex[userId] !== 'undefined') {
    state.companyAdminList.splice(state.companyAdminListIndex[userId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["u" /* DELETE_COMPANY_ADMIN_INFO_REQUEST */], function (state) {
  state.isSubmittingCompanyAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["t" /* DELETE_COMPANY_ADMIN_INFO_FAIL */], function (state) {
  state.isSubmittingCompanyAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["v" /* DELETE_COMPANY_ADMIN_INFO_SUCCESS */], function (state, userId) {
  state.currentCompanyAdminId = null;
  state.isSubmittingCompanyAdminInfo = false;
  // remove data in companyList
  var idx = '_' + userId;
  if (typeof state.companyAdminListIndex[idx] !== 'undefined') {
    // delete state.companyAdminList[state.companyProfileListIndex[idx]];
    state.companyAdminList.splice(state.companyProfileListIndex[idx], 1);
    rebuildCompanyAdminIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["G" /* GET_ADMIN_USER_LIST_REQUEST */], function (state) {
  state.isGettingAdmin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["H" /* GET_ADMIN_USER_LIST_SUCCESS */], function (state, result) {
  state.isGettingAdmin = false;
  state.adminList = result;
  rebuildAdminIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["F" /* GET_ADMIN_USER_LIST_FAIL */], function (state) {
  state.isGettingAdmin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["c" /* CREATE_ADMIN_USER_REQUEST */], function (state) {
  state.isSubmittingAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["d" /* CREATE_ADMIN_USER_SUCCESS */], function (state) {
  state.isSubmittingAdminInfo = false;
  rebuildAdminIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["b" /* CREATE_ADMIN_USER_FAIL */], function (state) {
  state.isSubmittingAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["V" /* UPDATE_ADMIN_USER_REQUEST */], function (state) {
  state.isSubmittingAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["W" /* UPDATE_ADMIN_USER_SUCCESS */], function (state) {
  state.isSubmittingAdminInfo = false;
  // rebuildAdminIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["U" /* UPDATE_ADMIN_USER_FAIL */], function (state) {
  state.isSubmittingAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["r" /* DELETE_ADMIN_USER_REQUEST */], function (state) {
  state.isSubmittingAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["s" /* DELETE_ADMIN_USER_SUCCESS */], function (state) {
  state.isSubmittingAdminInfo = false;
  /* // remove data in companyList
  const idx = `_${userId}`;
  if (typeof state.companyAdminListIndex[idx] !== 'undefined') {
    // delete state.companyAdminList[state.companyProfileListIndex[idx]];
    state.adminList.splice(state.adminListIndex[idx], 1);
    rebuildAdminIndex(state);
  } */
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["q" /* DELETE_ADMIN_USER_FAIL */], function (state) {
  state.isSubmittingAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["S" /* UNBLOCK_ADMIN_USER_REQUEST */], function (state) {
  state.isSubmittingAdminInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["T" /* UNBLOCK_ADMIN_USER_SUCCESS */], function (state) {
  state.isSubmittingAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["R" /* UNBLOCK_ADMIN_USER_FAIL */], function (state) {
  state.isSubmittingAdminInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["D" /* GET_ADMIN_MY_ADMIN_INFO_REQUEST */], function (state) {
  state.isGettingAdminMyAdmin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["E" /* GET_ADMIN_MY_ADMIN_INFO_SUCCESS */], function (state, result) {
  state.isGettingAdminMyAdmin = false;
  state.scbAdminInfo = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["C" /* GET_ADMIN_MY_ADMIN_INFO_FAIL */], function (state) {
  state.isGettingAdminMyAdmin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__mutations_company__["a" /* COMPANY_STATE_CLEARED */], function (state) {
  state.companyList.splice(0);
  state.companyListIndex = {};
  state.isGettingCompany = false;
  state.isUploadingCompanyFile = false;
  state.isSubmittingCompanyInfo = false;
  state.currentCompanyId = null;
  state.isGettingCompanyProfile = false;
  state.companyProfileList.splice(0);
  state.companyProfileListIndex = {};
  state.isSubmittingCompanyProfileInfo = false;
  state.currentCompanyProfileId = null;
  state.isUploadingCompanyProfileFile = false;
  state.isGettingCompanyAdmin = false;
  state.companyAdminList.splice(0);
  state.companyAdminListIndex = {};
  state.isSubmittingcompanyAdminInfo = false;
  state.currentCompanyAdminId = null;
  state.isSubmittingAdminInfo = false;
  state.adminList.splice(0);
  state.adminListIndex = {};
  state.isGettingAdmin = false;
  state.companyListSearchIndex = null;
  state.adminListSearchIndex = null;
}), _mutations);

var CompanyStore = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyStore);

/***/ }),

/***/ 1088:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPANY_STATE_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_COMPANY_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_COMPANY_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_COMPANY_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPLOAD_COMPANY_LOGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPLOAD_COMPANY_LOGO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPLOAD_COMPANY_LOGO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CURRENT_COMPANY_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CREATE_COMPANY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CREATE_COMPANY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_COMPANY_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UPDATE_COMPANY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UPDATE_COMPANY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_COMPANY_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DELETE_COMPANY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return DELETE_COMPANY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DELETE_COMPANY_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return GET_COMPANY_PROFILE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return GET_COMPANY_PROFILE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return GET_COMPANY_PROFILE_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CURRENT_COMPANY_PROFILE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPLOAD_COMPANY_PROFILE_LOGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPLOAD_COMPANY_PROFILE_LOGO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CREATE_COMPANY_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_COMPANY_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CREATE_COMPANY_PROFILE_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_COMPANY_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_COMPANY_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_COMPANY_PROFILE_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DELETE_COMPANY_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DELETE_COMPANY_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DELETE_COMPANY_PROFILE_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_COMPANY_ADMIN_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_COMPANY_ADMIN_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_COMPANY_ADMIN_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CURRENT_COMPANY_ADMIN_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_COMPANY_ADMIN_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_COMPANY_ADMIN_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_COMPANY_ADMIN_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_COMPANY_ADMIN_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_COMPANY_ADMIN_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_COMPANY_ADMIN_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DELETE_COMPANY_ADMIN_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DELETE_COMPANY_ADMIN_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DELETE_COMPANY_ADMIN_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_ADMIN_USER_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_ADMIN_USER_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_ADMIN_USER_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_ADMIN_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_ADMIN_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_ADMIN_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UPDATE_ADMIN_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_ADMIN_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UPDATE_ADMIN_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DELETE_ADMIN_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DELETE_ADMIN_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DELETE_ADMIN_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UNBLOCK_ADMIN_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UNBLOCK_ADMIN_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UNBLOCK_ADMIN_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_ADMIN_MY_ADMIN_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_ADMIN_MY_ADMIN_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_ADMIN_MY_ADMIN_INFO_FAIL; });
var COMPANY_STATE_CLEARED = 'company.STATE_CLEARED';
var GET_COMPANY_LIST_REQUEST = 'company.GET_COMPANY_LIST_REQUEST';
var GET_COMPANY_LIST_SUCCESS = 'company.GET_COMPANY_LIST_SUCCESS';
var GET_COMPANY_LIST_FAIL = 'company.GET_COMPANY_LIST_FAIL';
var UPLOAD_COMPANY_LOGO_REQUEST = 'company.UPLOAD_COMPANY_LOGO_REQUEST';
var UPLOAD_COMPANY_LOGO_SUCCESS = 'company.UPLOAD_COMPANY_LOGO_SUCCESS';
var UPLOAD_COMPANY_LOGO_FAIL = 'company.UPLOAD_COMPANY_LOGO_FAIL';
var CURRENT_COMPANY_SELECTED = 'company.CURRENT_COMPANY_SELECTED';
var CREATE_COMPANY_INFO_REQUEST = 'company.CREATE_COMPANY_INFO_REQUEST';
var CREATE_COMPANY_INFO_SUCCESS = 'company.CREATE_COMPANY_INFO_SUCCESS';
var CREATE_COMPANY_INFO_FAIL = 'company.CREATE_COMPANY_INFO_FAIL';
var UPDATE_COMPANY_INFO_REQUEST = 'company.UPDATE_COMPANY_INFO_REQUEST';
var UPDATE_COMPANY_INFO_SUCCESS = 'company.UPDATE_COMPANY_INFO_SUCCESS';
var UPDATE_COMPANY_INFO_FAIL = 'company.UPDATE_COMPANY_INFO_FAIL';
var DELETE_COMPANY_INFO_REQUEST = 'company.DELETE_COMPANY_INFO_REQUEST';
var DELETE_COMPANY_INFO_SUCCESS = 'company.DELETE_COMPANY_INFO_SUCCESS';
var DELETE_COMPANY_INFO_FAIL = 'company.DELETE_COMPANY_INFO_FAIL';
// PROFILES
var GET_COMPANY_PROFILE_LIST_REQUEST = 'company.GET_COMPANY_PROFILE_LIST_REQUEST';
var GET_COMPANY_PROFILE_LIST_SUCCESS = 'company.GET_COMPANY_PROFILE_LIST_SUCCESS';
var GET_COMPANY_PROFILE_LIST_FAIL = 'company.GET_COMPANY_PROFILE_LIST_FAIL';
var CURRENT_COMPANY_PROFILE_SELECTED = 'company.CURRENT_COMPANY_PROFILE_SELECTED';
var UPLOAD_COMPANY_PROFILE_LOGO_REQUEST = 'company.UPLOAD_COMPANY_PROFILE_LOGO_REQUEST';
var UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS = 'company.UPLOAD_COMPANY_PROFILE_LOGO_SUCCESS';
var UPLOAD_COMPANY_PROFILE_LOGO_FAIL = 'company.UPLOAD_COMPANY_PROFILE_LOGO_FAIL';
var CREATE_COMPANY_PROFILE_INFO_REQUEST = 'company.CREATE_COMPANY_PROFILE_INFO_REQUEST';
var CREATE_COMPANY_PROFILE_INFO_SUCCESS = 'company.CREATE_COMPANY_PROFILE_INFO_SUCCESS';
var CREATE_COMPANY_PROFILE_INFO_FAIL = 'company.CREATE_COMPANY_PROFILE_INFO_FAIL';
var UPDATE_COMPANY_PROFILE_INFO_REQUEST = 'company.UPDATE_COMPANY_PROFILE_INFO_REQUEST';
var UPDATE_COMPANY_PROFILE_INFO_SUCCESS = 'company.UPDATE_COMPANY_PROFILE_INFO_SUCCESS';
var UPDATE_COMPANY_PROFILE_INFO_FAIL = 'company.UPDATE_COMPANY_PROFILE_INFO_FAIL';
var DELETE_COMPANY_PROFILE_INFO_REQUEST = 'company.DELETE_COMPANY_PROFILE_INFO_REQUEST';
var DELETE_COMPANY_PROFILE_INFO_SUCCESS = 'company.DELETE_COMPANY_PROFILE_INFO_SUCCESS';
var DELETE_COMPANY_PROFILE_INFO_FAIL = 'company.DELETE_COMPANY_PROFILE_INFO_FAIL';
// COMPANY ADMIN USERS
var GET_COMPANY_ADMIN_LIST_REQUEST = 'company.GET_COMPANY_ADMIN_LIST_REQUEST';
var GET_COMPANY_ADMIN_LIST_SUCCESS = 'company.GET_COMPANY_ADMIN_LIST_SUCCESS';
var GET_COMPANY_ADMIN_LIST_FAIL = 'company.GET_COMPANY_ADMIN_LIST_FAIL';
var CURRENT_COMPANY_ADMIN_SELECTED = 'company.CURRENT_COMPANY_ADMIN_SELECTED';
var CREATE_COMPANY_ADMIN_INFO_REQUEST = 'company.CREATE_COMPANY_ADMIN_INFO_REQUEST';
var CREATE_COMPANY_ADMIN_INFO_SUCCESS = 'company.CREATE_COMPANY_ADMIN_INFO_SUCCESS';
var CREATE_COMPANY_ADMIN_INFO_FAIL = 'company.CREATE_COMPANY_ADMIN_INFO_FAIL';
var UPDATE_COMPANY_ADMIN_INFO_REQUEST = 'company.UPDATE_COMPANY_ADMIN_INFO_REQUEST';
var UPDATE_COMPANY_ADMIN_INFO_SUCCESS = 'company.UPDATE_COMPANY_ADMIN_INFO_SUCCESS';
var UPDATE_COMPANY_ADMIN_INFO_FAIL = 'company.UPDATE_COMPANY_ADMIN_INFO_FAIL';
var DELETE_COMPANY_ADMIN_INFO_REQUEST = 'company.DELETE_COMPANY_ADMIN_INFO_REQUEST';
var DELETE_COMPANY_ADMIN_INFO_SUCCESS = 'company.DELETE_COMPANY_ADMIN_INFO_SUCCESS';
var DELETE_COMPANY_ADMIN_INFO_FAIL = 'company.DELETE_COMPANY_ADMIN_INFO_FAIL';
// SCB ADMIN USERS
var GET_ADMIN_USER_LIST_REQUEST = 'company.GET_ADMIN_USER_LIST_REQUEST';
var GET_ADMIN_USER_LIST_SUCCESS = 'company.GET_ADMIN_USER_LIST_SUCCESS';
var GET_ADMIN_USER_LIST_FAIL = 'company.GET_ADMIN_USER_LIST_FAIL';
var CREATE_ADMIN_USER_REQUEST = 'company.CREATE_ADMIN_USER_REQUEST';
var CREATE_ADMIN_USER_SUCCESS = 'company.CREATE_ADMIN_USER_SUCCESS';
var CREATE_ADMIN_USER_FAIL = 'company.CREATE_ADMIN_USER_FAIL';
var UPDATE_ADMIN_USER_REQUEST = 'company.UPDATE_ADMIN_USER_REQUEST';
var UPDATE_ADMIN_USER_SUCCESS = 'company.UPDATE_ADMIN_USER_SUCCESS';
var UPDATE_ADMIN_USER_FAIL = 'company.UPDATE_ADMIN_USER_FAIL';
var DELETE_ADMIN_USER_REQUEST = 'company.DELETE_ADMIN_USER_REQUEST';
var DELETE_ADMIN_USER_SUCCESS = 'company.DELETE_ADMIN_USER_SUCCESS';
var DELETE_ADMIN_USER_FAIL = 'company.DELETE_ADMIN_USER_FAIL';
var UNBLOCK_ADMIN_USER_REQUEST = 'company.UNBLOCK_ADMIN_USER_REQUEST';
var UNBLOCK_ADMIN_USER_SUCCESS = 'company.UNBLOCK_ADMIN_USER_SUCCESS';
var UNBLOCK_ADMIN_USER_FAIL = 'company.UNBLOCK_ADMIN_USER_FAIL';
var GET_ADMIN_MY_ADMIN_INFO_REQUEST = 'company.GET_ADMIN_MY_ADMIN_INFO_REQUEST';
var GET_ADMIN_MY_ADMIN_INFO_SUCCESS = 'company.GET_ADMIN_MY_ADMIN_INFO_SUCCESS';
var GET_ADMIN_MY_ADMIN_INFO_FAIL = 'company.GET_ADMIN_MY_ADMIN_INFO_FAIL';

/***/ }),

/***/ 1089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_company__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations_biller__ = __webpack_require__(1090);




var _mutations;

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: [2, { "props": false }] */




var rebuildBillerProfileIndex = function rebuildBillerProfileIndex(state) {
  delete state.billerProfileListIndex;
  state.billerProfileListIndex = {};
  state.billerProfileList.forEach(function (item, index) {
    state.billerProfileListIndex['_' + item.id] = index;
  });
};

var rebuildBillerSlipIndex = function rebuildBillerSlipIndex(state) {
  delete state.billerSlipListIndex;
  state.billerSlipListIndex = {};
  state.billerSlipList.forEach(function (item, index) {
    state.billerSlipListIndex['_' + item.id] = index;
  });
};

var rebuildBillerUserIndex = function rebuildBillerUserIndex(state) {
  delete state.billerUserListIndex;
  state.billerUserListIndex = {};
  state.billerUserList.forEach(function (item, index) {
    state.billerUserListIndex['_' + item.id] = index;
  });
};

var state = {
  myAdminInfo: null,
  billerInfo: null,
  isGettingBillerMyAdmin: false,
  isGettingBillerCompany: false,
  isUploadingBillerCompanyFile: false,
  isSubmittingBillerCompanyInfo: false,
  // profiles
  isGettingBillerProfile: false,
  billerProfileList: [],
  billerProfileListIndex: {}, // reverse index
  isSubmittingBillerProfileInfo: false,
  currentBillerProfileId: null,
  isUploadingBillerProfileFile: false,
  // slips
  isGettingBillerSlip: false,
  billerSlipList: [],
  billerSlipListTotalItem: 0,
  billerSlipListIndex: {}, // reverse index
  isSubmittingBillerSlipInfo: false,
  currentBillerSlipId: null,
  // biller's users
  isGettingBillerUser: false,
  billerUserList: [],
  billerUserListIndex: {}, // reverse index
  isSubmittingBillerUserInfo: false,
  currentBillerUserId: null,
  // slips
  isPrintingSlip: false,
  isEmailingSlip: false,
  isDeletingSlip: false,
  isImportingSlip: false,
  slipSearchQuery: null,
  slipSearchOption: ['1']
};

var getters = {
  billerInfo: function billerInfo(state) {
    return state.billerInfo;
  },
  myAdminInfo: function myAdminInfo(state) {
    return state.myAdminInfo;
  },
  isInitialLoading: function isInitialLoading(state) {
    return state.isGettingBillerMyAdmin || state.isGettingBillerCompany;
  },

  // PROFILES
  billerProfileList: function billerProfileList(state) {
    return state.billerProfileList;
  },
  billerProfileListIndex: function billerProfileListIndex(state) {
    return state.billerProfileListIndex;
  },
  currentBillerProfile: function currentBillerProfile(state) {
    if (state.currentBillerProfileId) {
      var indexId = '_' + state.currentBillerProfileId;
      if (typeof state.billerProfileListIndex[indexId] !== 'undefined') {
        return state.billerProfileList[state.billerProfileListIndex[indexId]];
      }
    }
    return null;
  },

  // SLIPS
  billerSlipList: function billerSlipList(state) {
    return state.billerSlipList;
  },
  billerSlipListTotalItem: function billerSlipListTotalItem(state) {
    return state.billerSlipListTotalItem;
  },
  billerSlipListIndex: function billerSlipListIndex(state) {
    return state.billerSlipListIndex;
  },
  currentBillerSlip: function currentBillerSlip(state) {
    if (state.currentBillerSlipId) {
      var indexId = '_' + state.currentBillerSlipId;
      if (typeof state.billerSlipListIndex[indexId] !== 'undefined') {
        return state.billerSlipList[state.billerSlipListIndex[indexId]];
      }
    }
    return null;
  },

  // BILLER USERS
  billerUserList: function billerUserList(state) {
    return state.billerUserList;
  },
  billerUserListIndex: function billerUserListIndex(state) {
    return state.billerUserListIndex;
  },
  currentBillerUser: function currentBillerUser(state) {
    if (state.currentBillerUserId) {
      var indexId = '_' + state.currentBillerUserId;
      if (typeof state.billerUserListIndex[indexId] !== 'undefined') {
        return state.billerUserList[state.billerUserListIndex[indexId]];
      }
    }
    return null;
  },
  isPrintingSlip: function isPrintingSlip(state) {
    return state.isPrintingSlip;
  },
  slipSearchQuery: function slipSearchQuery(state) {
    return state.slipSearchQuery;
  },
  slipSearchOption: function slipSearchOption(state) {
    return state.slipSearchOption;
  }
};
var actions = {
  BILLER_CLEAR_STATE: function BILLER_CLEAR_STATE(_ref) {
    var commit = _ref.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["a" /* BILLER_STATE_CLEARED */]);
      resolve();
    });
  },
  GET_BILLER_MY_ADMIN_INFO: function GET_BILLER_MY_ADMIN_INFO(_ref2) {
    var commit = _ref2.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["D" /* GET_BILLER_MY_ADMIN_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].getBillerMyAdmin(function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["C" /* GET_BILLER_MY_ADMIN_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["E" /* GET_BILLER_MY_ADMIN_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  GET_BILLER_COMPANY_INFO: function GET_BILLER_COMPANY_INFO(_ref3, companyId) {
    var commit = _ref3.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["A" /* GET_BILLER_COMPANY_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].getBillerCompany(companyId, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["z" /* GET_BILLER_COMPANY_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["B" /* GET_BILLER_COMPANY_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPLOAD_BILLER_COMPANY_LOGO: function UPLOAD_BILLER_COMPANY_LOGO(_ref4, file) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_11" /* UPLOAD_BILLER_COMPANY_LOGO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].uploadCompanyLogo(file, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_10" /* UPLOAD_BILLER_COMPANY_LOGO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_12" /* UPLOAD_BILLER_COMPANY_LOGO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_COMPANY_INFO: function UPDATE_BILLER_COMPANY_INFO(_ref5, payload) {
    var commit = _ref5.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Z" /* UPDATE_BILLER_COMPANY_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].updateCompanyInfo(payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Y" /* UPDATE_BILLER_COMPANY_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_0" /* UPDATE_BILLER_COMPANY_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },

  // Profiles
  GET_BILLER_PROFILE_LIST: function GET_BILLER_PROFILE_LIST(_ref6) {
    var commit = _ref6.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["G" /* GET_BILLER_PROFILE_LIST_REQUEST */]);
      // company.getCompanyProfile(companyId, (err, result) => {
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].getBillerCompanyProfile(function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["F" /* GET_BILLER_PROFILE_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["H" /* GET_BILLER_PROFILE_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPLOAD_BILLER_PROFILE_LOGO: function UPLOAD_BILLER_PROFILE_LOGO(_ref7, file) {
    var commit = _ref7.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_17" /* UPLOAD_BILLER_PROFILE_LOGO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].uploadCompanyLogo(file, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_16" /* UPLOAD_BILLER_PROFILE_LOGO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_18" /* UPLOAD_BILLER_PROFILE_LOGO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_PROFILE: function SELECT_CURRENT_BILLER_PROFILE(_ref8, profileId) {
    var commit = _ref8.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["h" /* CURRENT_BILLER_PROFILE_SELECTED */], profileId);
      resolve();
    });
  },
  UPDATE_BILLER_PROFILE_INFO: function UPDATE_BILLER_PROFILE_INFO(_ref9, _ref10) {
    var commit = _ref9.commit;
    var profileId = _ref10.profileId,
        payload = _ref10.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_2" /* UPDATE_BILLER_PROFILE_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].updateCompanyProfile(profileId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_1" /* UPDATE_BILLER_PROFILE_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_3" /* UPDATE_BILLER_PROFILE_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_PROFILE_INFO: function DELETE_BILLER_PROFILE_INFO(_ref11, profileId) {
    var commit = _ref11.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["l" /* DELETE_BILLER_PROFILE_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].deleteCompanyProfile(profileId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["k" /* DELETE_BILLER_PROFILE_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["m" /* DELETE_BILLER_PROFILE_INFO_SUCCESS */], profileId);
        return resolve();
      });
    });
  },

  // Slips
  GET_BILLER_SLIP_LIST: function GET_BILLER_SLIP_LIST(_ref12, reqPayload) {
    var commit = _ref12.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["J" /* GET_BILLER_SLIP_LIST_REQUEST */], reqPayload.payload);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].getBillerSlips(reqPayload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["I" /* GET_BILLER_SLIP_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["K" /* GET_BILLER_SLIP_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_SLIP: function SELECT_CURRENT_BILLER_SLIP(_ref13, slipId) {
    var commit = _ref13.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["i" /* CURRENT_BILLER_SLIP_SELECTED */], slipId);
      resolve();
    });
  },
  CREATE_BILLER_SLIP_INFO: function CREATE_BILLER_SLIP_INFO(_ref14, _ref15) {
    var commit = _ref14.commit;
    var profileId = _ref15.profileId,
        payload = _ref15.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["c" /* CREATE_BILLER_SLIP_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].createBillerSlip(profileId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["b" /* CREATE_BILLER_SLIP_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["d" /* CREATE_BILLER_SLIP_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_SLIP_INFO: function UPDATE_BILLER_SLIP_INFO(_ref16, _ref17) {
    var commit = _ref16.commit;
    var slipId = _ref17.slipId,
        payload = _ref17.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_5" /* UPDATE_BILLER_SLIP_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].updateBillerSlip(slipId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_4" /* UPDATE_BILLER_SLIP_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_6" /* UPDATE_BILLER_SLIP_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_SLIP_INFO: function DELETE_BILLER_SLIP_INFO(_ref18, slipId) {
    var commit = _ref18.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["o" /* DELETE_BILLER_SLIP_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].deleteBillerSlip(slipId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["n" /* DELETE_BILLER_SLIP_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["p" /* DELETE_BILLER_SLIP_INFO_SUCCESS */], slipId);
        return resolve();
      });
    });
  },
  IMPORT_BILLER_SLIPS: function IMPORT_BILLER_SLIPS(_ref19, _ref20) {
    var commit = _ref19.commit;
    var profileId = _ref20.profileId,
        payload = _ref20.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["P" /* IMPORT_BILLER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].importBillerSlips(profileId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["O" /* IMPORT_BILLER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Q" /* IMPORT_BILLER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },

  // Biller Users
  GET_BILLER_USER_LIST: function GET_BILLER_USER_LIST(_ref21) {
    var commit = _ref21.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["M" /* GET_BILLER_USER_LIST_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].getBillerUsers(function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["L" /* GET_BILLER_USER_LIST_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["N" /* GET_BILLER_USER_LIST_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  SELECT_CURRENT_BILLER_USER: function SELECT_CURRENT_BILLER_USER(_ref22, userId) {
    var commit = _ref22.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["j" /* CURRENT_BILLER_USER_SELECTED */], userId);
      resolve();
    });
  },
  CREATE_BILLER_USER_INFO: function CREATE_BILLER_USER_INFO(_ref23, _ref24) {
    var commit = _ref23.commit;
    var companyId = _ref24.companyId,
        payload = _ref24.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["f" /* CREATE_BILLER_USER_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].createBillerUser(companyId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["e" /* CREATE_BILLER_USER_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["g" /* CREATE_BILLER_USER_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  UPDATE_BILLER_USER_INFO: function UPDATE_BILLER_USER_INFO(_ref25, _ref26) {
    var commit = _ref25.commit;
    var userId = _ref26.userId,
        payload = _ref26.payload;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_8" /* UPDATE_BILLER_USER_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].updateBillerUser(userId, payload, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_7" /* UPDATE_BILLER_USER_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_9" /* UPDATE_BILLER_USER_INFO_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_BILLER_USER_INFO: function DELETE_BILLER_USER_INFO(_ref27, userId) {
    var commit = _ref27.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["r" /* DELETE_BILLER_USER_INFO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].deleteCompanyAdmin(userId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["q" /* DELETE_BILLER_USER_INFO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["s" /* DELETE_BILLER_USER_INFO_SUCCESS */], userId);
        return resolve();
      });
    });
  },
  UNBLOCK_BILLER_USER: function UNBLOCK_BILLER_USER(_ref28, userId) {
    var commit = _ref28.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["W" /* UNBLOCK_BILLER_USER_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].unblockBillerAdmin(userId, function (err) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["V" /* UNBLOCK_BILLER_USER_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["X" /* UNBLOCK_BILLER_USER_SUCCESS */], userId);
        return resolve();
      });
    });
  },
  PRINT_PAYER_SLIP: function PRINT_PAYER_SLIP(_ref29, _ref30) {
    var commit = _ref29.commit;
    var profileId = _ref30.profileId,
        slips = _ref30.slips;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["S" /* PRINT_PAYER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].printPayerSlips(profileId, slips, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["R" /* PRINT_PAYER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["T" /* PRINT_PAYER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  PRINT_PAYER_QR: function PRINT_PAYER_QR(_ref31, _ref32) {
    var commit = _ref31.commit;
    var profileId = _ref32.profileId,
        slips = _ref32.slips;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["S" /* PRINT_PAYER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].printPayerQR(profileId, slips, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["R" /* PRINT_PAYER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["T" /* PRINT_PAYER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  EMAIL_PAYER_SLIP: function EMAIL_PAYER_SLIP(_ref33, _ref34) {
    var commit = _ref33.commit;
    var profileId = _ref34.profileId,
        slips = _ref34.slips;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["x" /* EMAIL_PAYER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].emailPayerSlips(profileId, slips, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["w" /* EMAIL_PAYER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["y" /* EMAIL_PAYER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  EMAIL_PAYER_QR: function EMAIL_PAYER_QR(_ref35, _ref36) {
    var commit = _ref35.commit;
    var profileId = _ref36.profileId,
        slips = _ref36.slips;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["x" /* EMAIL_PAYER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].emailPayerQR(profileId, slips, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["w" /* EMAIL_PAYER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["y" /* EMAIL_PAYER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  DELETE_PAYER_SLIP: function DELETE_PAYER_SLIP(_ref37, _ref38) {
    var commit = _ref37.commit;
    var profileId = _ref38.profileId,
        slips = _ref38.slips;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["u" /* DELETE_PAYER_SLIPS_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].deletePayerSlips(profileId, slips, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["t" /* DELETE_PAYER_SLIPS_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["v" /* DELETE_PAYER_SLIPS_SUCCESS */], result);
        return resolve(result);
      });
    });
  },
  TOGGLE_BILLER_SLIP_SEARCH_OPTION: function TOGGLE_BILLER_SLIP_SEARCH_OPTION(_ref39) {
    var commit = _ref39.commit;

    commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["U" /* TOGGLE_BILLER_SLIP_SEARCH_OPTION */]);
  },
  UPLOAD_BILLER_OTHER_BANK_LOGO: function UPLOAD_BILLER_OTHER_BANK_LOGO(_ref40, file) {
    var commit = _ref40.commit;

    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_14" /* UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST */]);
      __WEBPACK_IMPORTED_MODULE_4__services_company__["a" /* default */].uploadOtherBankLogo(file, function (err, result) {
        if (err) {
          commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_13" /* UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL */]);
          return reject(err);
        }
        commit(__WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_15" /* UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS */], result);
        return resolve(result);
      });
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["D" /* GET_BILLER_MY_ADMIN_INFO_REQUEST */], function (state) {
  state.isGettingBillerMyAdmin = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["E" /* GET_BILLER_MY_ADMIN_INFO_SUCCESS */], function (state, result) {
  state.isGettingBillerMyAdmin = false;
  state.myAdminInfo = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["C" /* GET_BILLER_MY_ADMIN_INFO_FAIL */], function (state) {
  state.isGettingBillerMyAdmin = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["A" /* GET_BILLER_COMPANY_INFO_REQUEST */], function (state) {
  state.isGettingBillerCompany = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["B" /* GET_BILLER_COMPANY_INFO_SUCCESS */], function (state, result) {
  state.isGettingBillerCompany = false;
  state.billerInfo = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["z" /* GET_BILLER_COMPANY_INFO_FAIL */], function (state) {
  state.isGettingBillerCompany = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_11" /* UPLOAD_BILLER_COMPANY_LOGO_REQUEST */], function (state) {
  state.isUploadingBillerCompanyFile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_10" /* UPLOAD_BILLER_COMPANY_LOGO_FAIL */], function (state) {
  state.isUploadingBillerCompanyFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_12" /* UPLOAD_BILLER_COMPANY_LOGO_SUCCESS */], function (state) {
  state.isUploadingBillerCompanyFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Z" /* UPDATE_BILLER_COMPANY_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerCompanyInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Y" /* UPDATE_BILLER_COMPANY_INFO_FAIL */], function (state) {
  state.isSubmittingBillerCompanyInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_0" /* UPDATE_BILLER_COMPANY_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerCompanyInfo = false;
  // replace data
  state.billerInfo = result;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["G" /* GET_BILLER_PROFILE_LIST_REQUEST */], function (state) {
  state.isGettingBillerProfile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["H" /* GET_BILLER_PROFILE_LIST_SUCCESS */], function (state, result) {
  state.isGettingBillerProfile = false;
  state.billerProfileList = result;
  // rebuild index
  rebuildBillerProfileIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["F" /* GET_BILLER_PROFILE_LIST_FAIL */], function (state) {
  state.isGettingBillerProfile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["h" /* CURRENT_BILLER_PROFILE_SELECTED */], function (state, profileId) {
  state.currentBillerProfileId = profileId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_17" /* UPLOAD_BILLER_PROFILE_LOGO_REQUEST */], function (state) {
  state.isUploadingBillerProfileFile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_16" /* UPLOAD_BILLER_PROFILE_LOGO_FAIL */], function (state) {
  state.isUploadingBillerProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_18" /* UPLOAD_BILLER_PROFILE_LOGO_SUCCESS */], function (state) {
  state.isUploadingBillerProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_2" /* UPDATE_BILLER_PROFILE_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerProfileInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_1" /* UPDATE_BILLER_PROFILE_INFO_FAIL */], function (state) {
  state.isSubmittingBillerProfileInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_3" /* UPDATE_BILLER_PROFILE_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerProfileInfo = false;
  // replace data in companyList
  var profileId = '_' + result.id;
  if (typeof state.billerProfileListIndex[profileId] !== 'undefined') {
    state.billerProfileList.splice(state.billerProfileListIndex[profileId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["l" /* DELETE_BILLER_PROFILE_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerProfileInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["k" /* DELETE_BILLER_PROFILE_INFO_FAIL */], function (state) {
  state.isSubmittingBillerProfileInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["m" /* DELETE_BILLER_PROFILE_INFO_SUCCESS */], function (state, profileId) {
  state.currentBillerProfileId = null;
  state.isSubmittingBillerProfileInfo = false;
  // remove data in companyList
  var idx = '_' + profileId;
  if (typeof state.billerProfileListIndex[idx] !== 'undefined') {
    // delete state.billerProfileList[state.billerProfileListIndex[idx]];
    state.billerProfileList.splice(state.billerProfileListIndex[idx], 1);
    rebuildBillerProfileIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["J" /* GET_BILLER_SLIP_LIST_REQUEST */], function (state, query) {
  state.isGettingBillerSlip = true;
  state.slipSearchQuery = {};
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(query).forEach(function (key) {
    if (key !== 'offset') {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.slipSearchQuery, key, query[key]);
    } else {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state.slipSearchQuery, key, 0);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["K" /* GET_BILLER_SLIP_LIST_SUCCESS */], function (state, _ref41) {
  var total = _ref41.total,
      data = _ref41.data;

  state.isGettingBillerSlip = false;
  state.billerSlipList = data;
  state.billerSlipListTotalItem = total;
  // rebuild index
  rebuildBillerSlipIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["I" /* GET_BILLER_SLIP_LIST_FAIL */], function (state) {
  state.isGettingBillerSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["i" /* CURRENT_BILLER_SLIP_SELECTED */], function (state, profileId) {
  state.currentBillerSlipId = profileId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["c" /* CREATE_BILLER_SLIP_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerSlipInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["b" /* CREATE_BILLER_SLIP_INFO_FAIL */], function (state) {
  state.isSubmittingBillerSlipInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["d" /* CREATE_BILLER_SLIP_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerSlipInfo = false;
  // add data in slipList
  state.billerSlipList.push(result);
  rebuildBillerSlipIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_5" /* UPDATE_BILLER_SLIP_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerSlipInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_4" /* UPDATE_BILLER_SLIP_INFO_FAIL */], function (state) {
  state.isSubmittingBillerSlipInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_6" /* UPDATE_BILLER_SLIP_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerSlipInfo = false;
  // replace data in companyList
  var slipId = '_' + result.id;
  if (typeof state.billerSlipListIndex[slipId] !== 'undefined') {
    state.billerSlipList.splice(state.billerSlipListIndex[slipId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["o" /* DELETE_BILLER_SLIP_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerSlipInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["n" /* DELETE_BILLER_SLIP_INFO_FAIL */], function (state) {
  state.isSubmittingBillerSlipInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["p" /* DELETE_BILLER_SLIP_INFO_SUCCESS */], function (state, slipId) {
  state.currentBillerProfileId = null;
  state.isSubmittingBillerSlipInfo = false;
  // remove data in companyList
  var idx = '_' + slipId;
  if (typeof state.billerSlipListIndex[idx] !== 'undefined') {
    state.billerSlipList.splice(state.billerSlipListIndex[idx], 1);
    rebuildBillerSlipIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["M" /* GET_BILLER_USER_LIST_REQUEST */], function (state) {
  state.isGettingBillerUser = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["N" /* GET_BILLER_USER_LIST_SUCCESS */], function (state, result) {
  state.isGettingBillerUser = false;
  state.billerUserList = result;
  // rebuild index
  rebuildBillerUserIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["L" /* GET_BILLER_USER_LIST_FAIL */], function (state) {
  state.isGettingBillerUser = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["j" /* CURRENT_BILLER_USER_SELECTED */], function (state, userId) {
  state.currentBillerUserId = userId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["f" /* CREATE_BILLER_USER_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerUserInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["e" /* CREATE_BILLER_USER_INFO_FAIL */], function (state) {
  state.isSubmittingBillerUserInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["g" /* CREATE_BILLER_USER_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerUserInfo = false;
  // inject data to billerUserList
  state.billerUserList.push(result);
  rebuildBillerUserIndex(state);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_8" /* UPDATE_BILLER_USER_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerUserInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_7" /* UPDATE_BILLER_USER_INFO_FAIL */], function (state) {
  state.isSubmittingBillerUserInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_9" /* UPDATE_BILLER_USER_INFO_SUCCESS */], function (state, result) {
  state.isSubmittingBillerUserInfo = false;
  // replace data in billerUserList
  var userId = '_' + result.id;
  if (typeof state.billerUserListIndex[userId] !== 'undefined') {
    state.billerUserList.splice(state.billerUserListIndex[userId], 1, result);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["r" /* DELETE_BILLER_USER_INFO_REQUEST */], function (state) {
  state.isSubmittingBillerUserInfo = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["q" /* DELETE_BILLER_USER_INFO_FAIL */], function (state) {
  state.isSubmittingBillerUserInfo = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["s" /* DELETE_BILLER_USER_INFO_SUCCESS */], function (state, userId) {
  state.currentBillerUserId = null;
  state.isSubmittingBillerUserInfo = false;
  // remove data in companyList
  var idx = '_' + userId;
  if (typeof state.billerUserListIndex[idx] !== 'undefined') {
    // delete state.billerUserList[state.billerProfileListIndex[idx]];
    state.billerUserList.splice(state.billerProfileListIndex[idx], 1);
    rebuildBillerUserIndex(state);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["S" /* PRINT_PAYER_SLIPS_REQUEST */], function (state) {
  state.isPrintingSlip = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["T" /* PRINT_PAYER_SLIPS_SUCCESS */], function (state) {
  state.isPrintingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["R" /* PRINT_PAYER_SLIPS_FAIL */], function (state) {
  state.isPrintingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["x" /* EMAIL_PAYER_SLIPS_REQUEST */], function (state) {
  state.isEmailingSlip = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["y" /* EMAIL_PAYER_SLIPS_SUCCESS */], function (state) {
  state.isEmailingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["w" /* EMAIL_PAYER_SLIPS_FAIL */], function (state) {
  state.isEmailingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["u" /* DELETE_PAYER_SLIPS_REQUEST */], function (state) {
  state.isDeletingSlip = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["v" /* DELETE_PAYER_SLIPS_SUCCESS */], function (state) {
  state.isDeletingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["t" /* DELETE_PAYER_SLIPS_FAIL */], function (state) {
  state.isDeletingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["P" /* IMPORT_BILLER_SLIPS_REQUEST */], function (state) {
  state.isImportingSlip = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["Q" /* IMPORT_BILLER_SLIPS_SUCCESS */], function (state) {
  state.isImportingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["O" /* IMPORT_BILLER_SLIPS_FAIL */], function (state) {
  state.isImportingSlip = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["U" /* TOGGLE_BILLER_SLIP_SEARCH_OPTION */], function (state) {
  if (state.slipSearchOption.length > 0) {
    state.slipSearchOption.splice(0);
  } else {
    state.slipSearchOption.push('1');
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_14" /* UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST */], function (state) {
  state.isUploadingBillerProfileFile = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_13" /* UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL */], function (state) {
  state.isUploadingBillerProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["_15" /* UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS */], function (state) {
  state.isUploadingBillerProfileFile = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__mutations_biller__["a" /* BILLER_STATE_CLEARED */], function (state) {
  state.myAdminInfo = null;
  state.billerInfo = null;
  state.isGettingBillerMyAdmin = false;
  state.isGettingBillerCompany = false;
  state.isUploadingBillerCompanyFile = false;
  state.isSubmittingBillerCompanyInfo = false;
  state.isGettingBillerProfile = false;
  state.billerProfileList.splice(0);
  state.billerProfileListIndex = {};
  state.isSubmittingBillerProfileInfo = false;
  state.currentBillerProfileId = null;
  state.isUploadingBillerProfileFile = false;
  state.isGettingBillerSlip = false;
  state.billerSlipList.splice(0);
  state.billerSlipListTotalItem = 0;
  state.billerSlipListIndex = {};
  state.isSubmittingBillerSlipInfo = false;
  state.currentBillerSlipId = null;
  state.isGettingBillerUser = false;
  state.billerUserList.splice(0);
  state.billerUserListIndex = {};
  state.isSubmittingBillerUserInfo = false;
  state.currentBillerUserId = null;
  state.isPrintingSlip = false;
  state.isEmailingSlip = false;
  state.isDeletingSlip = false;
  state.slipSearchQuery = null;
  state.slipSearchOption.splice(0);
  state.slipSearchOption.push('1');
}), _mutations);

var BillerStore = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/* harmony default export */ __webpack_exports__["a"] = (BillerStore);

/***/ }),

/***/ 1090:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BILLER_STATE_CLEARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_BILLER_MY_ADMIN_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_BILLER_MY_ADMIN_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_BILLER_MY_ADMIN_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_BILLER_COMPANY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_BILLER_COMPANY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_BILLER_COMPANY_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return UPLOAD_BILLER_COMPANY_LOGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return UPLOAD_BILLER_COMPANY_LOGO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return UPLOAD_BILLER_COMPANY_LOGO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return UPDATE_BILLER_COMPANY_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_BILLER_COMPANY_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return UPDATE_BILLER_COMPANY_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UNBLOCK_BILLER_USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UNBLOCK_BILLER_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return UNBLOCK_BILLER_USER_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_BILLER_PROFILE_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_BILLER_PROFILE_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_BILLER_PROFILE_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CURRENT_BILLER_PROFILE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return UPLOAD_BILLER_PROFILE_LOGO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return UPLOAD_BILLER_PROFILE_LOGO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return UPLOAD_BILLER_PROFILE_LOGO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return UPDATE_BILLER_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UPDATE_BILLER_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return UPDATE_BILLER_PROFILE_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DELETE_BILLER_PROFILE_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DELETE_BILLER_PROFILE_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_BILLER_PROFILE_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_BILLER_SLIP_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_BILLER_SLIP_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_BILLER_SLIP_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CURRENT_BILLER_SLIP_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CREATE_BILLER_SLIP_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CREATE_BILLER_SLIP_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_BILLER_SLIP_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_BILLER_SLIP_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return UPDATE_BILLER_SLIP_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_BILLER_SLIP_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DELETE_BILLER_SLIP_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DELETE_BILLER_SLIP_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELETE_BILLER_SLIP_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_BILLER_USER_LIST_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_BILLER_USER_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_BILLER_USER_LIST_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CURRENT_BILLER_USER_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREATE_BILLER_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CREATE_BILLER_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREATE_BILLER_USER_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return UPDATE_BILLER_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return UPDATE_BILLER_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return UPDATE_BILLER_USER_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DELETE_BILLER_USER_INFO_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DELETE_BILLER_USER_INFO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DELETE_BILLER_USER_INFO_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PRINT_PAYER_SLIPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRINT_PAYER_SLIPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRINT_PAYER_SLIPS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EMAIL_PAYER_SLIPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EMAIL_PAYER_SLIPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EMAIL_PAYER_SLIPS_FAIL; });
/* unused harmony export PRINT_PAYER_QR_REQUEST */
/* unused harmony export PRINT_PAYER_QR_SUCCESS */
/* unused harmony export PRINT_PAYER_QR_FAIL */
/* unused harmony export EMAIL_PAYER_QR_REQUEST */
/* unused harmony export EMAIL_PAYER_QR_SUCCESS */
/* unused harmony export EMAIL_PAYER_QR_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return DELETE_PAYER_SLIPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return DELETE_PAYER_SLIPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return DELETE_PAYER_SLIPS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return IMPORT_BILLER_SLIPS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return IMPORT_BILLER_SLIPS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return IMPORT_BILLER_SLIPS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return TOGGLE_BILLER_SLIP_SEARCH_OPTION; });
var BILLER_STATE_CLEARED = 'biller.STATE_CLEARED';
var GET_BILLER_MY_ADMIN_INFO_REQUEST = 'biller.GET_BILLER_MY_ADMIN_INFO_REQUEST';
var GET_BILLER_MY_ADMIN_INFO_SUCCESS = 'biller.GET_BILLER_MY_ADMIN_INFO_SUCCESS';
var GET_BILLER_MY_ADMIN_INFO_FAIL = 'biller.GET_BILLER_MY_ADMIN_INFO_FAIL';
var GET_BILLER_COMPANY_INFO_REQUEST = 'biller.GET_BILLER_COMPANY_INFO_REQUEST';
var GET_BILLER_COMPANY_INFO_SUCCESS = 'biller.GET_BILLER_COMPANY_INFO_SUCCESS';
var GET_BILLER_COMPANY_INFO_FAIL = 'biller.GET_BILLER_COMPANY_INFO_FAIL';
var UPLOAD_BILLER_COMPANY_LOGO_REQUEST = 'biller.UPLOAD_BILLER_COMPANY_LOGO_REQUEST';
var UPLOAD_BILLER_COMPANY_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_COMPANY_LOGO_SUCCESS';
var UPLOAD_BILLER_COMPANY_LOGO_FAIL = 'biller.UPLOAD_BILLER_COMPANY_LOGO_FAIL';
var UPDATE_BILLER_COMPANY_INFO_REQUEST = 'biller.UPDATE_BILLER_COMPANY_INFO_REQUEST';
var UPDATE_BILLER_COMPANY_INFO_SUCCESS = 'biller.UPDATE_BILLER_COMPANY_INFO_SUCCESS';
var UPDATE_BILLER_COMPANY_INFO_FAIL = 'biller.UPDATE_BILLER_COMPANY_INFO_FAIL';
var UNBLOCK_BILLER_USER_REQUEST = 'biller.UNBLOCK_BILLER_USER_REQUEST';
var UNBLOCK_BILLER_USER_SUCCESS = 'biller.UNBLOCK_BILLER_USER_SUCCESS';
var UNBLOCK_BILLER_USER_FAIL = 'biller.UNBLOCK_BILLER_USER_FAIL';
var UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_REQUEST';
var UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_SUCCESS';
var UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL = 'biller.UPLOAD_BILLER_OTHER_BANK_LOGO_FAIL';
// PROFILES
var GET_BILLER_PROFILE_LIST_REQUEST = 'biller.GET_BILLER_PROFILE_LIST_REQUEST';
var GET_BILLER_PROFILE_LIST_SUCCESS = 'biller.GET_BILLER_PROFILE_LIST_SUCCESS';
var GET_BILLER_PROFILE_LIST_FAIL = 'biller.GET_BILLER_PROFILE_LIST_FAIL';
var CURRENT_BILLER_PROFILE_SELECTED = 'biller.CURRENT_BILLER_PROFILE_SELECTED';
var UPLOAD_BILLER_PROFILE_LOGO_REQUEST = 'biller.UPLOAD_BILLER_PROFILE_LOGO_REQUEST';
var UPLOAD_BILLER_PROFILE_LOGO_SUCCESS = 'biller.UPLOAD_BILLER_PROFILE_LOGO_SUCCESS';
var UPLOAD_BILLER_PROFILE_LOGO_FAIL = 'biller.UPLOAD_BILLER_PROFILE_LOGO_FAIL';
var UPDATE_BILLER_PROFILE_INFO_REQUEST = 'biller.UPDATE_BILLER_PROFILE_INFO_REQUEST';
var UPDATE_BILLER_PROFILE_INFO_SUCCESS = 'biller.UPDATE_BILLER_PROFILE_INFO_SUCCESS';
var UPDATE_BILLER_PROFILE_INFO_FAIL = 'biller.UPDATE_BILLER_PROFILE_INFO_FAIL';
var DELETE_BILLER_PROFILE_INFO_REQUEST = 'biller.DELETE_BILLER_PROFILE_INFO_REQUEST';
var DELETE_BILLER_PROFILE_INFO_SUCCESS = 'biller.DELETE_BILLER_PROFILE_INFO_SUCCESS';
var DELETE_BILLER_PROFILE_INFO_FAIL = 'biller.DELETE_BILLER_PROFILE_INFO_FAIL';
// SLIPS
var GET_BILLER_SLIP_LIST_REQUEST = 'biller.GET_BILLER_SLIP_LIST_REQUEST';
var GET_BILLER_SLIP_LIST_SUCCESS = 'biller.GET_BILLER_SLIP_LIST_SUCCESS';
var GET_BILLER_SLIP_LIST_FAIL = 'biller.GET_BILLER_SLIP_LIST_FAIL';
var CURRENT_BILLER_SLIP_SELECTED = 'biller.CURRENT_BILLER_SLIP_SELECTED';
var CREATE_BILLER_SLIP_INFO_REQUEST = 'biller.CREATE_BILLER_SLIP_INFO_REQUEST';
var CREATE_BILLER_SLIP_INFO_SUCCESS = 'biller.CREATE_BILLER_SLIP_INFO_SUCCESS';
var CREATE_BILLER_SLIP_INFO_FAIL = 'biller.CREATE_BILLER_SLIP_INFO_FAIL';
var UPDATE_BILLER_SLIP_INFO_REQUEST = 'biller.UPDATE_BILLER_SLIP_INFO_REQUEST';
var UPDATE_BILLER_SLIP_INFO_SUCCESS = 'biller.UPDATE_BILLER_SLIP_INFO_SUCCESS';
var UPDATE_BILLER_SLIP_INFO_FAIL = 'biller.UPDATE_BILLER_SLIP_INFO_FAIL';
var DELETE_BILLER_SLIP_INFO_REQUEST = 'biller.DELETE_BILLER_SLIP_INFO_REQUEST';
var DELETE_BILLER_SLIP_INFO_SUCCESS = 'biller.DELETE_BILLER_SLIP_INFO_SUCCESS';
var DELETE_BILLER_SLIP_INFO_FAIL = 'biller.DELETE_BILLER_SLIP_INFO_FAIL';
// COMPANY ADMIN USERS
var GET_BILLER_USER_LIST_REQUEST = 'biller.GET_BILLER_USER_LIST_REQUEST';
var GET_BILLER_USER_LIST_SUCCESS = 'biller.GET_BILLER_USER_LIST_SUCCESS';
var GET_BILLER_USER_LIST_FAIL = 'biller.GET_BILLER_USER_LIST_FAIL';
var CURRENT_BILLER_USER_SELECTED = 'biller.CURRENT_BILLER_USER_SELECTED';
var CREATE_BILLER_USER_INFO_REQUEST = 'biller.CREATE_BILLER_USER_INFO_REQUEST';
var CREATE_BILLER_USER_INFO_SUCCESS = 'biller.CREATE_BILLER_USER_INFO_SUCCESS';
var CREATE_BILLER_USER_INFO_FAIL = 'biller.CREATE_BILLER_USER_INFO_FAIL';
var UPDATE_BILLER_USER_INFO_REQUEST = 'biller.UPDATE_BILLER_USER_INFO_REQUEST';
var UPDATE_BILLER_USER_INFO_SUCCESS = 'biller.UPDATE_BILLER_USER_INFO_SUCCESS';
var UPDATE_BILLER_USER_INFO_FAIL = 'biller.UPDATE_BILLER_USER_INFO_FAIL';
var DELETE_BILLER_USER_INFO_REQUEST = 'biller.DELETE_BILLER_USER_INFO_REQUEST';
var DELETE_BILLER_USER_INFO_SUCCESS = 'biller.DELETE_BILLER_USER_INFO_SUCCESS';
var DELETE_BILLER_USER_INFO_FAIL = 'biller.DELETE_BILLER_USER_INFO_FAIL';
// Payer
var PRINT_PAYER_SLIPS_REQUEST = 'biller.PRINT_PAYER_SLIP_REQUEST';
var PRINT_PAYER_SLIPS_SUCCESS = 'biller.PRINT_PAYER_SLIP_SUCCESS';
var PRINT_PAYER_SLIPS_FAIL = 'biller.PRINT_PAYER_SLIP_FAIL';
var EMAIL_PAYER_SLIPS_REQUEST = 'biller.EMAIL_PAYER_SLIP_REQUEST';
var EMAIL_PAYER_SLIPS_SUCCESS = 'biller.EMAIL_PAYER_SLIP_SUCCESS';
var EMAIL_PAYER_SLIPS_FAIL = 'biller.EMAIL_PAYER_SLIP_FAIL';
var PRINT_PAYER_QR_REQUEST = 'biller.PRINT_PAYER_QR_REQUEST';
var PRINT_PAYER_QR_SUCCESS = 'biller.PRINT_PAYER_QR_SUCCESS';
var PRINT_PAYER_QR_FAIL = 'biller.PRINT_PAYER_QR_FAIL';
var EMAIL_PAYER_QR_REQUEST = 'biller.EMAIL_PAYER_QR_REQUEST';
var EMAIL_PAYER_QR_SUCCESS = 'biller.EMAIL_PAYER_QR_SUCCESS';
var EMAIL_PAYER_QR_FAIL = 'biller.EMAIL_PAYER_QR_FAIL';
var DELETE_PAYER_SLIPS_REQUEST = 'biller.DELETE_PAYER_SLIP_REQUEST';
var DELETE_PAYER_SLIPS_SUCCESS = 'biller.DELETE_PAYER_SLIP_SUCCESS';
var DELETE_PAYER_SLIPS_FAIL = 'biller.DELETE_PAYER_SLIP_FAIL';
var IMPORT_BILLER_SLIPS_REQUEST = 'biller.IMPORT_BILLER_SLIPS_REQUEST';
var IMPORT_BILLER_SLIPS_SUCCESS = 'biller.IMPORT_BILLER_SLIPS_SUCCESS';
var IMPORT_BILLER_SLIPS_FAIL = 'biller.IMPORT_BILLER_SLIPS_FAIL';
var TOGGLE_BILLER_SLIP_SEARCH_OPTION = 'biller.TOGGLE_BILLER_SLIP_SEARCH_OPTION';

/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_biller__ = __webpack_require__(1092);



var defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? "AdminUserLoadInfo" : "BillerUserLoadInfo";

var requireBiller = function requireBiller(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.isAuthenticated) {
    return next({ name: 'Login' });
  } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
    return next({ name: 'ResetPassword' });
  } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.isAdmin) {
    return next({ name: 'Logout' });
  }
  // check if we have user's info or not
  // check if we have company info or not
  // if not, we try reloading them
  return next();
};

var requireBillerAdmin = function requireBillerAdmin(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.myAdminInfo) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.myAdminInfo.role === 'ADMIN') {
      return requireBiller(to, from, next);
    }
  }
  return next({ name: defaultRouteName });
};

var routes = [
// Company
{
  path: '/',
  name: 'BillerUserLoadInfo',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].userLoadInfo,
  beforeEnter: requireBiller,
  meta: {
    title: 'กำลังโหลด...'
  }
}, {
  path: '/company',
  name: 'BillerCompanyDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].companyDetail,
  beforeEnter: requireBiller,
  meta: {
    title: 'รายละเอียดบริษัท'
  }
}, {
  path: '/company/edit',
  name: 'BillerCompanyEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].companyEdit,
  beforeEnter: requireBillerAdmin,
  meta: {
    title: 'แก้ไขรายละเอียดบริษัท'
  }
}, {
  path: '/profiles',
  name: 'BillerProfileList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].profileList,
  beforeEnter: requireBiller,
  meta: {
    title: 'รายการข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/profiles/:profileId',
  props: true,
  name: 'BillerProfileDetail',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].profileDetail,
  beforeEnter: requireBiller,
  meta: {
    title: 'รายละเอียดข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/profiles/:profileId/edit',
  props: true,
  name: 'BillerProfileEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].profileForm,
  beforeEnter: requireBillerAdmin,
  meta: {
    title: 'แก้ไขข้อมูลบริษัทสำหรับรับชำระ'
  }
},
// Slips
{
  path: '/profiles/:profileId/slips/create',
  props: true,
  name: 'BillerSlipCreate',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].slipForm,
  beforeEnter: requireBiller,
  meta: {
    title: 'เพิ่มข้อมูลบริษัทสำหรับรับชำระ'
  }
}, {
  path: '/profiles/:profileId/slips/:slipId/edit',
  props: true,
  name: 'BillerSlipEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].slipForm,
  beforeEnter: requireBiller,
  meta: {
    title: 'แก้ไขข้อมูลผู้ชำระ'
  }
},
// Users
{
  path: '/users',
  name: 'BillerUserList',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].userList,
  beforeEnter: requireBillerAdmin,
  meta: {
    title: 'รายการบัญชีผู้ใช้ระบบของบริษัท'
  }
}, {
  path: '/users/create',
  name: 'BillerUserCreate',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].userForm,
  beforeEnter: requireBillerAdmin,
  meta: {
    title: 'สร้างบัญชีผู้ใช้ระบบของบริษัท'
  }
}, {
  path: '/users/:userId',
  props: true,
  name: 'BillerUserEdit',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_biller__["a" /* default */].userForm,
  beforeEnter: requireBillerAdmin,
  meta: {
    title: 'แก้ไขบัญชีผู้ใช้ระบบของบริษัท'
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 1092:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_load_info__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_list__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__profile_view__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__profile_form__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slip_form__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__user_list__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_form__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__company_detail__ = __webpack_require__(1122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__company_edit__ = __webpack_require__(1125);










/* harmony default export */ __webpack_exports__["a"] = ({
  userLoadInfo: __WEBPACK_IMPORTED_MODULE_0__user_load_info__["a" /* default */],
  profileList: __WEBPACK_IMPORTED_MODULE_1__profile_list__["a" /* default */],
  profileDetail: __WEBPACK_IMPORTED_MODULE_2__profile_view__["a" /* default */],
  profileForm: __WEBPACK_IMPORTED_MODULE_3__profile_form__["a" /* default */],
  slipForm: __WEBPACK_IMPORTED_MODULE_4__slip_form__["a" /* default */],
  userList: __WEBPACK_IMPORTED_MODULE_5__user_list__["a" /* default */],
  userForm: __WEBPACK_IMPORTED_MODULE_6__user_form__["a" /* default */],
  companyDetail: __WEBPACK_IMPORTED_MODULE_7__company_detail__["a" /* default */],
  companyEdit: __WEBPACK_IMPORTED_MODULE_8__company_edit__["a" /* default */]
});

/***/ }),

/***/ 1093:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_load_info_vue__ = __webpack_require__(486);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e4e71e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_load_info_vue__ = __webpack_require__(1095);
function injectStyle (ssrContext) {
  __webpack_require__(1094)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_load_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e4e71e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_load_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1094:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1095:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isLoading),expression:"isLoading",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"user-load-info",attrs:{"element-loading-text":"กำลังโหลดข้อมูล..."}},[_c('el-row',{staticClass:"reload-panel-holder",attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{attrs:{"span":24}},[(_vm.shouldReloadData && !_vm.isLoading)?_c('div',{staticClass:"reload-panel"},[_c('h3',[_vm._v("ระบบไม่สามารถโหลดข้อมูลของบริษัทได้"),_c('br'),_vm._v("กรุณาลองใหม่อีกครั้ง")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-refresh"},on:{"click":_vm.reloadInfo}},[_vm._v("โหลดข้อมูลใหม่")])],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_list_vue__ = __webpack_require__(487);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a5a4df_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_list_vue__ = __webpack_require__(1098);
function injectStyle (ssrContext) {
  __webpack_require__(1097)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a5a4df_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1097:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biller-page biller-profile-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":12}},[_c('h2',{staticClass:"page-title"},[_vm._v("ข้อมูลบริษัทสำหรับรับชำระ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":11}},[_c('el-input',{staticClass:"input-with-select",attrs:{"placeholder":"ค้นหารายชื่อบริษัท"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}},[_c('el-button',{attrs:{"slot":"append","icon":"el-icon-search"},slot:"append"})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"profile-list-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.profileListData,"default-sort":{prop: 'name', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","class-name":"no-wrap","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ข้อมูล Bill Payment","header-align":"center","align":"center"}},[_c('el-table-column',{attrs:{"prop":"bill_payment_comp_code","label":"COMP CODE","header-align":"center","align":"center","sortable":"","formatter":_vm.compCodeFormatter,"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"account_no","label":"หมายเลขบัญชี","header-align":"center","align":"center","sortable":"","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.account_no)?_c('div',{staticClass:"bill-payment-info-row",domProps:{"innerHTML":_vm._s(_vm.accountNoAllFormatter(scope.row.account_no))}}):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"biller_id","label":"Biller ID","header-align":"center","align":"center","sortable":"","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.biller_id)?_c('div',{staticClass:"bill-payment-info-row",domProps:{"innerHTML":_vm._s(_vm.accountNoAllFormatter(scope.row.biller_id))}}):_vm._e()]}}])})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payment_type","label":"วิธีการชำระเงิน","sortable":"","header-align":"center","align":"center","width":"140","formatter":_vm.paymentTypeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"update_at","label":"วันที่แก้ไข","width":"120","header-align":"center","align":"center","sortable":"","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleView(scope.$index, scope.row)}}},[_vm._v("ดูข้อมูล")])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_view_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cb3180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_view_vue__ = __webpack_require__(1110);
function injectStyle (ssrContext) {
  __webpack_require__(1100)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01cb3180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_http__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moxios__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moxios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moxios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);





var $http = new __WEBPACK_IMPORTED_MODULE_1__libs_http__["a" /* default */](window.appConfig.API_BILLING_BASE_URL);

var CompanyService = {
  setJWTToken: function setJWTToken(jwt) {
    $http.setJWTToken(jwt);
  },
  removeJWTToken: function removeJWTToken() {
    $http.removeJWTToken();
  },
  getCompany: function getCompany(payload, cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('get', '/companies/', null, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: [{
              id: 1,
              tax_id: '1234567890123',
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120'
              },
              profiles_count: 0
            }]
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      var url = '/companies/?query=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      $http.sendRequest('get', url, null, null, cb);
    }
  },
  uploadCompanyLogo: function uploadCompanyLogo(file, cb) {
    var uploadUrl = '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    var fd = new FormData();
    fd.append('upload_preset', window.appConfig.CLOUDINARY_UPLOAD_PRESET);
    fd.append('tags', 'browser_upload');
    fd.append('file', file);
    $http.sendRequest('post', uploadUrl, fd, {
      UNSET_COMMON_HEADER: true,
      'Content-Type': 'multipart/form-data'
    }, cb);
  },
  uploadOtherBankLogo: function uploadOtherBankLogo(file, cb) {
    var uploadUrl = '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    var fd = new FormData();
    fd.append('upload_preset', window.appConfig.CLOUDINARY_UPLOAD_PRESET);
    fd.append('tags', 'browser_upload');
    fd.append('file', file);
    $http.sendRequest('post', uploadUrl, fd, {
      UNSET_COMMON_HEADER: true,
      'Content-Type': 'multipart/form-data'
    }, cb);
  },
  createCompanyInfo: function createCompanyInfo(payload, cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('post', '/companies/', payload, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120'
              },
              profiles_count: 0
            }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http.sendRequest('post', '/companies/', payload, null, cb);
    }
  },
  updateCompanyInfo: function updateCompanyInfo(payload, cb) {
    var companyId = payload.id;
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('put', '/companies/' + companyId, payload, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              tax_id: '1234567890123',
              slug: 'haxter',
              name: 'Haxter Co., Ltd.',
              name_on_payment_card: 'บริษัท แฮกซ์เตอร์ จำกัด',
              logo: 'http://res.cloudinary.com/digit-zero/image/upload/v1524464010/scb-logo_sxjx7h.jpg',
              tel: '021234567',
              fax: '021234567',
              address: {
                line_1: '1757/29 ถนนจันทน์',
                district: 'ทุ่งมหาเมฆ',
                city: 'สาทร',
                province: 'กรุงเทพมหานคร',
                postal_code: '10120'
              },
              profiles_count: 0
            }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        }, 1000);
      });
    } else {
      $http.sendRequest('put', '/companies/' + companyId, payload, null, cb);
    }
  },
  deleteCompanyInfo: function deleteCompanyInfo(companyId, cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('delete', '/companies/' + companyId, null, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http.sendRequest('delete', '/companies/' + companyId, null, null, cb);
    }
  },

  // COMPANY PROFILES
  getCompanyProfile: function getCompanyProfile(companyId, cb) {
    $http.sendRequest('get', '/companies/' + companyId + '/profiles/', null, null, cb);
  },
  createCompanyProfile: function createCompanyProfile(companyId, payload, cb) {
    $http.sendRequest('post', '/companies/' + companyId + '/profiles/', payload, null, cb);
  },
  updateCompanyProfile: function updateCompanyProfile(profileId, payload, cb) {
    $http.sendRequest('put', '/profiles/' + profileId, payload, null, cb);
  },
  deleteCompanyProfile: function deleteCompanyProfile(profileId, cb) {
    $http.sendRequest('delete', '/profiles/' + profileId, null, null, cb);
  },
  getBillerCompanyProfile: function getBillerCompanyProfile(cb) {
    $http.sendRequest('get', '/profiles/', null, null, cb);
  },

  // COMPANY ADMIN USERS
  getCompanyAdmin: function getCompanyAdmin(companyId, cb) {
    $http.sendRequest('get', '/companies/' + companyId + '/users/', null, null, cb);
  },
  createCompanyAdmin: function createCompanyAdmin(companyId, payload, cb) {
    $http.sendRequest('post', '/companies/' + companyId + '/users/', payload, null, cb);
  },
  updateCompanyAdmin: function updateCompanyAdmin(userId, payload, cb) {
    $http.sendRequest('put', '/users/' + userId, payload, null, cb);
  },
  deleteCompanyAdmin: function deleteCompanyAdmin(userId, cb) {
    $http.sendRequest('delete', '/users/' + userId, null, null, cb);
  },
  getAdminMyAdmin: function getAdminMyAdmin(cb) {
    $http.sendRequest('get', '/admins/me', null, null, cb);
  },
  unblockAdminUser: function unblockAdminUser(adminId, cb) {
    $http.sendRequest('put', '/admins/' + adminId + '/activate', null, null, cb);
  },

  // ADMIN USERS
  getAdminUser: function getAdminUser(cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('get', '/admins/', null, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: [{
              id: 1,
              description: 'asdfasdf'
            }]
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http.sendRequest('get', '/admins/', null, null, cb);
    }
  },
  createAdminUser: function createAdminUser(payload, cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('post', '/admins/', payload, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              auth_user_id: 'user-id',
              description: 'asdfasdf'
            }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http.sendRequest('post', '/admins/', payload, null, cb);
    }
  },
  updateAdminUser: function updateAdminUser(payload, cb) {
    var userId = payload.id;
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('put', '/admins/' + userId, payload, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200,
            response: {
              id: 1,
              auth_user_id: 'user-id',
              description: 'asdfasdf'
            }
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        }, 1000);
      });
    } else {
      $http.sendRequest('put', '/admins/' + userId, payload, null, cb);
    }
  },
  deleteAdminUser: function deleteAdminUser(userId, cb) {
    // mock API
    var withMock = false;
    if (withMock) {
      __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.install($http.getInstance());
      setTimeout(function () {
        $http.sendRequest('delete', '/admins/' + userId, null, null, cb);
        __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.wait(function () {
          var request = __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.requests.mostRecent();
          request.respondWith({
            status: 200
          }).then(function () {
            __WEBPACK_IMPORTED_MODULE_2_moxios___default.a.uninstall($http.getInstance());
          });
        });
      }, 1000);
    } else {
      $http.sendRequest('delete', '/admins/' + userId, null, null, cb);
    }
  },

  // BILLER
  getBillerMyAdmin: function getBillerMyAdmin(cb) {
    $http.sendRequest('get', '/users/me', null, null, cb);
  },
  getBillerCompany: function getBillerCompany(companyId, cb) {
    $http.sendRequest('get', '/companies/' + companyId, null, null, cb);
  },

  // users
  getBillerUsers: function getBillerUsers(cb) {
    $http.sendRequest('get', '/users/', null, null, cb);
  },
  createBillerUser: function createBillerUser(companyId, payload, cb) {
    $http.sendRequest('post', '/users/', payload, {
      'Content-Type': 'application/json'
    }, cb);
  },
  updateBillerUser: function updateBillerUser(userId, payload, cb) {
    $http.sendRequest('put', '/users/' + userId, payload, {
      'Content-Type': 'application/json'
    }, cb);
  },
  unblockBillerAdmin: function unblockBillerAdmin(userId, cb) {
    $http.sendRequest('put', '/users/' + userId + '/activate', null, null, cb);
  },

  // Slips
  /* eslint no-param-reassign: 0 */
  getBillerSlips: function getBillerSlips(_ref, cb) {
    var profileId = _ref.profileId,
        payload = _ref.payload;

    // adjust payload value
    var dueDateFrom = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(payload.issued_on__from).tz("Asia/Bangkok");
    var dueDateTo = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(payload.issued_on__to).tz("Asia/Bangkok");
    if (dueDateFrom.isValid()) {
      payload.issued_on__from = dueDateFrom.format('YYYY-MM-DD');
    }
    if (dueDateTo.isValid()) {
      payload.issued_on__to = dueDateTo.format('YYYY-MM-DD');
    }
    var url = '/profiles/' + profileId + '/slips/?query=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
    /* $http
      .sendRequest('get', url, null, null, cb); */
    $http.getInstance().request({ url: url, method: 'GET' }).then(function (res) {
      var data = $http.getResponseData(res) || { total: 0, slips: [] };
      // const total = Number(res.headers['x-total']) || data.length;
      // console.log(data, res)
      cb(null, { total: Number(data.total), data: data.slips });
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  createBillerSlip: function createBillerSlip(profileId, payload, cb) {
    $http.sendRequest('post', '/profiles/' + profileId + '/slips/', payload, null, cb);
  },
  updateBillerSlip: function updateBillerSlip(slipId, payload, cb) {
    $http.sendRequest('put', '/slips/' + slipId, payload, null, cb);
  },
  deleteBillerSlip: function deleteBillerSlip(slipId, cb) {
    $http.sendRequest('delete', '/slips/' + slipId, null, null, cb);
  },
  printPayerSlips: function printPayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/print-orders/',
      method: 'put',
      timeout: 60000,
      headers: {
        Accept: 'application/pdf',
        'content-type': 'application/json'
      },
      data: {
        slip_ids: slips
      },
      responseType: 'arraybuffer'
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  emailPayerSlips: function emailPayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/email-orders/',
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json'
      },
      data: {
        slip_ids: slips
      }
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  printPayerQR: function printPayerQR(profileId, slips, cb) {
    var type = slips.length > 1 ? 'application/octet-stream' : 'image/png';
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/print-orders/qr-img/',
      method: 'put',
      timeout: 60000,
      headers: {
        Accept: type,
        'content-type': 'application/json'
      },
      data: {
        slip_ids: slips
      },
      responseType: 'arraybuffer'
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  emailPayerQR: function emailPayerQR(profileId, slips, cb) {
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/email-orders/qr-img/',
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json'
      },
      data: {
        slip_ids: slips
      }
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  deletePayerSlips: function deletePayerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/delete-orders/',
      method: 'put',
      headers: {
        'content-type': 'application/json'
      },
      data: {
        slip_ids: slips
      }
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  },
  importBillerSlips: function importBillerSlips(profileId, slips, cb) {
    $http.getInstance().request({
      url: '/profiles/' + profileId + '/upsert-slips-orders/',
      method: 'put',
      timeout: 60000,
      headers: {
        'content-type': 'application/json'
      },
      data: {
        slips: slips
      }
    }).then(function (res) {
      cb(null, $http.getResponseData(res));
    }).catch(function (err) {
      cb($http.getErrorData(err), null);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CompanyService);

/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'ErgoCom-Condensed.ttf': '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',
  'ErgoCom-MediumCondensed.ttf': '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',
  'pslxtext-webfont.ttf': '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',
  'pslxtext_bold-webfont.ttf': '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'
});

/***/ }),

/***/ 1110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSearching),expression:"isSearching",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"biller-page biller-profile-detail-page page-content",attrs:{"element-loading-text":"กำลังค้นหาข้อมูล..."}},[_c('el-row',{staticClass:"page-header -with-back-button -with-action-buttons",staticStyle:{"margin-bottom":"0"},attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"primary","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v("รายละเอียดข้อมูลบริษัทสำหรับรับชำระ")]),_vm._v(" "),_c('div',{staticClass:"action-buttons"},[_c('el-dropdown',{staticClass:"action-button",attrs:{"split-button":"","type":"primary","trigger":"click"},on:{"click":function($event){$event.preventDefault();return _vm.addPayer.apply(null, arguments)},"command":_vm.handleImportSlipsCommand}},[_vm._v("\n          เพิ่มผู้ชำระใหม่ "),_c('i',{staticClass:"el-icon-plus el-icon-right"}),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"import"}},[_vm._v("นำเข้าด้วยไฟล์ Excel (XLSX)")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"import-csv"}},[_vm._v("นำเข้าด้วยไฟล์ CSV")])],1)],1),_vm._v(" "),(_vm.isBillerAdmin)?_c('el-button',{staticClass:"action-button",attrs:{"type":"default"},on:{"click":function($event){$event.preventDefault();return _vm.editProfile.apply(null, arguments)}}},[_vm._v("\n          แก้ไขข้อมูลบริษัทสำหรับรับชำระ "),_c('i',{staticClass:"el-icon-edit el-icon-right"})]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.profile)?_c('div',{staticClass:"company-form company-detail-info profile-detail-info",staticStyle:{"background":"#f9f9fa","border-bottom":"1px solid #ccc","padding":"20px 0 0","margin-bottom":"20px"}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',{staticClass:"detail-row",staticStyle:{"margin-bottom":"0"}},[_c('el-col',{staticClass:"biller-profile-logo-holder",attrs:{"span":24}},[_c('el-row',[_c('el-col',{attrs:{"span":3}},[(_vm.profile.logo)?_c('div',{staticClass:"logo-holder",staticStyle:{"margin":"0 auto"}},[_c('img',{staticClass:"logo",attrs:{"src":_vm.profile.logo}})]):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n                  ชื่อข้อมูลบริษัทสำหรับรับชำระ\n                ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_vm._v("\n                  "+_vm._s(_vm.profile.name)+"\n                ")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":14}},[_c('el-row',[_c('el-col',{staticClass:"label row-center",attrs:{"span":8}},[_vm._v("\n                  COMP CODE\n                ")]),_vm._v(" "),_c('el-col',{staticClass:"label row-center",attrs:{"span":8}},[_vm._v("\n                  หมายเลขบัญชี\n                ")]),_vm._v(" "),_c('el-col',{staticClass:"label row-center",attrs:{"span":8}},[_vm._v("\n                  Biller ID\n                ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"row-center",attrs:{"span":8}},[_vm._v("\n                  "+_vm._s(_vm.profile.bill_payment_comp_code || '-')+"\n                ")]),_vm._v(" "),_c('el-col',{staticClass:"bill-payment-info-row row-center",attrs:{"span":8}},[(_vm.profile.account_no)?_c('div',{staticClass:"bill-payment-info-row",domProps:{"innerHTML":_vm._s(_vm.accountNoAllFormatter(_vm.profile.account_no))}}):_vm._e()]),_vm._v(" "),_c('el-col',{staticClass:"row-center",attrs:{"span":8}},[_vm._v("\n                  "+_vm._s(_vm.profile.bill_payment_biller_id || '-')+"\n                ")])],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"slip-search-filter"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"title"},[_vm._v("ค้นหารายการผู้ชำระ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-collapse',{staticClass:"search-option-collapse",on:{"change":_vm.searchOptionCollapseChange},model:{value:(_vm.slipSearchOption),callback:function ($$v) {_vm.slipSearchOption=$$v},expression:"slipSearchOption"}},[_c('el-collapse-item',{attrs:{"title":"ตัวเลือกการค้นหา","name":"1"}},[_c('template',{slot:"title"},[(_vm.slipSearchOption.indexOf('1') === -1)?_c('div',[_c('i',{staticClass:"el-icon-circle-plus-outline"}),_vm._v(" แสดงตัวเลือกการค้นหา\n                "),(_vm.filterAppliedCount > 0)?_c('span',{staticClass:"filter-count"},[_vm._v("(กำลังใช้งานอยู่ "+_vm._s(_vm.filterAppliedCount)+" ตัวเลือก)")]):_vm._e()]):_c('div',{staticClass:"hide-search-option-btn"},[_c('i',{staticClass:"el-icon-remove-outline"}),_vm._v(" ซ่อนตัวเลือกการค้นหา\n                "),(_vm.filterAppliedCount > 0)?_c('span',{staticClass:"filter-count"},[_vm._v("(กำลังใช้งานอยู่ "+_vm._s(_vm.filterAppliedCount)+" ตัวเลือก)")]):_vm._e()])]),_vm._v(" "),(_vm.profile)?_c('el-form',{ref:"searchForm",staticClass:"slip-search-form",attrs:{"model":_vm.searchForm,"label-width":"120px","label-position":"top","disabled":_vm.isSearching},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm()}}},[_c('el-row',{staticClass:"option-group-label"},[_c('el-col',{attrs:{"span":23}},[_c('label',{staticClass:"el-form-item__label"},[_vm._v("วันที่ครบกำหนดชำระ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"ตั้งแต่วันที่"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"เลือกวันเริ่มต้น","picker-options":_vm.searchPickerOptions},model:{value:(_vm.searchForm.issued_on__from),callback:function ($$v) {_vm.$set(_vm.searchForm, "issued_on__from", $$v)},expression:"searchForm.issued_on__from"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"label":"ถึงวันที่"}},[_c('el-date-picker',{attrs:{"type":"date","placeholder":"เลือกวันเริ่มต้น","picker-options":_vm.searchPickerOptions},model:{value:(_vm.searchForm.issued_on__to),callback:function ($$v) {_vm.$set(_vm.searchForm, "issued_on__to", $$v)},expression:"searchForm.issued_on__to"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label":"ชื่อผู้ชำระ"}},[_c('el-input',{attrs:{"id":"searchForm.payee__name","placeholder":"กรอกชื่อผู้ชำระ"},model:{value:(_vm.searchForm.payee__name),callback:function ($$v) {_vm.$set(_vm.searchForm, "payee__name", $$v)},expression:"searchForm.payee__name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":_vm.ref1Label}},[_c('el-input',{ref:"searchForm.ref1",attrs:{"id":"searchForm.ref1","placeholder":("กรอก" + _vm.ref1Label)},on:{"change":_vm.updateMaskRefCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'searchForm.ref1', 'refCode')}},model:{value:(_vm.searchForm.ref1),callback:function ($$v) {_vm.$set(_vm.searchForm, "ref1", $$v)},expression:"searchForm.ref1"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"label":_vm.ref2Label}},[_c('el-input',{ref:"searchForm.ref2",attrs:{"id":"searchForm.ref2","placeholder":("กรอก" + _vm.ref2Label)},on:{"change":_vm.updateMaskRefCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'searchForm.ref2', 'refCode')}},model:{value:(_vm.searchForm.ref2),callback:function ($$v) {_vm.$set(_vm.searchForm, "ref2", $$v)},expression:"searchForm.ref2"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"option-group-label"},[_c('el-col',{attrs:{"span":23}},[_c('label',{staticClass:"el-form-item__label"},[_vm._v("จำนวนเงิน (บาท)")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":11}},[_c('el-form-item',{attrs:{"label":"ตั้งแต่"}},[_c('el-input',{ref:"searchForm.amount__from",attrs:{"id":"searchForm.amount__from","placeholder":"กรอกจำนวนเงิน"},on:{"change":function($event){return _vm.updateMaskAmount('amount__from')}},nativeOn:{"input":function($event){return _vm.handleInput($event, 'searchForm.amount__from', 'amountMask')}},model:{value:(_vm.searchForm.amount__from),callback:function ($$v) {_vm.$set(_vm.searchForm, "amount__from", $$v)},expression:"searchForm.amount__from"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":11,"offset":1}},[_c('el-form-item',{attrs:{"label":"ถึง"}},[_c('el-input',{ref:"searchForm.amount__to",attrs:{"id":"searchForm.amount__to","placeholder":"กรอกจำนวนเงิน"},on:{"change":function($event){return _vm.updateMaskAmount('amount__to')}},nativeOn:{"input":function($event){return _vm.handleInput($event, 'searchForm.amount__to', 'amountMask')}},model:{value:(_vm.searchForm.amount__to),callback:function ($$v) {_vm.$set(_vm.searchForm, "amount__to", $$v)},expression:"searchForm.amount__to"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label":"พิมพ์แล้ว?"}},[_c('el-radio-group',{model:{value:(_vm.searchForm.is_printed),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_printed", $$v)},expression:"searchForm.is_printed"}},[_c('el-radio-button',{attrs:{"label":"ทั้งหมด"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"พิมพ์แล้ว"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"ยังไม่พิมพ์"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"label":"ส่งอีเมลแล้ว?"}},[_c('el-radio-group',{model:{value:(_vm.searchForm.is_sent),callback:function ($$v) {_vm.$set(_vm.searchForm, "is_sent", $$v)},expression:"searchForm.is_sent"}},[_c('el-radio-button',{attrs:{"label":"ทั้งหมด"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"ส่งแล้ว"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"label":"ยังไม่ส่ง"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"search-option-buttons"},[_c('el-col',{attrs:{"span":23}},[_c('el-form-item',{attrs:{"size":"large"}},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"searchForm.resetButton"},on:{"click":_vm.resetForm}},[_vm._v("ล้างค่า")]),_vm._v(" "),_c('el-button',{staticClass:"search-btn",attrs:{"native-type":"submit","type":"primary","icon":"el-icon-search"}},[_vm._v("ค้นหา")])],1)],1)],1)],1):_vm._e()],2)],1)],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isPrinting || _vm.isEmailing || _vm.isDeleting || _vm.isExporting),expression:"isPrinting || isEmailing || isDeleting || isExporting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"slip-list-table",attrs:{"element-loading-text":_vm.slipLoadingActionText}},[_c('div',{staticClass:"control-panel"},[_c('el-row',[_c('el-col',{attrs:{"span":6}},[_c('h3',{staticClass:"title"},[_vm._v("รายการผู้ชำระ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[(_vm.selectedSlips.length > 0)?_c('div',{staticClass:"action-buttons"},[_c('div',{staticClass:"slip-selected-count"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){$event.preventDefault();return _vm.clearSelection.apply(null, arguments)}}},[_vm._v("(ล้างค่าการเลือก)")]),_vm._v(" เลือกอยู่ "+_vm._s(_vm.selectedSlips.length)+" รายการ :\n            ")],1),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","plain":"","icon":"el-icon-delete"},on:{"click":_vm.requestDelete}},[_vm._v("ลบรายการ")]),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.handleExportCommand}},[_c('el-button',{attrs:{"type":"default"}},[_vm._v("\n                ส่งออก"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"xlsx"}},[_vm._v("ไฟล์ Excel (XLSX)")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"csv"}},[_vm._v("ไฟล์ CSV")])],1)],1),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.handlePrintCommand}},[_c('el-button',{attrs:{"type":"default"}},[_vm._v("\n                พิมพ์"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"pay-in"}},[_vm._v("Pay-in slip(s)")]),_vm._v(" "),(_vm.canGenerateQR)?_c('el-dropdown-item',{attrs:{"command":"qr"}},[_vm._v("รูปภาพ QR Code")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.handleEmailCommand}},[_c('el-button',{attrs:{"type":"default"}},[_vm._v("\n                ส่งอีเมล"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"pay-in"}},[_vm._v("Pay-in slip(s)")]),_vm._v(" "),(_vm.canGenerateQR)?_c('el-dropdown-item',{attrs:{"command":"qr"}},[_vm._v("รูปภาพ QR Code")]):_vm._e()],1)],1),_vm._v(" "),_c('el-button',{attrs:{"type":"default","plain":"","icon":"el-icon-tickets"},on:{"click":_vm.requestSummary}},[_vm._v("ดูรายการสรุป")])],1):_vm._e()])],1)],1),_vm._v(" "),(_vm.slipListDataTotalPage > 1)?_c('el-pagination',{attrs:{"layout":"prev, pager, next, jumper","background":"","current-page":_vm.slipListDataCurrentPage,"page-size":_vm.slipListDataItemPerPage,"total":_vm.slipListTotalItem},on:{"current-change":_vm.updateSlipListDataRows,"update:currentPage":function($event){_vm.slipListDataCurrentPage=$event},"update:current-page":function($event){_vm.slipListDataCurrentPage=$event}}}):_vm._e(),_vm._v(" "),_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isSortingData),expression:"isSortingData"}],ref:"slipListTable",staticClass:"slip-list-table",staticStyle:{"width":"100%"},attrs:{"data":_vm.slipListDataPaged,"default-sort":{prop: 'issued_on', order: 'descending'},"show-summary":"","summary-method":_vm.sumPagedSlips},on:{"select":_vm.handleSelectRow,"select-all":_vm.handleSelectAll,"sort-change":_vm.dataTableSorted}},[_c('el-table-column',{attrs:{"type":"selection","header-align":"center","align":"center","fixed":"left","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"header-align":"center","align":"center","prop":"id","label":"ID","class-name":"no-wrap","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issued_on","label":"วันที่ชำระ","width":"100","fixed":"left","sortable":"custom","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payer.name","label":"ชื่อลูกค้า","class-name":"no-wrap","min-width":"120","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref1","label":"Ref.1","min-width":"150","class-name":"no-wrap","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref2","label":"Ref.2","min-width":"150","class-name":"no-wrap","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":"ยอดเงิน","header-align":"right","align":"right","sortable":"custom","class-name":"no-wrap","min-width":"120","formatter":_vm.amountFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"print_status","label":"Print","align":"left","header-align":"left","width":"80"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"status-row",class:scope.row.print_status.payin ? 'success' : 'fail'},[_c('span',[_vm._v("Pay-in:")]),_vm._v(" "),_c('i',{class:scope.row.print_status.payin ? 'el-icon-check' : 'el-icon-minus'})]),_vm._v(" "),_c('div',{staticClass:"status-row",class:scope.row.print_status.qr ? 'success' : 'fail'},[_c('span',[_vm._v("QR:")]),_vm._v(" "),_c('i',{class:scope.row.print_status.qr ? 'el-icon-check' : 'el-icon-minus'})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"email_status","label":"Email","align":"left","header-align":"left","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"status-row",class:scope.row.email_status.payin ? 'success' : 'fail'},[_c('span',[_vm._v("Pay-in:")]),_vm._v(" "),_c('i',{class:scope.row.email_status.payin ? 'el-icon-check' : 'el-icon-minus'})]),_vm._v(" "),_c('div',{staticClass:"status-row",class:scope.row.email_status.qr ? 'success' : 'fail'},[_c('span',[_vm._v("QR:")]),_vm._v(" "),_c('i',{class:scope.row.email_status.qr ? 'el-icon-check' : 'el-icon-minus'})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleEdit(scope.$index, scope.row)}}},[_vm._v("แก้ไข")])]}}])})],1),_vm._v(" "),(_vm.slipListDataTotalPage > 1)?_c('el-pagination',{attrs:{"layout":"prev, pager, next, jumper","background":"","current-page":_vm.slipListDataCurrentPage,"page-size":_vm.slipListDataItemPerPage,"total":_vm.slipListTotalItem},on:{"current-change":_vm.updateSlipListDataRows,"update:currentPage":function($event){_vm.slipListDataCurrentPage=$event},"update:current-page":function($event){_vm.slipListDataCurrentPage=$event}}}):_vm._e()],1),_vm._v(" "),(_vm.pdfContent)?_c('a',{attrs:{"id":"slip-pdf-content","href":_vm.pdfContent,"download":_vm.pdfFilename}}):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"fullscreen":true,"title":_vm.summaryDialogTitle,"visible":_vm.isSummaryDialogShown},on:{"update:visible":function($event){_vm.isSummaryDialogShown=$event}}},[_c('el-table',{attrs:{"show-summary":"","summary-method":_vm.sumSlips,"data":_vm.summaryGridData}},[_c('el-table-column',{attrs:{"type":"index","fixed":"left","header-align":"center","align":"center","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issued_on","label":"วันที่ชำระ","width":"120","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{staticClass:"no-wrap",attrs:{"prop":"payer.name","label":"ชื่อลูกค้า","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref1","label":_vm.ref1Label,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref2","label":_vm.ref2Label,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":"จำนวนเงิน (บาท)","align":"right","width":"200","formatter":_vm.amountFormatter}})],1),_vm._v(" "),(_vm.summaryDialogMode === 'email' && _vm.summaryGridData2.length > 0)?_c('div',{attrs:{"id":"not-email-list"}},[_c('hr'),_vm._v(" "),_c('h4',{staticStyle:{"color":"red"}},[_vm._v("** รายการด้านล่างนี้จะไม่ถูกส่งไปทางอีเมล เนื่องจากไม่มีอีเมลระบุไว้ **")]),_vm._v(" "),_c('el-table',{attrs:{"show-summary":"","summary-method":_vm.sumSlips,"data":_vm.summaryGridData2}},[_c('el-table-column',{attrs:{"type":"index","fixed":"left","header-align":"center","align":"center","min-width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issued_on","label":"วันที่ชำระ","width":"120","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{staticClass:"no-wrap",attrs:{"prop":"payer.name","label":"ชื่อลูกค้า","min-width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref1","label":_vm.ref1Label,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref2","label":_vm.ref2Label,"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":"จำนวนเงิน (บาท)","align":"right","width":"200","formatter":_vm.amountFormatter}})],1)],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.cancelSummaryDialog}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),(['print', 'export'].indexOf(_vm.summaryDialogMode) !== -1 ||
        (['email'].indexOf(_vm.summaryDialogMode) !== -1 && _vm.summaryGridData.length > 0))?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmSummaryDialog}},[_vm._v(_vm._s(_vm._f("translate")('Confirm')))]):_vm._e(),_vm._v(" "),(_vm.summaryDialogMode === 'delete')?_c('el-button',{attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":_vm.confirmSummaryDialog}},[_vm._v("ยืนยันลบข้อมูล")]):_vm._e()],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"import-dialog",attrs:{"fullscreen":true,"title":_vm.importDialogTitle,"visible":_vm.isImportDialogShown,"close-on-click-modal":false,"close-on-press-escape":false,"show-close":false,"before-close":_vm.cancelImportDialog},on:{"update:visible":function($event){_vm.isImportDialogShown=$event}}},[(_vm.isImporting)?_c('div',{staticClass:"importing-icon"},[_c('i',{staticClass:"el-icon-loading icon"}),_c('br'),_vm._v(" "),_c('h4',{staticClass:"loading-text"},[_vm._v("กำลังประมวลผล...")])]):_vm._e(),_vm._v(" "),(!_vm.isImporting && _vm.xlsDataRows.length === 0 && _vm.xlsErrorRows.length === 0 && _vm.xlsSkipRows.length === 0)?_c('div',{staticClass:"xls-uploader-holder"},[_c('div',{staticClass:"template-download-instruction"},[_vm._v("\n        กรุณาใช้รูปแบบ "+_vm._s(_vm.importFileFormatName)+" ที่กำหนดเพื่อการนำเข้าข้อมูลที่ถูกต้อง\n        "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.downloadXLSTemplate.apply(null, arguments)}}},[_vm._v("ดาวน์โหลดรูปแบบ")])]),_vm._v(" "),_c('el-upload',{staticClass:"xls-uploader",attrs:{"action":"","drag":"","show-file-list":false,"before-upload":_vm.handleBeforeXLSUpload,"http-request":_vm.handleXLSImport}},[_c('i',{staticClass:"icon el-icon-document"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("\n          เลือกไฟล์ "+_vm._s(_vm.importFileFormatName)+" ที่ต้องการ หรือลากมาวางที่นี่เพื่อเริ่มนำเข้าข้อมูล"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('span',{staticClass:"el-button el-button--primary"},[_vm._v("เลือกไฟล์")])])])])],1):_vm._e(),_vm._v(" "),(!_vm.isImporting && (_vm.xlsDataRows.length > 0 || _vm.xlsErrorRows.length > 0 || _vm.xlsSkipRows.length > 0))?_c('el-row',{staticClass:"import-summary-table"},[_c('el-col',{attrs:{"span":24}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"import-summary-header"},[_vm._v("สรุปรายการเพื่อนำเข้า")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"header-label",attrs:{"span":8}},[_vm._v("\n            จำนวนรายการที่สามารถนำเข้า\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"header-label",attrs:{"span":8}},[_vm._v("\n            จำนวนรายการที่ข้าม(ข้อมูลไม่ครบ)\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"header-label",attrs:{"span":8}},[_vm._v("\n            จำนวนรายการที่มีปัญหา\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"value-label import-row-count",attrs:{"span":8}},[_vm._v("\n            "+_vm._s(_vm.numFormat(_vm.xlsDataRows.length))+"\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"value-label skip-row-count",attrs:{"span":8}},[_vm._v("\n            "+_vm._s(_vm.numFormat(_vm.xlsSkipRows.length))+"\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"value-label error-row-count",attrs:{"span":8}},[_vm._v("\n            "+_vm._s(_vm.numFormat(_vm.xlsErrorRows.length))+"\n          ")])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.isImporting && _vm.xlsDataRows.length > 0)?_c('div',{staticClass:"xls-data-preview"},[_c('el-table',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isSortingImport),expression:"isSortingImport"}],attrs:{"max-height":"300","show-summary":"","summary-method":_vm.sumImportSlips,"data":_vm.xlsDataRowsPaged}},[_c('el-table-column',{attrs:{"prop":"rowNumber","label":"No.","header-align":"center","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"type":"id","prop":"id","label":"ID","header-align":"center","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"issued_on","label":_vm.xlsTemplateHeaders[5],"width":"180","formatter":_vm.dateFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payer.name","label":_vm.xlsTemplateHeaders[1],"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payer.email","label":_vm.xlsTemplateHeaders[6],"width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref1","label":_vm.xlsTemplateHeaders[2],"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"ref2","label":_vm.xlsTemplateHeaders[3],"width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":_vm.xlsTemplateHeaders[4],"align":"right","width":"200","formatter":_vm.amountFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"notification_msg","label":_vm.xlsTemplateHeaders[7],"class-name":"no-wrap notification_msg-col","width":"200"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"remark","label":_vm.xlsTemplateHeaders[8],"align":"right","width":"200"}})],1),_vm._v(" "),(_vm.xlsDataTotalPage > 1)?_c('el-pagination',{attrs:{"layout":"prev, pager, next, jumper","background":"","current-page":_vm.xlsDataCurrentPage,"page-size":_vm.xlsDataItemPerPage,"total":_vm.xlsDataRows.length},on:{"update:currentPage":function($event){_vm.xlsDataCurrentPage=$event},"update:current-page":function($event){_vm.xlsDataCurrentPage=$event}}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isImporting)?_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[(!_vm.isImporting)?_c('el-button',{on:{"click":_vm.cancelImportDialog}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]):_vm._e(),_vm._v(" "),(!_vm.isImporting && _vm.xlsDataRows.length > 0)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.confirmImportDialog}},[_vm._v("ยืนยันการนำเข้า")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"id":"summaryPdfViewerDialog","title":"รายงานสรุปยอด","fullscreen":true,"before-close":_vm.closeSummaryResultDialog,"visible":_vm.isSummaryResultDialogShown},on:{"update:visible":function($event){_vm.isSummaryResultDialogShown=$event}}},[(_vm.isSummaryResultDialogShown)?_c('iframe',{attrs:{"id":"summaryPdfViewer","src":_vm.summaryPDFDataURL}}):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_form_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67b972c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_form_vue__ = __webpack_require__(1113);
function injectStyle (ssrContext) {
  __webpack_require__(1112)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profile_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f67b972c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_profile_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"company-profile-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v("แก้ไขข้อมูลบริษัทสำหรับรับชำระ")])],1)],1),_vm._v(" "),(_vm.profile)?_c('el-form',{ref:"profileForm",staticClass:"profile-form profile-detail-info detail-form company-detail-info",attrs:{"model":_vm.profileForm,"rules":_vm.profileFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('profileForm')}}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบริษัทสำหรับรับชำระ")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            ชื่อบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.profile.name))])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"logo-uploader-holder"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"โลโก้บริษัท","prop":"logo"}},[(_vm.profileForm.logo)?_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.profileForm.logo}})]):_vm._e(),_vm._v(" "),_c('el-upload',{staticClass:"company-logo-uploader",attrs:{"action":_vm.uploadUrl,"drag":"","show-file-list":false,"http-request":_vm.handleHttpRequest,"on-success":_vm.handleLogoSuccess,"on-error":_vm.handleLogoFail,"before-upload":_vm.beforeLogoUpload}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isUploading),expression:"isUploading"}],staticClass:"upload-instruction"},[_c('h3',[_vm._v("อัพโหลดโลโก้บริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-upload logo-uploader-icon"})])]),_vm._v(" "),(_vm.profileForm.logo)?_c('el-button',{staticClass:"remove-logo",attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":_vm.removeLogo}},[_vm._v("ลบโลโก้บริษัท")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-instruction-hint"},[_vm._v("\n              ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF\n            ")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่บริษัท "),_c('sup',{staticClass:"required"},[_vm._v("**")])])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"","prop":"use_company_address"}},[_c('el-checkbox',{attrs:{"id":"profileForm.use_company_address"},on:{"change":_vm.toggleUsingCompanyAddress},model:{value:(_vm.profileForm.use_company_address),callback:function ($$v) {_vm.$set(_vm.profileForm, "use_company_address", $$v)},expression:"profileForm.use_company_address"}},[_vm._v("ใช้ที่อยู่เดียวกับรายละเอียดหลักของบริษัท")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ที่อยู่","prop":"address.line_1"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.line_1","placeholder":"กรอกที่อยู่"},model:{value:(_vm.profileForm.address.line_1),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "line_1", $$v)},expression:"profileForm.address.line_1"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ตำบล/แขวง","prop":"address.district"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.district","placeholder":"กรอกตำบล/แขวง"},model:{value:(_vm.profileForm.address.district),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "district", $$v)},expression:"profileForm.address.district"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"อำเภอ/เขต","prop":"address.city"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.city","placeholder":"กรอกอำเภอ/เขต"},model:{value:(_vm.profileForm.address.city),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "city", $$v)},expression:"profileForm.address.city"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"จังหวัด","prop":"address.province"}},[_c('el-select',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.province"},model:{value:(_vm.profileForm.address.province),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "province", $$v)},expression:"profileForm.address.province"}},_vm._l((_vm.provinceList),function(province){return _c('el-option',{key:province,attrs:{"label":province,"value":province}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"รหัสไปรษณีย์","prop":"address.postal_code"}},[_c('el-input',{ref:"profileForm.address.postal_code",attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.postal_code","placeholder":"กรอกรหัสไปรษณีย์"},on:{"change":_vm.updatePostCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.address.postal_code', 'postcode')}},model:{value:(_vm.profileForm.address.postal_code),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "postal_code", $$v)},expression:"profileForm.address.postal_code"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"โทรศัพท์","prop":"address.tel"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.tel","placeholder":"กรอกโทรศัพท์"},model:{value:(_vm.profileForm.address.tel),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "tel", $$v)},expression:"profileForm.address.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"โทรสาร","prop":"address.fax"}},[_c('el-input',{attrs:{"disabled":_vm.profileForm.use_company_address,"id":"profileForm.address.fax","placeholder":"กรอกโทรสาร"},model:{value:(_vm.profileForm.address.fax),callback:function ($$v) {_vm.$set(_vm.profileForm.address, "fax", $$v)},expression:"profileForm.address.fax"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Bill Payment")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":7}},[_vm._v("\n            COMP CODE\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":7}},[_vm._v("\n            เลขที่บัญชี\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":7}},[_vm._v("\n            Biller ID\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":7}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.compCodeFormatter(_vm.profile.bill_payment_comp_code)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.accountNoFormatter(_vm.profile.bill_payment_account_no)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":7}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.billerIdFormatter(_vm.profile.bill_payment_biller_id)))])])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลสำหรับบาร์โค้ดและ QR code")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            "+_vm._s(_vm.profile.barcode_qrcode_biller_id_tax_id !== '' &&
            _vm.profile.barcode_qrcode_biller_id_tax_id !== null ? 'Biller ID' : 'หมายเลขบัญชี')+"\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":10,"offset":1}},[_vm._v("\n            Suffix\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v("\n            "+_vm._s(_vm.profile.barcode_qrcode_biller_id_tax_id !== '' &&
              _vm.profile.barcode_qrcode_biller_id_tax_id !== null ?
                _vm.billerIdFormatter(_vm.profile.barcode_qrcode_biller_id_tax_id) :
                _vm.accountNoFormatter(_vm.profile.barcode_qrcode_account_no))+"\n            ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":2,"offset":1}},[_c('div',{staticClass:"value-text"},[_vm._v("\n            "+_vm._s(_vm.profile.barcode_qrcode_biller_id_tax_id !== '' &&
              _vm.profile.barcode_qrcode_biller_id_tax_id !== null ?
              _vm.profile.barcode_qrcode_biller_id_suffix :
              _vm.profile.barcode_qrcode_account_no_suffix)+"\n            ")])])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Business Type")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"value-text"},[_vm._v("\n            "+_vm._s(_vm.profileBusinessType)+"\n          ")])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("วิธีการชำระเงิน")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v("\n            "+_vm._s(_vm.profile.payment_type === 'CHEQUE_OR_CASH' ? 'เช็ค/เงินสด' : 'เงินสดอย่างเดียว')+"\n            ")])])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Charge Type")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            "+_vm._s(_vm.profileForm.charge_payer ? 'Payer' : 'Biller')+"\n          ")])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            IB/IR\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.profile.ir_br))])])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("Account Reference")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            ชื่อบัญชี\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.profile.account_name))])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":10}},[_vm._v("\n            Label (Ref. 1)\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":10,"offset":1}},[_vm._v("\n            Label (Ref. 2)\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.profile.label_ref1))])]),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('div',{staticClass:"value-text"},[_vm._v(_vm._s(_vm.profile.label_ref2))])])],1)],1)],1),_vm._v(" "),(_vm.profileForm.allow_other_banks)?_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลบัญชีธนาคารอื่นๆที่จะปรากฎบน Pay-in Slip (สูงสุด 6 บัญชี)")]),_vm._v(" "),_c('div',{staticClass:"other-bank-upload-instruction"},[_vm._v("** ขนาดโลโก้ไม่เกิน 300px x 300px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},_vm._l((_vm.profileForm.other_banks),function(bankInfo,index,item){return _c('div',{staticClass:"other-bank-list"},[(_vm.isBillerAdmin)?_c('div',{staticClass:"other-bank-info form"},[_c('el-row',[_c('el-col',{attrs:{"span":1}},[_c('el-form-item',{attrs:{"label":"","prop":'other_banks.' + index +  '.is_active'}},[_c('el-checkbox',{on:{"change":function($event){return _vm.markBankInfoActive(index)}},model:{value:(bankInfo.is_active),callback:function ($$v) {_vm.$set(bankInfo, "is_active", $$v)},expression:"bankInfo.is_active"}},[_vm._v(_vm._s(index + 1)+".")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":2}},[(!bankInfo.is_active || (bankInfo.account_logo && bankInfo.is_active))?_c('div',{staticClass:"other-bank-logo-holder"},[(bankInfo.account_logo)?_c('img',{staticClass:"logo",attrs:{"src":bankInfo.account_logo}}):_vm._e()]):_vm._e(),_vm._v(" "),(!bankInfo.account_logo && bankInfo.is_active)?_c('el-upload',{staticClass:"other-bank-logo-uploader",attrs:{"action":_vm.uploadUrl,"drag":"","show-file-list":false,"http-request":_vm.handleOtherBankHttpRequest,"on-success":_vm.handleOtherBankLogoSuccessList[index],"on-error":_vm.handleLogoFail,"before-upload":_vm.beforeLogoUpload}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isUploading),expression:"isUploading"}],staticClass:"upload-instruction"},[_c('i',{staticClass:"el-icon-upload logo-uploader-icon"})])]):_vm._e(),_vm._v(" "),(bankInfo.account_logo && bankInfo.is_active)?_c('el-button',{staticClass:"remove-logo",attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":function($event){return _vm.removeOtherBankLogo(index)}}},[_vm._v("ลบโลโก้")]):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":21}},[_c('el-row',[_c('el-col',{attrs:{"span":6,"offset":1}},[_c('el-form-item',{attrs:{"label":"ชื่อธนาคาร/ตัวแทนรับชำระ","prop":'other_banks.' + index +  '.account_name',"rules":{ validator: _vm.checkOtherBankItem, trigger: 'blur' }}},[_c('el-input',{attrs:{"disabled":!bankInfo.is_active,"placeholder":"กรอกชื่อบัญชี"},model:{value:(bankInfo.account_name),callback:function ($$v) {_vm.$set(bankInfo, "account_name", $$v)},expression:"bankInfo.account_name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6,"offset":1}},[_c('el-form-item',{key:'other_banks.' + index +  '.account_number',attrs:{"label":"เลขที่บัญชี","prop":'other_banks.' + index +  '.account_number',"rules":{ validator: _vm.checkOtherBankItem, trigger: 'blur' }}},[_c('el-input',{ref:'profileForm.other_banks.' + index + '.account_number',refInFor:true,attrs:{"disabled":!bankInfo.is_active,"id":'profileForm.other_banks.' + index + '.account_number',"placeholder":"กรอกเลขที่บัญชี"},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.other_banks.' + index + '.account_number', 'accNumberOnly')}},model:{value:(bankInfo.account_number),callback:function ($$v) {_vm.$set(bankInfo, "account_number", $$v)},expression:"bankInfo.account_number"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6,"offset":1}},[_c('el-form-item',{key:'other_banks.' + index +  '.comcode',attrs:{"label":"COMP CODE","prop":'other_banks.' + index +  '.comcode'}},[_c('el-input',{attrs:{"disabled":!bankInfo.is_active,"id":'profileForm.other_banks.' + index + '.comcode',"placeholder":"กรอก COMP CODE"},model:{value:(bankInfo.comcode),callback:function ($$v) {_vm.$set(bankInfo, "comcode", $$v)},expression:"bankInfo.comcode"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":6,"offset":1}},[_c('el-form-item',{key:'other_banks.' + index +  '.service_fee',attrs:{"label":"ค่าธรรมเนียม","prop":'other_banks.' + index +  '.service_fee'}},[_c('el-input',{attrs:{"disabled":!bankInfo.is_active,"id":'profileForm.other_banks.' + index + '.service_fee',"placeholder":"กรอกค่าธรรมเนียม"},model:{value:(bankInfo.service_fee),callback:function ($$v) {_vm.$set(bankInfo, "service_fee", $$v)},expression:"bankInfo.service_fee"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6,"offset":1}},[(_vm.isBBLBank(bankInfo.account_name))?_c('el-form-item',{key:'other_banks.' + index +  '.service_code',attrs:{"label":"Service Code","prop":'other_banks.' + index +  '.service_code',"rules":{ validator: _vm.checkOtherBankItem, trigger: 'blur' }}},[_c('el-input',{attrs:{"disabled":!bankInfo.is_active,"id":'profileForm.other_banks.' + index + '.service_code',"placeholder":"กรอก Service Code"},model:{value:(bankInfo.service_code),callback:function ($$v) {_vm.$set(bankInfo, "service_code", $$v)},expression:"bankInfo.service_code"}})],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":6,"offset":1}},[(_vm.isBBLBank(bankInfo.account_name))?_c('el-form-item',{key:'other_banks.' + index +  '.branch_code',attrs:{"label":"รหัสสาขา","prop":'other_banks.' + index +  '.branch_code'}},[_c('el-input',{ref:'profileForm.other_banks.' + index + '.branch_code',refInFor:true,attrs:{"disabled":!bankInfo.is_active,"id":'profileForm.other_banks.' + index + '.branch_code',"placeholder":"กรอกรหัสสาขา"},nativeOn:{"input":function($event){return _vm.handleInput($event, 'profileForm.other_banks.' + index + '.branch_code', 'numberOnly')}},model:{value:(bankInfo.branch_code),callback:function ($$v) {_vm.$set(bankInfo, "branch_code", $$v)},expression:"bankInfo.branch_code"}})],1):_vm._e()],1)],1)],1)],1)],1):_c('div',{staticClass:"other-bank-info"},[_c('div',{staticClass:"logo"},[_vm._v("\n                  "+_vm._s(bankInfo.account_logo)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n                  "+_vm._s(_vm.getOtherBankInfoSummaryText(bankInfo))+"\n                ")])])])}),0)],1)],1)],1):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("การแจ้งเตือน")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{ref:"notification_msg",attrs:{"label":"","prop":"notification_msg"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"DATE","id":"profileForm.notification_msg_type_1"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_type", $$v)},expression:"profileForm.notification_msg_type"}},[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_vm._v("กรุณาชำระภายในวันที่")]),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_c('el-select',{staticStyle:{"width":"100px","text-align":"center"},attrs:{"disabled":_vm.profileForm.notification_msg_type === 'CUSTOM',"id":"profileForm.notification_msg_date"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_date),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_date", $$v)},expression:"profileForm.notification_msg_date"}},_vm._l((_vm.notificationDayList),function(day){return _c('el-option',{key:day,attrs:{"label":day,"value":day}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_vm._v("\n                      ของทุกเดือน\n                    ")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"20px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"CUSTOM","id":"profileForm.notification_msg_type_2"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.profileForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_type", $$v)},expression:"profileForm.notification_msg_type"}},[_vm._v("\n                  _\n                ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px"},attrs:{"disabled":_vm.profileForm.notification_msg_type !== 'CUSTOM',"id":"profileForm.notification_msg_custom","maxlength":100,"placeholder":"กรอกข้อความแจ้งเตือนที่ต้องการ"},model:{value:(_vm.profileForm.notification_msg_custom),callback:function ($$v) {_vm.$set(_vm.profileForm, "notification_msg_custom", $$v)},expression:"profileForm.notification_msg_custom"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"profileForm.cancelButton"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[_c('el-button',{attrs:{"type":"primary","id":"profileForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Save and continue')))])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slip_form_vue__ = __webpack_require__(493);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a331d3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slip_form_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1115)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slip_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a331d3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slip_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"company-profile-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"primary","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'เพิ่มรายการผู้ชำระใหม่'))])],1)],1),_vm._v(" "),(_vm.profile)?_c('el-form',{ref:"payerForm",staticClass:"slip-form profile-detail-info detail-form company-detail-info",attrs:{"model":_vm.payerForm,"rules":_vm.payerFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('payerForm')}}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'เพิ่มรายการผู้ชำระ')+"สำหรับ "+_vm._s(_vm.profile.name))])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ชื่อผู้ชำระ","prop":"payer.name"}},[_c('el-input',{attrs:{"id":"payerForm.payer.name","autofocus":true,"maxlength":40,"placeholder":"กรอกชื่อผู้ชำระ"},model:{value:(_vm.payerForm.payer.name),callback:function ($$v) {_vm.$set(_vm.payerForm.payer, "name", $$v)},expression:"payerForm.payer.name"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"อีเมลผู้ชำระสำหรับส่งใบ pay-in/qr code ทางอีเมล","prop":"payer.email"}},[_c('el-input',{attrs:{"id":"payerForm.payer.email","placeholder":"กรอกอีเมลผู้ชำระ"},model:{value:(_vm.payerForm.payer.email),callback:function ($$v) {_vm.$set(_vm.payerForm.payer, "email", $$v)},expression:"payerForm.payer.email"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("รายละเอียดการชำระ")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"วันที่ครบกำหนดชำระ","prop":"issued_on"}},[_c('el-date-picker',{attrs:{"type":"date","prefix-icon":"","id":"payerForm.issued_on","placeholder":"กรอกวันที่ครบกำหนดชำระ"},model:{value:(_vm.payerForm.issued_on),callback:function ($$v) {_vm.$set(_vm.payerForm, "issued_on", $$v)},expression:"payerForm.issued_on"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":_vm.ref1Label,"prop":"ref1"}},[_c('el-input',{ref:"payerForm.ref1",attrs:{"id":"payerForm.ref1","maxlength":20,"placeholder":("กรอก" + _vm.ref1Label)},on:{"change":_vm.updateMaskRefCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'payerForm.ref1', 'refCode')}},model:{value:(_vm.payerForm.ref1),callback:function ($$v) {_vm.$set(_vm.payerForm, "ref1", $$v)},expression:"payerForm.ref1"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":_vm.ref2Label,"prop":"ref2"}},[_c('el-input',{ref:"payerForm.ref2",attrs:{"id":"payerForm.ref2","maxlength":20,"placeholder":("กรอก" + _vm.ref2Label)},on:{"change":_vm.updateMaskRefCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'payerForm.ref2', 'refCode')}},model:{value:(_vm.payerForm.ref2),callback:function ($$v) {_vm.$set(_vm.payerForm, "ref2", $$v)},expression:"payerForm.ref2"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"จำนวนที่ต้องชำระ (บาท)","prop":"amount"}},[_c('el-input',{ref:"payerForm.amount",attrs:{"id":"payerForm.amount","placeholder":"กรอกจำนวนที่ต้องชำระ"},on:{"change":_vm.updateMaskAmount},nativeOn:{"input":function($event){return _vm.handleInput($event, 'payerForm.amount', 'amountMask')}},model:{value:(_vm.payerForm.amount),callback:function ($$v) {_vm.$set(_vm.payerForm, "amount", $$v)},expression:"payerForm.amount"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("การแจ้งเตือน")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-checkbox',{on:{"change":_vm.toggleUseSCBNotiMsg},model:{value:(_vm.useDefaultSCBNoti),callback:function ($$v) {_vm.useDefaultSCBNoti=$$v},expression:"useDefaultSCBNoti"}},[_vm._v("ใช้การแจ้งเตือนจาก Admin ของบริษัท")])],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"notification-block",attrs:{"span":21}},[_c('el-form-item',{ref:"notification_msg",attrs:{"label":"","prop":"notification_msg"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"disabled":_vm.useDefaultSCBNoti,"label":"DATE","id":"payerForm.notification_msg_type_1"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.payerForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.payerForm, "notification_msg_type", $$v)},expression:"payerForm.notification_msg_type"}},[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_vm._v("กรุณาชำระภายในวันที่")]),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_c('el-select',{staticStyle:{"width":"100px","text-align":"center"},attrs:{"disabled":_vm.payerForm.notification_msg_type === 'CUSTOM' || _vm.useDefaultSCBNoti,"id":"payerForm.notification_msg_date"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.payerForm.notification_msg_date),callback:function ($$v) {_vm.$set(_vm.payerForm, "notification_msg_date", $$v)},expression:"payerForm.notification_msg_date"}},_vm._l((_vm.notificationDayList),function(day){return _c('el-option',{key:day,attrs:{"label":day,"value":day}})}),1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":5,"offset":1}},[_vm._v("\n                        ของทุกเดือน\n                      ")])],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"20px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-radio',{attrs:{"label":"CUSTOM","disabled":_vm.useDefaultSCBNoti,"id":"payerForm.notification_msg_type_2"},on:{"change":_vm.toggleUsingNotificationMsgValue},model:{value:(_vm.payerForm.notification_msg_type),callback:function ($$v) {_vm.$set(_vm.payerForm, "notification_msg_type", $$v)},expression:"payerForm.notification_msg_type"}}),_vm._v(" "),_c('el-input',{staticStyle:{"width":"300px"},attrs:{"disabled":_vm.payerForm.notification_msg_type !== 'CUSTOM' || _vm.useDefaultSCBNoti,"id":"payerForm.notification_msg_custom","maxlength":100,"placeholder":"กรอกข้อความแจ้งเตือนที่ต้องการ"},model:{value:(_vm.payerForm.notification_msg_custom),callback:function ($$v) {_vm.$set(_vm.payerForm, "notification_msg_custom", $$v)},expression:"payerForm.notification_msg_custom"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{attrs:{"label":"Remark","prop":"remark"}},[_c('el-input',{attrs:{"id":"payerForm.remark","maxlength":100,"placeholder":"กรอกข้อความที่นี่"},model:{value:(_vm.payerForm.remark),callback:function ($$v) {_vm.$set(_vm.payerForm, "remark", $$v)},expression:"payerForm.remark"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"adminForm.cancelButton"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated && _vm.isBillerAdmin)?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"adminForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","id":"adminForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขรายการผู้ชำระ' : 'สร้างรายการผู้ชำระใหม่'))])],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_list_vue__ = __webpack_require__(494);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2663dfcc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_list_vue__ = __webpack_require__(1118);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2663dfcc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biller-list-page page-content"},[_c('el-row',{staticClass:"page-header -with-search-bar",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":8}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายชื่อบัญชีผู้ใช้ระบบ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":10}}),_vm._v(" "),_c('el-col',{attrs:{"span":5}},[_c('el-button',{staticClass:"search-button",attrs:{"type":"primary"},on:{"click":function($event){$event.preventDefault();return _vm.createCompanyUser.apply(null, arguments)}}},[_vm._v("\n        เพิ่มบัญชีผู้ใช้ระบบ "),_c('i',{staticClass:"el-icon-plus el-icon-right"})])],1)],1),_vm._v(" "),_c('div',{staticClass:"profile-list-table"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.userListData,"default-sort":{prop: 'email', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"email","label":"อีเมล","sortable":"","class-name":"no-wrap","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","sortable":"","class-name":"no-wrap","min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tel","label":"โทรศัพท์","sortable":"","formatter":_vm.telFormatter,"width":"140"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"role","label":"หน้าที่","sortable":"","formatter":_vm.roleFormatter,"width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"สถานะ","width":"100","formatter":_vm.statusFormatter},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":_vm.statusTypeFormatter(scope.row),"close-transition":""}},[_vm._v(_vm._s(_vm.statusFormatter(scope.row)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"รายละเอียด","min-width":"150","class-name":"desc-col"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"ตัวเลือก","header-align":"center","align":"center","class-name":"action-col","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.isBillerAdmin)?_c('el-button',{staticClass:"action-btn",attrs:{"type":"primary","plain":"","size":"mini"},on:{"click":function($event){$event.preventDefault();return _vm.handleEdit(scope.$index, scope.row)}}},[_vm._v("แก้ไข")]):_vm._e()]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_form_vue__ = __webpack_require__(495);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bd390b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_form_vue__ = __webpack_require__(1121);
function injectStyle (ssrContext) {
  __webpack_require__(1120)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bd390b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"biller-user-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชีผู้ดูแลบริษัท' : 'เพิ่มบัญชีผู้ดูแลบริษัท'))])],1)],1),_vm._v(" "),_c('el-form',{ref:"adminForm",staticClass:"admin-form company-detail-info",attrs:{"model":_vm.adminForm,"rules":_vm.adminFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('adminForm')}}},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"อีเมลผู้ดูแล","prop":"email"}},[_c('el-input',{attrs:{"id":"adminForm.email","disabled":_vm.adminForm.role === 'ADMIN',"placeholder":"กรอกอีเมลผู้ดูแล"},model:{value:(_vm.adminForm.email),callback:function ($$v) {_vm.$set(_vm.adminForm, "email", $$v)},expression:"adminForm.email"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ชื่อผู้ดูแล","prop":"name"}},[_c('el-input',{attrs:{"id":"adminForm.name","disabled":_vm.adminForm.role === 'ADMIN',"placeholder":"กรอกชื่อผู้ดูแล"},model:{value:(_vm.adminForm.name),callback:function ($$v) {_vm.$set(_vm.adminForm, "name", $$v)},expression:"adminForm.name"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"หมายเลขโทรศัพท์","prop":"tel"}},[_c('el-input',{attrs:{"id":"adminForm.tel","disabled":_vm.adminForm.role === 'ADMIN',"placeholder":"กรอกหมายเลขโทรศัพท์"},model:{value:(_vm.adminForm.tel),callback:function ($$v) {_vm.$set(_vm.adminForm, "tel", $$v)},expression:"adminForm.tel"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"สถานะบัญชี","prop":"status"}},[_c('el-checkbox',{attrs:{"disabled":_vm.adminForm.role === 'ADMIN',"id":"adminForm.status"},model:{value:(_vm.adminForm.status),callback:function ($$v) {_vm.$set(_vm.adminForm, "status", $$v)},expression:"adminForm.status"}},[_vm._v("Enable")])],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"รายละเอียดผู้ดูแล","prop":"description"}},[_c('el-input',{attrs:{"id":"adminForm.description","disabled":_vm.adminForm.role === 'ADMIN',"placeholder":"กรอกรายละเอียดผู้ดูแล"},model:{value:(_vm.adminForm.description),callback:function ($$v) {_vm.$set(_vm.adminForm, "description", $$v)},expression:"adminForm.description"}})],1)],1)],1),_vm._v(" "),(_vm.adminForm.role !== 'ADMIN')?_c('el-row',{staticClass:"detail-section assigned-profiles-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ข้อมูลรับชำระบริษัทที่ดูแล")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{staticClass:"assign-as-staff-holder",attrs:{"span":24}},[_c('el-select',{staticClass:"assign-as-staff",attrs:{"placeholder":"Assign same as staff"},on:{"change":_vm.assignAsStaff},model:{value:(_vm.assignStaffList),callback:function ($$v) {_vm.assignStaffList=$$v},expression:"assignStaffList"}},_vm._l((_vm.allStaffs),function(item){return _c('el-option',{key:("staff_" + (item.id)),attrs:{"label":item.name,"value":item.id}})}),1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"","prop":"assigned_profiles"}},[_c('el-select',{staticStyle:{"display":"none"},attrs:{"multiple":""},model:{value:(_vm.adminForm.assigned_profiles),callback:function ($$v) {_vm.$set(_vm.adminForm, "assigned_profiles", $$v)},expression:"adminForm.assigned_profiles"}},_vm._l((_vm.adminForm.assigned_profiles),function(id,$index){return _c('el-option',{key:("profile_" + $index + "_" + id),attrs:{"label":id,"value":id}})}),1)],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"profile-list-table"},[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.profileListData,"default-sort":{prop: 'name', order: 'ascending'}},on:{"selection-change":_vm.handleSelectionChange}},[_c('el-table-column',{attrs:{"type":"selection","header-align":"center","align":"center","fixed":"left","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"ชื่อ","class-name":"no-wrap","sortable":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"ข้อมูล Bill Payment","header-align":"center","align":"center"}},[_c('el-table-column',{attrs:{"prop":"bill_payment_comp_code","label":"COMP CODE","header-align":"center","align":"center","sortable":"","formatter":_vm.compCodeFormatter,"width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bill_payment_account_no","label":"หมายเลขบัญชี","header-align":"center","align":"center","sortable":"","formatter":_vm.accountNoFormatter,"width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"bill_payment_biller_id","label":"Biller ID","header-align":"center","align":"center","sortable":"","formatter":_vm.billerIdFormatter,"width":"130"}})],1),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"payment_type","label":"วิธีการชำระเงิน","sortable":"","header-align":"center","align":"center","width":"140","formatter":_vm.paymentTypeFormatter}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"update_at","label":"วันที่แก้ไข","width":"120","header-align":"center","align":"center","sortable":"","formatter":_vm.dateFormatter}})],1)],1)])],1)],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"adminForm.cancelButton"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[(_vm.isUpdated && _vm.adminForm.role === 'STAFF')?_c('el-button',{staticClass:"terminate-btn",attrs:{"type":"danger","icon":"el-icon-delete","id":"adminForm.terminateButton"},on:{"click":_vm.confirmTerminate}},[_vm._v(_vm._s(_vm._f("translate")('Terminate')))]):_vm._e(),_vm._v(" "),(_vm.adminForm.role === 'STAFF')?_c('el-button',{attrs:{"type":"primary","id":"adminForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm.isUpdated ? 'แก้ไขบัญชี' : 'สร้างบัญชี'))]):_vm._e()],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_detail_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2384e121_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_detail_vue__ = __webpack_require__(1124);
function injectStyle (ssrContext) {
  __webpack_require__(1123)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2384e121_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"biller-page company-detail-page page-content",class:{
    'no-company-info': !_vm.company,
  }},[(!_vm.company)?_c('el-row',{staticClass:"reload-panel-holder",attrs:{"type":"flex","justify":"left","align":"middle"}},[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"reload-panel"},[_c('h3',[_vm._v("ระบบไม่สามารถโหลดข้อมูลของบริษัทได้"),_c('br'),_vm._v("กรุณาลองใหม่อีกครั้ง")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","icon":"el-icon-refresh"},on:{"click":_vm.reloadInfo}},[_vm._v("โหลดข้อมูลใหม่")])],1)])],1):_vm._e(),_vm._v(" "),(_vm.company)?_c('el-row',{staticClass:"page-header",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('h2',{staticClass:"page-title"},[_vm._v("รายละเอียดบริษัท")])])],1):_vm._e(),_vm._v(" "),(_vm.company)?_c('div',{staticClass:"company-detail-info"},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            ชื่อบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.name))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            เลขประจำตัวผู้เสียภาษี\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            เว็ปไซต์สำหรับจัดการของบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.taxIdFormatter(_vm.company.tax_id)))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('code',{staticClass:"slug-host-code"},[_vm._v(_vm._s((_vm.baseHost + "/" + (_vm.company.slug))))])])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n            โลโก้บริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[(_vm.company.logo)?_c('img',{staticClass:"company-logo-preview",attrs:{"src":_vm.company.logo,"alt":_vm.company.name}}):_vm._e()])],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่หลักของบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n            ที่อยู่\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":24}},[_vm._v(_vm._s(_vm.company.address.line_1))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            อำเภอ/เขต\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            ตำบล/แขวง\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.city))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.district))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            จังหวัด\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            รหัสไปรษณีย์\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.province))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.company.address.postal_code))])],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            โทรศัพท์\n          ")]),_vm._v(" "),_c('el-col',{staticClass:"label",attrs:{"span":12}},[_vm._v("\n            โทรสาร\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.telFormatter(_vm.company.address.tel)))]),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_vm._v(_vm._s(_vm.faxFormatter(_vm.company.address.fax)))])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_edit_vue__ = __webpack_require__(497);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eee98b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_edit_vue__ = __webpack_require__(1127);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eee98b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.isSubmitting),expression:"isSubmitting",modifiers:{"fullscreen":true,"lock":true}}],staticClass:"biller-page company-edit-form-page page-content",attrs:{"element-loading-text":_vm.$t('Submitting...')}},[_c('el-row',{staticClass:"page-header -with-back-button",attrs:{"type":"flex","justify":"space-between"}},[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticClass:"back-button",attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){$event.preventDefault();return _vm.goBack.apply(null, arguments)}}}),_vm._v(" "),_c('h2',{staticClass:"page-title"},[_vm._v("แก้ไขรายละเอียดบริษัท")])],1)],1),_vm._v(" "),(_vm.company)?_c('el-form',{ref:"companyForm",staticClass:"company-form company-detail-info",attrs:{"model":_vm.companyForm,"rules":_vm.companyFormRules,"label-width":"120px","label-position":"top","disabled":_vm.isSubmitting},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.submitForm('companyForm')}}},[_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("รายละเอียดบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{staticClass:"label",attrs:{"span":24}},[_vm._v("\n            ชื่อบริษัท\n          ")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":12}},[_vm._v("\n            "+_vm._s(_vm.company.name)+"\n            "),_c('br'),_c('br')])],1),_vm._v(" "),_c('el-row',{staticClass:"logo-uploader-holder"},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{attrs:{"label":"โลโก้บริษัท","prop":"logo"}},[(_vm.companyForm.logo)?_c('div',{staticClass:"logo-holder"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.companyForm.logo}})]):_vm._e(),_vm._v(" "),_c('el-upload',{staticClass:"company-logo-uploader",attrs:{"action":_vm.uploadUrl,"drag":"","show-file-list":false,"http-request":_vm.handleHttpRequest,"on-success":_vm.handleLogoSuccess,"on-error":_vm.handleLogoFail,"before-upload":_vm.beforeLogoUpload}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isUploading),expression:"isUploading"}],staticClass:"upload-instruction"},[_c('h3',[_vm._v("อัพโหลดโลโก้บริษัท")]),_vm._v(" "),_c('i',{staticClass:"el-icon-upload logo-uploader-icon"})])]),_vm._v(" "),(_vm.companyForm.logo)?_c('el-button',{staticClass:"remove-logo",attrs:{"type":"danger","icon":"el-icon-delete"},on:{"click":_vm.removeLogo}},[_vm._v("ลบโลโก้บริษัท")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-instruction-hint"},[_vm._v("\n                ขนาดขั้นต่ำ 500px x 500px และต้องเป็นไฟล์นามสกุล JPG, PNG, GIF\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-section"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h3',{staticClass:"section-title"},[_vm._v("ที่อยู่หลักของบริษัท")])])],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ที่อยู่","prop":"address.line_1"}},[_c('el-input',{attrs:{"id":"companyForm.address.line_1","placeholder":"กรอกที่อยู่"},model:{value:(_vm.companyForm.address.line_1),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "line_1", $$v)},expression:"companyForm.address.line_1"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"ตำบล/แขวง","prop":"address.district"}},[_c('el-input',{attrs:{"id":"companyForm.address.district","placeholder":"กรอกตำบล/แขวง"},model:{value:(_vm.companyForm.address.district),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "district", $$v)},expression:"companyForm.address.district"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"อำเภอ/เขต","prop":"address.city"}},[_c('el-input',{attrs:{"id":"companyForm.address.city","placeholder":"กรอกอำเภอ/เขต"},model:{value:(_vm.companyForm.address.city),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "city", $$v)},expression:"companyForm.address.city"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"จังหวัด","prop":"address.province"}},[_c('el-select',{attrs:{"id":"companyForm.address.province"},model:{value:(_vm.companyForm.address.province),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "province", $$v)},expression:"companyForm.address.province"}},_vm._l((_vm.provinceList),function(province){return _c('el-option',{key:province,attrs:{"label":province,"value":province}})}),1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"รหัสไปรษณีย์","prop":"address.postal_code"}},[_c('el-input',{ref:"companyForm.address.postal_code",attrs:{"id":"companyForm.address.postal_code","placeholder":"กรอกรหัสไปรษณีย์"},on:{"change":_vm.updatePostCode},nativeOn:{"input":function($event){return _vm.handleInput($event, 'companyForm.address.postal_code', 'postcode')}},model:{value:(_vm.companyForm.address.postal_code),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "postal_code", $$v)},expression:"companyForm.address.postal_code"}})],1)],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"detail-row"},[_c('el-row',[_c('el-col',{attrs:{"span":10}},[_c('el-form-item',{attrs:{"label":"โทรศัพท์","prop":"address.tel"}},[_c('el-input',{attrs:{"id":"companyForm.address.tel","placeholder":"กรอกโทรศัพท์"},model:{value:(_vm.companyForm.address.tel),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "tel", $$v)},expression:"companyForm.address.tel"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":10,"offset":1}},[_c('el-form-item',{attrs:{"label":"โทรสาร","prop":"address.fax"}},[_c('el-input',{attrs:{"id":"companyForm.address.fax","placeholder":"กรอกโทรสาร"},model:{value:(_vm.companyForm.address.fax),callback:function ($$v) {_vm.$set(_vm.companyForm.address, "fax", $$v)},expression:"companyForm.address.fax"}})],1)],1)],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":21}},[_c('el-form-item',{staticClass:"button-bar"},[_c('el-button',{staticClass:"cancel-btn",attrs:{"type":"primary","plain":"","id":"companyForm.cancelButton"},on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm._f("translate")('Cancel')))]),_vm._v(" "),_c('div',{staticClass:"submit-button-group"},[_c('el-button',{attrs:{"type":"primary","id":"companyForm.submitButton","icon":"el-icon-edit","native-type":"submit"}},[_vm._v(_vm._s(_vm._f("translate")('Save and continue')))])],1)],1)],1)],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(153);
// Middleware stuffs


var defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? "AdminUserLoadInfo" : "BillerUserLoadInfo";

var routerMiddleware = {
  pageTitle: function pageTitle(to, from, next) {
    document.title = to.meta.title;
    return next();
  },
  checkIsLogin: function checkIsLogin(to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.isAuthenticated) {
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.needResetPwd) {
        return next({ name: 'ResetPassword' });
      }
      return next({ name: defaultRouteName });
    }
    return next();
  },
  requireAuthenticated: function requireAuthenticated(to, from, next) {
    if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.isAuthenticated) {
      return next({ name: 'Login' });
    } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.needResetPwd && ['ResetPassword', 'Logout'].indexOf(to.name) === -1) {
      return next({ name: 'ResetPassword' });
    }
    return next();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (routerMiddleware);

/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);


/* eslint new-cap: ["error", { "newIsCap": false }] */
/* eslint no-param-reassign: 0 */



// SENTRY STUFFS

// import _ from 'lodash';

var HttpClient = function HttpClient(baseUrl) {
  var $http = new __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: baseUrl,
    timeout: 60000
  });
  // this.$http = $http;
  return {
    getTokenExpirationDate: function getTokenExpirationDate(token) {
      if (token === null) return null;
      try {
        var decoded = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token);
        if (!decoded.exp) {
          return null;
        }
        return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(decoded.exp, 'X').tz("Asia/Bangkok");
      } catch (e) {
        console.error(e);
        return null;
      }
    },
    getInstance: function getInstance() {
      return $http;
    },
    sendRequest: function sendRequest(method, url, data, headers, cb) {
      var _this = this;

      var commonHeader = $http.defaults.headers.common;
      var shouldUnsetCommonHeader = false;
      if (headers !== null && headers.UNSET_COMMON_HEADER) {
        shouldUnsetCommonHeader = true;
        delete headers.UNSET_COMMON_HEADER;
      }
      // merge header
      var targetHeaders = commonHeader;
      if (headers !== null) {
        if (shouldUnsetCommonHeader) {
          targetHeaders = headers;
          $http.defaults.headers.common = {};
        } else {
          // targetHeaders = _.merge(headers, commonHeader);
          targetHeaders = commonHeader;
          // add/override headers
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(headers).forEach(function (headerKey) {
            targetHeaders[headerKey] = headers[headerKey];
          });
        }
      }
      $http.request({
        url: url,
        method: method,
        headers: targetHeaders,
        // headers,
        data: data
      }).then(function (res) {
        if (shouldUnsetCommonHeader) {
          $http.defaults.headers.common = commonHeader;
        }
        cb(null, _this.getResponseData(res));
      }).catch(function (err) {
        if (shouldUnsetCommonHeader) {
          $http.defaults.headers.common = commonHeader;
        }
        cb(_this.getErrorData(err), null);
      });
    },
    getResponseData: function getResponseData(res) {
      if (res.data) {
        return res.data;
      }
      return null;
    },
    getErrorData: function getErrorData(err) {
      if (window.appConfig.SENTRY_URL) {
        // check if error has response or not
        __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureException(err, {
          extra: {
            err_payload: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err))
          }
        });
      }
      if (err.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (err.response.data) {
          if (err.response.data.auth_code) {
            return err.response.data.auth_code;
          }
          if (err.response.data.error_message) {
            return err.response.data.error_message;
          }
          if (err.response.data.message) {
            return err.response.data.message;
          }
          return err.response.data;
        }
        return 'Unexpected error';
      } else if (err.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser
        return err.message;
      } else if (err.message) {
        return err.message;
      }
      return 'Unexpected error';
    },
    isAuthenticated: function isAuthenticated(token) {
      return typeof token === 'string';
    },

    /* isValidToken(token) {
      return new Promise((resolve, reject) => {
        const tokenExpired = this.isTokenExpired(token);
        if (tokenExpired) {
          reject('Login expired');
        } else {
          $http.post('/auth/verify-token', { token }).then(() => {
            resolve();
          }).catch((err) => {
            // check if error is network or not
            // console.error('catch verify token', getErrorData(err));
            reject(err);
          });
        }
      });
    }, */
    setJWTToken: function setJWTToken(jwt) {
      $http.defaults.headers.common.Authorization = 'Bearer ' + jwt;
    },
    removeJWTToken: function removeJWTToken() {
      $http.defaults.headers.common.Authorization = null;
    },
    isTokenExpired: function isTokenExpired(token) {
      var date = this.getTokenExpirationDate(token);
      if (date === null) {
        return false;
      }
      return date.diff(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok")) <= 0;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (HttpClient);

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_app__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_auth__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_company__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_biller__ = __webpack_require__(1089);



// import createMutationsSharer from 'vuex-shared-mutations';






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/**
 * Core Vue Store for the application
 */
var CoreStore = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_3__modules_app__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_4__modules_auth__["a" /* default */],
    company: __WEBPACK_IMPORTED_MODULE_5__modules_company__["a" /* default */],
    biller: __WEBPACK_IMPORTED_MODULE_6__modules_biller__["a" /* default */]
  },
  strict: debug,
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_2_vuex_persistedstate__["a" /* default */])({
    paths: ['app', 'auth', 'company', 'biller']
  })]
});

/* harmony default export */ __webpack_exports__["a"] = (CoreStore);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base64_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_base64_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_base64_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_encoding__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_text_encoding___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_text_encoding__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);
/* eslint no-param-reassign: 0 */






/* harmony default export */ __webpack_exports__["a"] = ({
  getURLSlug: function getURLSlug() {
    var hostName = window.location.hostname;
    var pathName = window.location.pathname;
    var envBaseHost = window.appConfig.BASE_URL;
    var hosts = envBaseHost ? envBaseHost.split(',') : [''];
    var isValidHostname = false;
    hosts.forEach(function (host) {
      if (hostName.indexOf(host) !== -1) {
        isValidHostname = true;
      }
    });
    // if (hostName.indexOf(window.appConfig.BASE_HOST) !== -1) {
    if (isValidHostname) {
      var domainComponents = pathName.split('/').filter(function (comp) {
        return comp !== '';
      });
      if (domainComponents.length > 0) {
        return domainComponents[0];
      }
    }
    return '';
  },
  getProvinceList: function getProvinceList() {
    return ['กรุงเทพมหานคร', 'กระบี่', 'กาญจนบุรี', 'กาฬสินธุ์', 'กำแพงเพชร', 'ขอนแก่น', 'จันทบุรี', 'ฉะเชิงเทรา', 'ชลบุรี', 'ชัยนาท', 'ชัยภูมิ', 'ชุมพร', 'เชียงราย', 'เชียงใหม่', 'ตรัง', 'ตราด', 'ตาก', 'นครนายก', 'นครปฐม', 'นครพนม', 'นครราชสีมา', 'นครศรีธรรมราช', 'นครสวรรค์', 'นนทบุรี', 'นราธิวาส', 'น่าน', 'บึงกาฬ', 'บุรีรัมย์', 'ปทุมธานี', 'ประจวบคีรีขันธ์', 'ปราจีนบุรี', 'ปัตตานี', 'พระนครศรีอยุธยา', 'พังงา', 'พัทลุง', 'พิจิตร', 'พิษณุโลก', 'เพชรบุรี', 'เพชรบูรณ์', 'แพร่', 'พะเยา', 'ภูเก็ต', 'มหาสารคาม', 'มุกดาหาร', 'แม่ฮ่องสอน', 'ยะลา', 'ยโสธร', 'ร้อยเอ็ด', 'ระนอง', 'ระยอง', 'ราชบุรี', 'ลพบุรี', 'ลำปาง', 'ลำพูน', 'เลย', 'ศรีสะเกษ', 'สกลนคร', 'สงขลา', 'สตูล', 'สมุทรปราการ', 'สมุทรสงคราม', 'สมุทรสาคร', 'สระแก้ว', 'สระบุรี', 'สิงห์บุรี', 'สุโขทัย', 'สุพรรณบุรี', 'สุราษฎร์ธานี', 'สุรินทร์', 'หนองคาย', 'หนองบัวลำภู', 'อ่างทอง', 'อุดรธานี', 'อุทัยธานี', 'อุตรดิตถ์', 'อุบลราชธานี', 'อำนาจเจริญ'];
  },
  base64Encode: function base64Encode(str) {
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf-8';

    var bytes = new __WEBPACK_IMPORTED_MODULE_1_text_encoding__["TextEncoder"](encoding).encode(str);
    return __WEBPACK_IMPORTED_MODULE_0_base64_js___default.a.fromByteArray(bytes);
  },
  base64Decode: function base64Decode(str) {
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'utf-8';

    var bytes = __WEBPACK_IMPORTED_MODULE_0_base64_js___default.a.toByteArray(str);
    return new __WEBPACK_IMPORTED_MODULE_1_text_encoding__["TextEncoder"](encoding).decode(bytes);
  },
  event: function event(name) {
    var evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
    return evt;
  },
  getMaskValue: function getMaskValue(value, maskOptions) {
    var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
    return mask.resolve(value.toString());
  },
  getUnmaskValue: function getUnmaskValue(value, maskOptions) {
    var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
    mask.resolve(value.toString());
    return mask.unmaskedValue;
  },
  handleInput: function handleInput(evt, refs, refName, mask, maskName) {
    if (!evt.isTrusted) return; // avoid infinite loop
    if (typeof refs[refName] === 'undefined') {
      return;
    }
    var el = evt.target;
    /* other properties to try to differentiate InputEvent of Event (custom)
     InputEvent (native)
       cancelable: false
       isTrusted: true
       composed: true
       isComposing: false
       which: 0
     Event (custom)
       cancelable: true
       isTrusted: false
     */
    // by default, keep cursor at same position as before the mask
    var position = el.selectionEnd;
    // save the character just inserted
    var lastCharPosition = position - 1;
    var digit = el.value[lastCharPosition];
    var maskOptions = mask[maskName];
    if (typeof maskOptions.mask === 'undefined') {
      maskOptions = {
        mask: mask[maskName]
      };
    }
    var originalValue = this.getUnmaskValue(el.value, maskOptions);
    var maskValue = this.getMaskValue(originalValue, maskOptions);
    el.value = maskValue;
    var midx = position - 1;
    while (position < maskValue.length && maskValue.charAt(midx) !== digit) {
      position += 1;
      midx = position - 1;
    }
    if (el === document.activeElement) {
      el.setSelectionRange(position, position);
      setTimeout(function () {
        el.setSelectionRange(position, position);
      }, 0);
    }
    el.dispatchEvent(this.event('input'));
  },
  getTokenExpirationDate: function getTokenExpirationDate(token) {
    if (token === null) return null;
    try {
      var decoded = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(token);
      if (!decoded.exp) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(decoded.exp, 'X').tz("Asia/Bangkok");
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  getTokenCompanyId: function getTokenCompanyId(token) {
    if (token === null) return null;
    try {
      var decoded = __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(token);
      if (!decoded.company_id) {
        return null;
      }
      return decoded.company_id;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  isTokenExpired: function isTokenExpired(token) {
    var date = this.getTokenExpirationDate(token);
    if (date === null) {
      return false;
    }
    return date.diff(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().tz("Asia/Bangkok")) <= 0;
  },
  getCurrentBaseHost: function getCurrentBaseHost() {
    var hostName = window.location.hostname;
    var envBaseHost = window.appConfig.BASE_HOST;
    var hosts = envBaseHost ? envBaseHost.split(',') : [''];
    var currentHostName = '';
    hosts.forEach(function (host) {
      if (hostName.indexOf(host) !== -1) {
        currentHostName = host;
      }
    });
    return currentHostName;
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_company__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
//
//
//
//
//
//
//
//
//






/**
 * Main App
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken !== null;
    },
    idToken: function idToken() {
      return this.$store.getters.idToken;
    },
    errorFlashs: function errorFlashs() {
      return this.$store.getters.errorFlashs;
    },
    appConfig: function appConfig() {
      if (window.appConfig) {
        return window.appConfig;
      }
      return {};
    }
  },
  methods: {
    checkTokenExpired: function checkTokenExpired() {
      if (this.isAuthenticated) {
        var isExpired = __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].isTokenExpired(this.$store.getters.idToken);
        if (isExpired) {
          this.$store.dispatch('ADD_ERROR_FLASH', this.$t('4032'));
          // this.$router.push({ name: 'Logout' });
          this.forceLogout();
        }
      }
    },
    updateActiveTimestamp: function updateActiveTimestamp() {
      this.$store.dispatch('UPDATE_ACTIVE_TIMESTAMP');
    },
    checkForceLogout: function checkForceLogout() {
      // get timestamp
      var storedTimestamp = this.$store.getters.activeTimestamp;
      if (storedTimestamp === 0) {
        return;
      }
      var now = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().tz("Asia/Bangkok");
      var currentTimestamp = Number(now.format('X'));
      var timeDiff = currentTimestamp - storedTimestamp;
      // check if exceed 10 seconds, force logout
      if (timeDiff > 10) {
        // this.$store.dispatch('ADD_ERROR_FLASH', this.$t('4032'));
        // this.$router.push({ name: 'Logout' });
        this.forceLogout();
      }
    },
    sendCheckSession: function sendCheckSession() {
      var _this = this;

      // console.log('sendCheckSession', this.isAuthenticated);
      if (this.isAuthenticated) {
        // check if session is expired or not
        // console.log('dispatch CHECK_SESSION');
        this.$store.dispatch('CHECK_SESSION').then(function () {
          // console.log('dispatch CHECK_SESSION_COUNT');
          _this.$store.dispatch('CLEAR_SESSION_COUNT');
        }).catch(function (err) {
          // console.log('ERROR', err);
          // something fail, should force logout
          if (err) {
            _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(err));
          }
          // this.$router.push({ name: 'Logout' });
          _this.forceLogout();
        });
      }
    },
    sendHeartbeat: function sendHeartbeat() {
      var _this2 = this;

      // check if login & have any activities to be sent
      if (this.isAuthenticated) {
        if (this.$store.getters.activityCount > 0) {
          this.$store.dispatch('SEND_HEARTBEAT').then(function () {}).catch(function (err) {
            // something fail, should force logout
            // this.$message.error(err);
            if (err) {
              _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(err));
            }
            _this2.$router.push({ name: 'Logout' });
          });
        }
        /* else if (this.$store.getters.checkSessionCount < process.env.CHECK_SESSION_COUNT || 5) {
          // check if we have 5 check session count or not
          this.$store.dispatch('ADD_SESSION_COUNT');
        } else {
          // check if session is expired or not
          this.sendCheckSession();
        } */
      }
      if (this.$store.getters.activityCount > 0) {
        this.$store.dispatch('CLEAR_ACTIVITY');
      }
    },
    detectActivity: function detectActivity(e) {
      if (this.isAuthenticated) {
        var activity = {
          type: e.type,
          timestamp: Date.now()
        };
        this.$store.dispatch('ADD_ACTIVITY', activity);
      }
    },
    forceLogout: function forceLogout() {
      var _this3 = this;

      // this.$router.push({ name: 'Logout' });
      this.$store.dispatch('LOGOUT', {
        vm: this
      }).then(function () {
        _this3.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: _this3.$t('Successfully logged out.')
        });
        _this3.$router.push({ name: 'Login' });
      }).catch(function (err) {
        // console.error(err);
        _this3.$log.error(err);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.checkForceLogout();
    // get slug
    var slug = __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getURLSlug();
    // we should check tenant_id & app_mode if it is different from the stored one or not
    var token = __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getTokenCompanyId(this.$store.getters.idToken);
    if (this.$store.getters.idToken && this.$store.getters.tenantId !== token) {
      // we should logout first
      // window.location.assign(`//${window.location.host}/${slug}/logout`);
      // this.$router.push({ name: 'Logout' });
      this.forceLogout();
    } else {
      this.$store.dispatch('SET_TENANT_ID', slug);
      // set app mode
      this.$store.dispatch('SET_APP_MODE', window.appConfig.SCB_BILLING_APP_MODE);
    }
    // setup heartbeat
    this.sendHeartbeat();
    this.sendCheckSession();
    this.checkTokenExpired();
    setInterval(this.sendHeartbeat, 60000 || 10000);
    setInterval(this.sendCheckSession, 60000 || 60000);
    // setInterval(this.sendCheckSession, 10000);
    setInterval(this.checkTokenExpired, 60000 || 60000);
    setInterval(this.updateActiveTimestamp, 1000);
    // add activity capture
    document.addEventListener('click', this.detectActivity);
    document.addEventListener('keyup', this.detectActivity);
    window.addEventListener('load', function (event) {
      var updateOnlineStatus = function updateOnlineStatus() {
        var isOnline = event.type === 'online' || navigator.onLine;
        if (isOnline) {
          _this4.sendCheckSession();
        }
      };

      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);
    });
    // check if we've JWT stored or not
    if (this.$store.getters.idToken) {
      __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].setJWTToken(this.$store.getters.idToken);
      __WEBPACK_IMPORTED_MODULE_1__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
    }
    // send check session to check if current session is valid or not
    this.sendCheckSession();
  },

  watch: {
    idToken: function idToken(newState, oldState) {
      var _this5 = this;

      var isLoggedOut = oldState !== null && newState === null;
      var isLoggedIn = oldState === null && newState !== null;

      if (isLoggedOut) {
        // remove JWT token from each service
        __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].removeJWTToken(this.$store.getters.idToken);
        __WEBPACK_IMPORTED_MODULE_1__services_company__["a" /* default */].removeJWTToken(this.$store.getters.idToken);
        // clear state
        /* this.$store.dispatch('APP_CLEAR_STATE');
        this.$store.dispatch('AUTH_CLEAR_STATE');
        this.$store.dispatch('BILLER_CLEAR_STATE');
        this.$store.dispatch('COMPANY_CLEAR_STATE'); */
        // force go to login page
        this.$router.push({ name: 'Login' });
        // force reload
        // if (process.env.SHOULD_LOGOUT_RELOAD_PAGE) {
        // console.log('FORCE RELOAD');
        window.location.reload();
        // }
      } else if (isLoggedIn) {
        // set JWT token for each service
        __WEBPACK_IMPORTED_MODULE_0__services_auth__["a" /* default */].setJWTToken(this.$store.getters.idToken);
        __WEBPACK_IMPORTED_MODULE_1__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
        this.$nextTick(function () {
          var goToRouteName = _this5.$store.getters.isBiller ? "BillerUserLoadInfo" : "AdminUserLoadInfo";
          _this5.$router.push({ name: goToRouteName });
          // console.log('FORCE RELOAD');
          window.location.reload();
        });
      }
    },
    errorFlashs: function errorFlashs(newState) {
      var _this6 = this;

      if (newState.length > 0) {
        // display all messages
        newState.forEach(function (errMessage) {
          _this6.$message.error({
            // title: 'Error',
            duration: 10000, // stay for 10s
            message: errMessage,
            showClose: true,
            type: 'error'
            // offset: 50,
          });
        });
        // clear message
        this.$store.dispatch('CLEAR_ERROR_FLASH');
      }
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_http__ = __webpack_require__(142);

// import moxios from 'moxios';

var $http = new __WEBPACK_IMPORTED_MODULE_0__libs_http__["a" /* default */](window.appConfig.API_AUTH_BASE_URL);

var AuthService = {
  setJWTToken: function setJWTToken(jwt) {
    $http.setJWTToken(jwt);
  },
  removeJWTToken: function removeJWTToken() {
    $http.removeJWTToken();
  },
  login: function login(tenantId, email, password, cb) {
    $http.sendRequest('post', "/auth-token", {
      tenant_id: tenantId,
      email: email,
      password: password
    }, null, cb);
  },
  logout: function logout(token, cb) {
    // window.localStorage.removeItem('vuex');
    $http.sendRequest('delete', '/auth-token/' + token, null, null, cb);
  },
  heartbeat: function heartbeat(token, cb) {
    $http.sendRequest('put', '/auth-token/' + token, {
      active: true
    }, null, cb);
  },
  checkSession: function checkSession(token, cb) {
    /* moxios.install($http.getInstance());
    setTimeout(() => {
      $http
        .sendRequest('get', `/auth-token/${token}/verification`,
          null, null, cb);
      moxios.wait(() => {
        const request = moxios.requests.mostRecent();
        request.respondWith({
          status: 403,
          response: {
            auth_code: 4031,
          },
        }).then(() => {
          moxios.uninstall($http.getInstance());
        });
      });
    }, 5000); */
    $http.sendRequest('get', '/auth-token/' + token + '/verification', null, null, cb);
  },
  resetPassword: function resetPassword(tenantId, email, cb) {
    // $http
    //   .sendRequest('post', '/reset-pwd-token', {
    //     tenant_id: tenantId,
    //     email,
    //   }, null, cb);
    $http.sendRequest('post', '/temporary-pwd', {
      tenant_id: tenantId,
      email: email
    }, null, cb);
  },
  changePassword: function changePassword(force, token, password, cb) {
    var endpoint = '/pwd';
    if (force) {
      endpoint += '?auth_token_str=' + token;
    } else {
      endpoint += '?reset_pwd_token=' + token;
    }
    $http.sendRequest('put', endpoint, {
      new_pwd: password
    }, null, cb);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthService);

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid_faUser__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid_faUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid_faUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsqr__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsqr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsqr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_qr__ = __webpack_require__(859);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint max-len: ["error", { "code": 200 }] */





var MainLayout = {
  name: 'main-layout',
  data: function data() {
    return {
      isShowingQRModal: false,
      isQRImporting: false,
      qrFile: null,
      qrVerificationResult: null,
      qrInfo: ''
    };
  },

  components: {
    FontAwesomeIcon: __WEBPACK_IMPORTED_MODULE_0__fortawesome_vue_fontawesome___default.a
  },
  computed: {
    shouldShowAside: function shouldShowAside() {
      if (this.$store.getters.isBiller) {
        return this.$store.getters.myAdminInfo && this.$store.getters.billerInfo && !this.$store.getters.isInitialLoading;
      } else if (this.$store.getters.isAdmin) {
        // return true;
        return this.$store.getters.scbAdminInfo && !this.$store.getters.isAdminInitialLoading;
      }
      return false;
    },
    appName: function appName() {
      return this.$store.getters.appName;
    },
    faUser: function faUser() {
      return __WEBPACK_IMPORTED_MODULE_1__fortawesome_fontawesome_free_solid_faUser___default.a;
    },
    isAdmin: function isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isBiller: function isBiller() {
      return this.$store.getters.isBiller;
    },
    isBillerAdmin: function isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    adminUserRole: function adminUserRole() {
      return this.$store.getters.adminUserRole;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    isAdminRole: function isAdminRole() {
      return this.$store.getters.isAdminRole;
    },
    billerRole: function billerRole() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role;
      }
      return '';
    },
    isContentLoading: function isContentLoading() {
      return this.$store.getters.isContentLoading;
    },
    currentYear: function currentYear() {
      var now = new Date();
      return now.getFullYear();
    },
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isNeedResetPwd: function isNeedResetPwd() {
      return this.$store.getters.needResetPwd;
    },
    userName: function userName() {
      return this.$store.getters.userName;
    },
    currentRoutePath: function currentRoutePath() {
      var parts = this.$store.state.route.path.split('/').filter(function (part) {
        return part !== '';
      });
      if (parts.length > 0) {
        return '/' + parts[0];
      }
      return this.$store.state.route.path;
    },
    companyProfileRoutes: function companyProfileRoutes() {
      return ['CompanyProfileCreate', 'CompanyProfileEdit'];
    },
    companyCompanyAdminRoutes: function companyCompanyAdminRoutes() {
      return ['CompanyAdminCreate', 'CompanyAdminEdit'];
    },
    currentCompanyRoutePath: function currentCompanyRoutePath() {
      // company profile
      // /company/{companyId}/profile
      if (this.companyProfileRoutes.indexOf(this.$store.state.route.name) !== -1) {
        var routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 4) {
          routes.push('profile');
        }
        if (routes.length > 4) {
          while (routes.length > 4) {
            routes.pop();
          }
        }
        return routes.join('/');
      }
      if (this.companyCompanyAdminRoutes.indexOf(this.$store.state.route.name) !== -1) {
        var _routes = this.$store.state.route.path.split('/');
        // remove the last part
        _routes.pop();
        if (_routes.length < 3) {
          _routes.push('admin');
        }
        return _routes.join('/');
      }
      // standard route
      return this.$store.state.route.path;
    },
    shouldShowMainMenu: function shouldShowMainMenu() {
      // return !this.shouldShowCompanyMenu;
      return this.$store.getters.isAdmin && !this.shouldShowCompanyMenu;
    },
    shouldShowCompanyMenu: function shouldShowCompanyMenu() {
      if (this.$store.getters.isBiller) return false;
      var isAdminInitialLoading = this.$store.getters.isAdminInitialLoading;

      var inboundPages = ['CompanyDetail', 'CompanyEdit', 'CompanyProfileList', 'CompanyProfileDetail', 'CompanyProfileCreate', 'CompanyProfileEdit', 'CompanyAdminList', 'CompanyAdminCreate', 'CompanyAdminEdit'];
      return inboundPages.indexOf(this.$store.state.route.name) !== -1 && this.currentCompany !== null && !isAdminInitialLoading;
    },
    shouldShowBillerMenu: function shouldShowBillerMenu() {
      if (this.$store.getters.isAdmin) return false;
      var isInitialLoading = this.$store.getters.isInitialLoading;

      var inboundPages = ['BillerCompanyDetail', 'BillerCompanyEdit', 'BillerProfileList', 'BillerProfileEdit', 'BillerProfileDetail', 'BillerSlipCreate', 'BillerSlipEdit', 'BillerUserList', 'BillerUserCreate', 'BillerUserEdit'];
      return inboundPages.indexOf(this.$store.state.route.name) !== -1 && this.billerInfo !== null && !isInitialLoading;
    },
    currentBillerRoutePath: function currentBillerRoutePath() {
      var profileRoutes = ['BillerProfileList', 'BillerProfileDetail', 'BillerProfileEdit', 'BillerSlipCreate', 'BillerSlipEdit'];
      var userRoutes = ['BillerUserList', 'BillerUserCreate', 'BillerUserEdit'];
      if (profileRoutes.indexOf(this.$store.state.route.name) !== -1) {
        var routes = this.$store.state.route.path.split('/');
        // remove the last part
        routes.pop();
        if (routes.length < 2) {
          routes.push('profiles');
        } else if (routes.length > 2) {
          // find how many times we have to pop excess companents
          // then pop all of them
          /* for (let p = 1; p <= (routes.length - 2) + 1; p += 1) {
            routes.pop();
          } */
          while (routes.length > 2) {
            routes.pop();
          }
        }
        return routes.join('/');
      }
      if (userRoutes.indexOf(this.$store.state.route.name) !== -1) {
        var _routes2 = this.$store.state.route.path.split('/');
        // remove the last part
        _routes2.pop();
        if (_routes2.length < 2) {
          _routes2.push('users');
        }
        if (_routes2.length > 2) {
          // pop all of them
          for (var p = 1; p <= _routes2.length - 2; p += 1) {
            _routes2.pop();
          }
        }
        return _routes2.join('/');
      }
      // standard route
      return this.$store.state.route.path;
    },
    currentCompany: function currentCompany() {
      return this.$store.getters.currentCompany;
    },
    currentBiller: function currentBiller() {
      return this.$store.getters.billerInfo;
    },
    qrInfoFormat: function qrInfoFormat() {
      return this.qrInfo.replace(' ', '');
    }
  },
  methods: {
    preventSCBSubmenuClosing: function preventSCBSubmenuClosing(index) {
      this.$refs.scbMainMenu.open(index);
    },
    preventCompanySubmenuClosing: function preventCompanySubmenuClosing(index) {
      this.$refs.companyMainMenu.open(index);
    },
    preventBillerSubmenuClosing: function preventBillerSubmenuClosing(index) {
      this.$refs.billerMainMenu.open(index);
    },
    viewCompanyDetail: function viewCompanyDetail() {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          companyId: this.currentCompany.id
        }
      });
    },
    viewBillerCompanyDetail: function viewBillerCompanyDetail() {
      this.$router.push({
        name: 'BillerCompanyDetail'
      });
    },
    showQRModal: function showQRModal() {
      this.isShowingQRModal = true;
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
    },
    handleBeforeQRUpload: function handleBeforeQRUpload(file) {
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
      var isValid = true;
      var isJPG = file.type === 'image/jpeg';
      var isPNG = file.type === 'image/png';
      var isGIF = file.type === 'image/gif';
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG && !isGIF) {
        isValid = false;
        this.$message.error('กรุณาเลือกไฟล์รูป QR เป็น jpeg, png หรือ gif เท่านั้น!');
      }
      if (!isLt2M) {
        isValid = false;
        this.$message.error('รูป QR ต้องมีขนาดไม่เกิน 2MB!');
      }
      if (isValid) {
        this.qrFile = file;
      }
      return true;
    },
    handleQRImport: function handleQRImport() {
      var _this = this;

      var vm = this;
      if (vm.qrFile) {
        vm.isQRImporting = true;
        vm.qrVerificationResult = null;
        // read image content first
        var qrReader = new FileReader();
        qrReader.addEventListener('load', function () {
          var image = new Image();
          image.crossOrigin = 'Anonymous';
          image.onload = function () {
            var canvasQR = document.createElement('canvas');
            var context = canvasQR.getContext('2d');

            canvasQR.width = image.width;
            canvasQR.height = image.height;
            context.drawImage(image, 0, 0);
            var qrWidth = image.width;
            var qrHeight = image.height;

            try {
              var imagedata = context.getImageData(0, 0, image.width, image.height);
              var code = __WEBPACK_IMPORTED_MODULE_2_jsqr___default()(imagedata.data, qrWidth, qrHeight);
              if (code) {
                var res = __WEBPACK_IMPORTED_MODULE_3__libs_qr__["a" /* default */].getVerificationResult({ result: code.data });
                vm.qrInfo = __WEBPACK_IMPORTED_MODULE_3__libs_qr__["a" /* default */].getHTMLInfo(res.format, { result: code.data });
                vm.qrVerificationResult = res;
              } else {
                _this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
              }
            } catch (e) {
              console.error(e);
              _this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
            }
          };
          image.src = qrReader.result;
          vm.qrFile = qrReader.result;
          vm.isQRImporting = false;
          vm.qrVerificationResult = null;
        }, false);
        try {
          qrReader.readAsDataURL(this.qrFile);
        } catch (e) {
          console.error(e);
          this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ QR ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
          vm.isQRImporting = false;
          vm.qrFile = null;
          vm.qrVerificationResult = null;
        }
      } else {
        vm.isQRImporting = false;
        vm.qrFile = null;
        vm.qrVerificationResult = null;
      }
    },
    resetQR: function resetQR() {
      this.isQRImporting = false;
      this.qrFile = null;
      this.qrVerificationResult = null;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MainLayout);

/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__login__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logout__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reset_password__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reset_password_with_token__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__forgot_password__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__admin_account_form__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__admin_account_list__ = __webpack_require__(1040);








/* harmony default export */ __webpack_exports__["a"] = ({
  login: __WEBPACK_IMPORTED_MODULE_0__login__["a" /* default */],
  logout: __WEBPACK_IMPORTED_MODULE_1__logout__["a" /* default */],
  resetPassword: __WEBPACK_IMPORTED_MODULE_2__reset_password__["a" /* default */],
  resetPasswordWithToken: __WEBPACK_IMPORTED_MODULE_3__reset_password_with_token__["a" /* default */],
  forgotPassword: __WEBPACK_IMPORTED_MODULE_4__forgot_password__["a" /* default */],
  adminAccountForm: __WEBPACK_IMPORTED_MODULE_5__admin_account_form__["a" /* default */],
  adminAccountList: __WEBPACK_IMPORTED_MODULE_6__admin_account_list__["a" /* default */]
});

/***/ }),

/***/ 469:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Login view
 */
var LoginView = {
  name: 'login',
  data: function data() {
    return {
      isSubmitting: false,
      showNotice: true,
      submitError: '',
      loginModel: {
        email: '',
        password: ''
      },
      loginRules: {
        email: [{ required: true, message: this.$t('Please input a valid email address'), trigger: 'blur' }, { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('Please input password'), trigger: 'blur' }]
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    currentYear: function currentYear() {
      var now = new Date();
      return now.getFullYear();
    },
    appName: function appName() {
      return this.$store.getters.appName;
    },
    tenantId: function tenantId() {
      return this.$store.getters.tenantId;
    }
  },
  methods: {
    closeNotice: function closeNotice() {
      this.showNotice = false;
    },
    addErrorMessage: function addErrorMessage() {
      this.$store.dispatch('ADD_ERROR_FLASH', 'error message');
    },
    validateForm: function validateForm(valid) {
      var _this = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.loginModel));
      payload.tenant_id = this.$store.getters.tenantId;
      this.$store.dispatch('LOGIN', payload).then(function () {
        _this.isSubmitting = false;
      }).catch(function (msg) {
        _this.isSubmitting = false;
        if (msg) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(msg));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    goToForgotPassword: function goToForgotPassword() {
      this.$router.push({ name: 'ForgotPassword' });
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LoginView);

/***/ }),

/***/ 470:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

var LogoutView = {
  name: 'logout',
  mounted: function mounted() {
    var _this = this;

    this.$store.dispatch('LOGOUT', {
      vm: this
    }).then(function () {
      _this.$message({
        type: 'success',
        showClose: true,
        duration: 10000,
        message: _this.$t('Successfully logged out.')
      });
      _this.$router.push({ name: 'Login' });
    }).catch(function (err) {
      // console.error(err);
      _this.$log.error(err);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LogoutView);

/***/ }),

/***/ 471:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_http__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xregexp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * ResetPassword view
 */
var ResetPasswordView = {
  name: 'reset-password',
  props: ['resetPasswordToken'],
  data: function data() {
    return {
      isSubmitting: false,
      errorMessage: '',
      submitError: '',
      resetPasswordModel: {
        password: '',
        passwordRepeat: ''
      },
      rules: {
        password: [{ required: true, message: this.$t('Please input password'), trigger: 'blur' }, {
          type: 'string',
          pattern: new __WEBPACK_IMPORTED_MODULE_2_xregexp___default.a('^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])([^\\s]){8,}$', 'g'),
          message: 'กรุณากรอกรหัสผ่านให้ถูกต้องตามรูปแบบที่ระบุไว้'
        }, { validator: this.checkPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' }],
        passwordRepeat: [{ required: true, message: this.$t('Please input password again'), trigger: 'blur' }, { validator: this.confirmPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' }]
      }
    };
  },

  computed: {
    needResetPwd: function needResetPwd() {
      return this.$store.getters.needResetPwd;
    }
  },
  methods: {
    cancel: function cancel() {
      this.$router.push({ name: 'Login' });
    },
    checkPassword: function checkPassword(rule, value, cb) {
      if (this.resetPasswordModel.passwordRepeat !== '') {
        this.$refs.resetPasswordModel.validateField('passwordRepeat');
        cb();
      }
    },
    confirmPassword: function confirmPassword(rule, value, cb) {
      if (value !== this.resetPasswordModel.password) {
        cb(new Error('Two inputs don\'t match!'));
      } else {
        cb();
      }
    },
    validateForm: function validateForm(valid) {
      var _this = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var payload = {
        force: true,
        token: this.$store.getters.idToken,
        password: this.resetPasswordModel.password
      };
      this.$store.dispatch('CHANGE_PASSWORD', payload).then(function () {
        _this.isSubmitting = false;
        // we're good. now redirect to default page
        _this.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: _this.$t('Successfully changed your password.')
        });
        var defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? "AdminUserLoadInfo" : "BillerUserLoadInfo";
        _this.$router.push({ name: defaultRouteName });
      }).catch(function (msg) {
        _this.isSubmitting = false;
        if (msg) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(msg));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForm: function submitForm(formName) {
      this.errorMessage = '';
      this.$refs[formName].validate(this.validateForm);
      return false;
    }
  },
  created: function created() {
    // check if user want to reset password with the valid token
    if (!this.needResetPwd && this.resetPasswordToken) {
      var isValid = false;
      // we have to verify token first
      var $http = new __WEBPACK_IMPORTED_MODULE_1__libs_http__["a" /* default */]();
      var expDate = $http.getTokenExpirationDate(this.resetPasswordToken);
      if (expDate) {
        // invalid token
        var now = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().tz("Asia/Bangkok");
        if (expDate.diff(now) > 0) {
          isValid = true;
        }
      }
      if (!isValid) {
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordView);

/***/ }),

/***/ 472:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_http__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xregexp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * ResetPassword view
 */
var ResetPasswordWithToken = {
  name: 'reset-password-with-token',
  // props: ['resetPasswordToken'],
  data: function data() {
    return {
      isSubmitting: false,
      errorMessage: '',
      submitError: '',
      resetPasswordModel: {
        password: '',
        passwordRepeat: ''
      },
      rules: {
        password: [{ required: true, message: this.$t('Please input password'), trigger: 'blur' }, {
          type: 'string',
          pattern: new __WEBPACK_IMPORTED_MODULE_2_xregexp___default.a('^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])([^\\s]){8,}$', 'g'),
          message: 'กรุณากรอกรหัสผ่านให้ถูกต้องตามรูปแบบที่ระบุไว้'
        }, { validator: this.checkPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' }],
        passwordRepeat: [{ required: true, message: this.$t('Please input password again'), trigger: 'blur' }, { validator: this.confirmPassword, message: this.$t('Please input password is not matched'), trigger: 'blur' }]
      }
    };
  },

  computed: {
    needResetPwd: function needResetPwd() {
      return this.$store.getters.needResetPwd;
    },
    currentYear: function currentYear() {
      var now = new Date();
      return now.getFullYear();
    },
    appName: function appName() {
      return this.$store.getters.appName;
    },
    resetPasswordToken: function resetPasswordToken() {
      return this.$route.query.rstToken;
    }
  },
  methods: {
    checkPassword: function checkPassword(rule, value, cb) {
      if (this.resetPasswordModel.passwordRepeat !== '') {
        this.$refs.resetPasswordModel.validateField('passwordRepeat');
        cb();
      }
    },
    confirmPassword: function confirmPassword(rule, value, cb) {
      if (value !== this.resetPasswordModel.password) {
        cb(new Error('Two inputs don\'t match!'));
      } else {
        cb();
      }
    },
    validateForm: function validateForm(valid) {
      var _this = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var payload = {
        force: false,
        token: this.resetPasswordToken,
        password: this.resetPasswordModel.password
      };
      this.$store.dispatch('CHANGE_PASSWORD', payload).then(function () {
        _this.isSubmitting = false;
        // we're good. now redirect to default page
        _this.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: _this.$t('Successfully changed your password.')
        });
        var defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? "AdminUserLoadInfo" : "BillerUserLoadInfo";
        _this.$router.push({ name: defaultRouteName });
      }).catch(function (msg) {
        _this.isSubmitting = false;
        if (msg) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(msg));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForm: function submitForm(formName) {
      this.errorMessage = '';
      this.$refs[formName].validate(this.validateForm);
      return false;
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Login' });
    }
  },
  created: function created() {
    // check if user want to reset password with the valid token
    if (this.resetPasswordToken) {
      var isValid = false;
      // we have to verify token first
      var $http = new __WEBPACK_IMPORTED_MODULE_1__libs_http__["a" /* default */]();
      var expDate = $http.getTokenExpirationDate(this.resetPasswordToken);
      if (expDate) {
        // invalid token
        var now = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()().tz("Asia/Bangkok");
        if (expDate.diff(now) > 0) {
          isValid = true;
        }
      }
      if (!isValid) {
        alert("ลิงค์เปลี่ยนรหัสนี้หมดอายุแล้ว กรุณากดเปลี่ยนรหัสเพื่อรับลิงค์ใหม่อีกครั้ง (ที่หน้า Login)");
        this.$router.push({ name: 'Login' });
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ResetPasswordWithToken);

/***/ }),

/***/ 473:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Login view
 */
var ForgotPasswordView = {
  name: 'forgot-password',
  data: function data() {
    return {
      isSubmitting: false,
      feedbackMessage: '',
      resetPasswordToken: '',
      submitError: '',
      forgotPasswordModel: {
        email: ''
      },
      forgotPasswordRules: {
        email: [{ required: true, message: this.$t('Please input a valid email address'), trigger: 'blur' }, { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' }]
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    currentYear: function currentYear() {
      var now = new Date();
      return now.getFullYear();
    },
    appName: function appName() {
      return this.$store.getters.appName;
    }
  },
  methods: {
    addErrorMessage: function addErrorMessage() {
      this.$store.dispatch('ADD_ERROR_FLASH', 'error message');
    },
    validateForgotPasswordForm: function validateForgotPasswordForm(valid) {
      var _this = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.forgotPasswordModel));
      payload.tenantId = this.$store.getters.tenantId;
      this.$store.dispatch('RESET_PASSWORD', payload).then(function (result) {
        _this.isSubmitting = false;
        if (result && result['reset-pwd-token']) {
          _this.resetPasswordToken = result['reset-pwd-token'];
        }
        _this.feedbackMessage = _this.$t('The reset password instructions should send to your email shortly.');
        _this.forgotPasswordModel.email = '';
        // this.$router.push({ name: 'Login' });
      }).catch(function (msg) {
        console.error(msg);
        _this.isSubmitting = false;
        if (msg) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(msg));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
      return true;
    },
    submitForgotPasswordForm: function submitForgotPasswordForm(formName) {
      this.$refs[formName].validate(this.validateForgotPasswordForm);
    },
    goToLogin: function goToLogin() {
      this.$router.push({ name: 'Login' });
    },
    cancel: function cancel() {
      this.$router.push({ name: 'Login' });
    }
  },
  mounted: function mounted() {
    this.resetPasswordToken = '';
    this.feedbackMessage = '';
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ForgotPasswordView);

/***/ }),

/***/ 474:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_imask__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */



/**
 * AdminAccount Form view
 */
var AdminAccountFormView = {
  name: 'account-form',
  props: ['adminId'],
  data: function data() {
    return {
      isSubmitting: false,
      isSetupUpdateData: false,
      roleList: [{ label: 'SCB Admin', value: 'ADMIN' }, { label: 'SCB Viewer', value: 'VIEWER' }],
      adminForm: {
        // auth_user_id: '',
        email: '',
        name: '',
        scb_employee_id: '',
        tel: '',
        status: true,
        description: '',
        role: 'viewer' // should change to viewer
        // created_at: '',
        // update_at: '',
      },
      isBlocked: false,
      adminFormRules: {
        email: [{ required: true, message: 'กรุณากรอกอีเมลผู้ดูแล', trigger: 'blur' }, { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' }],
        name: [{ required: true, message: 'กรุณากรอกชื่อผู้ดูแล', trigger: 'blur' }],
        scb_employee_id: [{ type: 'string', max: 6, required: true, message: 'กรุณากรอกรหัสพนักงานของธนาคาร', trigger: 'blur' }],
        tel: [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }]
        /* description: [
          { required: true, message: 'กรุณากรอกรายละเอียดผู้ดูแล', trigger: 'blur' },
        ], */
      },
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        },
        scb_employee_id: {
          mask: '000000'
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    isUpdated: function isUpdated() {
      return typeof this.adminId !== 'undefined';
    },
    adminInfo: function adminInfo() {
      var _this = this;

      if (this.isUpdated) {
        var adminInfo = null;
        this.$store.getters.adminList.forEach(function (item) {
          if (item.id === _this.adminId) {
            adminInfo = item;
          }
        });
        return adminInfo;
      }
      return null;
    }
  },
  methods: {
    backToAdminAccountList: function backToAdminAccountList() {
      this.$router.push({ name: 'AdminAccountList' });
    },
    confirmTerminate: function confirmTerminate() {
      var _this2 = this;

      this.$confirm('ท่านกำลังจะลบบัญชีผู้ดูแลนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.isSubmitting = true;
        _this2.$store.dispatch('DELETE_ADMIN_USER', _this2.adminId).then(function () {
          _this2.isSubmitting = false;
          _this2.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลผู้ดูแลสำเร็จแล้ว'
          });
          _this2.backToAdminAccountList();
        }).catch(function (msg) {
          _this2.isSubmitting = false;
          if (msg) {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
          } else {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    unblockUser: function unblockUser() {
      var _this3 = this;

      this.$confirm('ท่านกำลังจะปลดล็อคบัญชีผู้ดูแลนี้ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        // confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this3.isSubmitting = true;
        _this3.$store.dispatch('UNBLOCK_ADMIN_USER', _this3.adminId).then(function () {
          _this3.isSubmitting = false;
          _this3.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ปลดล็อคบัญชีผู้ดูแลสำเร็จแล้ว'
          });
          _this3.backToAdminAccountList();
        }).catch(function (msg) {
          _this3.isSubmitting = false;
          if (msg) {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t(msg));
          } else {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this4 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var action = this.isUpdated ? 'UPDATE_ADMIN_USER' : 'CREATE_ADMIN_USER';
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.adminForm));
      // transform payload's status
      payload.status = payload.status ? 'active' : 'inactive';
      // this.unmaskValue(payload, 'tel', this.mask.tel);
      delete payload.created_at;
      delete payload.update_at;
      this.$store.dispatch(action, payload).then(function () {
        _this4.isSubmitting = false;

        var successMessage = 'สร้างบัญชีผู้ดูแลใหม่สำเร็จแล้ว';
        if (_this4.isUpdated) {
          successMessage = 'แก้ไขข้อมูลบัญชีผู้ดูแลสำเร็จแล้ว';
        }
        _this4.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this4.backToAdminAccountList();
      }).catch(function (msg) {
        _this4.isSubmitting = false;
        if (msg) {
          _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t(msg));
        } else {
          _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t('Unexpected error'));
        }
      });
      return true;
    },
    setupUpdateData: function setupUpdateData() {
      var _this5 = this;

      if (typeof this.adminInfo !== 'undefined' && this.adminInfo) {
        this.isSetupUpdateData = true;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.adminInfo).forEach(function (key) {
          if (key === 'status') {
            var isActive = _this5.adminInfo[key] === 'active';
            _this5.isBlocked = _this5.adminInfo[key] === 'blocked';
            _this5.$set(_this5.adminForm, key, isActive);
          } else {
            _this5.$set(_this5.adminForm, key, _this5.adminInfo[key]);
          }
        });
        // this.isBlocked = true; // -- For testing unblock
      }
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.isBlocked = false;
      this.adminForm.email = '';
      this.adminForm.name = '';
      this.adminForm.scb_employee_id = '';
      this.adminForm.tel = '';
      this.adminForm.status = true;
      this.adminForm.description = '';
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* updateMaskTel() {
      try {
        this.maskValue(this.adminForm, 'tel', this.mask.tel);
      } catch (e) {
        console.error(e);
      }
    }, */
    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true }),
    statusFormatter: function statusFormatter(status) {
      var statusText = 'Disabled';
      if (this.isBlocked) {
        statusText = 'Blocked';
      } else if (status) {
        statusText = 'Enabled';
      }
      return statusText;
    },
    statusTypeFormatter: function statusTypeFormatter(status) {
      var type = 'info';
      if (this.isBlocked) {
        type = 'danger';
      } else if (status) {
        type = 'success';
      }
      return type;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    // load data to form
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this6.adminInfo === 'undefined' || _this6.adminInfo === null) {
          _this6.backToAdminAccountList();
        }
      }, 1000);
    }
    if (this.isUpdated && this.adminInfo) {
      this.$nextTick(function () {
        _this6.setupUpdateData();
      });
    }
  },

  watch: {
    adminInfo: function adminInfo(newVal) {
      var _this7 = this;

      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.$nextTick(function () {
          _this7.setupUpdateData();
        });
      }
    }
  },
  beforeRouterLeave: function beforeRouterLeave(to, from, next) {
    this.clearUpdateData();
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (AdminAccountFormView);

/***/ }),

/***/ 475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from '@/store';

// import lunr from 'lunr';

/* require('lunr-languages/lunr.stemmer.support')(lunr);
require('lunr-languages/lunr.multi')(lunr);
require('@/i18n/lunr.th')(lunr); */

/**
 * Admin Account List view
 */
var AdminAccountListView = {
  name: 'admin-account-list',
  data: function data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      indexer: null,
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    adminList: function adminList() {
      return this.$store.getters.adminList;
    },
    adminListData: function adminListData() {
      // return this.$store.getters.adminList;
      /* if (this.indexer && this.searchTerm.trim() !== '') {
        const res = this.indexer.search(this.searchTerm.trim().toLowerCase());
        // build result list
        const refs = res.map(item => parseInt(item.ref, 10));
        return this.adminList.filter(item => refs.indexOf(item.id) !== -1);
      } */
      var q = this.searchTerm.trim().toLowerCase();
      if (q !== '') {
        return this.adminList.filter(function (item) {
          var name = item.name.trim().toLowerCase();
          var email = item.email.trim().toLowerCase();
          var emp = item.scb_employee_id.toString().trim().toLowerCase();
          return name.indexOf(q) !== -1 || email.indexOf(q) !== -1 || emp.indexOf(q) !== -1;
        });
      }
      return this.adminList;
    }
  },
  methods: {
    createAdminAccount: function createAdminAccount() {
      this.$router.push({ name: 'AdminAccountCreate' });
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({
        name: 'AdminAccountEdit',
        params: {
          adminId: row.id
        }
      });
    },
    roleFormatter: function roleFormatter(row) {
      if (row.role) {
        return row.role.toUpperCase() === 'ADMIN' ? 'Admin' : 'Viewer';
      }
      return 'Viewer';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    statusFormatter: function statusFormatter(row) {
      var status = 'Disabled';
      if (row.status === 'blocked') {
        status = 'Blocked';
      } else if (row.status === 'active') {
        status = 'Enabled';
      }
      return status;
    },
    statusTypeFormatter: function statusTypeFormatter(row) {
      var type = 'info';
      if (row.status === 'blocked') {
        type = 'danger';
      } else if (row.status === 'active') {
        type = 'success';
      }
      return type;
    },
    setIndexer: function setIndexer(indexer) {
      this.indexer = indexer;
    },
    telFormatter: function telFormatter(row, column, cellValue) {
      /* if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.tel);
      }
      return '-'; */
      return cellValue || '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_1_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_ADMIN_USER_LIST').then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
      /* vm.setIndexer(lunr((builder) => {
        builder.use(lunr.multiLanguage('en', 'th'));
        builder.field('email');
        builder.field('name');
        builder.field('description');
         vm.adminList.forEach((item) => {
          const indexItem = JSON.parse(JSON.stringify(item));
          builder.add(indexItem);
        });
      })); */
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (AdminAccountListView);

/***/ }),

/***/ 476:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UnauthorizedError'
});

/***/ }),

/***/ 477:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_company__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var AdminLoadInfo = {
  name: 'admin-load-info',
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    shouldReloadData: function shouldReloadData() {
      return !this.$store.getters.scbAdminInfo;
    },
    idToken: function idToken() {
      return this.$store.getters.idToken;
    }
  },
  methods: {
    reloadInfo: function reloadInfo() {
      var _this = this;

      this.isLoading = true;
      // now we get the user info first
      this.$store.dispatch('GET_ADMIN_MY_ADMIN_INFO').then(function () {
        _this.$router.push({ name: 'CompanyList' });
      }).catch(function (err) {
        _this.isLoading = false;
        if (err) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(err));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.idToken) {
      __WEBPACK_IMPORTED_MODULE_0__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
      this.reloadInfo();
    }
  },

  watch: {
    idToken: function idToken(newVal) {
      if (newVal) {
        __WEBPACK_IMPORTED_MODULE_0__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
        this.reloadInfo();
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (AdminLoadInfo);

/***/ }),

/***/ 478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_async_merge_sort__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_async_merge_sort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_async_merge_sort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */
// import store from '@/store';



// import lunr from 'lunr';
// import _ from 'lodash';

/**
 * Company List view
 */
var CompanyListView = {
  name: 'company-list',
  data: function data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      indexer: null,
      isSortingData: false,
      companyListDataSorted: [],
      companyListDataCurrentPage: 1,
      companyListDataItemPerPage: 100,
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        }
      },
      query: {
        limit: 20,
        offset: 0,
        name__like: null
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    companyList: function companyList() {
      return this.$store.getters.companyList;
    },
    companyListData: function companyListData() {
      // return this.$store.getters.companyList;
      /* if (this.indexer && this.searchTerm.trim() !== '') {
        const res = this.indexer.search(this.searchTerm.trim().toLowerCase());
        // build result list
        const refs = res.map(item => parseInt(item.ref, 10));
        return this.companyList.filter(item => refs.indexOf(item.id) !== -1);
      } */
      // const q = this.searchTerm.trim().toLowerCase();
      // if (q !== '') {
      //   return this.companyList.filter((item) => {
      //     const name = item.name.trim().toLowerCase();
      //     return name.indexOf(q) !== -1;
      //   });
      // }
      return this.companyList;
    },
    companyListDataPaged: function companyListDataPaged() {
      // apply pagination data
      var offsetIndex = (this.companyListDataCurrentPage - 1) * this.companyListDataItemPerPage;
      var offsetEndIndex = offsetIndex + this.companyListDataItemPerPage;
      if (offsetIndex >= this.companyListData.length) {
        offsetIndex = this.companyListData.length - 1;
      }
      if (offsetEndIndex > this.companyListData.length) {
        offsetEndIndex = this.companyListData.length;
      }
      return this.companyListDataSorted.slice(offsetIndex, offsetEndIndex);
    },
    companyListDataTotalPage: function companyListDataTotalPage() {
      return Math.ceil(this.companyListData.length / this.companyListDataItemPerPage);
    },
    algoliaApiKey: function algoliaApiKey() {
      return Object({"NODE_ENV":"production","SCB_BILLING_APP_JOB_ID":"17037495774","SCB_BILLING_APP_VERSION":"e9e57dfaece12248c75dda9fba939a90507ebcb7","DEFAULT_TZ":"Asia/Bangkok","HEARTBEAT_INTERVAL":60000,"CHECK_SESSION_INTERVAL":60000,"CHECK_SESSION_COUNT":5,"SHOULD_LOGOUT_RELOAD_PAGE":false,"APP_ACCESS_CONTROL":true,"HANDLE_INPUT_DEBOUNCE_INTERVAL":300,"APP_PORT":80,"DEFAULT_ROUTE_NAME":"AdminUserLoadInfo","DEFAULT_BILLER_ROUTE_NAME":"BillerUserLoadInfo","ROUTER_MODE":"history","API_TIMEOUT_INTERVAL":60000,"CLOUDINARY_API_BASE_URL":"https://api.cloudinary.com/v1_1/","API_LOGIN_URL":"/auth-token"}).ALGOLIA_API_KEY;
    },
    vm: function vm() {
      return this;
    }
  },
  methods: {
    createCompany: function createCompany() {
      this.$router.push({ name: 'CompanyCreate' });
    },
    searchCompany: function searchCompany() {
      var _this = this;

      this.query.name__like = this.searchTerm;
      if (!this.searchTerm) {
        this.query.name__like = null;
      }
      this.$store.dispatch('START_CONTENT_LOADING');
      this.$store.dispatch('GET_COMPANY_LIST', this.query).then(function () {
        _this.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        _this.$store.dispatch('STOP_CONTENT_LOADING');
        _this.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    },
    addressFormatter: function addressFormatter(row) {
      return row.address.line_1 + '\n        ' + row.address.district + '\n        ' + row.address.city + '\n        ' + row.address.province + '\n        ' + row.address.postal_code;
    },
    telFormatter: function telFormatter(row) {
      var val = row.address.tel;
      if (val) {
        // return this.maskFormatter(val, this.mask.tel);
        return val;
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_1_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
    handleManage: function handleManage(index, row) {
      this.$router.push({
        name: 'CompanyDetail',
        params: {
          companyId: row.id
        }
      });
    },
    dataTableSorted: function dataTableSorted(_ref) {
      var _this2 = this;

      var prop = _ref.prop,
          order = _ref.order;

      if (prop && order) {
        this.isSortingData = true;
        var type = 'string';
        var sortProp = prop;
        if (order === 'descending') {
          sortProp = '-' + sortProp;
        }
        /* if (prop === 'issued_on') {
          // sort by date
          type = 'date';
        } else */
        if (prop === 'profiles_count') {
          // sort by number
          type = 'number';
        }
        __WEBPACK_IMPORTED_MODULE_2_async_merge_sort___default()(this.companyListData, this.dynamicSort(sortProp, type), function (err, sorted) {
          _this2.isSortingData = false;
          if (!err) {
            _this2.companyListDataSorted = sorted;
          }
        });
      } else {
        // reset sorting
        this.companyListDataSorted = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.companyListData));
      }
      // force hide loading after 5 seconds
      setTimeout(function () {
        if (_this2.isSortingData) {
          _this2.isSortingData = false;
        }
      }, 5000);
    },
    dynamicSort: function dynamicSort(prop, type) {
      var sortOrder = 1;
      if (prop[0] === '-') {
        sortOrder = -1;
        prop = prop.substr(1);
      }
      return function (a, b, cb) {
        // const result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
        var result = 0;
        var aValue = a[prop];
        var bValue = b[prop];
        if (type === 'date') {
          var aDate = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(aValue).tz("Asia/Bangkok");
          if (aDate.isValid()) {
            aValue = Number(aDate.format('X'));
          }
          var bDate = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(bValue).tz("Asia/Bangkok");
          if (bDate.isValid()) {
            bValue = Number(bDate.format('X'));
          }
        } else if (type === 'number') {
          aValue = Number(aValue);
          bValue = Number(bValue);
        }
        if (aValue < bValue) {
          result = -1;
        } else if (aValue > bValue) {
          result = 1;
        }
        return cb(null, result * sortOrder);
      };
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // Fetch data
    /* store.dispatch('START_CONTENT_LOADING');
    store.dispatch('GET_COMPANY_LIST').then(() => {
      store.dispatch('STOP_CONTENT_LOADING');
    }).catch((err) => {
      store.dispatch('STOP_CONTENT_LOADING');
      store.dispatch('ADD_ERROR_FLASH', err);
    }); */
    next(function (vm) {
      vm.$nextTick(function () {
        vm.$store.dispatch('START_CONTENT_LOADING');
        vm.$store.dispatch('GET_COMPANY_LIST', vm.query).then(function () {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
        }).catch(function (err) {
          vm.$store.dispatch('STOP_CONTENT_LOADING');
          vm.$store.dispatch('ADD_ERROR_FLASH', err);
        });
      });
      // vm.$store.dispatch('STOP_CONTENT_LOADING');
      // build indexer
      // vm.companyListData = vm.companyList;
      /* vm.setIndexer(lunr((builder) => {
        builder.field('name');
         vm.companyList.forEach((item) => {
          const { name, id } = JSON.parse(JSON.stringify(item));
          builder.add({
            name,
            id,
          });
        });
      })); */
    });
  },

  watch: {
    companyListDataCurrentPage: function companyListDataCurrentPage(val) {
      var _this3 = this;

      this.query.offset = (val - 1) * this.query.limit;
      this.$store.dispatch('START_CONTENT_LOADING');
      this.$store.dispatch('GET_COMPANY_LIST', this.query).then(function () {
        _this3.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        _this3.$store.dispatch('STOP_CONTENT_LOADING');
        _this3.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    },
    companyListData: function companyListData(newList, oldList) {
      if (newList && oldList !== newList) {
        this.companyListDataSorted = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newList));
      }
    },
    companyListDataSorted: function companyListDataSorted() {
      this.isSortingData = false;
    }
  }
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  /* beforeRouteUpdate(to, from, next) {
    // Fetch data
    store.dispatch('START_CONTENT_LOADING');
    store.dispatch('GET_COMPANY_LIST').then(() => {
      store.dispatch('STOP_CONTENT_LOADING');
    }).catch((err) => {
      store.dispatch('STOP_CONTENT_LOADING');
      store.dispatch('ADD_ERROR_FLASH', err);
    });
    next();
  }, */
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyListView);

/***/ }),

/***/ 479:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_helpers__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * Company List view
 */
var CompanyDetailView = {
  name: 'company-detail',
  props: ['companyId'],
  data: function data() {
    return {
      isSubmitting: false,
      mask: {
        taxId: {
          mask: [{ mask: '0000000000' }, { mask: '0000000000000' }]
        },
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        },
        fax: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    baseHost: function baseHost() {
      return __WEBPACK_IMPORTED_MODULE_1__libs_helpers__["a" /* default */].getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    }
  },
  methods: {
    backToCompanyList: function backToCompanyList() {
      this.$router.push({ name: 'CompanyList' });
    },
    telFormatter: function telFormatter(val) {
      if (val) {
        // return this.maskFormatter(val, this.mask.tel);
        return val;
      }
      return '-';
    },
    faxFormatter: function faxFormatter(val) {
      if (val) {
        // return this.maskFormatter(val, this.mask.fax);
        return val;
      }
      return '-';
    },
    taxIdFormatter: function taxIdFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.taxId);
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_0_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    }
  },
  mounted: function mounted() {
    if (typeof this.companyId === 'undefined') {
      // redirect back
      this.backToCompanyList();
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyDetailView);

/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_string__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_imask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */




// import XRegExp from 'xregexp';

/**
 * Company Form view
 */
var CompanyFormView = {
  name: 'company-form',
  props: ['companyId'],
  data: function data() {
    return {
      isSubmitting: false,
      isUploading: false,
      isSetupUpdateData: false,
      companyFormRules: {
        name: [{ required: true, max: 50, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' }],
        /* name_on_payment_card: [
          { required: true, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' },
        ], */
        tax_id: [{ required: true, validator: this.checkTaxID, message: 'กรุณากรอกเลขประจำตัวผู้เสียภาษี 10 หรือ 13 หลัก', trigger: 'blur' }],
        /* logo: [
          { required: true, message: 'กรุณาเลือกโลโก้บริษัท', trigger: 'blur' },
        ], */
        slug: [{ required: true, message: 'กรุณากรอกชื่อเว็ปในการจัดการข้อมูลบริษัท', trigger: 'blur' }, { validator: this.checkSlug, message: 'กรุณากรอกชื่อเว็ปในการจัดการข้อมูลบริษัทให้อยู่ในรูปแบบที่ถูกต้อง (ชื่อเว็ปประกอบด้วยตัวอักษรภาษาอังกฤษ "a-z", เลข "0-9" หรือ เครื่องหมายขีด "-" เท่านั้น)', trigger: 'blur' }],
        'address.line_1': [{ required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' }],
        'address.district': [{ required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' }],
        'address.city': [{ required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' }],
        'address.province': [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' }],
        'address.postal_code': [{ required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์', trigger: 'blur' }],
        'address.tel': [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }],
        'address.fax': [{ message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' }]
      },
      slugPreview: 'company-web-name',
      companyForm: {
        id: null,
        tax_id: '',
        slug: '',
        name: '',
        // name_on_payment_card: '',
        logo: '',
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: ''
        },
        profiles_count: 0
      },
      mask: {
        taxIdMask: [{ mask: '0000000000' }, { mask: '0000000000000' }],
        postcode: {
          mask: '00000'
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-0000' }, { mask: '{0}00-000-000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }]
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    isUpdated: function isUpdated() {
      return typeof this.companyId !== 'undefined';
    },
    uploadUrl: function uploadUrl() {
      return '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    },
    provinceList: function provinceList() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getProvinceList();
    },
    baseHost: function baseHost() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    },
    vm: function vm() {
      return this;
    }
  },
  methods: {
    goBack: function goBack() {
      if (this.isUpdated) {
        this.$router.push({
          name: 'CompanyDetail',
          params: {
            companyId: this.companyId
          }
        });
      } else {
        this.$router.push({ name: 'CompanyList' });
      }
    },
    handleLogoSuccess: function handleLogoSuccess(res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.companyForm.logo = res.secure_url;
      }
    },
    handleLogoFail: function handleLogoFail(res) {
      this.isUploading = false;
      var errorMessage = this.$t('Unexpected error');
      if (res) {
        errorMessage = res;
        if (res.error) {
          errorMessage = res.error;
          if (res.error.message) {
            errorMessage = res.error.message;
          }
        }
      }
      this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
    },
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Logo picture must be JPG, PNG or GIF format!');
      }
      if (!isLt2M) {
        this.$message.error('Logo picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    handleHttpRequest: function handleHttpRequest(options) {
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_COMPANY_LOGO', options.file);
    },
    confirmTerminate: function confirmTerminate() {
      var _this = this;

      this.$confirm('ท่านกำลังจะลบบริษัทนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', this.$t('Warning'), {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this.isSubmitting = true;
        _this.$store.dispatch('DELETE_COMPANY_INFO', _this.companyId).then(function () {
          _this.isSubmitting = false;
          _this.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลบริษัทสำเร็จแล้ว'
          });
          _this.$nextTick(function () {
            _this.$router.push({ name: 'CompanyList' });
          });
        }).catch(function (msg) {
          _this.isSubmitting = false;
          if (msg) {
            _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(msg));
          } else {
            _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this2 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var action = this.isUpdated ? 'UPDATE_COMPANY_INFO' : 'CREATE_COMPANY_INFO';
      var payload = this.companyForm;
      // transform payload
      this.$store.dispatch(action, payload).then(function () {
        _this2.isSubmitting = false;
        var successMessage = 'สร้างบริษัทสำเร็จแล้ว';
        if (_this2.isUpdated) {
          successMessage = 'แก้ไขข้อมูลบริษัทสำเร็จแล้ว';
        }
        _this2.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this2.$nextTick(function () {
          _this2.goBack();
        });
      }).catch(function (msg) {
        _this2.isSubmitting = false;
        if (msg) {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
        } else {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
        }
      });
      return true;
    },
    setSlugPreview: function setSlugPreview(slug) {
      this.slugPreview = slug;
    },

    genSlug: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function (vm) {
      var slug = __WEBPACK_IMPORTED_MODULE_3__libs_string__["a" /* default */].str_slug(vm.companyForm.slug);
      if (slug === '') {
        slug = 'company-web-name';
      }
      vm.setSlugPreview(slug);
    }, 150),
    checkTaxID: function checkTaxID(rule, value, cb) {
      var len = 0;
      if (value) {
        len = value.toString().length;
      }
      if (len !== 10 && len !== 13) {
        cb(new Error('Tax ID must be 10 or 13 digits'));
      }
      cb();
    },
    checkSlug: function checkSlug(rule, value, cb) {
      if (this.companyForm.slug !== this.slugPreview || ['scb'].indexOf(this.slugPreview) !== -1) {
        cb(new Error('mismatch slug'));
      } else {
        cb();
      }
    },
    assignSlug: function assignSlug() {
      if (this.slugPreview !== 'company-web-name') {
        this.companyForm.slug = this.slugPreview;
        this.$refs.companyForm.validateField('slug');
      }
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.companyForm.id = null;
      this.companyForm.tax_id = '';
      this.companyForm.slug = '';
      this.companyForm.name = '';
      // this.companyForm.name_on_payment_card = '';
      this.companyForm.logo = '';
      this.companyForm.address.tel = '';
      this.companyForm.address.fax = '';
      this.companyForm.address.line_1 = '';
      this.companyForm.address.district = '';
      this.companyForm.address.city = '';
      this.companyForm.address.province = '';
      this.companyForm.address.postal_code = '';
      this.companyForm.profiles_count = 0;
    },
    updateMaskTaxId: function updateMaskTaxId() {
      this.maskValue(this.companyForm, 'tax_id', {
        mask: this.mask.taxIdMask
      });
    },

    /* updateMaskTel() {
      this.maskValue(this.companyForm.address, 'tel', {
        mask: this.mask.telMask,
      });
    },
    updateMaskFax() {
      this.maskValue(this.companyForm.address, 'fax', {
        mask: this.mask.faxMask,
      });
    }, */
    updatePostCode: function updatePostCode() {
      try {
        this.maskValue(this.companyForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },
    setupUpdateData: function setupUpdateData() {
      var _this3 = this;

      this.isSetupUpdateData = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.company).forEach(function (key) {
        if (key === 'address') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.company.address).forEach(function (addrKey) {
            _this3.$set(_this3.companyForm.address, addrKey, _this3.company.address[addrKey]);
          });
        } else {
          _this3.$set(_this3.companyForm, key, _this3.company[key]);
        }
      });
      this.slugPreview = this.company.slug;
      this.updateMaskTaxId();
      this.updatePostCode();
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true })
  },
  mounted: function mounted() {
    var _this4 = this;

    // load data to form
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this4.company === 'undefined' || _this4.company === null) {
          _this4.goBack();
        }
      }, 1000);
    }
    this.$nextTick(function () {
      if (_this4.isUpdated && _this4.company) {
        _this4.setupUpdateData();
      }
    });
  },

  watch: {
    company: function company(newVal) {
      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_COMPANY', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyFormView);

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from '@/store';

/**
 * Company Admin List view
 */
var CompanyAdminListView = {
  name: 'company-admin-list',
  props: ['companyId'],
  data: function data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    adminList: function adminList() {
      return this.$store.getters.companyAdminList;
    },
    adminListData: function adminListData() {
      var q = this.searchTerm.trim().toLowerCase();
      if (q !== '') {
        return this.adminList.filter(function (item) {
          var name = item.name.trim().toLowerCase();
          var email = item.email.trim().toLowerCase();
          var desc = item.description.trim().toLowerCase();
          return name.indexOf(q) !== -1 || email.indexOf(q) !== -1 || desc.indexOf(q) !== -1;
        });
      }
      return this.adminList;
    }
  },
  methods: {
    backToCompanyDetail: function backToCompanyDetail() {
      var params = {
        companyId: this.companyId
      };
      this.$router.push({ name: 'CompanyDetail', params: params });
    },
    createCompanyAdmin: function createCompanyAdmin() {
      this.$router.push({
        name: 'CompanyAdminCreate',
        params: {
          companyId: this.companyId
        }
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({
        name: 'CompanyAdminEdit',
        params: {
          companyId: this.companyId,
          userId: row.id
        }
      });
    },
    roleFormatter: function roleFormatter(row) {
      return row.role === 'ADMIN' ? 'Biller Admin' : 'Biller Staff';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    statusFormatter: function statusFormatter(row) {
      var status = 'Disabled';
      if (row.status === 'blocked') {
        status = 'Blocked';
      } else if (row.status === 'active') {
        status = 'Enabled';
      }
      return status;
    },
    statusTypeFormatter: function statusTypeFormatter(row) {
      var type = 'info';
      if (row.status === 'blocked') {
        type = 'danger';
      } else if (row.status === 'active') {
        type = 'success';
      }
      return type;
    },
    telFormatter: function telFormatter(row, column, cellValue) {
      /* if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.tel);
      }
      return '-'; */
      return cellValue || '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_1_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_COMPANY_ADMIN_LIST', to.params.companyId).then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyAdminListView);

/***/ }),

/***/ 482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */



/**
 * Company Admin Form view
 */
var CompanyAdminFormView = {
  name: 'company-admin-form',
  props: ['companyId', 'userId'],
  data: function data() {
    return {
      isSubmitting: false,
      isSetupUpdateData: false,
      adminForm: {
        email: '',
        name: '',
        tel: '',
        status: true,
        description: '',
        role: 'ADMIN', // "ADMIN", "STAFF",
        assigned_profiles: []
      },
      isBlocked: false,
      adminFormRules: {
        email: [{ required: true, message: 'กรุณากรอกอีเมลผู้ดูแล', trigger: 'blur' }, { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' }],
        name: [{ required: true, message: 'กรุณากรอกชื่อผู้ดูแล', trigger: 'blur' }],
        tel: [{ message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }]
        /* description: [
          { required: true, message: 'กรุณากรอกรายละเอียดผู้ดูแล', trigger: 'blur' },
        ], */
      },
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    isUpdated: function isUpdated() {
      return typeof this.userId !== 'undefined';
    },
    userInfo: function userInfo() {
      var _this = this;

      if (this.isUpdated) {
        var userInfo = null;
        this.$store.getters.companyAdminList.forEach(function (item) {
          if (item.id === _this.userId) {
            userInfo = item;
          }
        });
        return userInfo;
        /* const indexId = `_${this.userId}`;
        if (typeof this.$store.getters.companyAdminListIndex[indexId] !== 'undefined') {
          const idx = this.$store.getters.companyAdminListIndex[indexId];
          return this.$store.getters.companyAdminList[idx];
        } */
      }
      return null;
    },
    shouldShowRole: function shouldShowRole() {
      return false; // SCB ADMIN should not see this field
    }
  },
  methods: {
    backToCompanyAdminList: function backToCompanyAdminList() {
      this.$router.push({
        name: 'CompanyAdminList',
        params: {
          companyId: this.companyId
        }
      });
    },
    confirmTerminate: function confirmTerminate() {
      var _this2 = this;

      this.$confirm('ท่านกำลังจะลบบัญชีผู้ดูแลบริษัทนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.isSubmitting = true;
        _this2.$store.dispatch('DELETE_COMPANY_ADMIN_INFO', _this2.userId).then(function () {
          _this2.isSubmitting = false;
          _this2.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลผู้ดูแลบริษัทสำเร็จแล้ว'
          });
          _this2.backToCompanyAdminList();
        }).catch(function (msg) {
          _this2.isSubmitting = false;
          if (msg) {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
          } else {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    unblockUser: function unblockUser() {
      var _this3 = this;

      this.$confirm('ท่านกำลังจะปลดล็อคบัญชีผู้ดูแลบริษัทนี้ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        // confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this3.isSubmitting = true;
        _this3.$store.dispatch('UNBLOCK_BILLER_USER', _this3.userId).then(function () {
          _this3.isSubmitting = false;
          _this3.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ปลดล็อคบัญชีผู้ดูแลบริษัทสำเร็จแล้ว'
          });
          _this3.backToCompanyAdminList();
        }).catch(function (msg) {
          _this3.isSubmitting = false;
          if (msg) {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t(msg));
          } else {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this4 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var action = this.isUpdated ? 'UPDATE_COMPANY_ADMIN_INFO' : 'CREATE_COMPANY_ADMIN_INFO';
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.adminForm));
      // transform payload's status
      payload.status = payload.status ? 'active' : 'inactive';
      delete payload.created_at;
      delete payload.update_at;
      var reqPayload = {
        payload: payload
      };
      if (this.isUpdated) {
        reqPayload.userId = payload.id;
      } else {
        reqPayload.companyId = this.companyId;
      }
      this.$store.dispatch(action, reqPayload).then(function () {
        _this4.isSubmitting = false;
        var successMessage = 'สร้างบัญชีผู้ดูแลบริษัทใหม่สำเร็จแล้ว';
        if (_this4.isUpdated) {
          successMessage = 'แก้ไขข้อมูลบัญชีผู้ดูแลบริษัทสำเร็จแล้ว';
        }
        _this4.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this4.backToCompanyAdminList();
      }).catch(function (msg) {
        _this4.isSubmitting = false;
        if (msg) {
          _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t(msg));
        } else {
          _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t('Unexpected error'));
        }
      });
      return true;
    },
    setupUpdateData: function setupUpdateData() {
      var _this5 = this;

      if (typeof this.userInfo !== 'undefined' && this.userInfo) {
        this.isSetupUpdateData = true;
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.userInfo).forEach(function (key) {
          if (key === 'status') {
            var isActive = _this5.userInfo[key] === 'active';
            _this5.isBlocked = _this5.userInfo[key] === 'blocked';
            _this5.$set(_this5.adminForm, key, isActive);
          } else {
            _this5.$set(_this5.adminForm, key, _this5.userInfo[key]);
          }
        });
        // this.isBlocked = true; // -- For testing unblock
      }
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.isBlocked = false;
      this.adminForm.email = '';
      this.adminForm.name = '';
      this.adminForm.tel = '';
      this.adminForm.status = true;
      this.adminForm.description = '';
      this.adminForm.role = 'ADMIN';
      this.adminForm.assigned_profiles.splice(0);
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* updateMaskTel() {
      try {
        this.maskValue(this.adminForm, 'tel', this.mask.tel);
      } catch (e) {
        console.error(e);
      }
    }, */
    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_3__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true }),
    statusFormatter: function statusFormatter(status) {
      var statusText = 'Disabled';
      if (this.isBlocked) {
        statusText = 'Blocked';
      } else if (status) {
        statusText = 'Enabled';
      }
      return statusText;
    },
    statusTypeFormatter: function statusTypeFormatter(status) {
      var type = 'info';
      if (this.isBlocked) {
        type = 'danger';
      } else if (status) {
        type = 'success';
      }
      return type;
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    // load data to form
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this6.userInfo === 'undefined' || _this6.userInfo === null) {
          _this6.backToCompanyAdminList();
        }
      }, 1000);
    }
    if (this.isUpdated && this.userInfo) {
      this.setupUpdateData();
    }
  },

  watch: {
    userInfo: function userInfo(newVal) {
      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  },
  beforeRouterLeave: function beforeRouterLeave(to, from, next) {
    this.clearUpdateData();
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyAdminFormView);

/***/ }),

/***/ 483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from '@/store';

/**
 * Company Profile Form view
 */
var CompanyProfileListView = {
  name: 'company-profile-list',
  props: ['companyId'],
  data: function data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      mask: {
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          mask: /^\d{0,15}$/
          /* mask: [
            { mask: '0000000000' },
            { mask: '0000000000000' },
          ], */
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isViewerRole: function isViewerRole() {
      return this.$store.getters.isViewerRole;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    profileList: function profileList() {
      return this.$store.getters.companyProfileList;
    },
    profileListData: function profileListData() {
      var _this = this;

      var q = this.searchTerm.trim().toLowerCase();
      if (q !== '') {
        return this.profileList.filter(function (item) {
          var name = item.name.trim().toLowerCase();
          var bpCompCode = (item.bill_payment_comp_code || '').trim().toLowerCase();
          var bpAccountNo = (item.bill_payment_account_no || '').trim().toLowerCase();
          var bpBillerId = (item.bill_payment_biller_id || '').trim().toLowerCase();
          return name.indexOf(q) !== -1 || bpCompCode.indexOf(q) !== -1 || bpAccountNo.indexOf(q) !== -1 || bpBillerId.indexOf(q) !== -1;
        });
      }
      return this.profileList.map(function (item) {
        var profile = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
        // account no
        var billPaymentAccountNo = _this.maskFormatter(profile.bill_payment_account_no, _this.mask.accountNo);
        var qrAccountNo = null;
        if (profile.barcode_qrcode_account_no) {
          var acc = _this.maskFormatter(profile.barcode_qrcode_account_no, _this.mask.accountNo);
          qrAccountNo = acc + ' (' + profile.barcode_qrcode_account_no_suffix + ')';
        }
        profile.account_no = {
          bill_payment: billPaymentAccountNo,
          qr: qrAccountNo
        };
        // biller_id
        var billPaymentBillerId = _this.maskFormatter(profile.bill_payment_biller_id, _this.mask.billerId);
        var qrBillerId = null;
        if (profile.barcode_qrcode_biller_id_tax_id) {
          qrBillerId = profile.barcode_qrcode_biller_id_tax_id + ' (' + profile.barcode_qrcode_biller_id_suffix + ')';
        }
        profile.biller_id = {
          bill_payment: billPaymentBillerId,
          qr: qrBillerId
        };
        return profile;
      });
    }
  },
  methods: {
    backToCompanyDetail: function backToCompanyDetail() {
      var params = {
        companyId: this.companyId
      };
      this.$router.push({ name: 'CompanyDetail', params: params });
    },
    paymentTypeFormatter: function paymentTypeFormatter(row) {
      return row.payment_type === 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : 'เช็ค/เงินสด';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    compCodeFormatter: function compCodeFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.compCode);
      }
      return '-';
    },
    accountNoFormatter: function accountNoFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.accountNo);
      }
      return '-';
    },
    accountNoAllFormatter: function accountNoAllFormatter(cellValue) {
      var billPayment = cellValue.bill_payment,
          qr = cellValue.qr;

      var output = [];
      if (billPayment) {
        output.push(billPayment);
      } else {
        output.push('-');
      }
      if (qr) {
        output.push(qr);
      } else {
        output.push('-');
      }
      if (output.length > 0) {
        return output.join('<br/>');
      }
      return '-';
    },
    billerIdFormatter: function billerIdFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.billerId);
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
    createProfile: function createProfile() {
      this.$router.push({
        name: 'CompanyProfileCreate',
        params: {
          companyId: this.companyId
        }
      });
    },
    handleEdit: function handleEdit(index, row) {
      if (this.isViewerRole) {
        this.$router.push({
          name: 'CompanyProfileDetail',
          params: {
            companyId: this.companyId,
            profileId: row.id
          }
        });
      } else {
        this.$router.push({
          name: 'CompanyProfileEdit',
          params: {
            companyId: this.companyId,
            profileId: row.id
          }
        });
      }
    },
    addressFormatter: function addressFormatter(row) {
      return row.address.line_1 + '\n      ' + row.address.district + '\n      ' + row.address.city + '\n      ' + row.address.province + '\n      ' + row.address.postal_code;
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_COMPANY_PROFILE_LIST', to.params.companyId).then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyProfileListView);

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_xregexp__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */





/**
 * Company Profile Form view
 */
var CompanyProfileFormView = {
  name: 'company-profile-form',
  props: ['companyId', 'profileId'],
  data: function data() {
    return {
      isSubmitting: false,
      isUploading: false,
      isSetupUpdateData: false,
      dayList: [],
      profileFormRules: {
        name: [{ required: true, max: 50, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' }],
        'address.line_1': [{ required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' }],
        'address.district': [{ required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' }],
        'address.city': [{ required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' }],
        'address.province': [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' }],
        'address.postal_code': [{ required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์', trigger: 'blur' }],
        'address.tel': [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }],
        'address.fax': [{ message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' }],
        bill_payment_comp_code: [{ validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentCompCode, message: 'กรุณากรอก COMP CODE', trigger: 'blur' }],
        bill_payment_account_no: [{ validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentAccountNo, message: 'กรุณากรอกหมายเลขบัญชี', trigger: 'blur,change' }],
        bill_payment_biller_id: [{ validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentBillerId, message: 'กรุณากรอก Biller ID จำนวน 15 หลัก', trigger: 'blur' }],
        barcode_qrcode_biller_id_tax_id: [{ validator: this.checkBarcodeQRCodeBillerId, message: 'กรุณากรอก Biller ID จำนวน 13 หลัก และ Suffix 2 หลัก', trigger: 'blur' }],
        barcode_qrcode_account_no: [{ validator: this.checkBarcodeQRCodeAccountNo, message: 'กรุณากรอกหมายเลขบัญชี และ Suffix 2 หลัก', trigger: 'blur,change' }],
        ir_br: [{ validator: this.checkIBIR, message: 'กรุณากรอก IB/IR', trigger: 'blur' }],
        account_name: [{ required: true, message: 'กรุณาชื่อบัญชี', trigger: 'blur' }],
        label_ref1: [{ max: 25, message: 'กรุณากรอกชื่อเรียก Reference No. 1', trigger: 'blur' }],
        label_ref2: [{ max: 25, message: 'กรุณากรอกชื่อเรียก Reference No. 2', trigger: 'blur' }],
        notification_msg: [{ validator: this.checkNotificationMsg, max: 100, message: 'กรุณากรอกข้อความแจ้งเตือน', trigger: 'blur' }],
        business_type_special_industry: [{ validator: this.checkBusinessType, message: 'กรุณากรอกสาขาธุรกิจ', trigger: 'change,blur' }]
      },
      profileForm: {
        id: null,
        name: '',
        use_company_address: true,
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: ''
        },
        use_bill_payment_comp_code: false,
        bill_payment_comp_code: '',
        use_bill_payment_account_no: false,
        bill_payment_account_no: '',
        use_bill_payment_biller_id: true,
        bill_payment_biller_id: '',
        barcode_qrcode_type: 'biller_id',
        barcode_qrcode_biller_id_tax_id: '',
        barcode_qrcode_biller_id_suffix: '',
        barcode_qrcode_account_no: '',
        barcode_qrcode_account_no_suffix: '',
        payment_type: 'CHEQUE_OR_CASH', // "CHEQUE_OR_CASH", "CASH_ONLY"
        charge_payer: false,
        ir_br: '',
        account_name: '',
        label_ref1: '',
        label_ref2: '',
        label_ref3: '',
        allow_other_banks: true,
        is_banking_agent: false,
        other_banks: [],
        notification_msg_type: 'CUSTOM', // DATE or CUSTOM
        notification_msg_date: '1',
        notification_msg_custom: '',
        notification_msg: '',
        logo: '',
        printing_option: 'COLOR', // "COLOR", "BLACK_AND_WHITE"
        business_type: 'B2C',
        business_type_special_industry: null
      },
      mask: {
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          /* mask: [
            { mask: '0000000000' },
            { mask: '0000000000000' },
          ], */
          mask: /^\d{0,15}$/
        },
        postcode: {
          mask: '00000'
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }],
        ibirMask: {
          mask: /^\d+\/\d+$/
        },
        qrBillerId: {
          mask: /^\d{0,13}$/
        },
        suffix: {
          mask: '00'
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isUpdated: function isUpdated() {
      return typeof this.companyId !== 'undefined' && typeof this.profileId !== 'undefined';
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    profile: function profile() {
      return this.$store.getters.currentCompanyProfile;
    },
    uploadUrl: function uploadUrl() {
      return '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    },
    provinceList: function provinceList() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getProvinceList();
    },
    notificationDayList: function notificationDayList() {
      return this.dayList;
    }
  },
  methods: {
    backToCompanyProfileList: function backToCompanyProfileList() {
      var params = {
        companyId: this.companyId
      };
      this.$router.push({ name: 'CompanyProfileList', params: params });
    },
    populateAddressFromCompany: function populateAddressFromCompany(isCopy) {
      var _this = this;

      if (isCopy) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.company.address).forEach(function (key) {
          var val = isCopy ? _this.company.address[key] : '';
          _this.$set(_this.profileForm.address, key, val);
        });
      }
      /* if (isCopy) {
        this.$set(this.profileForm.address, 'tel', this.company.address.tel);
        this.$set(this.profileForm.address, 'fax', this.company.address.fax);
      } */
      this.updatePostCode();
    },
    toggleUsingCompanyAddress: function toggleUsingCompanyAddress() {
      this.populateAddressFromCompany(this.profileForm.use_company_address);
    },
    handleBillPaymentData: function handleBillPaymentData() {
      if (this.profileForm.use_bill_payment_biller_id) {
        this.$refs.profileForm.validateField('bill_payment_biller_id');
      } else {
        // this.profileForm.bill_payment_biller_id = '';
        this.$refs.bill_payment_biller_id.resetField();
      }
      if (this.profileForm.use_bill_payment_comp_code) {
        this.$refs.profileForm.validateField('bill_payment_comp_code');
      } else {
        // this.profileForm.bill_payment_comp_code = '';
        this.$refs.bill_payment_comp_code.resetField();
      }
      if (this.profileForm.use_bill_payment_account_no) {
        this.$refs.profileForm.validateField('bill_payment_account_no');
      } else {
        // this.profileForm.bill_payment_account_no = '';
        this.$refs.bill_payment_account_no.resetField();
        // this.$refs.bill_payment_account_no.resetField();
      }
      if (!this.profileForm.use_bill_payment_comp_code && !this.profileForm.use_bill_payment_account_no && !this.profileForm.use_bill_payment_biller_id) {
        this.$refs.profileForm.validateField('bill_payment_biller_id');
        this.$refs.profileForm.validateField('bill_payment_comp_code');
        this.$refs.profileForm.validateField('bill_payment_account_no');
      }
    },
    toggleUsingCompCode: function toggleUsingCompCode() {
      this.handleBillPaymentData();
    },
    toggleUsingAccountNo: function toggleUsingAccountNo() {
      this.handleBillPaymentData();
    },
    toggleUsingBillerId: function toggleUsingBillerId() {
      this.handleBillPaymentData();
      if (this.profileForm.use_bill_payment_biller_id) {
        this.profileForm.barcode_qrcode_type = 'biller_id';
        this.changeBillPaymentBillerId();
      }
    },
    toggleUsingBarcodeQRcodeType: function toggleUsingBarcodeQRcodeType() {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        this.profileForm.barcode_qrcode_account_no = '';
        this.profileForm.barcode_qrcode_account_no_suffix = '';
      } else {
        this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        this.profileForm.barcode_qrcode_biller_id_suffix = '';
      }
      this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
      this.$refs.profileForm.validateField('barcode_qrcode_account_no');
    },
    changeBillPaymentBillerId: function changeBillPaymentBillerId() {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        if (this.profileForm.use_bill_payment_biller_id) {
          // update paired biller_id
          var billerId = this.profileForm.bill_payment_biller_id;
          if (billerId && billerId.length >= 15) {
            var qrBillerId = billerId.substr(0, 13);
            var suffix = billerId.substring(13, 15);
            this.profileForm.barcode_qrcode_biller_id_tax_id = qrBillerId;
            this.profileForm.barcode_qrcode_biller_id_suffix = suffix;
            // validate qrcode biller_id
            this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
            // update format
            this.updateMaskBillerId();
          } else {
            this.profileForm.barcode_qrcode_biller_id_tax_id = billerId;
          }
        }
        // this.profileForm.barcode_qrcode_account_no = '';
        this.profileForm.barcode_qrcode_account_no_suffix = '';
        this.$refs.barcode_qrcode_account_no.resetField();
        // this.$refs.barcode_qrcode_account_no_suffix.resetField();
      } else {
        // this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        this.profileForm.barcode_qrcode_biller_id_suffix = '';
        this.$refs.barcode_qrcode_biller_id_tax_id.resetField();
        // this.$refs.barcode_qrcode_biller_id_suffix.resetField();
      }
      this.updateMaskBillerId();
    },
    checkBillerID: function checkBillerID(rule, value, cb) {
      var len = 0;
      if (value) {
        len = value.toString().length;
      }
      if (len !== 15) {
        cb(new Error('Biller ID must be 15 digits'));
      }
      cb();
    },
    checkBillPaymentFields: function checkBillPaymentFields(rule, value, cb) {
      // check at least one of 'bill_payment_comp_code',
      // 'bill_payment_account_no', 'bill_payment_biller_id'
      if (!this.profileForm.use_bill_payment_comp_code && !this.profileForm.use_bill_payment_account_no && !this.profileForm.use_bill_payment_biller_id) {
        cb(new Error('required bill payment information'));
      } else {
        cb();
      }
    },
    checkBillPaymentCompCode: function checkBillPaymentCompCode(rule, value, cb) {
      if (this.profileForm.use_bill_payment_comp_code && (this.profileForm.bill_payment_comp_code === null || this.profileForm.bill_payment_comp_code.trim() === '')) {
        cb(new Error('COMP CODE is required'));
      } else {
        cb();
      }
    },
    checkBillPaymentAccountNo: function checkBillPaymentAccountNo(rule, value, cb) {
      if (this.profileForm.use_bill_payment_account_no && (this.profileForm.bill_payment_account_no === null || this.profileForm.bill_payment_account_no.trim() === '')) {
        cb(new Error('Account No. is required'));
      } else {
        // check account format
        var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(this.mask.accountNo);
        var val = this.profileForm.bill_payment_account_no;
        if (val) {
          var resolvedValue = mask.resolve(val.toString());
          if (this.profileForm.use_bill_payment_account_no && resolvedValue.length !== 13) {
            cb(new Error('Account No. is not correct'));
          } else {
            cb();
          }
        } else {
          cb();
        }
      }
    },
    checkBillPaymentBillerId: function checkBillPaymentBillerId(rule, value, cb) {
      if (this.profileForm.use_bill_payment_biller_id) {
        var len = 0;
        if (value) {
          len = value.toString().length;
        }
        if (this.profileForm.bill_payment_biller_id === null || this.profileForm.bill_payment_biller_id.trim() === '') {
          cb(new Error('Biller ID is required'));
        } else if (len !== 15) {
          cb(new Error('Biller ID must be 15 digits'));
        }
      }
      cb();
    },
    checkBarcodeQRCodeBillerId: function checkBarcodeQRCodeBillerId(rule, value, cb) {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        var len = 0;
        if (value) {
          len = value.toString().length;
        }
        if (this.profileForm.barcode_qrcode_biller_id_tax_id === null || this.profileForm.barcode_qrcode_biller_id_tax_id.trim() === '') {
          cb(new Error('Biller ID is required'));
        } else if (len !== 13) {
          cb(new Error('Biller ID must be 13 digits'));
        } else if (this.profileForm.barcode_qrcode_biller_id_suffix === null || this.profileForm.barcode_qrcode_biller_id_suffix.trim() === '') {
          cb(new Error('Biller ID Suffix is required'));
        } else if (this.profileForm.barcode_qrcode_biller_id_suffix && this.profileForm.barcode_qrcode_biller_id_suffix.length !== 2) {
          cb(new Error('Biller ID Suffix must be 2 digits'));
        } else {
          cb();
        }
      } else {
        cb();
      }
    },
    checkBarcodeQRCodeAccountNo: function checkBarcodeQRCodeAccountNo(rule, value, cb) {
      if (this.profileForm.barcode_qrcode_type === 'account_no') {
        if (this.profileForm.barcode_qrcode_account_no === null || this.profileForm.barcode_qrcode_account_no.trim() === '') {
          cb(new Error('Account No. is required'));
        } else if (this.profileForm.barcode_qrcode_account_no_suffix === null || this.profileForm.barcode_qrcode_account_no_suffix.trim() === '') {
          cb(new Error('Account No. Suffix is required'));
        } else if (this.profileForm.barcode_qrcode_account_no_suffix && this.profileForm.barcode_qrcode_account_no_suffix.length !== 2) {
          cb(new Error('Account No. Suffix must be 2 digits'));
        } else {
          // check account format
          var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(this.mask.accountNo);
          var val = this.profileForm.barcode_qrcode_account_no;
          if (val) {
            var resolvedValue = mask.resolve(val.toString());
            if (resolvedValue.length !== 13) {
              cb(new Error('Account No. is not correct'));
            } else {
              cb();
            }
          } else {
            cb();
          }
        }
      } else {
        cb();
      }
    },
    checkChargePayer: function checkChargePayer() {
      if (this.profileForm.charge_payer) {
        this.$refs.profileForm.validateField('ir_br');
      }
    },
    checkIBIR: function checkIBIR(rule, value, cb) {
      if (this.profileForm.charge_payer && this.profileForm.ir_br.trim() === '') {
        cb(new Error('IB/IR is required'));
      } else {
        cb();
      }
    },
    checkNotificationMsg: function checkNotificationMsg(rule, value, cb) {
      // check if custom message is select and not blank
      this.updateNotificationMsgValue();
      /* if (this.profileForm.notification_msg_type === 'CUSTOM' &&
        this.profileForm.notification_msg_custom.trim() === '') {
        cb(new Error('Custom Notification message is required'));
      } */
      cb();
    },
    businessTypeChange: function businessTypeChange() {
      if (this.profileForm.business_type !== 'SPECIAL') {
        this.profileForm.business_type_special_industry = null;
      }
      this.$refs.profileForm.validateField('business_type_special_industry');
    },
    checkBusinessType: function checkBusinessType(rule, value, cb) {
      var isValid = true;
      if (this.profileForm.business_type === 'SPECIAL') {
        if (this.profileForm.business_type_special_industry === null || this.profileForm.business_type_special_industry.trim() === '') {
          isValid = false;
          cb(new Error('Business type special industry required'));
        }
      } else {
        this.profileForm.business_type_special_industry = null;
      }
      if (isValid) {
        cb();
      }
    },
    toggleUsingNotificationMsgValue: function toggleUsingNotificationMsgValue() {
      // update notification_msg
      // this.updateNotificationMsgValue();
      if (this.profileForm.notification_msg_type === 'DATE') {
        this.profileForm.notification_msg_custom = '';
      }
      this.$refs.profileForm.validateField('notification_msg');
    },
    updateNotificationMsgValue: function updateNotificationMsgValue() {
      if (this.profileForm.notification_msg_type === 'CUSTOM') {
        this.profileForm.notification_msg = this.profileForm.notification_msg_custom;
      } else {
        this.profileForm.notification_msg = '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E0A\u0E33\u0E23\u0E30\u0E20\u0E32\u0E22\u0E43\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 ' + this.profileForm.notification_msg_date + ' \u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E40\u0E14\u0E37\u0E2D\u0E19';
      }
    },
    handleLogoSuccess: function handleLogoSuccess(res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.profileForm.logo = res.secure_url;
      }
    },
    handleLogoFail: function handleLogoFail(res) {
      this.isUploading = false;
      var errorMessage = this.$t('Unexpected error');
      if (res) {
        errorMessage = res;
        if (res.error) {
          errorMessage = res.error;
          if (res.error.message) {
            errorMessage = res.error.message;
          }
        }
      }
      this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
    },
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Logo picture must be JPG, PNG or GIF format!');
      }
      if (!isLt2M) {
        this.$message.error('Logo picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    handleHttpRequest: function handleHttpRequest(options) {
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_COMPANY_PROFILE_LOGO', options.file);
    },
    buildPayload: function buildPayload() {
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.profileForm));
      // remove unnecessary key
      var stripKeys = [
      // 'use_company_address',
      'use_bill_payment_comp_code', 'use_bill_payment_account_no', 'use_bill_payment_biller_id', 'barcode_qrcode_type', 'notification_msg_type', 'notification_msg_date', 'notification_msg_custom'];
      var makeNullKeys = ['bill_payment_comp_code', 'bill_payment_account_no', 'bill_payment_biller_id', 'barcode_qrcode_biller_id_tax_id', 'barcode_qrcode_biller_id_suffix', 'barcode_qrcode_account_no', 'barcode_qrcode_account_no_suffix', 'notification_msg'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        if (stripKeys.indexOf(key) !== -1) {
          delete payload[key];
        }
        if (key === 'use_company_address') {
          payload.use_company_address = payload.use_company_address || false;
        }
        // transform data before sending
        if (makeNullKeys.indexOf(key) !== -1) {
          if (payload[key] === '') {
            payload[key] = null;
          }
        }
      });
      if (!this.isUpdated) {
        delete payload.id;
      }
      // transform notification_msg
      if (payload.notification_msg) {
        payload.notification_msg = payload.notification_msg.replace(new __WEBPACK_IMPORTED_MODULE_5_xregexp___default.a('[ ]{2,}', 'g'), ' ');
      }
      this.unmaskValue(payload, 'bill_payment_account_no', this.mask.accountNo);
      this.unmaskValue(payload, 'barcode_qrcode_account_no', this.mask.accountNo);
      return payload;
    },
    submitForm: function submitForm(formName) {
      this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
      this.$refs.profileForm.validateField('barcode_qrcode_account_no');
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this2 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      // build payload first
      this.updateNotificationMsgValue();
      this.isSubmitting = true;
      var action = this.isUpdated ? 'UPDATE_COMPANY_PROFILE_INFO' : 'CREATE_COMPANY_PROFILE_INFO';
      var payload = this.buildPayload();
      var reqPayload = {
        payload: payload
      };
      if (this.isUpdated) {
        reqPayload.profileId = payload.id;
      } else {
        reqPayload.companyId = this.companyId;
      }
      this.$store.dispatch(action, reqPayload).then(function () {
        _this2.isSubmitting = false;
        var successMessage = 'สร้างข้อมูลสำหรับรับชำระของบริษัทสำเร็จแล้ว';
        if (_this2.isUpdated) {
          successMessage = 'แก้ไขข้อมูลสำหรับรับชำระของบริษัทสำเร็จแล้ว';
        }
        _this2.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this2.$nextTick(function () {
          _this2.backToCompanyProfileList();
        });
      }).catch(function (msg) {
        _this2.isSubmitting = false;
        if (msg) {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
        } else {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
        }
      });
      return true;
    },
    confirmTerminate: function confirmTerminate() {
      var _this3 = this;

      this.$confirm('ท่านกำลังจะลบข้อมูลบริษัทสำหรับรับชำระนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this3.isSubmitting = true;
        _this3.$store.dispatch('DELETE_COMPANY_PROFILE_INFO', _this3.profileId).then(function () {
          _this3.isSubmitting = false;
          _this3.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลบริษัทสำหรับรับชำระสำเร็จแล้ว'
          });
          _this3.backToCompanyProfileList();
        }).catch(function (msg) {
          _this3.isSubmitting = false;
          if (msg) {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t(msg));
          } else {
            _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    setupUpdateData: function setupUpdateData() {
      var _this4 = this;

      this.isSetupUpdateData = true;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.profile).forEach(function (key) {
        if (key === 'address') {
          // let isUseCompanyAddress = true;
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.profile.address).forEach(function (addrKey) {
            // check if the value for this profile & company are the same or not
            /* if (this.profile.address[addrKey] !== this.company.address[addrKey]) {
              isUseCompanyAddress = false;
            } */
            _this4.$set(_this4.profileForm.address, addrKey, _this4.profile.address[addrKey]);
          });
          // this.use_company_address = isUseCompanyAddress;
        } else if (key === 'notification_msg') {
          if (_this4.profile[key] === null) {
            _this4.$set(_this4.profileForm, key, '');
          } else {
            _this4.$set(_this4.profileForm, key, _this4.profile[key]);
          }
        } else if (key === 'other_banks') {
          // loop through array of other bank info
          _this4.profile[key].forEach(function (bankInfo) {
            _this4.profileForm[key].push({
              account_name: bankInfo.account_name,
              account_number: bankInfo.account_number,
              account_logo: bankInfo.account_logo,
              comcode: bankInfo.comcode,
              service_fee: bankInfo.service_fee,
              service_code: bankInfo.service_code,
              branch_code: bankInfo.branch_code
            });
          });
        } else {
          _this4.$set(_this4.profileForm, key, _this4.profile[key]);
        }
      });
      // update required control fields' value
      this.profileForm.use_bill_payment_comp_code = !!this.profileForm.bill_payment_comp_code;
      this.profileForm.use_bill_payment_account_no = !!this.profileForm.bill_payment_account_no;
      this.profileForm.use_bill_payment_biller_id = !!this.profileForm.bill_payment_biller_id;
      this.profileForm.barcode_qrcode_type = this.profileForm.barcode_qrcode_biller_id_tax_id ? 'biller_id' : 'account_no';
      this.profileForm.notification_msg_type = this.profileForm.notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 && this.profileForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
      if (this.profileForm.notification_msg_type === 'DATE') {
        this.profileForm.notification_msg_date = this.profileForm.notification_msg.replace('กรุณาชำระภายในวันที่', '').replace('ของทุกเดือน', '');
      } else {
        this.profileForm.notification_msg_custom = this.profileForm.notification_msg;
      }
      if (this.profileForm.business_type === '') {
        this.profileForm.business_type = 'B2C';
      }
      if (this.profileForm.business_type !== 'SPECIAL') {
        this.profileForm.business_type_special_industry = null;
      }
      this.updatePostCode();
      this.updateMaskAccountNo();
      this.updateMaskBillerId();
      // this.updateMaskIBIR();
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.profileForm.id = null;
      this.profileForm.name = '';
      this.profileForm.use_company_address = true;
      this.profileForm.address.line_1 = '';
      this.profileForm.address.district = '';
      this.profileForm.address.city = '';
      this.profileForm.address.province = '';
      this.profileForm.address.postal_code = '';
      this.profileForm.address.tel = '';
      this.profileForm.address.fax = '';
      this.profileForm.use_bill_payment_comp_code = false;
      this.profileForm.bill_payment_comp_code = '';
      this.profileForm.use_bill_payment_account_no = false;
      this.profileForm.bill_payment_account_no = '';
      this.profileForm.use_bill_payment_biller_id = true;
      this.profileForm.bill_payment_biller_id = '';
      this.profileForm.barcode_qrcode_type = 'biller_id';
      this.profileForm.barcode_qrcode_biller_id_tax_id = '';
      this.profileForm.barcode_qrcode_biller_id_suffix = '';
      this.profileForm.barcode_qrcode_account_no = '';
      this.profileForm.barcode_qrcode_account_no_suffix = '';
      this.profileForm.payment_type = 'CHEQUE_OR_CASH';
      this.profileForm.charge_payer = false;
      this.profileForm.ir_br = '';
      this.profileForm.account_name = '';
      this.profileForm.label_ref1 = '';
      this.profileForm.label_ref2 = '';
      this.profileForm.label_ref3 = '';
      this.profileForm.allow_other_banks = true;
      this.profileForm.is_banking_agent = false;
      this.profileForm.other_banks.splice(0);
      this.profileForm.notification_msg_type = 'CUSTOM';
      this.profileForm.notification_msg_date = '1';
      this.profileForm.notification_msg_custom = '';
      this.profileForm.notification_msg = '';
      this.profileForm.logo = '';
      this.profileForm.printing_option = 'COLOR';
    },

    /* updateMaskTel() {
      this.maskValue(this.profileForm.address, 'tel', {
        mask: this.mask.telMask,
      });
    },
    updateMaskFax() {
      this.maskValue(this.profileForm.address, 'fax', {
        mask: this.mask.faxMask,
      });
    }, */
    updatePostCode: function updatePostCode() {
      try {
        this.maskValue(this.profileForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },

    /* updateMaskIBIR() {
      this.maskValue(this.profileForm, 'ir_br', this.mask.ibirMask);
    }, */
    updateMaskCompCode: function updateMaskCompCode() {
      this.maskValue(this.profileForm, 'bill_payment_comp_code', this.mask.compCode);
    },
    updateMaskAccountNo: function updateMaskAccountNo() {
      this.maskValue(this.profileForm, 'bill_payment_account_no', this.mask.accountNo);
      this.maskValue(this.profileForm, 'barcode_qrcode_account_no', this.mask.accountNo);
    },
    updateMaskBillerId: function updateMaskBillerId() {
      this.maskValue(this.profileForm, 'bill_payment_biller_id', this.mask.billerId);
      this.maskValue(this.profileForm, 'barcode_qrcode_biller_id_tax_id', this.mask.qrBillerId);
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true }),
    isBBLBank: function isBBLBank(accountName) {
      var testString = accountName.toLowerCase();
      var isBBL = testString.indexOf('bbl') !== -1 || testString.indexOf('bangkok') !== -1 || testString.indexOf('กรุงเทพ') !== -1;
      return isBBL;
    },
    getOtherBankInfoSummaryText: function getOtherBankInfoSummaryText(bankInfo) {
      var bankInfoText = bankInfo.account_name + ' A/C : ' + bankInfo.account_number + ' / COMP CODE: ' + bankInfo.comcode;
      if (this.isBBLBank(bankInfo.account_name)) {
        bankInfoText += ' / SERVICE CODE: ' + bankInfo.service_code + ' / BR CODE: ' + bankInfo.branch_code;
      }
      bankInfoText += ' / FEE : ' + bankInfo.service_fee;
      return bankInfoText;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    // clear list
    this.dayList.splice(0);
    // populate day list
    for (var d = 1; d <= 31; d += 1) {
      this.dayList.push(d);
    }
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this5.profile === 'undefined' || _this5.profile === null) {
          _this5.backToCompanyProfileList();
        }
      }, 1000);
      if (this.profile) {
        this.setupUpdateData();
      }
    } else {
      // default to assign company's address for this profile automatically
      this.populateAddressFromCompany(true);
    }
  },

  watch: {
    profile: function profile(newVal) {
      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
      vm.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', vm.profileId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyProfileFormView);

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */

/**
 * Company Profile Detail view
 */
var CompanyProfileDetailView = {
  name: 'company-profile-detail',
  props: ['companyId', 'profileId'],
  data: function data() {
    return {
      isSubmitting: false,
      dayList: [],
      profileForm: {
        id: null,
        name: '',
        use_company_address: true,
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: ''
        },
        use_bill_payment_comp_code: false,
        bill_payment_comp_code: '',
        use_bill_payment_account_no: false,
        bill_payment_account_no: '',
        use_bill_payment_biller_id: true,
        bill_payment_biller_id: '',
        barcode_qrcode_type: 'biller_id',
        barcode_qrcode_biller_id_tax_id: '',
        barcode_qrcode_biller_id_suffix: '',
        barcode_qrcode_account_no: '',
        barcode_qrcode_account_no_suffix: '',
        payment_type: 'CHEQUE_OR_CASH', // "CHEQUE_OR_CASH", "CASH_ONLY"
        charge_payer: false,
        ir_br: '',
        account_name: '',
        label_ref1: '',
        label_ref2: '',
        label_ref3: '',
        allow_other_banks: true,
        other_banks: [{
          account_name: 'ธนาคารกรุงเทพ',
          account_number: '000-0-12345-1',
          account_logo: 'https://res.cloudinary.com/hpfrx0s4s/image/upload/v1529001251/xlvi0rbddydqkqsyxaxe.png',
          comcode: '3748',
          service_fee: 'ค่าธรรมเนียม 15 บาททุกรายการ',
          service_code: '0838',
          branch_code: '0001'
        }],
        notification_msg_type: 'CUSTOM', // DATE or CUSTOM
        notification_msg_date: '1',
        notification_msg_custom: '',
        notification_msg: '',
        logo: '',
        printing_option: 'COLOR', // "COLOR", "BLACK_AND_WHITE"
        business_type: 'B2C',
        business_type_special_industry: null
      },
      mask: {
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          /* mask: [
            { mask: '0000000000' },
            { mask: '0000000000000' },
          ], */
          mask: /^\d{0,15}$/
        },
        postcode: {
          mask: '00000'
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }],
        ibirMask: {
          mask: /^\d+\/\d+$/
        },
        qrBillerId: {
          mask: /^\d{0,13}$/
        },
        suffix: {
          mask: '00'
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    profile: function profile() {
      return this.$store.getters.currentCompanyProfile;
    }
  },
  methods: {
    backToCompanyProfileList: function backToCompanyProfileList() {
      var params = {
        companyId: this.companyId
      };
      this.$router.push({ name: 'CompanyProfileList', params: params });
    },
    setupUpdateData: function setupUpdateData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.profile).forEach(function (key) {
        if (key === 'address') {
          // let isUseCompanyAddress = true;
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.profile.address).forEach(function (addrKey) {
            // check if the value for this profile & company are the same or not
            /* if (this.profile.address[addrKey] !== this.company.address[addrKey]) {
              isUseCompanyAddress = false;
            } */
            _this.$set(_this.profileForm.address, addrKey, _this.profile.address[addrKey]);
          });
          // this.use_company_address = isUseCompanyAddress;
        } else if (key === 'notification_msg') {
          if (_this.profile[key] === null) {
            _this.$set(_this.profileForm, key, '');
          } else {
            _this.$set(_this.profileForm, key, _this.profile[key]);
          }
        } else {
          _this.$set(_this.profileForm, key, _this.profile[key]);
        }
      });
      // update required control fields' value
      this.profileForm.use_bill_payment_comp_code = !!this.profileForm.bill_payment_comp_code;
      this.profileForm.use_bill_payment_account_no = !!this.profileForm.bill_payment_account_no;
      this.profileForm.use_bill_payment_biller_id = !!this.profileForm.bill_payment_biller_id;
      this.profileForm.barcode_qrcode_type = this.profileForm.barcode_qrcode_biller_id_tax_id ? 'biller_id' : 'account_no';
      this.profileForm.notification_msg_type = this.profileForm.notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 && this.profileForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
      if (this.profileForm.notification_msg_type === 'DATE') {
        this.profileForm.notification_msg_date = this.profileForm.notification_msg.replace('กรุณาชำระภายในวันที่', '').replace('ของทุกเดือน', '');
      } else {
        this.profileForm.notification_msg_custom = this.profileForm.notification_msg;
      }
      if (this.profileForm.business_type === '') {
        this.profileForm.business_type = 'B2C';
      }
      if (this.profileForm.business_type !== 'SPECIAL') {
        this.profileForm.business_type_special_industry = null;
      }
      this.updatePostCode();
      this.updateMaskAccountNo();
      this.updateMaskBillerId();
    },
    updatePostCode: function updatePostCode() {
      try {
        this.maskValue(this.profileForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },
    updateMaskCompCode: function updateMaskCompCode() {
      this.maskValue(this.profileForm, 'bill_payment_comp_code', this.mask.compCode);
    },
    updateMaskAccountNo: function updateMaskAccountNo() {
      this.maskValue(this.profileForm, 'bill_payment_account_no', this.mask.accountNo);
      this.maskValue(this.profileForm, 'barcode_qrcode_account_no', this.mask.accountNo);
    },
    updateMaskBillerId: function updateMaskBillerId() {
      this.maskValue(this.profileForm, 'bill_payment_biller_id', this.mask.billerId);
      this.maskValue(this.profileForm, 'barcode_qrcode_biller_id_tax_id', this.mask.qrBillerId);
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_1_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    isBBLBank: function isBBLBank(accountName) {
      var testString = accountName.toLowerCase();
      var isBBL = testString.indexOf('bbl') !== -1 || testString.indexOf('bangkok') !== -1 || testString.indexOf('กรุงเทพ') !== -1;
      return isBBL;
    },
    getOtherBankInfoSummaryText: function getOtherBankInfoSummaryText(bankInfo) {
      var bankInfoText = bankInfo.account_name + ' A/C : ' + bankInfo.account_number + ' / COMP CODE: ' + bankInfo.comcode;
      if (this.isBBLBank(bankInfo.account_name)) {
        bankInfoText += ' / SERVICE CODE: ' + bankInfo.service_code + ' / BR CODE: ' + bankInfo.branch_code;
      }
      bankInfoText += ' / FEE : ' + bankInfo.service_fee;
      return bankInfoText;
    },
    clearUpdateData: function clearUpdateData() {
      this.profileForm.id = null;
      this.profileForm.name = '';
      this.profileForm.use_company_address = true;
      this.profileForm.address.line_1 = '';
      this.profileForm.address.district = '';
      this.profileForm.address.city = '';
      this.profileForm.address.province = '';
      this.profileForm.address.postal_code = '';
      this.profileForm.address.tel = '';
      this.profileForm.address.fax = '';
      this.profileForm.use_bill_payment_comp_code = false;
      this.profileForm.bill_payment_comp_code = '';
      this.profileForm.use_bill_payment_account_no = false;
      this.profileForm.bill_payment_account_no = '';
      this.profileForm.use_bill_payment_biller_id = true;
      this.profileForm.bill_payment_biller_id = '';
      this.profileForm.barcode_qrcode_type = 'biller_id';
      this.profileForm.barcode_qrcode_biller_id_tax_id = '';
      this.profileForm.barcode_qrcode_biller_id_suffix = '';
      this.profileForm.barcode_qrcode_account_no = '';
      this.profileForm.barcode_qrcode_account_no_suffix = '';
      this.profileForm.payment_type = 'CHEQUE_OR_CASH';
      this.profileForm.charge_payer = false;
      this.profileForm.ir_br = '';
      this.profileForm.account_name = '';
      this.profileForm.label_ref1 = '';
      this.profileForm.label_ref2 = '';
      this.profileForm.label_ref3 = '';
      this.profileForm.allow_other_banks = false;
      this.profileForm.other_banks.splice(0);
      this.profileForm.notification_msg_type = 'CUSTOM';
      this.profileForm.notification_msg_date = '1';
      this.profileForm.notification_msg_custom = '';
      this.profileForm.notification_msg = '';
      this.profileForm.logo = '';
      this.profileForm.printing_option = 'COLOR';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // clear list
    this.dayList.splice(0);
    // populate day list
    for (var d = 1; d <= 31; d += 1) {
      this.dayList.push(d);
    }
    setTimeout(function () {
      if (typeof _this2.profile === 'undefined' || _this2.profile === null) {
        _this2.backToCompanyProfileList();
      }
    }, 1000);
    if (this.profile) {
      this.setupUpdateData();
    }
  },

  watch: {
    profile: function profile(newVal) {
      if (newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
      vm.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', vm.profileId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_COMPANY_PROFILE', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (CompanyProfileDetailView);

/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_company__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var UserLoadInfo = {
  name: 'user-load-info',
  data: function data() {
    return {
      isLoading: false
    };
  },

  computed: {
    shouldReloadData: function shouldReloadData() {
      return !(this.$store.getters.myAdminInfo && this.$store.getters.billerInfo);
    },
    idToken: function idToken() {
      return this.$store.getters.idToken;
    }
  },
  methods: {
    reloadInfo: function reloadInfo() {
      var _this = this;

      this.isLoading = true;
      // now we get the user info first
      this.$store.dispatch('GET_BILLER_MY_ADMIN_INFO').then(function () {
        _this.$store.dispatch('GET_BILLER_COMPANY_INFO', _this.$store.getters.myAdminInfo.company_id).then(function () {
          _this.isLoading = false;
          _this.$router.push({ name: 'BillerCompanyDetail' });
        }).catch(function (err) {
          _this.isLoading = false;
          if (err) {
            _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(err));
          } else {
            _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
          }
        });
      }).catch(function (err) {
        _this.isLoading = false;
        if (err) {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(err));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
    }
  },
  mounted: function mounted() {
    if (this.idToken) {
      __WEBPACK_IMPORTED_MODULE_0__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
      this.reloadInfo();
    }
  },

  watch: {
    idToken: function idToken(newVal) {
      if (newVal) {
        __WEBPACK_IMPORTED_MODULE_0__services_company__["a" /* default */].setJWTToken(this.$store.getters.idToken);
        this.reloadInfo();
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (UserLoadInfo);

/***/ }),

/***/ 487:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_imask__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */

// import store from '@/store';


var BillerProfileListView = {
  name: 'biller-profile-list',
  data: function data() {
    return {
      isSubmitting: false,
      searchTerm: '',
      mask: {
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          mask: /^\d{0,15}$/
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.billerInfo;
    },
    companyId: function companyId() {
      return this.company.id;
    },
    profileList: function profileList() {
      return this.$store.getters.billerProfileList;
    },
    profileListData: function profileListData() {
      var _this = this;

      var q = this.searchTerm.trim().toLowerCase();
      if (q !== '') {
        return this.profileList.filter(function (item) {
          var name = item.name.trim().toLowerCase();
          return name.indexOf(q) !== -1;
        });
      }
      return this.profileList.map(function (item) {
        var profile = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
        // account no
        var billPaymentAccountNo = _this.maskFormatter(profile.bill_payment_account_no, _this.mask.accountNo);
        var qrAccountNo = null;
        if (profile.barcode_qrcode_account_no) {
          var acc = _this.maskFormatter(profile.barcode_qrcode_account_no, _this.mask.accountNo);
          qrAccountNo = acc + ' (' + profile.barcode_qrcode_account_no_suffix + ')';
        }
        profile.account_no = {
          bill_payment: billPaymentAccountNo,
          qr: qrAccountNo
        };
        // biller_id
        var billPaymentBillerId = _this.maskFormatter(profile.bill_payment_biller_id, _this.mask.billerId);
        var qrBillerId = null;
        if (profile.barcode_qrcode_biller_id_tax_id) {
          qrBillerId = profile.barcode_qrcode_biller_id_tax_id + ' (' + profile.barcode_qrcode_biller_id_suffix + ')';
        }
        profile.biller_id = {
          bill_payment: billPaymentBillerId,
          qr: qrBillerId
        };
        return profile;
      });
    }
  },
  methods: {
    paymentTypeFormatter: function paymentTypeFormatter(row) {
      return row.payment_type === 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : 'เช็ค/เงินสด';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    compCodeFormatter: function compCodeFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.compCode);
      }
      return '-';
    },
    accountNoFormatter: function accountNoFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.accountNo);
      }
      return '-';
    },
    accountNoAllFormatter: function accountNoAllFormatter(cellValue) {
      var billPayment = cellValue.bill_payment,
          qr = cellValue.qr;

      var output = [];
      if (billPayment) {
        output.push(billPayment);
      } else {
        output.push('-');
      }
      if (qr) {
        output.push(qr);
      } else {
        output.push('-');
      }
      if (output.length > 0) {
        return output.join('<br/>');
      }
      return '-';
    },
    billerIdFormatter: function billerIdFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.billerId);
      }
      return '-';
    },
    billerIdAllFormatter: function billerIdAllFormatter(cellValue) {
      var billPayment = cellValue.bill_payment,
          qr = cellValue.qr;

      var output = [];
      if (billPayment) {
        output.push(billPayment);
      }
      if (qr) {
        output.push(qr);
      }
      if (output.length > 0) {
        return output.join('<br/>');
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_2_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
    handleView: function handleView(index, row) {
      this.$router.push({
        name: 'BillerProfileDetail',
        params: {
          companyId: this.companyId,
          profileId: row.id
        }
      });
    },
    addressFormatter: function addressFormatter(row) {
      return row.address.line_1 + '\n      ' + row.address.district + '\n      ' + row.address.city + '\n      ' + row.address.province + '\n      ' + row.address.postal_code;
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_BILLER_PROFILE_LIST', vm.$store.getters.billerInfo.id).then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerProfileListView);

/***/ }),

/***/ 488:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_xlsx__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_pdffonts__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_xregexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_papaparse__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_papaparse__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */
/* eslint new-cap: 0 */












// import asyncMergeSort from 'async-merge-sort';

var defaultOffset = 0;
var defaultLimit = 100;

var xlsxTemplateHeadersArray = ['ID', 'Payer Name * (40)', 'Ref.1 * (Max 20)', 'Ref.2 (Max 20)', 'Amount *', 'Payment Date * (dd/mm/yy) yy = 18', 'Email Address', 'Alert Message (100)', 'Remark (100)'];

var BillerProfileDetailView = {
  name: 'biller-profile-detail',
  props: ['profileId'],
  data: function data() {
    return {
      isSearching: false,
      isPrinting: false,
      isEmailing: false,
      isDeleting: false,
      isExporting: false,
      isImporting: false,
      isSortingImport: false,
      isSortingData: false,
      isChangingPage: false,
      xlsUpdateFile: null,
      xlsDataRows: [],
      xlsDataRowsSorted: [],
      xlsDataCurrentPage: 1,
      xlsDataItemPerPage: 100,
      slipListDataSorted: [],
      slipListDataCurrentPage: 1,
      slipListDataItemPerPage: defaultLimit,
      xlsSkipRows: [],
      xlsErrorRows: [],
      activeSearchOption: ['1'],
      searchPickerOptions: {
        /* disabledDate(time) {
          return time.getTime() > Date.now();
        }, */
        shortcuts: [{
          text: 'วันนี้',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'เมื่อวานนี้',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'สัปดาห์ก่อน',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      summaryDialogMode: '',
      summaryDialogRequest: '',
      summaryDialogTitle: '',
      exportFileFormat: 'xlsx',
      importFileFormat: 'xlsx',
      isSummaryDialogShown: false,
      isImportDialogShown: false,
      isSummaryResultDialogShown: false,
      summaryPDFDataURL: null,
      pdfFilename: '',
      pdfContent: null,
      // selectedSlips: [],
      selectedSlipsPaged: {},
      searchForm: {
        amount__from: null,
        amount__to: null,
        issued_on__from: null,
        issued_on__to: null,
        payee__name: null,
        ref1: null,
        ref2: null,
        is_printed: 'ทั้งหมด',
        limit: defaultLimit,
        offset: defaultOffset,
        id__in: null,
        is_sent: 'ทั้งหมด',
        order_by: 'issued_on',
        order_dir: 'desc'
      },
      mask: {
        accountNo: {
          mask: '000-0-00000-0'
        },
        amountMask: {
          mask: __WEBPACK_IMPORTED_MODULE_6_imask__["MaskedNumber"],
          scale: 2,
          signed: false,
          thousandsSeparator: ',',
          padFractionalZeros: true,
          normalizeZeros: true,
          radix: '.',
          mapToRadix: ['.']
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }],
        refCode: {
          mask: /^[0-9A-Z]{0,20}$/
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isBillerAdmin: function isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    canGenerateQR: function canGenerateQR() {
      if (this.profile) {
        return this.profile.barcode_qrcode_biller_id_tax_id !== null && this.profile.barcode_qrcode_biller_id_tax_id !== '';
      }
      return false;
    },
    importDialogTitle: function importDialogTitle() {
      if (this.importFileFormat === 'xlsx') {
        return 'นำเข้ารายการด้วย Excel (XSLX)';
      }
      return 'นำเข้ารายการด้วย CSV';
    },
    importFileFormatName: function importFileFormatName() {
      if (this.importFileFormat === 'xlsx') {
        return 'Excel (XLSX)';
      }
      return 'CSV';
    },

    /* hasQRAccountNo() {
      if (this.profile) {
        return this.profile.barcode_qrcode_account_no !== null &&
          this.profile.barcode_qrcode_account_no !== '';
      }
      return null;
    }, */
    company: function company() {
      return this.$store.getters.billerInfo;
    },
    profile: function profile() {
      var profile = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.$store.getters.currentBillerProfile));
      if (profile) {
        var billPaymentAccountNo = this.maskFormatter(profile.bill_payment_account_no, this.mask.accountNo);
        var qrAccountNo = null;
        if (profile.barcode_qrcode_account_no) {
          var acc = this.maskFormatter(profile.barcode_qrcode_account_no, this.mask.accountNo);
          qrAccountNo = acc + ' (' + profile.barcode_qrcode_account_no_suffix + ')';
        }
        profile.account_no = {
          bill_payment: billPaymentAccountNo,
          qr: qrAccountNo
        };
      }
      return profile;
    },
    slipList: function slipList() {
      return this.$store.getters.billerSlipList;
    },
    slipListData: function slipListData() {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.slipList)).map(function (slip) {
        // construct print status
        slip.print_status = {
          payin: slip.is_printed || false,
          qr: slip.is_printed_qr_image || false
        };
        // construct email status
        slip.email_status = {
          payin: slip.is_sent || false,
          qr: slip.is_sent_qr_image || false
        };
        return slip;
      });
    },
    ref1Label: function ref1Label() {
      if (this.profile) {
        return this.profile.label_ref1 + ' (Ref. 1)';
      }
      return '';
    },
    ref2Label: function ref2Label() {
      if (this.profile) {
        return this.profile.label_ref2 + ' (Ref. 2)';
      }
      return '';
    },
    slipLoadingActionText: function slipLoadingActionText() {
      if (this.isPrinting) {
        return 'กำลังพิมพ์...';
      } else if (this.isEmailing) {
        return 'กำลังส่งอีเมล...';
      } else if (this.isDeleting) {
        return 'กำลังลบ...';
      } else if (this.isExporting) {
        return 'กำลังส่งออก...';
      }
      return '';
    },
    summaryGridData: function summaryGridData() {
      var _this = this;

      var slipList = [];
      if (this.summaryDialogMode === 'email') {
        /* return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1 &&
          slip.payer.email.trim() !== ''); */
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId && slip.payer.email.trim() !== '') {
              slipList.push(slip);
            }
          });
        }); */
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
          _this.selectedSlipsPaged[paged].forEach(function (slip) {
            if (slip.payer.email && slip.payer.email.trim() !== '') {
              slipList.push(slip);
            }
          });
        });
      } else {
        /* this.selectedSlips.forEach((slipId) => {
          this.slipListData.forEach((slip) => {
            if (slip.id === slipId) {
              slipList.push(slip);
            }
          });
        }); */
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
          _this.selectedSlipsPaged[paged].forEach(function (slip) {
            slipList.push(slip);
          });
        });
      }
      return slipList;
      // return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1);
    },
    summaryGridData2: function summaryGridData2() {
      var _this2 = this;

      if (this.summaryDialogMode !== 'email') {
        return null;
      }
      var slipList = [];
      /* return this.slipListData.filter(slip => this.selectedSlips.indexOf(slip.id) !== -1 &&
        slip.payer.email.trim() === ''); */
      /* this.selectedSlips.forEach((slipId) => {
        this.slipListData.forEach((slip) => {
          if (slip.id === slipId && slip.payer.email.trim() === '') {
            slipList.push(slip);
          }
        });
      }); */
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
        _this2.selectedSlipsPaged[paged].forEach(function (slip) {
          if (slip.payer.email === null || slip.payer.email.trim() === '') {
            slipList.push(slip);
          }
        });
      });
      return slipList;
    },
    xlsTemplateHeaders: function xlsTemplateHeaders() {
      return xlsxTemplateHeadersArray;
    },
    xlsTemplateHeadersKey: function xlsTemplateHeadersKey() {
      var headerKeys = {};
      headerKeys[xlsxTemplateHeadersArray[0]] = 'id';
      headerKeys[xlsxTemplateHeadersArray[1]] = 'payer.name';
      headerKeys[xlsxTemplateHeadersArray[2]] = 'ref1';
      headerKeys[xlsxTemplateHeadersArray[3]] = 'ref2';
      headerKeys[xlsxTemplateHeadersArray[4]] = 'amount';
      headerKeys[xlsxTemplateHeadersArray[5]] = 'issued_on';
      headerKeys[xlsxTemplateHeadersArray[6]] = 'payer.email';
      headerKeys[xlsxTemplateHeadersArray[7]] = 'notification_msg';
      headerKeys[xlsxTemplateHeadersArray[8]] = 'remark';
      return headerKeys;
    },
    xlsExportHeaderKey: function xlsExportHeaderKey() {
      return {
        id: xlsxTemplateHeadersArray[0],
        'payer.name': xlsxTemplateHeadersArray[1],
        'payer.email': xlsxTemplateHeadersArray[6],
        issued_on: xlsxTemplateHeadersArray[5],
        amount: xlsxTemplateHeadersArray[4],
        ref1: xlsxTemplateHeadersArray[2],
        ref2: xlsxTemplateHeadersArray[3],
        notification_msg: xlsxTemplateHeadersArray[7],
        remark: xlsxTemplateHeadersArray[8]
        // company_id: 'บริษัท',
        // created_at: 'สร้างเมื่อ',
        // emailed_at: 'ส่งอีเมลเมื่อ',
        // is_printed: 'พิมพ์แล้ว?',
        // is_sent: 'ส่งอีเมลแล้ว?',
        // payer: 'ลูกค้า',
        // printed_at: 'พิมพ์เมื่อ',
        // profile_id: 'บัญชีสำหรับรับชำระ',
        // updated_at: 'แก้ไขล่าสุดเมื่อ',
      };
    },

    slipSearchOption: {
      get: function get() {
        return this.$store.getters.slipSearchOption;
      },
      set: function set() {}
    },
    filterAppliedCount: function filterAppliedCount() {
      var searchQueryFilter = this.$store.getters.slipSearchQuery;
      if (searchQueryFilter) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(searchQueryFilter).filter(function (key) {
          if (['order_by', 'order_dir', 'offset', 'limit'].indexOf(key) !== -1) return false;
          return searchQueryFilter[key] !== null;
        }).length;
      }
      return 0;
    },

    // table filter
    slipFilterDate: function slipFilterDate() {
      return this.slipListData.map(function (item) {
        return item.issued_on;
      }).filter(function (val, index, self) {
        return self.indexOf(val) === index;
      }).map(function (val) {
        var data = {
          text: val,
          value: val
        };
        return data;
      });
    },
    slipFilterName: function slipFilterName() {
      return this.slipListData.map(function (item) {
        return item.payer.name;
      }).filter(function (val, index, self) {
        return self.indexOf(val) === index;
      }).map(function (val) {
        var data = {
          text: val,
          value: val
        };
        return data;
      });
    },
    xlsDataRowsPaged: function xlsDataRowsPaged() {
      // apply pagination data
      var offsetIndex = (this.xlsDataCurrentPage - 1) * this.xlsDataItemPerPage;
      var offsetEndIndex = offsetIndex + this.xlsDataItemPerPage;
      if (offsetIndex >= this.xlsDataRows.length) {
        offsetIndex = this.xlsDataRows.length - 1;
      }
      if (offsetEndIndex > this.xlsDataRows.length) {
        offsetEndIndex = this.xlsDataRows.length;
      }
      return this.xlsDataRowsSorted.slice(offsetIndex, offsetEndIndex);
    },
    xlsDataTotalPage: function xlsDataTotalPage() {
      return Math.ceil(this.xlsDataRows.length / this.xlsDataItemPerPage);
    },
    slipListDataPaged: function slipListDataPaged() {
      // apply pagination data
      /* let offsetIndex = (this.slipListDataCurrentPage - 1) * this.slipListDataItemPerPage;
      let offsetEndIndex = offsetIndex + this.slipListDataItemPerPage;
      if (offsetIndex >= this.slipListData.length) {
        offsetIndex = this.slipListData.length - 1;
      }
      if (offsetEndIndex > this.slipListData.length) {
        offsetEndIndex = this.slipListData.length;
      }
      return this.slipListDataSorted.slice(offsetIndex, offsetEndIndex); */
      return this.slipListDataSorted;
    },
    slipListTotalItem: function slipListTotalItem() {
      return this.$store.getters.billerSlipListTotalItem;
    },
    slipListDataTotalPage: function slipListDataTotalPage() {
      // return Math.ceil(this.slipListData.length / this.slipListDataItemPerPage);
      return Math.ceil(this.slipListTotalItem / this.slipListDataItemPerPage);
    },
    selectedSlips: function selectedSlips() {
      var _this3 = this;

      var slips = [];
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (page) {
        /* this.selectedSlipsPaged[page].forEach((slipId) => {
          slips.push(slipId);
        }); */
        _this3.selectedSlipsPaged[page].forEach(function (slip) {
          slips.push(slip.id);
        });
      });
      return slips;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'BillerProfileList' });
    },
    numFormat: function numFormat(num) {
      if (num === 0) return '-';
      return __WEBPACK_IMPORTED_MODULE_5_numeral___default()(num).format('0,0');
    },
    filterHandler: function filterHandler(value, row, column) {
      var property = column.property;
      return row[property] === value;
    },
    search: function search() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(_this4.searchForm));
        // transform payload
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
          if (payload[key] !== null) {
            if (payload[key].toString().trim() === '') {
              payload[key] = null;
            }
          }
        });
        // amount
        if (payload.amount__from) {
          _this4.unmaskValue(payload, 'amount__from', _this4.mask.amountMask);
          var amountFromValue = parseInt(payload.amount__from, 10);
          if (amountFromValue < 0) {
            payload.amount__from = null;
          }
        }
        if (payload.amount__to) {
          _this4.unmaskValue(payload, 'amount__to', _this4.mask.amountMask);
          var amountToValue = parseInt(payload.amount__to, 10);
          if (amountToValue < 0) {
            payload.amount__to = null;
          }
        }
        // is_printed
        if (payload.is_printed === 'พิมพ์แล้ว') {
          payload.is_printed = true;
        } else if (payload.is_printed === 'ยังไม่พิมพ์') {
          payload.is_printed = false;
        } else {
          payload.is_printed = null;
        }
        // is_sent
        if (payload.is_sent === 'ส่งแล้ว') {
          payload.is_sent = true;
        } else if (payload.is_sent === 'ยังไม่ส่ง') {
          payload.is_sent = false;
        } else {
          payload.is_sent = null;
        }
        var reqPayload = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
          profileId: _this4.profileId,
          payload: payload
        }));
        _this4.isSearching = true;
        _this4.$store.dispatch('GET_BILLER_SLIP_LIST', reqPayload).then(function () {
          _this4.isSearching = false;
          _this4.updatePagedSelection(_this4.slipListDataCurrentPage);
          resolve();
        }).catch(function (msg) {
          _this4.isSearching = false;
          if (msg) {
            _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t(msg));
          } else {
            _this4.$store.dispatch('ADD_ERROR_FLASH', _this4.$t('Unexpected error'));
          }
          reject();
        });
      });
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },

    /* amountFormatter(row, column, cellValue) {
      return numeral(cellValue).format('0,0.00');
    }, */
    accountNoFormatter: function accountNoFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.accountNo);
      }
      return '-';
    },
    accountNoAllFormatter: function accountNoAllFormatter(cellValue) {
      var billPayment = cellValue.bill_payment,
          qr = cellValue.qr;

      var output = [];
      if (billPayment) {
        output.push(billPayment);
      }
      if (qr) {
        output.push(qr);
      }
      if (output.length > 0) {
        return output.join('<br/>');
      }
      return '-';
    },
    amountFormatter: function amountFormatter(row, column, cellValue) {
      return this.maskFormatter(cellValue, this.mask.amountMask);
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_6_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },
    getFlagText: function getFlagText(value) {
      return value ? 'Yes' : 'No';
    },
    handleSelectAll: function handleSelectAll(selectionRows) {
      var _this5 = this;

      if (typeof this.selectedSlipsPaged['_' + this.slipListDataCurrentPage] === 'undefined') {
        this.$set(this.selectedSlipsPaged, '_' + this.slipListDataCurrentPage, []);
      }
      this.selectedSlipsPaged['_' + this.slipListDataCurrentPage].splice(0);
      selectionRows.forEach(function (item) {
        var slip = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));
        /* if (this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`]
        .indexOf(item.id) === -1) {
          this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(item.id);
        } */
        var isFound = false;
        _this5.selectedSlipsPaged['_' + _this5.slipListDataCurrentPage].forEach(function (selectedSlip) {
          if (selectedSlip.id === item.id) {
            isFound = true;
          }
        });
        if (!isFound) {
          _this5.selectedSlipsPaged['_' + _this5.slipListDataCurrentPage].push(slip);
        }
      });
    },
    handleSelectRow: function handleSelectRow(selectionRows) {
      var _this6 = this;

      if (typeof this.selectedSlipsPaged['_' + this.slipListDataCurrentPage] === 'undefined') {
        this.$set(this.selectedSlipsPaged, '_' + this.slipListDataCurrentPage, []);
      }
      this.selectedSlipsPaged['_' + this.slipListDataCurrentPage].splice(0);
      selectionRows.forEach(function (item) {
        var slip = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));
        /* if (this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`]
        .indexOf(item.id) === -1) {
          this.selectedSlipsPaged[`_${this.slipListDataCurrentPage}`].push(item.id);
        } */
        var isFound = false;
        _this6.selectedSlipsPaged['_' + _this6.slipListDataCurrentPage].forEach(function (selectedSlip) {
          if (selectedSlip.id === item.id) {
            isFound = true;
          }
        });
        if (!isFound) {
          _this6.selectedSlipsPaged['_' + _this6.slipListDataCurrentPage].push(slip);
        }
      });
    },
    addPayer: function addPayer() {
      this.$router.push({
        name: 'BillerSlipCreate',
        params: {
          profileId: this.profileId
        }
      });
    },
    editProfile: function editProfile() {
      this.$router.push({
        name: 'BillerProfileEdit',
        params: {
          profileId: this.profileId
        }
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({
        name: 'BillerSlipEdit',
        params: {
          profileId: this.profileId,
          slipId: row.id
        }
      });
    },
    requestSummary: function requestSummary() {
      var _this7 = this;

      // ----- BUILD HEADER -----
      var startDate = 0;
      var endDate = 0;
      var startDateText = '';
      var endDateText = '';

      var summaryList = [];
      /* this.selectedSlips.forEach((slipId) => {
        this.slipListData.forEach((slip) => {
          if (slip.id === slipId) {
            summaryList.push(slip);
          }
        });
      }); */
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
        _this7.selectedSlipsPaged[paged].forEach(function (slip) {
          summaryList.push(slip);
        });
      });

      var tableRows = [[{ text: 'No.', bold: true, alignment: 'center' }, { text: 'วันที่ชำระ', bold: true, alignment: 'center' }, { text: 'ชื่อลูกค้า', bold: true, alignment: 'center' }, { text: 'Ref.1', bold: true, alignment: 'center' }, { text: 'Ref.2', bold: true, alignment: 'center' }, { text: 'ยอดเงิน', bold: true, alignment: 'center' }, { text: 'พิมพ์?', bold: true, alignment: 'center' }, { text: 'อีเมล?', bold: true, alignment: 'center' }]];
      var itemCount = summaryList.length;
      var lineItemCount = 0;
      var amountSum = 0;
      summaryList.forEach(function (slip) {
        lineItemCount += 1;
        amountSum += slip.amount;
        var issuedDateText = '';
        var issuedOnDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(slip.issued_on).tz("Asia/Bangkok");
        if (issuedOnDate.isValid()) {
          issuedDateText = issuedOnDate.format('ll');
          if (startDate === 0 || Number(issuedOnDate.format('X') < startDate)) {
            startDate = Number(issuedOnDate.format('X'));
          }
          if (endDate === 0 || Number(issuedOnDate.format('X') > endDate)) {
            endDate = Number(issuedOnDate.format('X'));
          }
        }
        tableRows.push([{ text: lineItemCount, alignment: 'center' }, { text: issuedDateText, alignment: 'center' }, { text: slip.payer.name, alignment: 'left' }, { text: slip.ref1 || '-', alignment: 'center' }, { text: slip.ref2 || '-', alignment: 'center' }, { text: __WEBPACK_IMPORTED_MODULE_5_numeral___default()(slip.amount).format('0,0.00'), alignment: 'right' }, { text: slip.is_printed ? 'พิมพ์แล้ว' : 'ยังไม่พิมพ์', alignment: 'center' }, { text: slip.is_sent ? 'ส่งแล้ว' : 'ยังไม่ส่ง', alignment: 'center' }]);
      });
      // add summary row
      tableRows.push([{ text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14: ' + itemCount, bold: true, alignment: 'left', border: [false, false, false, false] }, { text: 'ยอดสุทธิ:', colSpan: 2, bold: true, alignment: 'right', border: [false, false, false, false] }, {}, { text: __WEBPACK_IMPORTED_MODULE_5_numeral___default()(amountSum).format('0,0.00'), bold: true, alignment: 'right', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }, { text: '', border: [false, false, false, false] }]);
      if (startDate !== 0) {
        var startDateObject = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(startDate, 'X').tz("Asia/Bangkok");
        startDateText = startDateObject.format('ll');
      }
      if (endDate !== 0) {
        var endDateObject = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(endDate, 'X').tz("Asia/Bangkok");
        endDateText = endDateObject.format('ll');
      }
      var summaryDate = '';
      if (startDate !== 0 && endDate !== 0) {
        summaryDate = '\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E04\u0E23\u0E1A\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E0A\u0E33\u0E23\u0E30 ' + startDateText + ' \u2014 ' + endDateText;
      }
      var printFlagText = this.searchForm.is_printed;
      var sentFlagText = this.searchForm.is_sent;

      summaryDate += ' (Print Flag: ' + printFlagText + ', Email Flag: ' + sentFlagText + ')';
      // -----------------------
      __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_12__libs_pdffonts__["a" /* default */];
      __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake___default.a.fonts = {
        ErgoCom: {
          normal: 'ErgoCom-Condensed.ttf',
          bold: 'ErgoCom-MediumCondensed.ttf'
        },
        pslxtext: {
          normal: 'pslxtext-webfont.ttf',
          bold: 'pslxtext_bold-webfont.ttf'
        }
      };
      var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        // pageMargins: [60, 40, 60, 40],
        pageMargins: [10, 10, 10, 10],
        footer: function footer(currentPage, pageCount) {
          return currentPage.toString() + ' \u0E08\u0E32\u0E01 ' + pageCount;
        },

        content: [{ text: 'รายงานสรุปยอด', fontSize: 18, bold: true, alignment: 'center' }, { text: summaryDate, fontSize: 14, alignment: 'center' }, { text: '    ', fontSize: 11, alignment: 'center' }, {
          columns: [{ width: '*', text: '' }, {
            width: 'auto',
            table: {
              headerRows: 1,
              widths: [25, 80, 140, 140, 140, 100, 60, 60],
              body: tableRows
            },
            fontSize: 11,
            alignment: 'center',
            layout: {
              fillColor: function fillColor(i) {
                return i % 2 === 0 ? '#efefef' : null;
              }
            }
          }, { width: '*', text: '' }]
        }],
        defaultStyle: {
          font: 'pslxtext'
        }
      };

      var vm = this;
      __WEBPACK_IMPORTED_MODULE_11_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).getDataUrl(function (dataURL) {
        // check if this is IE or not
        if (window.navigator.msSaveOrOpenBlob) {
          // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
          // create blob from data URL
          var byteString = atob(dataURL.split(',')[1]);
          // write the bytes of the string to an ArrayBuffer
          var ab = new ArrayBuffer(byteString.length);
          // create a view into the buffer
          var ia = new Uint8Array(ab);
          // set the bytes of the buffer to the correct values
          for (var i = 0; i < byteString.length; i += 1) {
            ia[i] = byteString.charCodeAt(i);
          }
          var blob = new Blob([ia], {
            type: 'application/pdf'
          });
          var companyId = _this7.$store.getters.tenantId;
          var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok");
          var nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
          var pdfFilename = 'bppayin-slip-' + companyId + '-' + nowText + '.pdf';
          window.navigator.msSaveBlob(blob, pdfFilename);
        } else {
          vm.summaryPDFDataURL = dataURL;
          vm.isSummaryResultDialogShown = true;
        }
      });
    },
    requestDelete: function requestDelete() {
      this.summaryDialogMode = 'delete';
      this.summaryDialogRequest = 'delete';
      this.summaryDialogTitle = 'รายการที่ต้องการลบ';
      this.isSummaryDialogShown = true;
    },
    requestExport: function requestExport(fileFormat) {
      this.summaryDialogMode = 'export';
      this.summaryDialogRequest = 'export';
      this.summaryDialogTitle = 'รายการที่ต้องการส่งออก';
      this.isSummaryDialogShown = true;
      this.exportFileFormat = fileFormat;
    },
    handleExportCommand: function handleExportCommand(command) {
      this.requestExport(command);
    },
    handlePrintCommand: function handlePrintCommand(command) {
      this.summaryDialogMode = 'print';
      this.summaryDialogRequest = command;
      var payloadText = command === 'pay-in' ? 'Pay-in slip(s)' : 'รูปภาพ QR Code';
      this.summaryDialogTitle = '\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E1E\u0E34\u0E21\u0E1E\u0E4C ' + payloadText;
      this.isSummaryDialogShown = true;
    },
    handleEmailCommand: function handleEmailCommand(command) {
      this.summaryDialogMode = 'email';
      this.summaryDialogRequest = command;
      var payloadText = command === 'pay-in' ? 'Pay-in slip(s)' : 'รูปภาพ QR Code';
      this.summaryDialogTitle = '\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07 ' + payloadText + ' \u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25';
      this.isSummaryDialogShown = true;
      // this.$message(`[Not Implemented] Requesting emailing ${command}`);
    },
    cancelSummaryDialog: function cancelSummaryDialog() {
      this.summaryDialogMode = '';
      this.summaryDialogRequest = '';
      this.summaryDialogTitle = '';
      this.isSummaryDialogShown = false;
    },
    confirmSummaryDialog: function confirmSummaryDialog() {
      // check mode (print or email)
      var mode = this.summaryDialogMode;
      var requestAsset = this.summaryDialogRequest;
      var isValid = false;
      if (mode === 'print') {
        if (requestAsset === 'pay-in') {
          isValid = true;
          this.requestPrintPayinSlip();
        } else if (requestAsset === 'qr') {
          isValid = true;
          // this.$message(`[Not Implemented] Requesting emailing ${requestAsset}`);
          this.requestPrintQR();
        }
      } else if (mode === 'email') {
        if (requestAsset === 'pay-in') {
          isValid = true;
          this.requestEmailPayinSlip();
        } else if (requestAsset === 'qr') {
          isValid = true;
          // this.$message(`[Not Implemented] Requesting emailing ${requestAsset}`);
          this.requestEmailPayinQR();
        }
      } else if (mode === 'delete' && requestAsset === 'delete') {
        isValid = true;
        this.requestDeletePayinSlip();
      } else if (mode === 'export' && requestAsset === 'export') {
        isValid = true;
        this.requestExportPayinSlip(this.exportFileFormat);
      }
      if (!isValid) {
        this.$message('Invalid request');
      }
      // clear state
      this.summaryDialogMode = '';
      this.summaryDialogRequest = '';
      this.summaryDialogTitle = '';
      this.isSummaryDialogShown = false;
    },
    forceDownloadPDF: function forceDownloadPDF(pdfDataURL) {
      this.pdfContent = pdfDataURL;
      var companyId = this.$store.getters.tenantId;
      var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok");
      var nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
      this.pdfFilename = 'bppayin-slip-' + companyId + '-' + nowText + '.pdf';
      this.$nextTick(function () {
        var link = document.getElementById('slip-pdf-content');
        link.click();
      });
    },
    saveFile: function saveFile(blob, type, extension /* , contentType */) {
      var companyId = this.$store.getters.tenantId;
      var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok");
      var nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');
      this.pdfFilename = 'bppayin-' + type + '-' + companyId + '-' + nowText + '.' + extension;
      // check if this is IE or not
      try {
        if (window.navigator.msSaveOrOpenBlob) {
          // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
          window.navigator.msSaveBlob(blob, this.pdfFilename);
        } else {
          // const file = new File([blob], this.pdfFilename, { type: contentType });
          // FileSaver.saveAs(file);
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(blob, this.pdfFilename);
        }
      } catch (err) {
        __WEBPACK_IMPORTED_MODULE_14_raven_js___default.a.captureException(err, {
          extra: {
            err_payload: JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(err))
          }
        });
      }
    },
    requestPrintPayinSlip: function requestPrintPayinSlip() {
      var _this8 = this;

      this.isPrinting = true;
      var isGeneratePDF = true;
      if (this.selectedSlips.length >= 30) {
        isGeneratePDF = false;
      }
      this.$store.dispatch('PRINT_PAYER_SLIP', {
        profileId: this.profileId,
        slips: this.selectedSlips
      }).then(function (res) {
        _this8.isPrinting = false;
        if (isGeneratePDF) {
          var pdfContent = res;
          var pdfBlob = new Blob([pdfContent], {
            type: 'application/pdf'
          });
          _this8.saveFile(pdfBlob, 'slip', 'pdf', 'application/pdf');
        } else {
          // show message box instead
          var adminEmail = '';
          if (_this8.myAdminInfo && _this8.myAdminInfo.email) {
            adminEmail = _this8.myAdminInfo.email;
          }
          var msg = '\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E31\u0E48\u0E07\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E43\u0E1A Pay-In \u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 30 \u0E43\u0E1A \u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E44\u0E1F\u0E25\u0E4C\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25 ' + adminEmail;
          _this8.$alert(msg, 'ส่งคำสั่งการสั่งพิมพ์เรียบร้อยแล้ว', {
            confirmButtonText: 'OK'
          }).then(function () {}).catch(function () {});
        }
        _this8.search();
      }).catch(function (msg) {
        var errMsg = msg;
        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          errMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(msg);
        }
        _this8.isPrinting = false;
        _this8.pdfContent = null;
        _this8.pdfFilename = '';
        if (errMsg) {
          _this8.$store.dispatch('ADD_ERROR_FLASH', _this8.$t(errMsg));
        } else {
          _this8.$store.dispatch('ADD_ERROR_FLASH', _this8.$t('Unexpected error'));
        }
      });
    },
    requestDeletePayinSlip: function requestDeletePayinSlip() {
      var _this9 = this;

      this.isDeleting = true;
      this.$store.dispatch('DELETE_PAYER_SLIP', {
        profileId: this.profileId,
        slips: this.selectedSlips
      }).then(function () {
        _this9.isDeleting = false;
        // this.selectedSlips.splice(0);
        _this9.selectedSlipsPaged = {};
        _this9.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: 'ลบรายการผู้ชำระสำเร็จแล้ว'
        });
        // reload data
        _this9.search();
      }).catch(function (msg) {
        _this9.isDeleting = false;
        var errMsg = msg;
        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          errMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(msg);
        }
        if (errMsg) {
          _this9.$store.dispatch('ADD_ERROR_FLASH', _this9.$t(errMsg));
        } else {
          _this9.$store.dispatch('ADD_ERROR_FLASH', _this9.$t('Unexpected error'));
        }
      });
    },
    requestPrintQR: function requestPrintQR() {
      var _this10 = this;

      this.isPrinting = true;
      var vm = this;
      var isDownloadable = true;
      if (this.selectedSlips.length > 50) {
        isDownloadable = false;
      }
      this.$store.dispatch('PRINT_PAYER_QR', {
        profileId: this.profileId,
        slips: this.selectedSlips
      }).then(function (resContent) {
        _this10.isPrinting = false;
        if (isDownloadable) {
          var extension = vm.selectedSlips.length > 1 ? 'zip' : 'png';
          var contentType = vm.selectedSlips.length > 1 ? 'application/octet-stream' : 'image/png';
          var contentBlob = new Blob([resContent], {
            type: contentType
          });
          _this10.saveFile(contentBlob, 'QR', extension, contentType);
        } else {
          // show message box instead
          var adminEmail = '';
          if (_this10.myAdminInfo && _this10.myAdminInfo.email) {
            adminEmail = _this10.myAdminInfo.email;
          }
          var msg = '\u0E40\u0E19\u0E37\u0E48\u0E2D\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E31\u0E48\u0E07\u0E1E\u0E34\u0E21\u0E1E\u0E4C QR \u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 50 \u0E43\u0E1A \u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E44\u0E1F\u0E25\u0E4C\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E32\u0E07\u0E2D\u0E35\u0E40\u0E21\u0E25 ' + adminEmail;
          _this10.$alert(msg, 'ส่งคำสั่งการสั่งพิมพ์เรียบร้อยแล้ว', {
            confirmButtonText: 'OK'
          }).then(function () {}).catch(function () {});
        }
        _this10.search();
      }).catch(function (msg) {
        var errMsg = msg;
        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          errMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(msg);
        }
        _this10.isPrinting = false;
        _this10.pdfContent = null;
        _this10.pdfFilename = '';
        if (errMsg) {
          _this10.$store.dispatch('ADD_ERROR_FLASH', _this10.$t(errMsg));
        } else {
          _this10.$store.dispatch('ADD_ERROR_FLASH', _this10.$t('Unexpected error'));
        }
      });
    },
    makeXlSCol: function makeXlSCol(refstr) {
      var o = [];
      var range = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.decode_range(refstr);
      for (var i = 0; i <= range.e.c; i += 1) {
        o.push({ name: __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.encode_col(i), key: i });
      }
      return o;
    },

    /* requestExportPayinSlip(fileFormat) {
      if (fileFormat === 'csv') {
        this.requestExportPayinSlipCSV();
      } else {
        this.requestExportPayinSlipExcel();
      }
    },
    requestExportPayinSlipCSV() {
      // this.isExporting = true;
      console.log('export csv');
    }, */
    requestExportPayinSlip: function requestExportPayinSlip(fileFormat) {
      var _this11 = this;

      var isCSV = fileFormat === 'csv';
      this.isExporting = true;
      // prepare data for exporting
      var fieldLabels = this.xlsExportHeaderKey;
      var excludeFields = ['profile_id', 'company_id', 'created_at', 'updated_at', 'emailed_at', 'is_printed', 'is_sent', 'printed_at'];
      var jsonData = [];
      var slipSelectedData = [];

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
        _this11.selectedSlipsPaged[paged].forEach(function (slip) {
          slipSelectedData.push(slip);
        });
      });
      // this.slipListData.forEach((item) => {
      slipSelectedData.forEach(function (item) {
        var rowData = {};
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item).forEach(function (attr) {
          if (excludeFields.indexOf(attr) === -1) {
            var label = fieldLabels[attr];
            var val = item[attr];
            if (label || attr === 'payer') {
              if (attr === 'issued_on') {
                var issuedOnDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(val).tz("Asia/Bangkok");
                if (issuedOnDate.isValid()) {
                  val = issuedOnDate.format('D/M/YY');
                }
              }
              if (attr === 'payer') {
                rowData[fieldLabels['payer.name']] = val.name;
                rowData[fieldLabels['payer.email']] = val.email;
                return;
              }
              if (attr === 'notification_msg') {
                if (val === null) {
                  val = 'DEFAULT';
                }
              }
              rowData[label] = val;
            }
          }
        });
        // SORT data for keys
        var xlsRowData = [];
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this11.xlsTemplateHeadersKey).forEach(function (xlsKey) {
          var val = rowData[xlsKey];
          if (typeof val === 'undefined') {
            val = '';
          }
          xlsRowData.push(val);
        });
        jsonData.push(xlsRowData);
      });
      // Convert back to XLSX
      // add header
      var xlsxData = [];
      xlsxData.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.xlsTemplateHeadersKey));
      // merge array
      xlsxData = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.concat(xlsxData, jsonData);

      var companyId = this.$store.getters.tenantId;
      var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok");
      var nowText = now.format('YYYY-MM-DD[T]hh:mm:ss');

      if (isCSV) {
        console.log('export CSV', xlsxData);
        /* let csvContent = '';
        xlsxData.forEach((rowData) => {
          csvContent += `"${rowData.join('","')}"\n`;
        }); */
        var csvContent = __WEBPACK_IMPORTED_MODULE_15_papaparse___default.a.unparse(xlsxData, {
          quotes: true
        });
        try {
          var csvFilename = 'bppayin-slip-' + companyId + '-' + nowText + '.csv';
          var blob = new Blob([csvContent], {
            type: 'application/octet-stream'
          });
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(blob, csvFilename);
        } catch (e) {
          this.$store.dispatch('ADD_ERROR_FLASH', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(e));
        }
      } else {
        // create new workbook
        var worksheet = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.aoa_to_sheet(xlsxData);
        var dataWorkbook = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.book_new();
        __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.book_append_sheet(dataWorkbook, worksheet, 'SLIPS');
        try {
          var xlsFilename = 'bppayin-slip-' + companyId + '-' + nowText + '.xlsx';
          var wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
          var wbout = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.write(dataWorkbook, wopts);
          var _blob = new Blob([wbout], {
            type: 'application/octet-stream'
          });
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(_blob, xlsFilename);
        } catch (e) {
          this.$store.dispatch('ADD_ERROR_FLASH', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(e));
        }
      }
      this.isExporting = false;
    },
    requestEmailPayinSlip: function requestEmailPayinSlip() {
      var _this12 = this;

      this.isEmailing = true;
      var emailSlipList = [];
      /* this.selectedSlips.forEach((slipId) => {
        this.slipListData.forEach((slip) => {
          if (slip.id === slipId && slip.payer.email.trim() !== '') {
            emailSlipList.push(slipId);
          }
        });
      }); */
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
        _this12.selectedSlipsPaged[paged].forEach(function (slip) {
          if (slip.payer.email && slip.payer.email.trim() !== '') {
            emailSlipList.push(slip.id);
          }
        });
      });
      this.$store.dispatch('EMAIL_PAYER_SLIP', {
        profileId: this.profileId,
        slips: emailSlipList
      }).then(function () {
        _this12.isEmailing = false;
        _this12.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: 'ส่งคำร้องเพื่อส่งอีเมลรายการผู้ชำระสำเร็จแล้ว'
        });
        // reload data
        _this12.search();
      }).catch(function (msg) {
        _this12.isEmailing = false;
        var errMsg = msg;
        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          errMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(msg);
        }
        if (errMsg) {
          _this12.$store.dispatch('ADD_ERROR_FLASH', _this12.$t(errMsg));
        } else {
          _this12.$store.dispatch('ADD_ERROR_FLASH', _this12.$t('Unexpected error'));
        }
      });
    },
    requestEmailPayinQR: function requestEmailPayinQR() {
      var _this13 = this;

      this.isEmailing = true;
      var emailSlipList = [];
      /* this.selectedSlips.forEach((slipId) => {
        this.slipListData.forEach((slip) => {
          if (slip.id === slipId && slip.payer.email.trim() !== '') {
            emailSlipList.push(slipId);
          }
        });
      }); */
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.selectedSlipsPaged).forEach(function (paged) {
        _this13.selectedSlipsPaged[paged].forEach(function (slip) {
          if (slip.payer.email && slip.payer.email.trim() !== '') {
            emailSlipList.push(slip.id);
          }
        });
      });
      this.$store.dispatch('EMAIL_PAYER_QR', {
        profileId: this.profileId,
        slips: emailSlipList
      }).then(function () {
        _this13.isEmailing = false;
        _this13.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: 'ส่งคำร้องเพื่อส่งอีเมลรายการ QR code ของผู้ชำระสำเร็จแล้ว'
        });
        // reload data
        _this13.search();
      }).catch(function (msg) {
        _this13.isEmailing = false;
        var errMsg = msg;
        if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
          errMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(msg);
        }
        if (errMsg) {
          _this13.$store.dispatch('ADD_ERROR_FLASH', _this13.$t(errMsg));
        } else {
          _this13.$store.dispatch('ADD_ERROR_FLASH', _this13.$t('Unexpected error'));
        }
      });
    },
    sumImportSlips: function sumImportSlips(param) {
      var _this14 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
          // sums[index] = 'ยอดสุทธิ';
          sums[index] = '';
          return;
        }
        if (['rowNumber', 'ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
          sums[index] = '';
          return;
        }
        if (column.type === 'index') {
          sums[index] = _this14.xlsDataRowsSorted.length;
          return;
        }
        var values = _this14.xlsDataRowsSorted.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          var colValue = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0));
          sums[index] = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(colValue).format('0,0.00');
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    sumPagedSlips: function sumPagedSlips(param) {
      var _this15 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
          // sums[index] = 'ยอดสุทธิ';
          sums[index] = '';
          return;
        }
        if (['rowNumber', 'ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
          sums[index] = '';
          return;
        }
        if (column.type === 'index') {
          sums[index] = _this15.slipListDataSorted.length;
          return;
        }
        var values = _this15.slipListDataSorted.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          var colValue = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0));
          sums[index] = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(colValue).format('0,0.00');
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    sumSlips: function sumSlips(param) {
      var columns = param.columns,
          data = param.data;

      var sums = [];
      columns.forEach(function (column, index) {
        if (['selection', 'blank'].indexOf(column.type) !== -1 || column.label === 'ตัวเลือก') {
          // sums[index] = 'ยอดสุทธิ';
          sums[index] = '';
          return;
        }
        if (['ref1', 'ref2', 'is_printed', 'is_sent', 'id', 'payer.name', 'payer.email', 'notification_msg', 'remark'].indexOf(column.property) !== -1) {
          sums[index] = '';
          return;
        }
        if (column.type === 'index') {
          sums[index] = data.length;
          return;
        }
        var values = data.map(function (item) {
          return Number(item[column.property]);
        });
        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          var colValue = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(values.reduce(function (prev, curr) {
            var value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0));
          sums[index] = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(colValue).format('0,0.00');
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },

    // IMPORT XLSX
    handleImportSlipsCommand: function handleImportSlipsCommand(command) {
      if (command === 'import' || command === 'import-csv') {
        this.isImportDialogShown = true;
        this.importFileFormat = command === 'import' ? 'xlsx' : 'csv';
      }
    },
    handleBeforeXLSUpload: function handleBeforeXLSUpload(file) {
      var isValid = true;
      var isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      var isCSV = file.type === 'text/csv' || file.name.split('.').pop() === 'csv';
      // check file type
      if (!isXLSX && !isCSV) {
        this.$message.error('กรุณานำเข้าด้วยไฟล์ XLSX หรือ CSV เท่านั้น!');
        isValid = false;
      }
      // check format
      if (isValid) {
        this.xlsUpdateFile = file;
      }
      return true;
    },
    handleXLSImport: function handleXLSImport() {
      var _this16 = this;

      if (this.xlsUpdateFile) {
        var vm = this;
        vm.isImporting = true;
        vm.xlsDataRows.splice(0);
        vm.xlsSkipRows.splice(0);
        vm.xlsErrorRows.splice(0);
        var xlsxReader = new FileReader();
        xlsxReader.addEventListener('load', function () {
          var xlsxData = [];
          if (_this16.importFileFormat === 'xlsx') {
            var dataURL = xlsxReader.result;
            var pos = dataURL.indexOf('base64,');
            if (pos !== -1) {
              var dataIndicator = dataURL.substring(0, pos + 7);
              dataURL = dataURL.replace(dataIndicator, '');
              var wb = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.read(dataURL, { type: 'base64', cellDates: true, cellNF: false, cellText: false });
              var ws = wb.Sheets[wb.SheetNames[0]];
              // iterate all cell
              // check for date type cell, then adjust format
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(ws).forEach(function (cellAddress) {
                var cell = ws[cellAddress];
                if (cell.t === 'd') {
                  var cellDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(cell.v).tz("Asia/Bangkok");
                  if (cellDate.isValid()) {
                    cell.w = cellDate.format('D/M/YY');
                  }
                }
              });
              xlsxData = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.sheet_to_json(ws, { header: 1 });
            }
          } else if (_this16.importFileFormat === 'csv') {
            var csvContent = xlsxReader.result;
            var csvResults = __WEBPACK_IMPORTED_MODULE_15_papaparse___default.a.parse(csvContent);
            if (csvResults.data.length > 0) {
              xlsxData = csvResults.data;
            }
          }
          if (xlsxData.length > 0) {
            var _loop = function _loop(rowNumber) {
              // xlsxData.forEach((row, rowNumber) => {
              var row = xlsxData[rowNumber];
              // skip row 1, it is header
              if (rowNumber > 0) {
                // check if row has 8 column or not.
                // If yes, just add 1 more as `remark` column is not read from file
                if (row.length <= 8) {
                  var colCount = 9 - row.length;
                  for (var cc = 0; cc < colCount; cc += 1) {
                    row.push('');
                  }
                }
                var blankCount = 0;
                var mustSkip = false;
                // check blank row
                for (var sr = 0; sr < row.length; sr += 1) {
                  if (typeof row[sr] !== 'undefined' && row[sr].toString().trim() === '') {
                    blankCount += 1;
                  }
                }
                if (blankCount >= row.length) {
                  mustSkip = true;
                }
                if (!mustSkip) {
                  var shouldSkip = false;
                  var keyCount = 0;
                  var rowData = {};
                  var templateHeaderCount = vm.xlsTemplateHeaders.length;
                  vm.xlsTemplateHeaders.forEach(function (header, headerIndex) {
                    for (var c = 0; c < row.length; c += 1) {
                      var cellValue = row[c] || '';
                      var cellIndex = c;
                      if (cellIndex === headerIndex) {
                        var isValid = true;
                        var attr = vm.xlsTemplateHeadersKey[header];
                        var val = cellValue;
                        // console.log(header, ' => ', attr, ' = ', val);
                        // transform & check validity
                        if (['rowNumber', 'id'].indexOf(attr) !== -1) {
                          if (isNaN(parseInt(val, 10))) {
                            isValid = false;
                            if (attr === 'id' && val.toString().trim() === '') {
                              isValid = true;
                            }
                          }
                        }
                        if (attr === 'amount') {
                          if (isNaN(parseInt(val, 10))) {
                            isValid = false;
                          } else {
                            // round 2 digit
                            var valNumeral = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(val);
                            val = __WEBPACK_IMPORTED_MODULE_5_numeral___default()(val).format('0.00');
                            if (valNumeral.value() > 99999999.99) {
                              isValid = false;
                            }
                          }
                        }
                        if (['payer.name', 'ref1'].indexOf(attr) !== -1) {
                          if (val.toString().trim() === '') {
                            isValid = false;
                          }
                          if (attr === 'payer.name') {
                            // max length 40 chars
                            val = val.substr(0, 40);
                          }
                        }
                        if (attr === 'payer.email') {
                          // check email format
                          if (val && val.toString().trim() !== '') {
                            var emailRegEx = new __WEBPACK_IMPORTED_MODULE_13_xregexp___default.a('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$', 'g');
                            isValid = emailRegEx.test(val);
                          }
                        }
                        if (['ref1', 'ref2'].indexOf(attr) !== -1) {
                          // max length 20 chars
                          val = val.substr(0, 20);

                          if (attr === 'ref1' && val && val.toString().trim() === '') {
                            isValid = false;
                          } else if (val && val.toString().trim() !== '') {
                            // validate format
                            var refRegEx = new __WEBPACK_IMPORTED_MODULE_13_xregexp___default.a('^[0-9A-Z]{0,20}$', 'g');
                            isValid = refRegEx.test(val);
                          }
                        }
                        if (['notification_msg', 'remark'].indexOf(attr) !== -1) {
                          // max length 100 chars
                          val = val.substr(0, 100);
                        }
                        if (attr === 'issued_on') {
                          var issuedOnDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(val, 'D/M/YY').tz("Asia/Bangkok");
                          if (issuedOnDate.isValid()) {
                            val = issuedOnDate.format('YYYY-MM-DD');
                          } else {
                            isValid = false;
                          }
                        }
                        if (isValid) {
                          keyCount += 1;
                          if (typeof val !== 'undefined' && val !== null) {
                            rowData[attr] = val.toString().trim();
                          } else {
                            rowData[attr] = val;
                          }
                        } else {
                          shouldSkip = true;
                        }
                      }
                    }
                  });
                  // console.log('shouldSkip', shouldSkip, rowData);
                  if (keyCount === templateHeaderCount) {
                    // transform rowData for display
                    var tableRowData = {};
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rowData).forEach(function (key) {
                      var val = rowData[key];
                      if (['id', 'amount'].indexOf(key) !== -1) {
                        // convert to number
                        if (val.toString().trim() !== '') {
                          val = Number(val);
                        } else if (key === 'id') {
                          // id is not presented, set it to null.
                          // otherwise, API will complain for Number type
                          val = null;
                        }
                      }
                      if (key.indexOf('payer') !== -1) {
                        if (typeof tableRowData.payer === 'undefined') {
                          tableRowData.payer = {
                            name: '',
                            email: ''
                          };
                        }
                        tableRowData.payer[key.replace('payer.', '')] = val;
                      } else if (key === 'notification_msg') {
                        if (val === 'DEFAULT') {
                          if (_this16.profile) {
                            tableRowData[key] = _this16.profile.notification_msg;
                          }
                        } else {
                          tableRowData[key] = val;
                        }
                      } else {
                        tableRowData[key] = val;
                      }
                    });
                    // add rowNumber
                    tableRowData.rowNumber = vm.xlsDataRows.length + 1;
                    vm.xlsDataRows.push(tableRowData);
                  }
                  if (shouldSkip) {
                    vm.xlsSkipRows.push(row);
                  }
                }
              }
            };

            for (var rowNumber = 0; rowNumber < xlsxData.length; rowNumber += 1) {
              _loop(rowNumber);
            }
            // });
            if (vm.xlsDataRows.length === 0 && vm.xlsSkipRows.length === 0) {
              vm.$store.dispatch('ADD_ERROR_FLASH', 'กรุณานำเข้าไฟล์ XLSX ที่มีข้อมูลสำหรับนำเข้า');
            }
            if (vm.xlsDataRows.length > 0) {
              vm.xlsDataRowsSorted = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(vm.xlsDataRows));
            }
          } else {
            vm.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ XLSX ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
          }
          vm.isImporting = false;
        }, false);
        try {
          if (this.importFileFormat === 'xlsx') {
            xlsxReader.readAsDataURL(this.xlsUpdateFile);
          } else {
            xlsxReader.readAsText(this.xlsUpdateFile);
          }
        } catch (e) {
          console.error(e);
          this.$store.dispatch('ADD_ERROR_FLASH', 'ไม่สามารถอ่านข้อมูลไฟล์ XLSX ที่ต้องการได้ กรุณาเลือกไฟล์ใหม่อีกครั้ง');
          vm.isImporting = false;
        }
      }
    },
    cancelImportDialog: function cancelImportDialog() {
      this.isImporting = false;
      this.isImportDialogShown = false;
      this.xlsUpdateFile = null;
      this.xlsDataRows.splice(0);
      this.xlsErrorRows.splice(0);
      this.xlsSkipRows.splice(0);
    },
    confirmImportDialog: function confirmImportDialog() {
      var _this17 = this;

      this.isImporting = true;
      var reqPayload = {
        profileId: this.profileId,
        payload: this.xlsDataRows
      };
      this.$store.dispatch('IMPORT_BILLER_SLIPS', reqPayload).then(function () {
        _this17.isImporting = false;
        _this17.isImportDialogShown = false;
        _this17.xlsUpdateFile = null;
        _this17.xlsDataRows.splice(0);
        _this17.xlsErrorRows.splice(0);
        _this17.xlsSkipRows.splice(0);
        _this17.search();
      }).catch(function (msg) {
        _this17.isImporting = false;
        if (msg) {
          _this17.$store.dispatch('ADD_ERROR_FLASH', _this17.$t(msg));
        } else {
          _this17.$store.dispatch('ADD_ERROR_FLASH', _this17.$t('Unexpected error'));
        }
      });
    },
    downloadXLSTemplate: function downloadXLSTemplate() {
      // create new workbook
      var xlsxData = [];
      xlsxData.push(this.xlsTemplateHeaders);
      if (this.importFileFormat === 'xlsx') {
        var worksheet = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.aoa_to_sheet(xlsxData);
        var dataWorkbook = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.book_new();
        __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.utils.book_append_sheet(dataWorkbook, worksheet, 'SLIPS');
        var wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
        var wbout = __WEBPACK_IMPORTED_MODULE_10_xlsx___default.a.write(dataWorkbook, wopts);

        try {
          var xlsFilename = 'bppayin-slip-import-template.xlsx';
          var blob = new Blob([wbout], {
            type: 'application/octet-stream'
          });
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(blob, xlsFilename);
        } catch (e) {
          this.$store.dispatch('ADD_ERROR_FLASH', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(e));
        }
      } else {
        /* let csvContent = '';
        xlsxData.forEach((rowData) => {
          csvContent += `"${rowData.join('","')}"\n`;
        }); */
        var csvContent = __WEBPACK_IMPORTED_MODULE_15_papaparse___default.a.unparse(xlsxData, {
          quotes: true
        });
        try {
          var csvFilename = 'bppayin-slip-import-template.csv';
          var _blob2 = new Blob([csvContent], {
            type: 'application/octet-stream'
          });
          __WEBPACK_IMPORTED_MODULE_9_file_saver___default.a.saveAs(_blob2, csvFilename);
        } catch (e) {
          this.$store.dispatch('ADD_ERROR_FLASH', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(e));
        }
      }
    },

    // -- END IMPORT XLSX
    closeSummaryResultDialog: function closeSummaryResultDialog() {
      this.isSummaryResultDialogShown = false;
      this.summaryPDFDataURL = null;
    },
    searchOptionCollapseChange: function searchOptionCollapseChange() {
      this.$store.dispatch('TOGGLE_BILLER_SLIP_SEARCH_OPTION');
    },
    submitForm: function submitForm() {
      // clear selected slips
      // this.selectedSlips.splice(0);
      this.selectedSlipsPaged = {};
      this.search();
    },
    resetForm: function resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.amount__from = null;
      this.searchForm.amount__to = null;
      this.searchForm.issued_on__from = null;
      this.searchForm.issued_on__to = null;
      this.searchForm.payee__name = null;
      this.searchForm.ref1 = null;
      this.searchForm.ref2 = null;
      this.searchForm.is_printed = 'ทั้งหมด';
      this.searchForm.limit = defaultLimit;
      this.searchForm.offset = defaultOffset;
      this.searchForm.id__in = null;
      this.searchForm.is_sent = 'ทั้งหมด';
      this.searchForm.order_by = 'issued_on';
      this.searchForm.order_dir = 'desc';
      this.search();
    },
    updateMaskAmount: function updateMaskAmount(field) {
      this.maskValue(this.searchForm, field, this.mask.amountMask);
    },
    updateMaskRefCode: function updateMaskRefCode() {
      if (this.searchForm.ref1) {
        this.searchForm.ref1 = this.searchForm.ref1.toUpperCase();
        this.maskValue(this.searchForm, 'ref1', this.mask.refCode);
      }
      if (this.searchForm.ref2) {
        this.searchForm.ref2 = this.searchForm.ref2.toUpperCase();
        this.maskValue(this.searchForm, 'ref2', this.mask.refCode);
      }
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_6_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_6_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      var _this18 = this;

      if (['searchForm.ref1', 'searchForm.ref2'].indexOf(refName) !== -1) {
        if (this.searchForm.ref1) {
          this.searchForm.ref1 = this.searchForm.ref1.toUpperCase();
        }
        if (this.searchForm.ref2) {
          this.searchForm.ref2 = this.searchForm.ref2.toUpperCase();
        }
      }
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_7__libs_helpers__["a" /* default */].handleInput(evt, _this18.$refs, refName, _this18.mask, maskName);
      });
    }, 300, { tailing: true }),
    // pagination stuffs
    updateImportDataRows: function updateImportDataRows() {
      // console.log(page);
    },
    updateSlipListDataRows: function updateSlipListDataRows(page) {
      var _this19 = this;

      if (!this.isChangingPage) {
        this.isChangingPage = true;
        // get new data from the latest page
        var offsetIndex = (page - 1) * this.slipListDataItemPerPage;
        if (offsetIndex >= this.slipListTotalItem) {
          offsetIndex = this.slipListTotalItem - 1;
        }
        this.searchForm.offset = offsetIndex;
        this.search().then(function () {
          _this19.isChangingPage = false;
        });
      }
    },
    updatePagedSelection: function updatePagedSelection(page) {
      var _this20 = this;

      // update selection
      var currentSelectedSlipListPageData = null;
      if (typeof this.selectedSlipsPaged['_' + page] !== 'undefined') {
        var slipList = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.selectedSlipsPaged['_' + page]));
        currentSelectedSlipListPageData = slipList.map(function (slip) {
          return slip.id;
        });
      }
      if (currentSelectedSlipListPageData) {
        this.slipListDataPaged.forEach(function (row) {
          _this20.$refs.slipListTable.toggleRowSelection(row, currentSelectedSlipListPageData.indexOf(row.id) !== -1);
        });
      }
    },
    dynamicSort: function dynamicSort(prop, type) {
      var sortOrder = 1;
      if (prop[0] === '-') {
        sortOrder = -1;
        prop = prop.substr(1);
      }
      return function (a, b, cb) {
        // const result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
        var result = 0;
        var aValue = a[prop];
        var bValue = b[prop];
        if (type === 'date') {
          var aDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(aValue).tz("Asia/Bangkok");
          if (aDate.isValid()) {
            aValue = Number(aDate.format('X'));
          }
          var bDate = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(bValue).tz("Asia/Bangkok");
          if (bDate.isValid()) {
            bValue = Number(bDate.format('X'));
          }
        } else if (type === 'number') {
          aValue = Number(aValue);
          bValue = Number(bValue);
        }
        if (aValue < bValue) {
          result = -1;
        } else if (aValue > bValue) {
          result = 1;
        }
        return cb(null, result * sortOrder);
      };
    },
    importTableSorted: function importTableSorted(_ref) {
      var prop = _ref.prop,
          order = _ref.order;

      if (prop && order) {
        /* this.isSortingImport = true;
        let type = 'string';
        let sortProp = prop;
        if (order === 'descending') {
          sortProp = `-${sortProp}`;
        }
        if (prop === 'issued_on') {
          // sort by date
          type = 'date';
        } else if (['amount', 'id'].indexOf(prop) !== -1) {
          // sort by number
          type = 'number';
        }
        asyncMergeSort(this.xlsDataRows,
          this.dynamicSort(sortProp, type),
          (err, sorted) => {
            this.isSortingImport = false;
            if (!err) {
              this.xlsDataRowsSorted = sorted;
            }
          }); */
        this.searchForm.order_by = prop;
        this.searchForm.order_dir = order === 'descending' ? 'desc' : 'asc';
      } else {
        // reset sorting
        // this.xlsDataRowsSorted = JSON.parse(JSON.stringify(this.xlsDataRows));
        this.searchForm.order_by = 'issued_on';
        this.searchForm.order_dir = 'desc';
      }
      // clear selection
      // this.selectedSlips.splice(0);
      this.selectedSlipsPaged = {};
      this.search();
      // force hide loading after 5 seconds
      /* setTimeout(() => {
        if (this.isSortingImport) {
          this.isSortingImport = false;
        }
      }, 5000); */
    },
    dataTableSorted: function dataTableSorted(_ref2) {
      var prop = _ref2.prop,
          order = _ref2.order;

      if (prop && order) {
        this.searchForm.order_by = prop;
        this.searchForm.order_dir = order === 'descending' ? 'desc' : 'asc';
      } else {
        // reset sorting
        this.searchForm.order_by = 'issued_on';
        this.searchForm.order_dir = 'desc';
      }
      this.selectedSlipsPaged = {};
      this.search();
    },
    clearSelection: function clearSelection() {
      this.selectedSlipsPaged = {};
      this.$refs.slipListTable.clearSelection();
    }
  },
  mounted: function mounted() {
    var _this21 = this;

    if (this.$store.getters.slipSearchQuery) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.searchForm).forEach(function (key) {
        // if (this.$store.getters.slipSearchQuery[key]) {
        var val = _this21.$store.getters.slipSearchQuery[key];
        if (key === 'is_printed') {
          if (val === true) {
            val = 'พิมพ์แล้ว';
          } else if (val === false) {
            val = 'ยังไม่พิมพ์';
          } else if (val === null) {
            val = 'ทั้งหมด';
          }
        } else if (key === 'is_sent') {
          if (val === true) {
            val = 'ส่งแล้ว';
          } else if (val === false) {
            val = 'ยังไม่ส่ง';
          } else if (val === null) {
            val = 'ทั้งหมด';
          }
        } else if (key === 'limit') {
          if (val === null) {
            val = defaultLimit;
          }
        } else if (key === 'offset') {
          if (val === null) {
            val = defaultOffset;
          }
        }
        _this21.$set(_this21.searchForm, key, val);
        // }
      });
    }
    this.search();
  },

  watch: {
    // vm.xlsDataRowsSorted = JSON.parse(JSON.stringify(vm.xlsDataRows));
    slipListData: function slipListData(newList, oldList) {
      if (newList && oldList !== newList) {
        this.slipListDataSorted = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(newList));
      }
    },
    slipListDataSorted: function slipListDataSorted() {
      this.isSortingData = false;
    },
    xlsDataRowsSorted: function xlsDataRowsSorted() {
      this.isSortingImport = false;
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', vm.profileId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // clear current selection
    this.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerProfileDetailView);

/***/ }),

/***/ 491:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_xregexp__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */




/**
 * Biller Profile Form view
 */
var BillerProfileFormView = {
  name: 'biller-profile-form',
  props: ['profileId'],
  data: function data() {
    return {
      isSubmitting: false,
      isUploading: false,
      currentOtherBankUploading: '',
      isSetupUpdateData: false,
      isUpdated: true,
      useDefaultSCBNoti: true,
      dayList: [],
      profileFormRules: {
        name: [{ required: true, message: 'กรุณากรอกชื่อบริษัท', trigger: 'blur' }],
        'address.line_1': [{ required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' }],
        'address.district': [{ required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' }],
        'address.city': [{ required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' }],
        'address.province': [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' }],
        'address.postal_code': [{ required: true, message: 'กรุณากรอกรหัสไปรษณีย์', trigger: 'blur' }],
        'address.tel': [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }],
        'address.fax': [{ message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' }],
        bill_payment_comp_code: [{ validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentCompCode, message: 'กรุณากรอก COMP CODE', trigger: 'blur' }],
        bill_payment_account_no: [{ validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentAccountNo, message: 'กรุณากรอกหมายเลขบัญชี', trigger: 'blur' }],
        bill_payment_biller_id: [{ type: 'string', min: 15, max: 15, message: 'กรุณากรอก Biller ID ความยาว 15 หลัก', trigger: 'blur' }, { validator: this.checkBillPaymentFields, message: 'กรุณาเลือกอย่างน้อย 1 รายการ', trigger: 'blur' }, { validator: this.checkBillPaymentBillerId, message: 'กรุณากรอก Biller ID', trigger: 'blur' }],
        barcode_qrcode_biller_id_tax_id: [{ type: 'string', min: 13, max: 13, message: 'กรุณากรอก Biller ID ความยาว 13 หลัก', trigger: 'blur' }, { validator: this.checkBarcodeQRCodeBillerId, message: 'กรุณากรอก Biller ID และ Suffix 2 หลัก', trigger: 'blur' }],
        barcode_qrcode_account_no: [{ validator: this.checkBarcodeQRCodeAccountNo, message: 'กรุณากรอกหมายเลขบัญชี และ Suffix 2 หลัก', trigger: 'blur' }],
        ir_br: [{ validator: this.checkIBIR, message: 'กรุณากรอก IB/IR', trigger: 'blur' }],
        account_name: [{ required: true, message: 'กรุณาชื่อบัญชี', trigger: 'blur' }],
        label_ref1: [{ required: true, message: 'กรุณากรอกชื่อเรียก Ref. 1', trigger: 'blur' }],
        label_ref2: [{ required: true, message: 'กรุณากรอกชื่อเรียก Ref. 2', trigger: 'blur' }],
        notification_msg: [{ validator: this.checkNotificationMsg, message: 'กรุณากรอกข้อความแจ้งเตือน', trigger: 'blur' }]
        /* // Other Banks
        'other_banks.account_name': [
          { required: true, message: 'กรุณากรอกชื่อบัญชี', trigger: 'blur' },
        ],
        'other_banks.account_number': [
          { required: true, message: 'กรุณากรอกเลขที่บัญชี', trigger: 'blur' },
        ], */
      },
      profileForm: {
        id: null,
        name: '',
        use_company_address: true,
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: ''
        },
        use_bill_payment_comp_code: false,
        bill_payment_comp_code: '',
        use_bill_payment_account_no: false,
        bill_payment_account_no: '',
        use_bill_payment_biller_id: true,
        bill_payment_biller_id: '',
        barcode_qrcode_type: 'biller_id',
        barcode_qrcode_biller_id_tax_id: '',
        barcode_qrcode_biller_id_suffix: '',
        barcode_qrcode_account_no: '',
        barcode_qrcode_account_no_suffix: '',
        payment_type: 'CHEQUE_OR_CASH', // "CHEQUE_OR_CASH", "CASH_ONLY"
        charge_payer: false,
        ir_br: '',
        account_name: '',
        label_ref1: 'Ref. 1',
        label_ref2: 'Ref. 2',
        label_ref3: 'Ref. 3',
        allow_other_banks: false,
        other_banks: [],
        notification_msg_type: 'CUSTOM', // DATE or CUSTOM
        notification_msg_date: '1',
        notification_msg_custom: '',
        notification_msg: '',
        logo: '',
        printing_option: 'COLOR' // "COLOR", "BLACK_AND_WHITE"
      },
      mask: {
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          mask: /^\d{0,15}$/
        },
        postcode: {
          mask: '00000'
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }],
        numberOnly: {
          mask: /^\d+/
        },
        accNumberOnly: {
          mask: '0000000000'
        }
      },
      handleOtherBankLogoSuccessList: [this.handleOtherBankLogo1Success, this.handleOtherBankLogo2Success, this.handleOtherBankLogo3Success, this.handleOtherBankLogo4Success, this.handleOtherBankLogo5Success, this.handleOtherBankLogo6Success]
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isBillerAdmin: function isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    company: function company() {
      return this.$store.getters.billerInfo;
    },
    companyId: function companyId() {
      return this.company.id;
    },
    profile: function profile() {
      return this.$store.getters.currentBillerProfile;
    },
    uploadUrl: function uploadUrl() {
      return '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    },
    provinceList: function provinceList() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getProvinceList();
    },
    notificationDayList: function notificationDayList() {
      return this.dayList;
    },
    profileBusinessType: function profileBusinessType() {
      if (this.profile) {
        if (this.profile.business_type === 'B2C') {
          return 'B2C';
        } else if (this.profile.business_type === 'B2B') {
          return 'ธุรกิจ B2B';
        } else if (this.profile.business_type === 'EDU') {
          return 'สถานศึกษา';
        } else if (this.profile.business_type === 'SPECIAL') {
          var businessText = this.profile.business_type_special_industry || '';
          return '\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E1E\u0E34\u0E40\u0E28\u0E29: ' + businessText;
        }
      }
      return '';
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: 'BillerProfileDetail',
        params: {
          profileId: this.profileId
        }
      });
    },
    populateAddressFromCompany: function populateAddressFromCompany(isCopy) {
      var _this = this;

      if (isCopy) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.company.address).forEach(function (key) {
          var val = isCopy ? _this.company.address[key] : '';
          _this.$set(_this.profileForm.address, key, val);
        });
      }
      /* if (isCopy) {
        this.$set(this.profileForm.address, 'tel', this.company.tel);
        this.$set(this.profileForm.address, 'fax', this.company.fax);
      } */
      this.updatePostCode();
    },
    toggleUsingCompanyAddress: function toggleUsingCompanyAddress() {
      this.populateAddressFromCompany(this.profileForm.use_company_address);
    },
    handleBillPaymentData: function handleBillPaymentData() {
      if (this.profileForm.use_bill_payment_biller_id) {
        this.$refs.profileForm.validateField('bill_payment_biller_id');
      } else {
        // this.profileForm.bill_payment_biller_id = '';
        this.$refs.bill_payment_biller_id.resetField();
      }
      if (this.profileForm.use_bill_payment_comp_code) {
        this.$refs.profileForm.validateField('bill_payment_comp_code');
      } else {
        // this.profileForm.bill_payment_comp_code = '';
        this.$refs.bill_payment_comp_code.resetField();
      }
      if (this.profileForm.use_bill_payment_account_no) {
        this.$refs.profileForm.validateField('bill_payment_account_no');
      } else {
        // this.profileForm.bill_payment_account_no = '';
        this.$refs.bill_payment_account_no.resetField();
      }
      if (!this.profileForm.use_bill_payment_comp_code && !this.profileForm.use_bill_payment_account_no && !this.profileForm.use_bill_payment_biller_id) {
        this.$refs.profileForm.validateField('bill_payment_biller_id');
        this.$refs.profileForm.validateField('bill_payment_comp_code');
        this.$refs.profileForm.validateField('bill_payment_account_no');
      }
    },
    toggleUsingCompCode: function toggleUsingCompCode() {
      this.handleBillPaymentData();
    },
    toggleUsingAccountNo: function toggleUsingAccountNo() {
      this.handleBillPaymentData();
    },
    toggleUsingBillerId: function toggleUsingBillerId() {
      this.handleBillPaymentData();
      if (this.profileForm.use_bill_payment_biller_id) {
        this.profileForm.barcode_qrcode_type = 'biller_id';
        this.changeBillPaymentBillerId();
      }
    },
    toggleUsingBarcodeQRcodeType: function toggleUsingBarcodeQRcodeType() {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        this.profileForm.barcode_qrcode_account_no = '';
        this.profileForm.barcode_qrcode_account_no_suffix = '';
      } else {
        this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        this.profileForm.barcode_qrcode_biller_id_suffix = '';
      }
      this.$refs.profileForm.validateField('barcode_qrcode_biller_id_tax_id');
      this.$refs.profileForm.validateField('barcode_qrcode_account_no');
    },
    changeBillPaymentBillerId: function changeBillPaymentBillerId() {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        if (this.profileForm.use_bill_payment_biller_id) {
          // update paired biller_id
          var billerId = this.profileForm.bill_payment_biller_id;
          this.profileForm.barcode_qrcode_biller_id_tax_id = billerId;
        }
        // this.profileForm.barcode_qrcode_account_no = '';
        // this.profileForm.barcode_qrcode_account_no_suffix = '';
        this.$refs.barcode_qrcode_account_no.resetField();
      } else {
        // this.profileForm.barcode_qrcode_biller_id_tax_id = '';
        // this.profileForm.barcode_qrcode_biller_id_suffix = '';
        this.$refs.barcode_qrcode_biller_id_tax_id.resetField();
      }
    },
    checkBillPaymentFields: function checkBillPaymentFields(rule, value, cb) {
      // check at least one of 'bill_payment_comp_code',
      // 'bill_payment_account_no', 'bill_payment_biller_id'
      if (!this.profileForm.use_bill_payment_comp_code && !this.profileForm.use_bill_payment_account_no && !this.profileForm.use_bill_payment_biller_id) {
        cb(new Error('required bill payment information'));
      } else {
        cb();
      }
    },
    checkBillPaymentCompCode: function checkBillPaymentCompCode(rule, value, cb) {
      if (this.profileForm.use_bill_payment_comp_code && this.profileForm.bill_payment_comp_code && this.profileForm.bill_payment_comp_code.trim() === '') {
        cb(new Error('COMP CODE is required'));
      } else {
        cb();
      }
    },
    checkBillPaymentAccountNo: function checkBillPaymentAccountNo(rule, value, cb) {
      if (this.profileForm.use_bill_payment_account_no && this.profileForm.bill_payment_account_no && this.profileForm.bill_payment_account_no.trim() === '') {
        cb(new Error('Account No. is required'));
      } else {
        cb();
      }
    },
    checkBillPaymentBillerId: function checkBillPaymentBillerId(rule, value, cb) {
      if (this.profileForm.use_bill_payment_biller_id && this.profileForm.bill_payment_biller_id && this.profileForm.bill_payment_biller_id.trim() === '') {
        cb(new Error('Biller ID is required'));
      } else {
        cb();
      }
    },
    checkBarcodeQRCodeBillerId: function checkBarcodeQRCodeBillerId(rule, value, cb) {
      if (this.profileForm.barcode_qrcode_type === 'biller_id') {
        if (this.profileForm.barcode_qrcode_biller_id_tax_id && this.profileForm.barcode_qrcode_biller_id_tax_id.trim() === '') {
          cb(new Error('Biller ID is required'));
        } else if (this.profileForm.barcode_qrcode_biller_id_suffix && this.profileForm.barcode_qrcode_biller_id_suffix.trim() === '') {
          cb(new Error('Biller ID Suffix is required'));
        } else if (this.profileForm.barcode_qrcode_biller_id_suffix && this.profileForm.barcode_qrcode_biller_id_suffix.length !== 2) {
          cb(new Error('Biller ID Suffix must be 2 digits'));
        } else {
          cb();
        }
      } else {
        cb();
      }
    },
    checkBarcodeQRCodeAccountNo: function checkBarcodeQRCodeAccountNo(rule, value, cb) {
      if (this.profileForm.barcode_qrcode_type === 'account_no') {
        if (this.profileForm.barcode_qrcode_account_no && this.profileForm.barcode_qrcode_account_no.trim() === '') {
          cb(new Error('Account No. is required'));
        } else if (this.profileForm.barcode_qrcode_account_no_suffix && this.profileForm.barcode_qrcode_account_no_suffix.trim() === '') {
          cb(new Error('Account No. Suffix is required'));
        } else if (this.profileForm.barcode_qrcode_account_no_suffix && this.profileForm.barcode_qrcode_account_no_suffix.length !== 2) {
          cb(new Error('Account No. Suffix must be 2 digits'));
        } else {
          cb();
        }
      } else {
        cb();
      }
    },
    checkChargePayer: function checkChargePayer() {
      if (this.profileForm.charge_payer) {
        this.$refs.profileForm.validateField('ir_br');
      }
    },
    checkIBIR: function checkIBIR(rule, value, cb) {
      if (this.profileForm.charge_payer && this.profileForm.ir_br.trim() === '') {
        cb(new Error('IB/IR is required'));
      }
      cb();
    },
    checkNotificationMsg: function checkNotificationMsg(rule, value, cb) {
      // check if custom message is select and not blank
      this.updateNotificationMsgValue();
      /* if (this.profileForm.notification_msg_type === 'CUSTOM' &&
        this.profileForm.notification_msg_custom.trim() === '') {
        cb(new Error('Custom Notification message is required'));
      } */
      cb();
    },
    checkOtherBankItem: function checkOtherBankItem(rule, value, cb) {
      var fieldLabels = {
        account_name: 'ชื่อบัญชี',
        account_number: 'หมายเลขบัญชี'
      };
      var fieldItem = rule.fullField.split('.');
      if (fieldItem.length === 3) {
        var field = fieldItem[0];
        var index = fieldItem[1];
        var itemField = fieldItem[2];
        var bankInfo = this.profileForm[field][index];
        var isActive = bankInfo.is_active;
        if (isActive) {
          if (itemField === 'account_name' && bankInfo[itemField].trim() === '') {
            cb(new Error('\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01' + fieldLabels[itemField]));
          }
          if (itemField === 'account_number' && bankInfo[itemField].trim() !== '' && bankInfo[itemField].length !== 10) {
            cb(new Error('\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01' + fieldLabels[itemField] + '\u0E43\u0E2B\u0E49\u0E04\u0E23\u0E1A 10 \u0E2B\u0E25\u0E31\u0E01'));
          }
          if (this.isBBLBank(bankInfo.account_name)) {
            if (itemField === 'service_code' && bankInfo.service_code.trim() === '') {
              cb(new Error('\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01 Service Code'));
            }
          }
        }
      }
      cb();
    },
    toggleUsingNotificationMsgValue: function toggleUsingNotificationMsgValue() {
      // update notification_msg
      // this.updateNotificationMsgValue();
      if (this.profileForm.notification_msg_type === 'DATE') {
        this.profileForm.notification_msg_custom = '';
      }
      this.$refs.profileForm.validateField('notification_msg');
    },
    updateNotificationMsgValue: function updateNotificationMsgValue() {
      if (this.profileForm.notification_msg_type === 'CUSTOM') {
        this.profileForm.notification_msg = this.profileForm.notification_msg_custom;
      } else {
        this.profileForm.notification_msg = '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E0A\u0E33\u0E23\u0E30\u0E20\u0E32\u0E22\u0E43\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 ' + this.profileForm.notification_msg_date + ' \u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E40\u0E14\u0E37\u0E2D\u0E19';
      }
    },
    handleLogoSuccess: function handleLogoSuccess(res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.profileForm.logo = res.secure_url;
      }
    },
    handleOtherBankLogo1Success: function handleOtherBankLogo1Success(res) {
      this.handleOtherBankLogoSuccess(0, res);
    },
    handleOtherBankLogo2Success: function handleOtherBankLogo2Success(res) {
      this.handleOtherBankLogoSuccess(1, res);
    },
    handleOtherBankLogo3Success: function handleOtherBankLogo3Success(res) {
      this.handleOtherBankLogoSuccess(2, res);
    },
    handleOtherBankLogo4Success: function handleOtherBankLogo4Success(res) {
      this.handleOtherBankLogoSuccess(3, res);
    },
    handleOtherBankLogo5Success: function handleOtherBankLogo5Success(res) {
      this.handleOtherBankLogoSuccess(4, res);
    },
    handleOtherBankLogo6Success: function handleOtherBankLogo6Success(res) {
      this.handleOtherBankLogoSuccess(5, res);
    },
    handleOtherBankLogoSuccess: function handleOtherBankLogoSuccess(index, res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.profileForm.other_banks[index].account_logo = res.secure_url;
      }
    },
    handleLogoFail: function handleLogoFail(res) {
      this.isUploading = false;
      var errorMessage = this.$t('Unexpected error');
      if (res) {
        errorMessage = res;
        if (res.error) {
          errorMessage = res.error;
          if (res.error.message) {
            errorMessage = res.error.message;
          }
        }
      }
      this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
    },
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Logo picture must be JPG, PNG or GIF format!');
      }
      if (!isLt2M) {
        this.$message.error('Logo picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    handleHttpRequest: function handleHttpRequest(options) {
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_BILLER_COMPANY_LOGO', options.file);
    },
    handleOtherBankHttpRequest: function handleOtherBankHttpRequest(options) {
      console.log(options);
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_BILLER_OTHER_BANK_LOGO', options.file);
    },
    buildPayload: function buildPayload() {
      var _this2 = this;

      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.profileForm));
      // remove unnecessary key
      var stripKeys = [
      // 'use_company_address',
      'use_bill_payment_comp_code', 'use_bill_payment_account_no', 'use_bill_payment_biller_id', 'barcode_qrcode_type', 'notification_msg_type', 'notification_msg_date', 'notification_msg_custom'];
      var makeNullKeys = ['bill_payment_comp_code', 'bill_payment_account_no', 'bill_payment_biller_id', 'barcode_qrcode_biller_id_tax_id', 'barcode_qrcode_biller_id_suffix', 'barcode_qrcode_account_no', 'barcode_qrcode_account_no_suffix', 'notification_msg'];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        if (stripKeys.indexOf(key) !== -1) {
          delete payload[key];
        }
        if (key === 'use_company_address') {
          payload.use_company_address = payload.use_company_address || false;
        }
        // transform data before sending
        if (makeNullKeys.indexOf(key) !== -1) {
          if (payload[key] === '') {
            payload[key] = null;
          }
        }
      });
      payload.other_banks.forEach(function (bankInfo) {
        delete bankInfo.is_active;
        if (!_this2.isBBLBank(bankInfo.account_name)) {
          bankInfo.service_code = '';
          bankInfo.branch_code = '';
        }
      });
      return payload;
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this3 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      // build payload first
      this.updateNotificationMsgValue();
      this.isSubmitting = true;
      var payload = this.buildPayload();
      // transform notification_msg
      if (payload.notification_msg) {
        payload.notification_msg = payload.notification_msg.replace(new __WEBPACK_IMPORTED_MODULE_5_xregexp___default.a('[ ]{2,}', 'g'), ' ');
      }
      var reqPayload = {
        profileId: payload.id,
        payload: payload
      };
      this.$store.dispatch('UPDATE_BILLER_PROFILE_INFO', reqPayload).then(function () {
        _this3.isSubmitting = false;
        _this3.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: 'แก้ไขข้อมูลสำหรับรับชำระเงินของบริษัทสำเร็จแล้ว'
        });
        _this3.$nextTick(function () {
          _this3.goBack();
        });
      }).catch(function (msg) {
        _this3.isSubmitting = false;
        if (msg) {
          _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t(msg));
        } else {
          _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t('Unexpected error'));
        }
      });
      return true;
    },
    setupUpdateData: function setupUpdateData() {
      var _this4 = this;

      this.isSetupUpdateData = true;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.profile).forEach(function (key) {
        if (key === 'address') {
          // let isUseCompanyAddress = true;
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this4.profile.address).forEach(function (addrKey) {
            // check if the value for this profile & company are the same or not
            /* if (this.profile.address[addrKey] !== this.company.address[addrKey]) {
              isUseCompanyAddress = false;
            } */
            _this4.$set(_this4.profileForm.address, addrKey, _this4.profile.address[addrKey]);
          });
          // this.use_company_address = isUseCompanyAddress;
        } else if (key === 'notification_msg') {
          if (_this4.profile[key] === null) {
            _this4.$set(_this4.profileForm, key, '');
          } else {
            _this4.$set(_this4.profileForm, key, _this4.profile[key]);
          }
        } else if (key === 'other_banks') {
          // loop through array of other bank info
          _this4.profile[key].forEach(function (bankInfo) {
            _this4.profileForm[key].push({
              is_active: bankInfo.account_name.trim() !== '',
              account_name: bankInfo.account_name,
              account_number: bankInfo.account_number,
              account_logo: bankInfo.account_logo,
              comcode: bankInfo.comcode,
              service_fee: bankInfo.service_fee,
              service_code: bankInfo.service_code,
              branch_code: bankInfo.branch_code
            });
          });
          // check if other_banks is 6 yet?
          var addOtherBanksRowCount = 6 - _this4.profileForm.other_banks.length;
          for (var rowCount = 0; rowCount < addOtherBanksRowCount; rowCount += 1) {
            _this4.profileForm[key].push({
              is_active: false,
              account_name: '',
              account_number: '',
              account_logo: '',
              comcode: '',
              service_fee: '',
              service_code: '',
              branch_code: ''
            });
          }
        } else {
          _this4.$set(_this4.profileForm, key, _this4.profile[key]);
        }
      });
      // update required control fields' value
      this.profileForm.use_bill_payment_comp_code = !!this.profileForm.bill_payment_comp_code;
      this.profileForm.use_bill_payment_account_no = !!this.profileForm.bill_payment_account_no;
      this.profileForm.use_bill_payment_biller_id = !!this.profileForm.bill_payment_biller_id;
      this.profileForm.barcode_qrcode_type = this.profileForm.barcode_qrcode_biller_id_tax_id ? 'biller_id' : 'account_no';
      this.profileForm.notification_msg_type = this.profileForm.notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 && this.profileForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
      if (this.profileForm.notification_msg_type === 'DATE') {
        if (this.profileForm.notification_msg) {
          this.profileForm.notification_msg_date = this.profileForm.notification_msg.replace('กรุณาชำระภายในวันที่', '').replace('ของทุกเดือน', '');
        } else {
          this.profileForm.notification_msg_date = 1;
        }
      } else {
        this.profileForm.notification_msg_custom = this.profileForm.notification_msg;
      }
      this.updatePostCode();
      // FIX ME - Remove
      /* this.profileForm.allow_other_banks = true;
      for (let rowCount = 0; rowCount < 6; rowCount += 1) {
        this.profileForm.other_banks.push({
          is_active: false,
          account_name: '',
          account_number: '',
          account_logo: '',
          comcode: '',
          service_fee: '',
          service_code: '',
          branch_code: '',
        });
      } */
      // END FIX ME
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.profileForm.id = null;
      this.profileForm.name = '';
      this.profileForm.use_company_address = true;
      this.profileForm.address.line_1 = '';
      this.profileForm.address.district = '';
      this.profileForm.address.city = '';
      this.profileForm.address.province = '';
      this.profileForm.address.postal_code = '';
      this.profileForm.address.tel = '';
      this.profileForm.address.fax = '';
      this.profileForm.use_bill_payment_comp_code = false;
      this.profileForm.bill_payment_comp_code = '';
      this.profileForm.use_bill_payment_account_no = false;
      this.profileForm.bill_payment_account_no = '';
      this.profileForm.use_bill_payment_biller_id = true;
      this.profileForm.bill_payment_biller_id = '';
      this.profileForm.barcode_qrcode_type = 'biller_id';
      this.profileForm.barcode_qrcode_biller_id_tax_id = '';
      this.profileForm.barcode_qrcode_biller_id_suffix = '';
      this.profileForm.barcode_qrcode_account_no = '';
      this.profileForm.barcode_qrcode_account_no_suffix = '';
      this.profileForm.payment_type = 'CHEQUE_OR_CASH';
      this.profileForm.charge_payer = false;
      this.profileForm.ir_br = '';
      this.profileForm.account_name = '';
      this.profileForm.label_ref1 = 'Ref. 1';
      this.profileForm.label_ref2 = 'Ref. 2';
      this.profileForm.label_ref3 = 'Ref. 3';
      this.profileForm.allow_other_banks = false;
      this.profileForm.other_banks.splice(0);
      this.profileForm.notification_msg_type = 'CUSTOM';
      this.profileForm.notification_msg_date = '1';
      this.profileForm.notification_msg_custom = '';
      this.profileForm.notification_msg = '';
      this.profileForm.logo = '';
      this.profileForm.printing_option = 'COLOR';
      this.useDefaultSCBNoti = true;
    },
    removeLogo: function removeLogo() {
      var _this5 = this;

      this.$confirm('คุณต้องการยืนยันการลบโลโก้บริษัทออกใช่หรือไม่?', 'ยืนยันการลบโลโก้บริษัท', {
        confirmButtonText: 'ยืนยันการลบ',
        confirmButtonClass: 'danger-btn',
        cancelButtonText: 'ยกเลิก',
        type: 'warning'
      }).then(function () {
        _this5.profileForm.logo = '';
      }).catch(function () {});
    },
    removeOtherBankLogo: function removeOtherBankLogo(index) {
      var _this6 = this;

      this.$confirm('คุณต้องการยืนยันการลบโลโก้ธนาคารอื่นออกใช่หรือไม่?', 'ยืนยันการลบโลโก้ธนาคารอื่น', {
        confirmButtonText: 'ยืนยันการลบ',
        confirmButtonClass: 'danger-btn',
        cancelButtonText: 'ยกเลิก',
        type: 'warning'
      }).then(function () {
        _this6.profileForm.other_banks[index].account_logo = '';
      }).catch(function () {});
    },

    /* updateMaskTel() {
      this.maskValue(this.profileForm.address, 'tel', {
        mask: this.mask.telMask,
      });
    },
    updateMaskFax() {
      this.maskValue(this.profileForm.address, 'fax', {
        mask: this.mask.faxMask,
      });
    }, */
    updatePostCode: function updatePostCode() {
      try {
        this.maskValue(this.profileForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },
    compCodeFormatter: function compCodeFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.compCode);
      }
      return '-';
    },
    accountNoFormatter: function accountNoFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.accountNo);
      }
      return '-';
    },
    billerIdFormatter: function billerIdFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.billerId);
      }
      return '-';
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_4_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true }),
    isBBLBank: function isBBLBank(accountName) {
      var testString = accountName.toLowerCase();
      var isBBL = testString.indexOf('bbl') !== -1 || testString.indexOf('bangkok') !== -1 || testString.indexOf('กรุงเทพ') !== -1;
      return isBBL;
    },
    markBankInfoActive: function markBankInfoActive(index) {
      var bankInfo = this.profileForm.other_banks[index];
      if (!bankInfo.is_active) {
        // clear data
        bankInfo.account_name = '';
        bankInfo.account_number = '';
        bankInfo.account_logo = '';
        bankInfo.comcode = '';
        bankInfo.service_fee = '';
        bankInfo.service_code = '';
        bankInfo.branch_code = '';
      }
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this7.profile === 'undefined' || _this7.profile === null) {
          _this7.goBack();
        }
      }, 1000);
    }
    this.clearUpdateData();
    // clear list
    this.dayList.splice(0);
    // populate day list
    for (var d = 1; d <= 31; d += 1) {
      this.dayList.push(d);
    }
    if (this.isUpdated && this.profile) {
      this.setupUpdateData();
    }
  },

  watch: {
    profile: function profile(newVal) {
      if (!this.isSetupUpdateData && this.isUpdated && newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', vm.profileId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // clear current selection
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerProfileFormView);

/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */






var BillerSlipFormView = {
  name: 'biller-profile-form',
  props: ['profileId', 'slipId'],
  data: function data() {
    return {
      isSubmitting: false,
      isSetupUpdateData: false,
      useDefaultSCBNoti: true,
      dayList: [],
      payerForm: {
        payer: {
          name: '',
          email: ''
        },
        issued_on: '',
        amount: '',
        ref1: '',
        ref2: '',
        ref3: '',
        remark: '',
        is_sent: false,
        is_printed: false,
        notification_msg_type: 'CUSTOM', // DATE or CUSTOM
        notification_msg_date: '1',
        notification_msg_custom: '',
        notification_msg: ''
      },
      payerFormRules: {
        'payer.name': [{ required: true, max: 40, message: 'กรุณากรอกชื่อผู้ชำระ', trigger: 'blur' }],
        'payer.email': [
        // { required: true, message: 'กรุณากรอกอีเมลผู้ชำระ', trigger: 'blur' },
        { type: 'email', message: 'กรุณากรอกอีเมลผู้ชำระให้ถูกต้อง', trigger: 'blur' }],
        issued_on: [{ required: true, message: 'กรุณาเลือกวันที่ครบกำหนดชำระ', trigger: 'blur' }],
        amount: [{ required: true, message: 'กรุณากรอกจำนวนที่ต้องชำระ', trigger: 'blur' }, {
          validator: this.validateAmount,
          message: 'กรุณากรอกจำนวนที่ต้องชำระไม่เกิน 100 ล้านบาท',
          trigger: 'blur'
        }],
        ref1: [{ type: 'string', required: true, max: 20, message: 'กรุณากรอก Ref. 1', trigger: 'blur' }],
        ref2: [{ type: 'string', max: 20, message: 'กรุณากรอก Ref. 2', trigger: 'blur' }],
        notification_msg: [{ validator: this.checkNotificationMsg, max: 100, message: 'กรุณากรอกข้อความแจ้งเตือน', trigger: 'blur' }]
      },
      mask: {
        amountMask: {
          mask: __WEBPACK_IMPORTED_MODULE_5_imask__["MaskedNumber"],
          scale: 2,
          signed: false,
          thousandsSeparator: ',',
          padFractionalZeros: true,
          normalizeZeros: true,
          radix: '.',
          mapToRadix: ['.'],
          max: 99999999.99
        },
        refCode: {
          mask: /^[0-9A-Z]{0,20}$/
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isUpdated: function isUpdated() {
      return typeof this.slipId !== 'undefined';
    },
    isBillerAdmin: function isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    profile: function profile() {
      return this.$store.getters.currentBillerProfile;
    },
    slip: function slip() {
      return this.$store.getters.currentBillerSlip;
    },
    ref1Label: function ref1Label() {
      if (this.profile) {
        return this.profile.label_ref1 + ' (Reference No. 1)';
      }
      return '';
    },
    ref2Label: function ref2Label() {
      if (this.profile) {
        return this.profile.label_ref2 + ' (Reference No. 2)';
      }
      return '';
    },
    ref1ErrorMessage: function ref1ErrorMessage() {
      return '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01' + this.ref1Label;
    },
    ref2ErrorMessage: function ref2ErrorMessage() {
      return '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01' + this.ref2Label;
    },
    notificationDayList: function notificationDayList() {
      return this.dayList;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: 'BillerProfileDetail',
        params: {
          profileId: this.profileId
        }
      });
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      // build payload first
      this.updateNotificationMsgValue();
      this.isSubmitting = true;
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.payerForm));
      // adjust format for date & amount
      payload.issued_on = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(payload.issued_on).format('YYYY-MM-DD');
      // payload.amount = numeral(payload.amount).value();
      this.unmaskValue(payload, 'amount', this.mask.amountMask);
      var action = this.isUpdated ? 'UPDATE_BILLER_SLIP_INFO' : 'CREATE_BILLER_SLIP_INFO';
      var reqPayload = {
        payload: payload
      };
      if (this.isUpdated) {
        reqPayload.slipId = payload.id;
      } else {
        reqPayload.profileId = this.profileId;
      }
      this.$store.dispatch(action, reqPayload).then(function () {
        _this.isSubmitting = false;
        var successMessage = 'สร้างรายการผู้ชำระเงินใหม่สำเร็จแล้ว';
        if (_this.isUpdated) {
          successMessage = 'แก้ไขรายการผู้ชำระเงินสำเร็จแล้ว';
        }
        _this.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this.$nextTick(function () {
          _this.goBack();
        });
      }).catch(function (msg) {
        _this.isSubmitting = false;
        if (msg) {
          var errMessage = msg;
          if ((typeof msg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(msg)) === 'object') {
            var errorObjects = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(msg).forEach(function (key) {
              errorObjects.push(key + ': ' + msg[key]);
            });
            errMessage = errorObjects.join(', ');
          }
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t(errMessage));
        } else {
          _this.$store.dispatch('ADD_ERROR_FLASH', _this.$t('Unexpected error'));
        }
      });
      return true;
    },
    confirmTerminate: function confirmTerminate() {
      var _this2 = this;

      this.$confirm('ท่านกำลังจะลบรายการผู้ชำระนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.isSubmitting = true;
        _this2.$store.dispatch('DELETE_BILLER_SLIP_INFO', _this2.slipId).then(function () {
          _this2.isSubmitting = false;
          _this2.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบรายการผู้ชำระสำเร็จแล้ว'
          });
          _this2.goBack();
        }).catch(function (msg) {
          _this2.isSubmitting = false;
          if (msg) {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
          } else {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    validateAmount: function validateAmount(rule, value, cb) {
      this.updateMaskAmount();
      var num = __WEBPACK_IMPORTED_MODULE_3_numeral___default()(this.payerForm.amount);
      if (num.value() > 99999999.99) {
        cb(new Error('Amount must more than 0'));
      } else {
        cb();
      }
    },
    setupUpdateData: function setupUpdateData() {
      var _this3 = this;

      this.isSetupUpdateData = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.slip).forEach(function (key) {
        if (key === 'payer') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.slip.payer).forEach(function (payerKey) {
            _this3.$set(_this3.payerForm.payer, payerKey, _this3.slip.payer[payerKey]);
          });
        } else if (key === 'issued_on') {
          var issuedOn = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(_this3.slip[key]).tz("Asia/Bangkok");
          if (issuedOn.isValid()) {
            _this3.$set(_this3.payerForm, key, issuedOn.toDate());
          } else {
            _this3.$set(_this3.payerForm, key, _this3.slip[key]);
          }
        } else if (key === 'notification_msg') {
          if (_this3.slip[key] === null) {
            _this3.useDefaultSCBNoti = true;
            if (_this3.profile && _this3.profile.notification_msg) {
              _this3.$set(_this3.payerForm, key, _this3.profile.notification_msg);
            }
          } else {
            _this3.$set(_this3.payerForm, key, _this3.slip[key]);
          }
        } else {
          _this3.$set(_this3.payerForm, key, _this3.slip[key]);
        }
      });
      if (this.profile && (this.profile.notification_msg === this.payerForm.notification_msg || this.profile.notification_msg === null && this.payerForm.notification_msg === '')) {
        this.useDefaultSCBNoti = true;
      } else {
        this.useDefaultSCBNoti = false;
      }
      if (this.payerForm.notification_msg === null) {
        this.payerForm.notification_msg = '';
      }
      this.checkNotiMessageType();
      this.$nextTick(function () {
        // update mask stuffs
        _this3.updateMaskAmount();
        _this3.updateMaskRefCode();
      });
    },
    clearUpdateData: function clearUpdateData() {
      var _this4 = this;

      this.isSetupUpdateData = false;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.payerForm).forEach(function (key) {
        if (key === 'payer') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.payerForm.payer).forEach(function (payerKey) {
            _this4.$set(_this4.payerForm.payer, payerKey, '');
          });
        } else {
          _this4.$set(_this4.payerForm, key, '');
        }
      });
    },
    checkNotificationMsg: function checkNotificationMsg(rule, value, cb) {
      // check if custom message is select and not blank
      this.updateNotificationMsgValue();
      cb();
    },
    toggleUseSCBNotiMsg: function toggleUseSCBNotiMsg() {
      if (!this.isUpdated && this.profile) {
        if (this.profile.notification_msg) {
          this.payerForm.notification_msg = this.profile.notification_msg;
        } else {
          this.payerForm.notification_msg = '';
        }
      }
      if (this.useDefaultSCBNoti) {
        this.payerForm.notification_msg_type = '';
        // get data from profile
        if (this.profile) {
          if (this.profile.notification_msg) {
            this.payerForm.notification_msg = this.profile.notification_msg;
          } else {
            this.payerForm.notification_msg = '';
          }
        }
      } else {
        this.payerForm.notification_msg_type = this.payerForm.notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 && this.payerForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
        if (this.payerForm.notification_msg_type === 'DATE') {
          this.payerForm.notification_msg_date = this.payerForm.notification_msg.replace('กรุณาชำระภายในวันที่', '').replace('ของทุกเดือน', '');
        } else {
          this.payerForm.notification_msg_custom = this.payerForm.notification_msg;
        }
      }
    },
    updateNotificationMsgValue: function updateNotificationMsgValue() {
      if (this.payerForm.notification_msg_type === 'CUSTOM') {
        this.payerForm.notification_msg = this.payerForm.notification_msg_custom;
      } else if (this.payerForm.notification_msg_type === 'DATE') {
        this.payerForm.notification_msg = '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E0A\u0E33\u0E23\u0E30\u0E20\u0E32\u0E22\u0E43\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48 ' + this.payerForm.notification_msg_date + ' \u0E02\u0E2D\u0E07\u0E17\u0E38\u0E01\u0E40\u0E14\u0E37\u0E2D\u0E19';
      }
    },
    checkNotiMessageType: function checkNotiMessageType() {
      if (this.useDefaultSCBNoti) {
        this.payerForm.notification_msg_type = '';
        // get data from profile
        if (this.profile) {
          if (this.profile.notification_msg) {
            this.payerForm.notification_msg = this.profile.notification_msg;
          } else {
            this.payerForm.notification_msg = '';
          }
        }
      } else {
        this.payerForm.notification_msg_type = this.payerForm.notification_msg.indexOf('กรุณาชำระภายในวันที่') !== -1 && this.payerForm.notification_msg.indexOf('ของทุกเดือน') !== -1 ? 'DATE' : 'CUSTOM';
        if (this.payerForm.notification_msg_type === 'DATE') {
          this.payerForm.notification_msg_date = this.payerForm.notification_msg.replace('กรุณาชำระภายในวันที่', '').replace('ของทุกเดือน', '');
        } else {
          this.payerForm.notification_msg_custom = this.payerForm.notification_msg;
        }
      }
    },
    toggleUsingNotificationMsgValue: function toggleUsingNotificationMsgValue() {
      if (this.payerForm.notification_msg_type === 'DATE') {
        this.payerForm.notification_msg_custom = '';
      }
      this.$refs.payerForm.validateField('notification_msg');
    },
    updateMaskAmount: function updateMaskAmount() {
      this.maskValue(this.payerForm, 'amount', this.mask.amountMask);
    },
    updateMaskRefCode: function updateMaskRefCode() {
      this.payerForm.ref1 = this.payerForm.ref1.toUpperCase();
      this.payerForm.ref2 = this.payerForm.ref2.toUpperCase();
      this.maskValue(this.payerForm, 'ref1', this.mask.refCode);
      this.maskValue(this.payerForm, 'ref2', this.mask.refCode);
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_5_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_5_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_7_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      var _this5 = this;

      if (['payerForm.ref1', 'payerForm.ref2'].indexOf(refName) !== -1) {
        this.payerForm.ref1 = this.payerForm.ref1.toUpperCase();
        this.payerForm.ref2 = this.payerForm.ref2.toUpperCase();
      }
      this.$nextTick(function () {
        __WEBPACK_IMPORTED_MODULE_6__libs_helpers__["a" /* default */].handleInput(evt, _this5.$refs, refName, _this5.mask, maskName);
      });
    }, 300, { tailing: true })
  },
  mounted: function mounted() {
    var _this6 = this;

    this.clearUpdateData();
    var now = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().tz("Asia/Bangkok");
    // default date is today
    this.payerForm.issued_on = now.toDate();
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this6.slip === 'undefined' || _this6.slip === null) {
          _this6.goBack();
        }
      }, 1000);
    }
    // clear list
    this.dayList.splice(0);
    // populate day list
    for (var d = 1; d <= 31; d += 1) {
      this.dayList.push(d);
    }
    if (this.isUpdated && this.slip) {
      this.setupUpdateData();
    } else if (!this.isUpdated && this.profile) {
      if (this.profile.notification_msg) {
        this.payerForm.notification_msg = this.profile.notification_msg;
      } else {
        this.payerForm.notification_msg = '';
      }
    }
  },

  watch: {
    slip: function slip(newVal) {
      if (!this.isSetupUpdateData && this.isUpdated && newVal) {
        this.setupUpdateData();
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$store.dispatch('SELECT_CURRENT_BILLER_PROFILE', vm.profileId);
      vm.$store.dispatch('SELECT_CURRENT_BILLER_SLIP', vm.slipId);
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // clear current selection
    this.clearUpdateData();
    this.$store.dispatch('SELECT_CURRENT_BILLER_SLIP', '');
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerSlipFormView);

/***/ }),

/***/ 494:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_imask__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import store from '@/store';


var BillerUserListView = {
  name: 'biller-user-list',
  data: function data() {
    return {
      searchTerm: '',
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isBillerAdmin: function isBillerAdmin() {
      if (this.$store.getters.myAdminInfo) {
        return this.$store.getters.myAdminInfo.role === 'ADMIN';
      }
      return false;
    },
    company: function company() {
      return this.$store.getters.currentCompany;
    },
    userList: function userList() {
      return this.$store.getters.billerUserList;
    },
    userListData: function userListData() {
      /* const q = this.searchTerm.trim().toLowerCase();
      if (q !== '') {
        return this.userList.filter((item) => {
          const name = item.name.trim().toLowerCase();
          const email = item.email.trim().toLowerCase();
          const desc = item.description.trim().toLowerCase();
          return name.indexOf(q) !== -1 ||
            email.indexOf(q) !== -1 ||
            desc.indexOf(q) !== -1;
        });
      } */
      return this.userList;
    }
  },
  methods: {
    createCompanyUser: function createCompanyUser() {
      this.$router.push({
        name: 'BillerUserCreate'
      });
    },
    handleEdit: function handleEdit(index, row) {
      this.$router.push({
        name: 'BillerUserEdit',
        params: {
          userId: row.id
        }
      });
    },
    roleFormatter: function roleFormatter(row) {
      return row.role === 'ADMIN' ? 'Biller Admin' : 'Biller Staff';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    statusFormatter: function statusFormatter(row) {
      var status = 'Disabled';
      if (row.status === 'blocked') {
        status = 'Blocked';
      } else if (row.status === 'active') {
        status = 'Enabled';
      }
      return status;
    },
    statusTypeFormatter: function statusTypeFormatter(row) {
      var type = 'info';
      if (row.status === 'blocked') {
        type = 'danger';
      } else if (row.status === 'active') {
        type = 'success';
      }
      return type;
    },
    telFormatter: function telFormatter(row, column, cellValue) {
      /* if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.tel);
      }
      return '-'; */
      return cellValue || '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_1_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    }
  },
  // Handle Routing
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_BILLER_USER_LIST', vm.$store.getters.billerInfo.id).then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerUserListView);

/***/ }),

/***/ 495:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_imask__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */




/**
 * Biller User Form view
 */
var BillerUserFormView = {
  name: 'biller-user-form',
  props: ['userId'],
  data: function data() {
    return {
      isSubmitting: false,
      isSetupUpdateData: false,
      assignStaffList: [],
      adminForm: {
        email: '',
        name: '',
        tel: '',
        status: true,
        description: '',
        role: 'STAFF', // "ADMIN", "STAFF",
        assigned_profiles: []
      },
      adminFormRules: {
        email: [{ required: true, message: 'กรุณากรอกอีเมลผู้ดูแล', trigger: 'blur' }, { type: 'email', message: this.$t('Please input a valid email address'), trigger: 'blur' }],
        name: [{ required: true, message: 'กรุณากรอกชื่อผู้ดูแล', trigger: 'blur' }],
        tel: [{ message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }],
        /* description: [
          { required: true, message: 'กรุณากรอกรายละเอียดผู้ดูแล', trigger: 'blur' },
        ], */
        assigned_profiles: [{ validator: this.checkAssignedProfiles, message: 'กรุณาเลือกข้อมูลรับชำระเงินของบริษัทที่ให้พนักงานดูแล', trigger: 'blur' }]
      },
      mask: {
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        },
        compCode: {
          mask: /^\d{0,4}$/
        },
        accountNo: {
          mask: '000-0-00000-0'
        },
        billerId: {
          mask: /^\d{0,15}$/
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    isUpdated: function isUpdated() {
      return typeof this.userId !== 'undefined';
    },
    companyId: function companyId() {
      return this.$store.getters.billerInfo.id;
    },
    profileListData: function profileListData() {
      return this.$store.getters.billerProfileList;
    },
    allStaffs: function allStaffs() {
      var billerUserList = [];
      if (this.userId) {
        var uid = parseInt(this.userId, 10);
        billerUserList = this.$store.getters.billerUserList.filter(function (user) {
          return user.id !== uid;
        });
      } else {
        billerUserList = this.$store.getters.billerUserList;
      }
      return billerUserList.filter(function (user) {
        return user.role === 'STAFF';
      });
    },
    userInfo: function userInfo() {
      var _this = this;

      if (this.isUpdated) {
        /* const indexId = `_${this.userId}`;
        if (typeof this.$store.getters.billerUserListIndex[indexId] !== 'undefined') {
          const idx = this.$store.getters.billerUserListIndex[indexId];
          return this.$store.getters.billerUserList[idx];
        } */
        var userInfo = null;
        this.$store.getters.billerUserList.forEach(function (item) {
          if (item.id === _this.userId) {
            userInfo = item;
          }
        });
        return userInfo;
      }
      return null;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: 'BillerUserList'
      });
    },
    confirmTerminate: function confirmTerminate() {
      var _this2 = this;

      this.$confirm('ท่านกำลังจะลบบัญชีผู้ดูแลบริษัทนี้ออกจากระบบ ท่านต้องการยืนยันเพื่อดำเนินการต่อหรือไม่?', 'ระวัง', {
        confirmButtonText: this.$t('Confirm'),
        confirmButtonClass: 'danger-btn',
        cancelButtonText: this.$t('Cancel'),
        type: 'warning'
      }).then(function () {
        _this2.isSubmitting = true;
        _this2.$store.dispatch('DELETE_BILLER_USER_INFO', _this2.userId).then(function () {
          _this2.isSubmitting = false;
          _this2.$message({
            type: 'success',
            showClose: true,
            duration: 10000,
            message: 'ลบข้อมูลผู้ดูแลบริษัทสำเร็จแล้ว'
          });
          _this2.goBack();
        }).catch(function (msg) {
          _this2.isSubmitting = false;
          if (msg) {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
          } else {
            _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
          }
        });
      }).catch(function () {});
    },
    checkAssignedProfiles: function checkAssignedProfiles(rule, value, cb) {
      if (this.adminForm.assigned_profiles.length === 0) {
        cb(new Error());
      } else {
        cb();
      }
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this3 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var action = this.isUpdated ? 'UPDATE_BILLER_USER_INFO' : 'CREATE_BILLER_USER_INFO';
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.adminForm));
      // transform payload's status
      // transform payload
      // this.unmaskValue(payload, 'tel', this.mask.tel);
      payload.status = payload.status ? 'active' : 'inactive';
      delete payload.created_at;
      delete payload.update_at;
      var reqPayload = {
        payload: payload
      };
      if (this.isUpdated) {
        reqPayload.userId = payload.id;
      } else {
        reqPayload.companyId = this.companyId;
      }
      this.$store.dispatch(action, reqPayload).then(function () {
        _this3.isSubmitting = false;
        var successMessage = 'สร้างบัญชีผู้ดูแลบริษัทใหม่สำเร็จแล้ว';
        if (_this3.isUpdated) {
          successMessage = 'แก้ไขข้อมูลบัญชีผู้ดูแลบริษัทสำเร็จแล้ว';
        }
        _this3.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: successMessage
        });
        _this3.goBack();
      }).catch(function (msg) {
        _this3.isSubmitting = false;
        if (msg) {
          _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t(msg));
        } else {
          _this3.$store.dispatch('ADD_ERROR_FLASH', _this3.$t('Unexpected error'));
        }
      });
      return true;
    },
    setupUpdateData: function setupUpdateData() {
      var _this4 = this;

      this.isSetupUpdateData = true;
      if (this.userInfo) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.userInfo).forEach(function (key) {
          if (key === 'status') {
            var isActive = _this4.userInfo[key] === 'active';
            _this4.$set(_this4.adminForm, key, isActive);
          } else if (key === 'assigned_profiles') {
            if (_this4.profileListData) {
              // remove duplicate key
              var userKeys = {};
              _this4.userInfo.assigned_profiles.forEach(function (id) {
                if (!userKeys[id]) {
                  userKeys[id] = id;
                }
              });
              _this4.adminForm.assigned_profiles.splice(0);
              _this4.profileListData.forEach(function (row) {
                if (userKeys[row.id]) {
                  _this4.adminForm.assigned_profiles.push(row.id);
                  if (_this4.$refs.multipleTable) {
                    _this4.$refs.multipleTable.toggleRowSelection(row, true);
                  }
                }
              });
            }
          } else {
            _this4.$set(_this4.adminForm, key, _this4.userInfo[key]);
          }
        });
        this.$nextTick(function () {
          // this.updateMaskTel();
          _this4.updateProfileTable();
        });
      }
    },
    clearUpdateData: function clearUpdateData() {
      this.isSetupUpdateData = false;
      this.adminForm.email = '';
      this.adminForm.name = '';
      this.adminForm.tel = '';
      this.adminForm.status = true;
      this.adminForm.description = '';
      this.adminForm.role = 'STAFF';
      this.adminForm.assigned_profiles.splice(0);
    },
    paymentTypeFormatter: function paymentTypeFormatter(row) {
      return row.payment_type === 'CASH_ONLY' ? 'เงินสดอย่างเดียว' : 'เช็ค/เงินสด';
    },
    dateFormatter: function dateFormatter(row, column, cellValue) {
      var date = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(cellValue).tz("Asia/Bangkok");
      if (date.isValid()) {
        return date.format('ll');
      }
      return '-';
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this5 = this;

      // adminForm
      this.adminForm.assigned_profiles.splice(0);
      val.forEach(function (item) {
        _this5.adminForm.assigned_profiles.push(item.id);
      });
    },
    assignAsStaff: function assignAsStaff(value) {
      var _this6 = this;

      var key = '_' + value;
      if (typeof this.$store.getters.billerUserListIndex[key] !== 'undefined') {
        var idx = this.$store.getters.billerUserListIndex[key];
        if (typeof this.$store.getters.billerUserList[idx] !== 'undefined') {
          var user = this.$store.getters.billerUserList[idx];
          this.profileListData.forEach(function (row) {
            if (user.assigned_profiles.indexOf(row.id) !== -1) {
              if (_this6.$refs.multipleTable) {
                _this6.$refs.multipleTable.toggleRowSelection(row, true);
              }
            }
          });
        }
      }
    },
    updateProfileTable: function updateProfileTable() {
      var _this7 = this;

      this.profileListData.forEach(function (row) {
        if (_this7.adminForm.assigned_profiles.indexOf(row.id) !== -1) {
          if (_this7.$refs.multipleTable) {
            _this7.$refs.multipleTable.toggleRowSelection(row, true);
          }
        }
      });
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_5_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_5_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* updateMaskTel() {
      try {
        this.maskValue(this.adminForm, 'tel', this.mask.tel);
      } catch (e) {
        console.error(e);
      }
    }, */
    compCodeFormatter: function compCodeFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.compCode);
      }
      return '-';
    },
    accountNoFormatter: function accountNoFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.accountNo);
      }
      return '-';
    },
    billerIdFormatter: function billerIdFormatter(row, column, cellValue) {
      if (cellValue) {
        return this.maskFormatter(cellValue, this.mask.billerId);
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_5_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true })
  },
  mounted: function mounted() {
    var _this8 = this;

    // load data to form
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this8.userInfo === 'undefined' || _this8.userInfo === null) {
          _this8.goBack();
        }
      }, 1000);
    }
    if (this.isUpdated && this.userInfo) {
      this.setupUpdateData();
    }
  },

  watch: {
    userInfo: function userInfo(newVal) {
      if (this.isUpdated && !this.isSetupUpdateData && newVal) {
        this.setupUpdateData();
      }
    },
    profileListData: function profileListData(newVal) {
      var _this9 = this;

      if (this.isUpdated && newVal) {
        this.$nextTick(function () {
          _this9.setupUpdateData();
        });
      }
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      // Fetch data
      vm.$store.dispatch('SELECT_CURRENT_COMPANY', vm.companyId);
      vm.$store.dispatch('START_CONTENT_LOADING');
      vm.$store.dispatch('GET_BILLER_PROFILE_LIST', vm.$store.getters.billerInfo.id).then(function () {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
      }).catch(function (err) {
        vm.$store.dispatch('STOP_CONTENT_LOADING');
        vm.$store.dispatch('ADD_ERROR_FLASH', err);
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.clearUpdateData();
    if (this.$refs.multipleTable) {
      this.$refs.multipleTable.clearSelection();
    }
    next();
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerUserFormView);

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_helpers__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var BillerCompanyDetailView = {
  name: 'biller-company-detail',
  data: function data() {
    return {
      mask: {
        taxId: {
          mask: [{ mask: '0000000000' }, { mask: '0000000000000' }]
        },
        tel: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }]
        },
        fax: {
          mask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }]
        }
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.billerInfo;
    },
    baseHost: function baseHost() {
      /* const hostName = window.location.hostname;
      const hosts = window.appConfig.BASE_HOST.splice(',');
      let currentHostName = '';
      hosts.forEach((host) => {
        if (hostName.indexOf(host) !== -1) {
          currentHostName = host;
        }
      });
      return currentHostName; */
      return __WEBPACK_IMPORTED_MODULE_1__libs_helpers__["a" /* default */].getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    }
  },
  methods: {
    reloadInfo: function reloadInfo() {
      this.$router.push({ name: 'BillerUserLoadInfo' });
    },
    telFormatter: function telFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.tel);
      }
      return '-';
    },
    faxFormatter: function faxFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.fax);
      }
      return '-';
    },
    taxIdFormatter: function taxIdFormatter(val) {
      if (val) {
        return this.maskFormatter(val, this.mask.taxId);
      }
      return '-';
    },
    maskFormatter: function maskFormatter(val, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_0_imask__["createMask"])(maskOptions);
      if (val) {
        return mask.resolve(val.toString());
      }
      return '';
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerCompanyDetailView);

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imask__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-param-reassign: 0 */



// import XRegExp from 'xregexp';

var BillerUserListView = {
  name: 'biller-company-edit',
  data: function data() {
    return {
      isSubmitting: false,
      isUploading: false,
      companyForm: {
        id: null,
        tax_id: '',
        slug: '',
        name: '',
        name_on_payment_card: '',
        logo: '',
        // tel: '',
        // fax: '',
        address: {
          line_1: '',
          district: '',
          city: '',
          province: '',
          postal_code: '',
          tel: '',
          fax: ''
        },
        profiles_count: 0
      },
      companyFormRules: {
        /* logo: [
          { required: true, message: 'กรุณาเลือกโลโก้บริษัท', trigger: 'blur' },
        ], */
        'address.line_1': [{ required: true, message: 'กรุณากรอกที่อยู่บริษัท', trigger: 'blur' }],
        'address.district': [{ required: true, message: 'กรุณากรอกตำบล/แขวง', trigger: 'blur' }],
        'address.city': [{ required: true, message: 'กรุณากรอกอำเภอ/เขต', trigger: 'blur' }],
        'address.province': [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'blur' }],
        'address.postal_code': [{ required: true, min: 5, message: 'กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง', trigger: 'blur' }],
        'address.tel': [{ required: true, message: 'กรุณากรอกหมายเลขโทรศัพท์', trigger: 'blur' }],
        'address.fax': [{ message: 'กรุณากรอกหมายเลขโทรสาร', trigger: 'blur' }]
      },
      mask: {
        postcode: {
          mask: '00000'
        },
        telMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }, { mask: '{0}00-000-0000' }],
        faxMask: [{ mask: '{02}-000-0000' }, { mask: '{0}00-000-000' }]
      }
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.getters.idToken;
    },
    company: function company() {
      return this.$store.getters.billerInfo;
    },
    uploadUrl: function uploadUrl() {
      return '' + "https://api.cloudinary.com/v1_1/" + window.appConfig.CLOUDINARY_CLOUD_NAME + '/upload';
    },
    provinceList: function provinceList() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getProvinceList();
    },
    baseHost: function baseHost() {
      return __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].getCurrentBaseHost();
      // return window.appConfig.BASE_HOST;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({ name: 'BillerCompanyDetail' });
    },
    handleLogoSuccess: function handleLogoSuccess(res) {
      this.isUploading = false;
      if (res.secure_url) {
        this.companyForm.logo = res.secure_url;
      }
    },
    handleLogoFail: function handleLogoFail(res) {
      this.isUploading = false;
      var errorMessage = this.$t('Unexpected error');
      if (res) {
        errorMessage = res;
        if (res.error) {
          errorMessage = res.error;
          if (res.error.message) {
            errorMessage = res.error.message;
          }
        }
      }
      this.$store.dispatch('ADD_ERROR_FLASH', errorMessage);
    },
    beforeLogoUpload: function beforeLogoUpload(file) {
      var isImage = ['image/jpeg', 'image/png', 'image/gif'].indexOf(file.type) !== -1;
      var isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('Logo picture must be JPG, PNG or GIF format!');
      }
      if (!isLt2M) {
        this.$message.error('Logo picture size can not exceed 2MB!');
      }
      return isImage && isLt2M;
    },
    handleHttpRequest: function handleHttpRequest(options) {
      this.isUploading = true;
      return this.$store.dispatch('UPLOAD_BILLER_COMPANY_LOGO', options.file);
    },
    removeLogo: function removeLogo() {
      var _this = this;

      this.$confirm('คุณต้องการยืนยันการลบโลโก้บริษัทออกใช่หรือไม่?', 'ยืนยันการลบโลโก้บริษัท', {
        confirmButtonText: 'ยืนยันการลบ',
        confirmButtonClass: 'danger-btn',
        cancelButtonText: 'ยกเลิก',
        type: 'warning'
      }).then(function () {
        _this.companyForm.logo = '';
      }).catch(function () {});
    },
    submitForm: function submitForm(formName) {
      this.$refs[formName].validate(this.validateForm);
    },
    validateForm: function validateForm(valid) {
      var _this2 = this;

      if (!valid) {
        this.$log.error('error submit!!');
        return false;
      }
      this.isSubmitting = true;
      var payload = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.companyForm));
      this.$store.dispatch('UPDATE_BILLER_COMPANY_INFO', payload).then(function () {
        _this2.isSubmitting = false;
        _this2.$message({
          type: 'success',
          showClose: true,
          duration: 10000,
          message: 'แก้ไขข้อมูลบริษัทสำเร็จแล้ว'
        });
        _this2.$nextTick(function () {
          _this2.goBack();
        });
      }).catch(function (msg) {
        _this2.isSubmitting = false;
        if (msg) {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t(msg));
        } else {
          _this2.$store.dispatch('ADD_ERROR_FLASH', _this2.$t('Unexpected error'));
        }
      });
      return true;
    },

    /* updateMaskTel() {
      this.maskValue(this.companyForm.address, 'tel', {
        mask: this.mask.telMask,
      });
    },
    updateMaskFax() {
      this.maskValue(this.companyForm.address, 'fax', {
        mask: this.mask.faxMask,
      });
    }, */
    updatePostCode: function updatePostCode() {
      try {
        this.maskValue(this.companyForm.address, 'postal_code', this.mask.postcode);
      } catch (e) {
        console.error(e);
      }
    },
    maskValue: function maskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        var resolvedValue = mask.resolve(val.toString());
        form[field] = resolvedValue;
      }
    },
    unmaskValue: function unmaskValue(form, field, maskOptions) {
      var mask = Object(__WEBPACK_IMPORTED_MODULE_3_imask__["createMask"])(maskOptions);
      var val = form[field];
      if (val) {
        mask.resolve(val.toString());
        form[field] = mask.unmaskedValue;
      }
    },

    /* eslint prefer-arrow-callback: 0 */
    handleInput: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce(function handleInputFn(evt, refName, maskName) {
      __WEBPACK_IMPORTED_MODULE_2__libs_helpers__["a" /* default */].handleInput(evt, this.$refs, refName, this.mask, maskName);
    }, 300, { tailing: true })
  },
  mounted: function mounted() {
    var _this3 = this;

    // load data to form
    if (this.isUpdated) {
      setTimeout(function () {
        if (typeof _this3.company === 'undefined' || _this3.company === null) {
          _this3.goBack();
        }
      }, 1000);
    }
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.company).forEach(function (key) {
        if (key === 'address') {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this3.company.address).forEach(function (addrKey) {
            _this3.$set(_this3.companyForm.address, addrKey, _this3.company.address[addrKey]);
          });
        } else {
          _this3.$set(_this3.companyForm, key, _this3.company[key]);
        }
      });
      _this3.updatePostCode();
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (BillerUserListView);

/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue__);



var _this = this;

/* eslint global-require: 0 */
// import dotenv from '@/libs/dotenv';





var getAppMode = function getAppMode() {
  var defaultMode = 'biller';
  var hostName = window.location.hostname;
  var pathName = window.location.pathname;
  // check if hostName contains the BASE_HOST or not
  var envBaseHost = window.appConfig.BASE_HOST;
  var hosts = envBaseHost ? envBaseHost.split(',') : [''];
  var isValidHostname = false;
  hosts.forEach(function (host) {
    if (hostName.indexOf(host) !== -1) {
      isValidHostname = true;
    }
  });
  // if (hostName.indexOf(window.appConfig.BASE_HOST) !== -1) {
  if (isValidHostname) {
    var domainComponents = pathName.split('/').filter(function (comp) {
      return comp !== '';
    });
    if (domainComponents.length > 0) {
      if (domainComponents[0].toLowerCase() === 'admin') {
        return 'admin';
      }
    }
  }
  return defaultMode;
};

// Check for app mode
var appMode = getAppMode();
window.appConfig.SCB_BILLING_APP_MODE = appMode;

var bootstrap = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var _require, mainApp;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            /* if (typeof window.appConfig.APP_INIT === 'undefined') {
              const configEnvPath = process.env.NODE_ENV === 'development' ? '/static/' : '/';
              window.appConfig = await dotenv.getConfigEnv(configEnvPath);
            } */
            _require = __webpack_require__(741), mainApp = _require.mainApp;


            if (window.appConfig.SENTRY_URL) {
              __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.config(window.appConfig.SENTRY_URL, {
                release: "e9e57dfaece12248c75dda9fba939a90507ebcb7",
                environment: window.appConfig.SCB_BILLING_APP_ENV,
                tags: {
                  build: "17037495774",
                  mode: window.appConfig.SCB_BILLING_APP_MODE
                }
              }).addPlugin(__WEBPACK_IMPORTED_MODULE_5_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_3_vue__["default"]).install();
              __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.context(function () {
                mainApp.initApp();
              });
            } else {
              mainApp.initApp();
            }

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function bootstrap() {
    return _ref.apply(this, arguments);
  };
}();

bootstrap();

/***/ }),

/***/ 741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainApp", function() { return mainApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainAppInfo", function() { return mainAppInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_element_th__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n_element_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__i18n_element_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_i18n__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_en__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_th__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_styles_main_scss__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_styles_main_scss__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import ElementUILocale from 'element-ui/lib/locale/lang/th';


// import Vuency from 'vuency';










// SENTRY STUFFS

// import RavenVue from 'raven-js/plugins/vue';

// import style sheet



var initApp = function initApp() {
  /**
   * ACCESS CONTROL
   * Check if the host contained 'admin' at the beginning or not.
   * if not, show the error page
   */
  if (true) {
    var mode = window.appConfig.SCB_BILLING_APP_MODE;
    var slug = __WEBPACK_IMPORTED_MODULE_8__libs_helpers__["a" /* default */].getURLSlug();
    var accessControlSlug = mode === 'admin' ? 'admin' : '*';
    var reservedPaths = ['unauthorized', 'login', 'logout', 'reset-password', 'forgot-password', 'company', 'admins', 'profiles', 'users'];
    var isValidSlug = false;
    if (mode === 'admin' && accessControlSlug === 'admin' && accessControlSlug === slug) {
      isValidSlug = true;
    } else if (mode === 'biller' && accessControlSlug === '*' && slug !== '' && slug !== 'admin' && reservedPaths.indexOf(slug) === -1) {
      isValidSlug = true;
    }
    if (!isValidSlug) {
      // go to error page
      if (slug !== '' || reservedPaths.indexOf(slug) !== -1) {
        window.location.assign('//' + window.location.host + '/');
      }
      __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push({ name: 'UnauthorizedError' });
      if (window.appConfig.SENTRY_URL) {
        __WEBPACK_IMPORTED_MODULE_12_raven_js___default.a.captureMessage('Unauthorized access!');
      }
    }
  }

  // enable Sentry Vue plugin
  /* if (window.appConfig.SENTRY_DSN) {
    // Raven.addPlugin(RavenVue, Vue);
    Raven
      .config(window.appConfig.SENTRY_DSN, {
        release: process.env.SCB_BILLING_APP_VERSION,
        environment: window.appConfig.SCB_BILLING_APP_ENV,
      })
      .addPlugin(RavenVue, Vue)
      .install();
  } */

  // enable persistent store of router
  Object(__WEBPACK_IMPORTED_MODULE_4_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */]);

  // enable i18n
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex_i18n__["a" /* default */].plugin, __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */]);

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].i18n.add('en', __WEBPACK_IMPORTED_MODULE_6__i18n_en__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].i18n.add('th', __WEBPACK_IMPORTED_MODULE_7__i18n_th__["a" /* default */]);
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].i18n.set('th');

  // enable element UI
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_1__i18n_element_th___default.a });

  // enable logger
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuejs_logger___default.a, {
    // required ['debug', 'info', 'warn', 'error', 'fatal']
    logLevel:  true ? 'error' : 'debug',
    // optional : defaults to false if not specified
    stringifyArguments: "production" !== 'production',
    // optional : defaults to false if not specified
    showLogLevel: "production" !== 'production',
    // optional : defaults to false if not specified
    showMethodName: "production" !== 'production',
    // optional : defaults to '|' if not specified
    separator: '|',
    // optional : defaults to false if not specified
    showConsoleColors: "production" !== 'production'
  });

  // Enable concurrency management
  // Vue.use(Vuency);

  // config Vue
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.devtools = true;

  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$scbAppInfo = {
    env: window.appConfig.SCB_BILLING_APP_ENV,
    build: "17037495774",
    version: "e9e57dfaece12248c75dda9fba939a90507ebcb7",
    mode: window.appConfig.SCB_BILLING_APP_MODE
  };

  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */] }
  });
};

// const initApp = () => {};

var mainApp = {
  initApp: initApp
  // initApp2,
};
var mainAppInfo = {};

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable strict, lines-around-directive, no-underscore-dangle */


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'ตกลง',
      clear: 'ล้างข้อมูล'
    },
    datepicker: {
      now: 'ตอนนี้',
      today: 'วันนี้',
      cancel: 'ยกเลิก',
      clear: 'ล้างข้อมูล',
      confirm: 'ตกลง',
      selectDate: 'เลือกวันที่',
      selectTime: 'เลือกเวลา',
      startDate: 'วันที่เริ่มต้น',
      startTime: 'เวลาเริ่มต้น',
      endDate: 'วันที่สิ้นสุด',
      endTime: 'เวลาสิ้นสุด',
      prevYear: 'ปีที่แล้ว', // to be translated
      nextYear: 'ปีต่อไป', // to be translated
      prevMonth: 'เดือนที่แล้ว', // to be translated
      nextMonth: 'เดือนต่อไป', // to be translated
      year: 'ปี',
      month1: 'มกราคม',
      month2: 'กุมภาพันธ์',
      month3: 'มีนาคม',
      month4: 'เมษายน',
      month5: 'พฤษภาคม',
      month6: 'มิถุนายน',
      month7: 'กรกฎาคม',
      month8: 'สิงหาคม',
      month9: 'กันยายน',
      month10: 'ตุลาคม',
      month11: 'พฤศจิกายน',
      month12: 'ธันวาคม',
      // week: 'week',
      weeks: {
        sun: 'อา',
        mon: 'จ',
        tue: 'อ',
        wed: 'พ',
        thu: 'พฤ',
        fri: 'ศ',
        sat: 'ส'
      },
      months: {
        jan: 'ม.ค.',
        feb: 'ก.พ.',
        mar: 'มี.ค.',
        apr: 'เม.ษ.',
        may: 'พ.ค.',
        jun: 'มิ.ย.',
        jul: 'ก.ค.',
        aug: 'ส.ค.',
        sep: 'ก.ย.',
        oct: 'ต.ค.',
        nov: 'พ.ย.',
        dec: 'ธ.ค.'
      }
    },
    select: {
      loading: 'กำลังโหลด',
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      noData: 'ไม่พบข้อมูล',
      placeholder: 'เลือก'
    },
    cascader: {
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      loading: 'กำลังโหลด',
      placeholder: 'เลือก'
    },
    pagination: {
      goto: 'ไปที่',
      pagesize: '/หน้า',
      total: 'ทั้งหมด {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'ข้อความ',
      confirm: 'ตกลง',
      cancel: 'ยกเลิก',
      error: 'คุณป้อนข้อมูลไม่ถูกต้อง'
    },
    upload: {
      deleteTip: 'กดลบเพื่อลบออก', // to be translated
      delete: 'ลบ',
      preview: 'ตัวอย่าง',
      continue: 'ทำต่อ'
    },
    table: {
      emptyText: 'ไม่พบข้อมูล',
      confirmFilter: 'ยืนยัน',
      resetFilter: 'รีเซ็ต',
      clearFilter: 'ทั้งหมด',
      sumText: 'รวม' // to be translated
    },
    tree: {
      emptyText: 'ไม่พบข้อมูล'
    },
    transfer: {
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      noData: 'ไม่พบข้อมูล',
      titles: ['รายการ 1', 'รายการ 2'], // to be translated
      filterPlaceholder: 'กรอกคำหลัก', // to be translated
      noCheckedFormat: '{total} รายการ', // to be translated
      hasCheckedFormat: '{checked}/{total} ถูกเลือก' // to be translated
    }
  }
};

/***/ }),

/***/ 815:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint quote-props: 0 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // Error Messages
  // Error 401
  '4011': 'invalid email or password',
  // Error 403
  '4031': 'inactive 30 minutes',
  '4032': 'expired token',
  '4033': 'session was overridden',
  '4034': 'already logged out',
  '4035': 'account inactive contact admin',
  '4036': 'invalid token',
  '4037': 'Password expired',
  '4038': 'same password is not allowed'
});

/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint quote-props: 0 */
/* harmony default export */ __webpack_exports__["a"] = ({
  'OK': 'ตกลง',
  'Login': 'เข้าสู่ระบบ',
  'Logout': 'ออกจากระบบ',
  'Tenant': 'บริษัท',
  'E-mail': 'อีเมล',
  'Password': 'รหัสผ่าน',
  'Please input a valid email address': 'กรุณากรอกอีเมลให้ถูกต้อง',
  'Please input password': 'กรุณากรอกรหัสผ่าน',
  'Password Repeat': 'ยืนยันรหัสผ่าน',
  'Please input password again': 'กรุณากรอกรหัสผ่านอีกครั้ง',
  'Please input password is not matched': 'กรุณากรอกรหัสผ่านให้เหมือนกัน',
  'Confirm': 'ยืนยัน',
  'Admin Panel': 'ส่วนจัดการดูแลระบบ',
  'Submitting...': 'กำลังส่งข้อมูล...',
  'Loading...': 'กำลังดึงข้อมูล...',
  'Successfully logged out.': 'ออกจากระบบสำเร็จแล้ว',
  'Reset Password': 'เปลี่ยนรหัสผ่าน',
  'Recover Password now!': 'เปลี่ยนรหัสผ่านทันที!',
  'Forgot your password?': 'ลืมรหัสผ่านใช่หรือไม่?',
  'Successfully changed your password.': 'เปลี่ยนรหัสผ่านของคุณสำเร็จแล้ว',
  'The reset password instructions should send to your email shortly.': 'ระบบกำลังจัดส่งอีเมลสำหรับการเปลี่ยนรหัสผ่านไปยังอีเมลของท่าน',
  // Notify Message title
  'Cancel': 'ยกเลิก',
  'Success': 'สำเร็จแล้ว',
  'Submit': 'ส่งข้อมูล',
  'Terminate': 'ลบข้อมูล',
  'Save and continue': 'บันทึกและดำเนินการต่อ',
  'Warning': 'ระวัง',
  // Error Messages
  'Unexpected error': 'เกิดข้อผิดพลาดที่ไม่สามารถระบุได้',
  // Error 401
  '4011': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  // Error 403
  '4031': 'ไม่มีการใช้งานเกิน 30 นาที',
  '4032': 'โทเค็นหมดอายุ',
  // '4033': 'เซสชั่นถูกเปลี่ยนแปลง',
  '4033': 'บัญชีถูกเข้าสู่ระบบจากเซสชั่นอื่นแล้ว',
  '4034': 'ออกจากระบบอยู่แล้ว',
  '4035': 'บัญชีถูกระงับการใช้งาน กรุณาติดต่อผู้ดูแลระบบ',
  '4036': 'โทเค็นไม่ถูกต้อง',
  '4037': 'รหัสผ่านปัจจุบันของคุณถูกใช้งานเป็นเวลามากกว่า 90 วันแล้ว ระบบกำลังทำการส่งอีเมลให้คุณเพื่อทำการตั้งรหัสผ่านใหม่',
  '4038': 'กรุณาตั้งรหัสผ่านใหม่ให้แตกต่างจากรหัสผ่านปัจจุบันของคุณ'
});

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 296,
	"./af.js": 296,
	"./ar": 297,
	"./ar-dz": 298,
	"./ar-dz.js": 298,
	"./ar-kw": 299,
	"./ar-kw.js": 299,
	"./ar-ly": 300,
	"./ar-ly.js": 300,
	"./ar-ma": 301,
	"./ar-ma.js": 301,
	"./ar-sa": 302,
	"./ar-sa.js": 302,
	"./ar-tn": 303,
	"./ar-tn.js": 303,
	"./ar.js": 297,
	"./az": 304,
	"./az.js": 304,
	"./be": 305,
	"./be.js": 305,
	"./bg": 306,
	"./bg.js": 306,
	"./bm": 307,
	"./bm.js": 307,
	"./bn": 308,
	"./bn-bd": 309,
	"./bn-bd.js": 309,
	"./bn.js": 308,
	"./bo": 310,
	"./bo.js": 310,
	"./br": 311,
	"./br.js": 311,
	"./bs": 312,
	"./bs.js": 312,
	"./ca": 313,
	"./ca.js": 313,
	"./cs": 314,
	"./cs.js": 314,
	"./cv": 315,
	"./cv.js": 315,
	"./cy": 316,
	"./cy.js": 316,
	"./da": 317,
	"./da.js": 317,
	"./de": 318,
	"./de-at": 319,
	"./de-at.js": 319,
	"./de-ch": 320,
	"./de-ch.js": 320,
	"./de.js": 318,
	"./dv": 321,
	"./dv.js": 321,
	"./el": 322,
	"./el.js": 322,
	"./en-au": 323,
	"./en-au.js": 323,
	"./en-ca": 324,
	"./en-ca.js": 324,
	"./en-gb": 325,
	"./en-gb.js": 325,
	"./en-ie": 326,
	"./en-ie.js": 326,
	"./en-il": 327,
	"./en-il.js": 327,
	"./en-in": 328,
	"./en-in.js": 328,
	"./en-nz": 329,
	"./en-nz.js": 329,
	"./en-sg": 330,
	"./en-sg.js": 330,
	"./eo": 331,
	"./eo.js": 331,
	"./es": 332,
	"./es-do": 333,
	"./es-do.js": 333,
	"./es-mx": 334,
	"./es-mx.js": 334,
	"./es-us": 335,
	"./es-us.js": 335,
	"./es.js": 332,
	"./et": 336,
	"./et.js": 336,
	"./eu": 337,
	"./eu.js": 337,
	"./fa": 338,
	"./fa.js": 338,
	"./fi": 339,
	"./fi.js": 339,
	"./fil": 340,
	"./fil.js": 340,
	"./fo": 341,
	"./fo.js": 341,
	"./fr": 342,
	"./fr-ca": 343,
	"./fr-ca.js": 343,
	"./fr-ch": 344,
	"./fr-ch.js": 344,
	"./fr.js": 342,
	"./fy": 345,
	"./fy.js": 345,
	"./ga": 346,
	"./ga.js": 346,
	"./gd": 347,
	"./gd.js": 347,
	"./gl": 348,
	"./gl.js": 348,
	"./gom-deva": 349,
	"./gom-deva.js": 349,
	"./gom-latn": 350,
	"./gom-latn.js": 350,
	"./gu": 351,
	"./gu.js": 351,
	"./he": 352,
	"./he.js": 352,
	"./hi": 353,
	"./hi.js": 353,
	"./hr": 354,
	"./hr.js": 354,
	"./hu": 355,
	"./hu.js": 355,
	"./hy-am": 356,
	"./hy-am.js": 356,
	"./id": 357,
	"./id.js": 357,
	"./is": 358,
	"./is.js": 358,
	"./it": 359,
	"./it-ch": 360,
	"./it-ch.js": 360,
	"./it.js": 359,
	"./ja": 361,
	"./ja.js": 361,
	"./jv": 362,
	"./jv.js": 362,
	"./ka": 363,
	"./ka.js": 363,
	"./kk": 364,
	"./kk.js": 364,
	"./km": 365,
	"./km.js": 365,
	"./kn": 366,
	"./kn.js": 366,
	"./ko": 367,
	"./ko.js": 367,
	"./ku": 368,
	"./ku.js": 368,
	"./ky": 369,
	"./ky.js": 369,
	"./lb": 370,
	"./lb.js": 370,
	"./lo": 371,
	"./lo.js": 371,
	"./lt": 372,
	"./lt.js": 372,
	"./lv": 373,
	"./lv.js": 373,
	"./me": 374,
	"./me.js": 374,
	"./mi": 375,
	"./mi.js": 375,
	"./mk": 376,
	"./mk.js": 376,
	"./ml": 377,
	"./ml.js": 377,
	"./mn": 378,
	"./mn.js": 378,
	"./mr": 379,
	"./mr.js": 379,
	"./ms": 380,
	"./ms-my": 381,
	"./ms-my.js": 381,
	"./ms.js": 380,
	"./mt": 382,
	"./mt.js": 382,
	"./my": 383,
	"./my.js": 383,
	"./nb": 384,
	"./nb.js": 384,
	"./ne": 385,
	"./ne.js": 385,
	"./nl": 386,
	"./nl-be": 387,
	"./nl-be.js": 387,
	"./nl.js": 386,
	"./nn": 388,
	"./nn.js": 388,
	"./oc-lnc": 389,
	"./oc-lnc.js": 389,
	"./pa-in": 390,
	"./pa-in.js": 390,
	"./pl": 391,
	"./pl.js": 391,
	"./pt": 392,
	"./pt-br": 393,
	"./pt-br.js": 393,
	"./pt.js": 392,
	"./ro": 394,
	"./ro.js": 394,
	"./ru": 395,
	"./ru.js": 395,
	"./sd": 396,
	"./sd.js": 396,
	"./se": 397,
	"./se.js": 397,
	"./si": 398,
	"./si.js": 398,
	"./sk": 399,
	"./sk.js": 399,
	"./sl": 400,
	"./sl.js": 400,
	"./sq": 401,
	"./sq.js": 401,
	"./sr": 402,
	"./sr-cyrl": 403,
	"./sr-cyrl.js": 403,
	"./sr.js": 402,
	"./ss": 404,
	"./ss.js": 404,
	"./sv": 405,
	"./sv.js": 405,
	"./sw": 406,
	"./sw.js": 406,
	"./ta": 407,
	"./ta.js": 407,
	"./te": 408,
	"./te.js": 408,
	"./tet": 409,
	"./tet.js": 409,
	"./tg": 410,
	"./tg.js": 410,
	"./th": 411,
	"./th.js": 411,
	"./tk": 412,
	"./tk.js": 412,
	"./tl-ph": 413,
	"./tl-ph.js": 413,
	"./tlh": 414,
	"./tlh.js": 414,
	"./tr": 415,
	"./tr.js": 415,
	"./tzl": 416,
	"./tzl.js": 416,
	"./tzm": 417,
	"./tzm-latn": 418,
	"./tzm-latn.js": 418,
	"./tzm.js": 417,
	"./ug-cn": 419,
	"./ug-cn.js": 419,
	"./uk": 420,
	"./uk.js": 420,
	"./ur": 421,
	"./ur.js": 421,
	"./uz": 422,
	"./uz-latn": 423,
	"./uz-latn.js": 423,
	"./uz.js": 422,
	"./vi": 424,
	"./vi.js": 424,
	"./x-pseudo": 425,
	"./x-pseudo.js": 425,
	"./yo": 426,
	"./yo.js": 426,
	"./zh-cn": 427,
	"./zh-cn.js": 427,
	"./zh-hk": 428,
	"./zh-hk.js": 428,
	"./zh-mo": 429,
	"./zh-mo.js": 429,
	"./zh-tw": 430,
	"./zh-tw.js": 430
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 821;

/***/ }),

/***/ 822:
/***/ (function(module, exports) {

module.exports = {"version":"2021a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020 +0030|.Q 0 -k -u|01212121212121212121212121212121212121212121212131313131313131|-2bRzX.8 9RbX.8 fdE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE Mok 1BXE M0k 1BXE fak 9vbu bjCu MLu 1Bcu MLu 1BAu MLu 1Bcu MLu 1Bcu MLu 1Bcu MLu|41e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EWT EPT EDT|59.u 50 40 40 40|01212314141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2kNuO.u 1drbO.u 6tX0 cp0 1hS0 pF0 J630 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(432);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ad8b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(850);
function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_741ad8b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 826:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":"app-config"}},[_vm._v(_vm._s(_vm.appConfig))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_helpers__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_main__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_auth__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_error__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes_admin__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__routes_biller__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__middleware__ = __webpack_require__(1128);





// import async from 'async';
// import store from '@/store';

// Views


// import CompanyView from '@/pages/company';

// import BillerView from '@/pages/biller';
// import Hello from '@/components/Hello';

// Routes



// Middleware


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var defaultRouteName = window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? "AdminUserLoadInfo" : "BillerUserLoadInfo";

var defaultRoutes = [
// Auth Stuffs
{
  path: '/reset-password',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_auth__["a" /* default */].resetPassword,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_9__middleware__["a" /* default */].requireAuthenticated,
  meta: {
    title: 'เปลี่ยนรหัสผ่าน'
  }
}];
var routes = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.concat(defaultRoutes, window.appConfig.SCB_BILLING_APP_MODE === 'admin' ? __WEBPACK_IMPORTED_MODULE_7__routes_admin__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__routes_biller__["a" /* default */]);
var slug = __WEBPACK_IMPORTED_MODULE_3__libs_helpers__["a" /* default */].getURLSlug();
var base = slug === '' ? '/' : '/' + slug + '/';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  base: base,
  mode: "history",
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_auth__["a" /* default */].login,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_9__middleware__["a" /* default */].checkIsLogin,
    meta: {
      title: 'เข้าสู่ระบบ'
    }
  }, {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_auth__["a" /* default */].forgotPassword,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_9__middleware__["a" /* default */].checkIsLogin,
    meta: {
      title: 'ลืมรหัสผ่าน'
    }
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_auth__["a" /* default */].logout,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_9__middleware__["a" /* default */].requireAuthenticated,
    meta: {
      title: 'ออกจากระบบ'
    }
  }, {
    path: '/reset-password-with-token',
    props: true,
    name: 'ResetPasswordWithToken',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_auth__["a" /* default */].resetPasswordWithToken,
    meta: {
      title: 'เปลี่ยนรหัสผ่าน'
    }
  }, {
    path: '/',
    name: 'MainLayout',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_main__["a" /* default */],
    redirect: { name: defaultRouteName },
    children: routes
  }, {
    path: '*',
    redirect: { name: defaultRouteName }
  },
  // Error
  {
    path: '/unauthorized',
    name: 'UnauthorizedError',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_error__["a" /* default */].unauthorized,
    meta: {
      title: 'ไม่อนุญาต'
    }
  }]
});
router.beforeEach(__WEBPACK_IMPORTED_MODULE_9__middleware__["a" /* default */].pageTitle);
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(440);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049dce26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(1020);
function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_049dce26_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 854:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xregexp__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xregexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xregexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crc__ = __webpack_require__(1006);
/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */



var twoNumbersRegEx = new __WEBPACK_IMPORTED_MODULE_0_xregexp___default.a('^[0-9]{2}$');
var numberOnlyRegEx = new __WEBPACK_IMPORTED_MODULE_0_xregexp___default.a('^[0-9]*$');
var TQRAmountRegEx = new __WEBPACK_IMPORTED_MODULE_0_xregexp___default.a('^([0-9]+)([.]*)([0-9]+)$');

var formatBOT = 'มาตรฐานของ BOT';
var formatThaiQR = 'มาตรฐานของ Thai QR 1.3.3';

var TQRIDwithSubdata = ['26', '27', '29', '30', '31', '39', '51', '62', '80'];

var QRChecker = {
  /**
   * Get QR Code Format
   */
  getVerificationResult: function getVerificationResult(_ref) {
    var result = _ref.result;

    var format = 'ไม่ตรงตามมาตรฐานของ BOT หรือ Thai QR 1.3.3';
    var correctness = false;
    var incorrectReason = '';
    // check type
    if (result.substr(0, 1) === '|') {
      format = formatBOT;

      var parts = result.substr(1).split('\r');
      if (parts.length >= 4) {
        if (parts[0].length !== 15) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Tax ID + Suffix มีจำนวนไม่เท่ากับ 15 หลัก');
        }

        if (parts[1].length > 20) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Ref. 1 มีจำนวนมากกว่า 20 หลัก');
        }

        if (parts[2].length > 20) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Ref. 2 มีจำนวนมากกว่า 20 หลัก');
        }

        if (parts[3].length < 1 || parts[3].length > 10) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Total Amount มีจำนวนน้อยกว่า 1 หลัก หรือมากกว่า 10 หลัก');
        }

        if (!numberOnlyRegEx.test(parts[3])) {
          incorrectReason = this.appendIncorrectReason(incorrectReason, 'Total Amount มีตัวอักษรแทรกอยู่');
        }

        if (incorrectReason === '') {
          correctness = true;
        }
      } else {
        incorrectReason = 'ไม่พบตัวอักษร Carriage Return หรือ มีข้อมูลไม่ครบอย่างน้อย 4 field (TaxID+Suffix, Ref.1, Ref.2, TotalAmount)';
      }
    } else if (result.substr(0, 6) === '000201') {
      format = formatThaiQR;

      var dataExclChecksum = result.substr(0, result.length - 4);
      var calCRC = __WEBPACK_IMPORTED_MODULE_1_crc__["a" /* default */].crc16xmodem(dataExclChecksum, 0xffff).toString(16).toUpperCase();

      var res = this.splitTQRData(result.substr(6));
      // console.log(res);
      if (res.success === false) {
        incorrectReason = this.appendIncorrectReason(incorrectReason, 'ไม่สามารถถอดรหัสในรูปแบบ [ID:Length:Data] ได้');
        incorrectReason = this.appendIncorrectReason(incorrectReason, res.failedReason);
        return { format: format, correctness: correctness, incorrectReason: incorrectReason };
      }

      for (var i = 0; i < res.dataParts.length; i++) {
        var dataPart = res.dataParts[i];
        if (dataPart.id === '52') {
          if (!numberOnlyRegEx.test(dataPart.d) || dataPart.d.length !== 4) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 4 \u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25');
          }
        }

        if (dataPart.id === '53') {
          if (dataPart.d !== '764') {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 764');
          }
        }

        if (dataPart.id === '54') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 13) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E1C\u0E34\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A');
          }
        }

        if (dataPart.id === '55') {
          if (!numberOnlyRegEx.test(dataPart.d) || dataPart.d.length !== 2) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 2 \u0E2B\u0E23\u0E37\u0E2D\u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25');
          }
        }

        if (dataPart.id === '56') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 13) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1C\u0E34\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19');
          }
        }

        if (dataPart.id === '57') {
          if (!TQRAmountRegEx.test(dataPart.d) || dataPart.d.length > 5) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E1E\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1C\u0E34\u0E14\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A percentage');
          }
        }

        if (dataPart.id === '58') {
          if (dataPart.d !== 'TH') {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 \'TH\'');
          }
        }

        if (dataPart.id === '59') {
          if (dataPart.d.length > 25) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 25');
          }
        }

        if (dataPart.id === '60') {
          if (dataPart.d.length > 15) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 15');
          }
        }

        if (dataPart.id === '61') {
          if (dataPart.d.length > 10) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 10');
          }
        }

        if (dataPart.id === '64') {
          if (dataPart.d.length > 99) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 99');
          }
        }

        if (dataPart.id === '63') {
          if (dataPart.d.length > 4 || dataPart.d !== calCRC) {
            incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + dataPart.id + ' Checksum \u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 (\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E04\u0E37\u0E2D ' + calCRC + ')');
          }
        }

        if (TQRIDwithSubdata.includes(dataPart.id)) {
          var res2 = this.splitTQRData(dataPart.d);
          var parentID = dataPart.id;
          for (var j = 0; j < res2.dataParts.length; j++) {
            var subPart = res2.dataParts[j];
            if (parentID === '29') {
              // promptpay
              if (subPart.id === '01') {
                // mobile number
                if (!numberOnlyRegEx.test(subPart.d) || subPart.d.substr(0, 4) !== '0066') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') \u0E40\u0E1A\u0E2D\u0E23\u0E4C\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D\u0E44\u0E21\u0E48\u0E02\u0E36\u0E49\u0E19\u0E15\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22 0066 \u0E2B\u0E23\u0E37\u0E2D \u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48');
                }
              }

              if (subPart.id === '02') {
                // nat id
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') National ID or Tax ID \u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48');
                }
              }

              if (subPart.id === '03') {
                // e wallet
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') E-Wallet ID \u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48');
                }
              }

              if (subPart.id === '04') {
                // bank account
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') Bank account \u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48');
                }
              }

              if (subPart.id === '05') {
                // OTA
                if (subPart.d !== 'A000000677010114') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') OTA \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 A000000677010114');
                }
              }
            }

            if (parentID === '30') {
              // promptpay bill payment
              if (subPart.id === '00') {
                if (subPart.d !== 'A000000677010112') {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') AID \u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 A000000677010112');
                }
              }

              if (subPart.id === '01') {
                // biller id
                if (!numberOnlyRegEx.test(subPart.d)) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') Biller ID \u0E21\u0E35\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E41\u0E17\u0E23\u0E01\u0E2D\u0E22\u0E39\u0E48');
                }
              }

              if (subPart.id === '02') {
                // ref1
                if (subPart.d.length > 20) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') Reference 1 \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 20');
                }
              }

              if (subPart.id === '03') {
                // ref2
                if (subPart.d.length > 20) {
                  incorrectReason = this.appendIncorrectReason(incorrectReason, 'ID: ' + parentID + '(' + subPart.id + ') Reference 2 \u0E21\u0E35\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 20');
                }
              }
            }
          } // sub data for loop
        } // if subdata
      } // for loop

      if (incorrectReason === '') {
        correctness = true;
      }
    } // else format TQR
    return { format: format, correctness: correctness, incorrectReason: incorrectReason };
  },
  getHTMLInfo: function getHTMLInfo(format, _ref2) {
    var result = _ref2.result;

    var info = '';
    if (format === formatBOT) {
      info = result.split('\r').join('<br/>');
    } else if (format === formatThaiQR) {
      var res = this.splitTQRData(result);
      for (var i = 0; i < res.dataParts.length; i++) {
        if (TQRIDwithSubdata.includes(res.dataParts[i].id)) {
          info = info + '<br/> ' + res.dataParts[i].id + ' ' + res.dataParts[i].len;
          var res2 = this.splitTQRData(res.dataParts[i].d);
          for (var j = 0; j < res2.dataParts.length; j++) {
            info = info + '<br/> &nbsp; ' + res2.dataParts[j].id + ' ' + res2.dataParts[j].len + ' ' + res2.dataParts[j].d;
          }
          info = info + '<br/> ' + res2.data;
        } else {
          info = info + '<br/> ' + res.dataParts[i].id + ' ' + res.dataParts[i].len + ' ' + res.dataParts[i].d;
        }
      }
      info = info + '<br/> ' + res.data + '<br/>';
    } else {
      info = result;
    }
    return info;
  },
  appendIncorrectReason: function appendIncorrectReason(currentStr, appendingStr) {
    var str = '';
    if (currentStr === '') {
      str = '- ' + appendingStr;
    } else {
      str = currentStr + '<br/>-  ' + appendingStr;
    }
    return str;
  },
  splitTQRData: function splitTQRData(rawData) {
    var data = rawData;
    var success = true;
    var dataParts = [];
    var failedReason = '';
    while (data.length > 0) {
      var cursor = 0;
      var id = data.substr(cursor, 2);
      var len = data.substr(cursor + 2, 2);
      if (!twoNumbersRegEx.test(id) || !twoNumbersRegEx.test(len)) {
        success = false;
        failedReason = 'พบตัวอักษรใน field ID หรือ Length';
        return { success: success, dataParts: dataParts, data: data, failedReason: failedReason };
      }

      var dLen = parseInt(len, 10);
      var d = data.substr(cursor + 4, dLen);

      dataParts.push({ id: id, len: len, d: d });
      if (d.length !== dLen || dLen < 1) {
        success = false;
        failedReason = 'พบข้อมูลมีความยาวไม่ตรงกับที่ระบุใน field Length';
        return { success: success, dataParts: dataParts, data: data, failedReason: failedReason };
      }

      cursor = cursor + 4 + dLen;
      data = data.substr(cursor);
    }
    return { success: success, dataParts: dataParts, data: data, failedReason: failedReason };
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QRChecker);

/***/ })

},[503]);


// WEBPACK FOOTER //
// static/js/app.6197efcedab207c28dd6.js